/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/chaht01.github.io/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(48);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export keyframes */
/* unused harmony export createGlobalStyle */
/* unused harmony export isStyledComponent */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__emotion_is_prop_valid__ = __webpack_require__(101);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"/chaht01.github.io"}).SC_ATTR || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.1.2");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.1.2" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.1.2", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.1.2" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    return !isFalsish(obj[key]);
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (executionContext) {
      var shouldThrow = false;

      try {
        // eslint-disable-next-line new-cap
        if (Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isElement"])(new chunk(executionContext))) {
          shouldThrow = true;
        }
      } catch (e) {
        /* */
      }

      if (shouldThrow) {
        throw new StyledComponentsError(13, getComponentName(chunk));
      }

      return flatten(chunk(executionContext), executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCss(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });
    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var didWarnAboutClassNameUsage = new Set();

var classNameUsageCheckInjector = (function (target) {
  var elementClassName = '';

  var targetCDM = target.componentDidMount;

  // eslint-disable-next-line no-param-reassign
  target.componentDidMount = function componentDidMount() {
    if (typeof targetCDM === 'function') {
      targetCDM.call(this);
    }

    var forwardTarget = this.props.forwardedComponent.target;

    if (target.props && target.props.suppressClassNameWarning || target.attrs && target.attrs.suppressClassNameWarning || didWarnAboutClassNameUsage.has(forwardTarget)) {
      return;
    }

    didWarnAboutClassNameUsage.add(forwardTarget);

    var classNames = elementClassName.replace(/ +/g, ' ').trim().split(' ');
    // eslint-disable-next-line react/no-find-dom-node
    var node = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);
    var selector = classNames.map(function (s) {
      return '.' + s;
    }).join('');

    if (node && node.nodeType === 1 && !classNames.every(function (className) {
      return node.classList && node.classList.contains(className);
    }) && !node.querySelector(selector)) {
      console.warn('It looks like you\'ve wrapped styled() around your React component (' + getComponentName(forwardTarget) + '), but the className prop is not being passed down to a child. No styles will be rendered unless className is composed within your React component.');
    }
  };

  var prevRenderInner = target.renderInner;

  // eslint-disable-next-line no-param-reassign
  target.renderInner = function renderInner() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var element = prevRenderInner.apply(this, args);

    elementClassName = element.props.className;

    return element;
  };
});

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".')
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }

    if (false) {
      classNameUsageCheckInjector(_this);
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else if (theme !== undefined) {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps), this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(this.props.theme || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.attrs, this.props);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') continue;else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_8__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  });

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent() {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["b"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93), __webpack_require__(94)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(53)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pxToVw;
function pxToVw(px){// return (100 * px) / 1200;
return px;}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n    @media (max-width: ","em) {\n      ","\n    }\n  "],["\n    @media (max-width: ","em) {\n      ","\n    }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var sizes={sm:640,md:960,lg:1200};var media=Object.keys(sizes).reduce(function(acc,label){acc[label]=function(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject,sizes[label]/16,__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */].apply(undefined,arguments));};return acc;},{});/* harmony default export */ __webpack_exports__["a"] = (media);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
var colors={semiblack:"#231f20",black:"#111111",semiwhite:"#e1e1e7",white:"#f1f1f5",lightGreeny:"#f1f3f4"};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProgramTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProgramDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SectionDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SectionTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ArticleTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArticleSubTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DemoLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Helper_media__ = __webpack_require__(5);
var _templateObject=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tline-height: 1;\n\t',';\n\t',';\n'],['\n\tfont-size: ','px;\n\tline-height: 1;\n\t',';\n\t',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 48px;\n    margin-top: 1em;\n  '],['\n    font-size: 48px;\n    margin-top: 1em;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 32px;\n    margin-top: 1em;\n  '],['\n    font-size: 32px;\n    margin-top: 1em;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: ','px;\n  margin-top: 1em;\n'],['\n  font-size: ','px;\n  margin-top: 1em;\n']),_templateObject6=_taggedTemplateLiteral(['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tfont-weight: 100;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\tbackground-image: linear-gradient(0deg, #fff 100%, #fff);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 58%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\t',' ',';\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n'],['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tfont-weight: 100;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\tbackground-image: linear-gradient(0deg, #fff 100%, #fff);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 58%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\t',' ',';\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: ','px;\n  '],['\n    font-size: ','px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 1em;\n\tfont-weight: 100;\n\t',';\n\t',';\n'],['\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 1em;\n\tfont-weight: 100;\n\t',';\n\t',';\n']),_templateObject9=_taggedTemplateLiteral(['\n    font-size: 40px\n  '],['\n    font-size: 40px\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    font-size: 30px\n  '],['\n    font-size: 30px\n  ']),_templateObject11=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\n\t',';\n\t',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\n\t',';\n\t',';\n']),_templateObject12=_taggedTemplateLiteral(['\n    font-size: 16px\n  '],['\n    font-size: 16px\n  ']),_templateObject13=_taggedTemplateLiteral(['\n\tdisplay: block;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tmargin-bottom: 0.8em;\n\t',';\n\t',';\n'],['\n\tdisplay: block;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tmargin-bottom: 0.8em;\n\t',';\n\t',';\n']),_templateObject14=_taggedTemplateLiteral(['\n    font-size: 15px\n  '],['\n    font-size: 15px\n  ']),_templateObject15=_taggedTemplateLiteral(['\n    font-size: 13px\n  '],['\n    font-size: 13px\n  ']),_templateObject16=_taggedTemplateLiteral(['\n\tdisplay: block;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 0.8em;\n\n\t',' ',';\n'],['\n\tdisplay: block;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 0.8em;\n\n\t',' ',';\n']),_templateObject17=_taggedTemplateLiteral(['\n  font-size: 24px;\n'],['\n  font-size: 24px;\n']),_templateObject18=_taggedTemplateLiteral(['\n  font-size: 20px;\n'],['\n  font-size: 20px;\n']),_templateObject19=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.4;\n\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.4;\n\n\t',' ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n  font-size: ','px;\n'],['\n  font-size: ','px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProgramTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(64),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject2),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject3));var ProgramDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)));var DemoLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].a(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(14)));var SectionTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(50.65),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject9),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject10));var SectionDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject12),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject12));var ArticleSubTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(15),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject14),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject15));var ArticleTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject17),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject18));var ArticleParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(49);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(11);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*
 * Konva JavaScript Framework v2.6.0
 * http://konvajs.github.io/
 * Licensed under the MIT
 * Date: Fri Dec 14 2018
 *
 * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
 * Modified work Copyright (C) 2014 - present by Anton Lavrenov (Konva)
 *
 * @license
 */

// runtime check for already included Konva
(function() {
  'use strict';
  /**
   * @namespace Konva
   */

  var PI_OVER_180 = Math.PI / 180;

  var Konva = {
    // public
    version: '2.6.0',

    // private
    stages: [],
    idCounter: 0,
    ids: {},
    names: {},
    shapes: {},
    listenClickTap: false,
    inDblClickWindow: false,

    isBrowser:
      typeof window !== 'undefined' &&
      // browser case
      ({}.toString.call(window) === '[object Window]' ||
        // electron case
        {}.toString.call(window) === '[object global]'),

    isUnminified: /comment/.test(function() {
      /* comment */
    }),

    // configurations
    enableTrace: false,
    traceArrMax: 100,
    dblClickWindow: 400,
    /**
     * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
     * But you may override such property, if you want to use your value.
     * @property pixelRatio
     * @default undefined
     * @memberof Konva
     * @example
     * Konva.pixelRatio = 1;
     */
    pixelRatio: undefined,
    /**
     * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point,
     * only then start dragging. Default is 3px.
     * @property dragDistance
     * @default 0
     * @memberof Konva
     * @example
     * Konva.dragDistance = 10;
     */
    dragDistance: 3,
    /**
     * Use degree values for angle properties. You may set this property to false if you want to use radiant values.
     * @property angleDeg
     * @default true
     * @memberof Konva
     * @example
     * node.rotation(45); // 45 degrees
     * Konva.angleDeg = false;
     * node.rotation(Math.PI / 2); // PI/2 radian
     */
    angleDeg: true,
    /**
     * Show different warnings about errors or wrong API usage
     * @property showWarnings
     * @default true
     * @memberof Konva
     * @example
     * Konva.showWarnings = false;
     */
    showWarnings: true,

    /**
     * @namespace Filters
     * @memberof Konva
     */
    Filters: {},

    /**
     * returns whether or not drag and drop is currently active
     * @method
     * @memberof Konva
     */
    isDragging: function() {
      var dd = Konva.DD;

      // if DD is not included with the build, then
      // drag and drop is not even possible
      if (dd) {
        return dd.isDragging;
      }
      return false;
    },
    /**
     * returns whether or not a drag and drop operation is ready, but may
     *  not necessarily have started
     * @method
     * @memberof Konva
     */
    isDragReady: function() {
      var dd = Konva.DD;

      // if DD is not included with the build, then
      // drag and drop is not even possible
      if (dd) {
        return !!dd.node;
      }
      return false;
    },
    _addId: function(node, id) {
      if (!id) {
        return;
      }
      // do we need this warning?
      // if (this.ids[id]) {
      //   Konva.Util.warn(
      //     'Duplicate id "' +
      //       id +
      //       '". Please don not use same id several times. It may break find() method look up.'
      //   );
      // }
      this.ids[id] = node;
    },
    _removeId: function(id) {
      if (id !== undefined) {
        delete this.ids[id];
      }
    },
    _addName: function(node, name) {
      if (name) {
        if (!this.names[name]) {
          this.names[name] = [];
        }
        this.names[name].push(node);
      }
    },
    _removeName: function(name, _id) {
      if (!name) {
        return;
      }
      var nodes = this.names[name];
      if (!nodes) {
        return;
      }
      for (var n = 0; n < nodes.length; n++) {
        var no = nodes[n];
        if (no._id === _id) {
          nodes.splice(n, 1);
        }
      }
      if (nodes.length === 0) {
        delete this.names[name];
      }
    },
    getAngle: function(angle) {
      return this.angleDeg ? angle * PI_OVER_180 : angle;
    },
    _detectIE: function(ua) {
      var msie = ua.indexOf('msie ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    },
    _parseUA: function(userAgent) {
      var ua = userAgent.toLowerCase(),
        // jQuery UA regex
        match =
          /(chrome)[ /]([\w.]+)/.exec(ua) ||
          /(webkit)[ /]([\w.]+)/.exec(ua) ||
          /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
          /(msie) ([\w.]+)/.exec(ua) ||
          (ua.indexOf('compatible') < 0 &&
            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
          [],
        // adding mobile flag as well
        mobile = !!userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
        ),
        ieMobile = !!userAgent.match(/IEMobile/i);

      return {
        browser: match[1] || '',
        version: match[2] || '0',
        isIE: Konva._detectIE(ua),
        // adding mobile flab
        mobile: mobile,
        ieMobile: ieMobile // If this is true (i.e., WP8), then Konva touch events are executed instead of equivalent Konva mouse events
      };
    },
    // user agent
    UA: undefined
  };

  var glob =
    typeof global !== 'undefined'
      ? global
      : typeof window !== 'undefined'
        ? window
        : typeof WorkerGlobalScope !== 'undefined'
          ? self
          : {};

  Konva.UA = Konva._parseUA((glob.navigator && glob.navigator.userAgent) || '');

  if (glob.Konva) {
    console.error(
      'Konva instance is already exist in current eviroment. ' +
        'Please use only one instance.'
    );
  }
  glob.Konva = Konva;
  Konva.global = glob;
  Konva.window = glob;
  Konva.document = glob.document;

  if (true) {
    module.exports = Konva;
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(function() {
      return Konva;
    });
  }
})();

/*eslint-disable  eqeqeq, no-cond-assign, no-empty*/
(function() {
  'use strict';
  /**
   * Collection constructor.  Collection extends
   *  Array.  This class is used in conjunction with {@link Konva.Container#get}
   * @constructor
   * @memberof Konva
   */
  Konva.Collection = function() {
    var args = [].slice.call(arguments),
      length = args.length,
      i = 0;

    this.length = length;
    for (; i < length; i++) {
      this[i] = args[i];
    }
    return this;
  };
  Konva.Collection.prototype = [];
  /**
   * iterate through node array and run a function for each node.
   *  The node and index is passed into the function
   * @method
   * @memberof Konva.Collection.prototype
   * @param {Function} func
   * @example
   * // get all nodes with name foo inside layer, and set x to 10 for each
   * layer.get('.foo').each(function(shape, n) {
   *   shape.setX(10);
   * });
   */
  Konva.Collection.prototype.each = function(func) {
    for (var n = 0; n < this.length; n++) {
      func(this[n], n);
    }
  };
  /**
   * convert collection into an array
   * @method
   * @memberof Konva.Collection.prototype
   */
  Konva.Collection.prototype.toArray = function() {
    var arr = [],
      len = this.length,
      n;

    for (n = 0; n < len; n++) {
      arr.push(this[n]);
    }
    return arr;
  };
  /**
   * convert array into a collection
   * @method
   * @memberof Konva.Collection
   * @param {Array} arr
   */
  Konva.Collection.toCollection = function(arr) {
    var collection = new Konva.Collection(),
      len = arr.length,
      n;

    for (n = 0; n < len; n++) {
      collection.push(arr[n]);
    }
    return collection;
  };

  // map one method by it's name
  Konva.Collection._mapMethod = function(methodName) {
    Konva.Collection.prototype[methodName] = function() {
      var len = this.length,
        i;

      var args = [].slice.call(arguments);
      for (i = 0; i < len; i++) {
        this[i][methodName].apply(this[i], args);
      }

      return this;
    };
  };

  Konva.Collection.mapMethods = function(constructor) {
    var prot = constructor.prototype;
    for (var methodName in prot) {
      Konva.Collection._mapMethod(methodName);
    }
  };

  /*
    * Last updated November 2011
    * By Simon Sarris
    * www.simonsarris.com
    * sarris@acm.org
    *
    * Free to use and distribute at will
    * So long as you are nice to people, etc
    */

  /*
    * The usage of this class was inspired by some of the work done by a forked
    * project, KineticJS-Ext by Wappworks, which is based on Simon's Transform
    * class.  Modified by Eric Rowell
    */

  /**
   * Transform constructor. Transform object is a private class of Konva framework.
   * In most of the cases you don't need to use it in your app.
   * But there is a documentation for that class in case you still want
   * to make some manual calculations.
   * @constructor
   * @param {Array} [m] Optional six-element matrix
   * @memberof Konva
   */
  Konva.Transform = function(m) {
    this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
  };

  Konva.Transform.prototype = {
    /**
     * Copy Konva.Transform object
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     */
    copy: function() {
      return new Konva.Transform(this.m);
    },
    /**
     * Transform point
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Object} point 2D point(x, y)
     * @returns {Object} 2D point(x, y)
     */
    point: function(point) {
      var m = this.m;
      return {
        x: m[0] * point.x + m[2] * point.y + m[4],
        y: m[1] * point.x + m[3] * point.y + m[5]
      };
    },
    /**
     * Apply translation
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} x
     * @param {Number} y
     * @returns {Konva.Transform}
     */
    translate: function(x, y) {
      this.m[4] += this.m[0] * x + this.m[2] * y;
      this.m[5] += this.m[1] * x + this.m[3] * y;
      return this;
    },
    /**
     * Apply scale
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */
    scale: function(sx, sy) {
      this.m[0] *= sx;
      this.m[1] *= sx;
      this.m[2] *= sy;
      this.m[3] *= sy;
      return this;
    },
    /**
     * Apply rotation
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} rad  Angle in radians
     * @returns {Konva.Transform}
     */
    rotate: function(rad) {
      var c = Math.cos(rad);
      var s = Math.sin(rad);
      var m11 = this.m[0] * c + this.m[2] * s;
      var m12 = this.m[1] * c + this.m[3] * s;
      var m21 = this.m[0] * -s + this.m[2] * c;
      var m22 = this.m[1] * -s + this.m[3] * c;
      this.m[0] = m11;
      this.m[1] = m12;
      this.m[2] = m21;
      this.m[3] = m22;
      return this;
    },
    /**
     * Returns the translation
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Object} 2D point(x, y)
     */
    getTranslation: function() {
      return {
        x: this.m[4],
        y: this.m[5]
      };
    },
    /**
     * Apply skew
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */
    skew: function(sx, sy) {
      var m11 = this.m[0] + this.m[2] * sy;
      var m12 = this.m[1] + this.m[3] * sy;
      var m21 = this.m[2] + this.m[0] * sx;
      var m22 = this.m[3] + this.m[1] * sx;
      this.m[0] = m11;
      this.m[1] = m12;
      this.m[2] = m21;
      this.m[3] = m22;
      return this;
    },
    /**
     * Transform multiplication
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Konva.Transform} matrix
     * @returns {Konva.Transform}
     */
    multiply: function(matrix) {
      var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
      var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];

      var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
      var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];

      var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
      var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];

      this.m[0] = m11;
      this.m[1] = m12;
      this.m[2] = m21;
      this.m[3] = m22;
      this.m[4] = dx;
      this.m[5] = dy;
      return this;
    },
    /**
     * Invert the matrix
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     */
    invert: function() {
      var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
      var m0 = this.m[3] * d;
      var m1 = -this.m[1] * d;
      var m2 = -this.m[2] * d;
      var m3 = this.m[0] * d;
      var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
      var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
      this.m[0] = m0;
      this.m[1] = m1;
      this.m[2] = m2;
      this.m[3] = m3;
      this.m[4] = m4;
      this.m[5] = m5;
      return this;
    },
    /**
     * return matrix
     * @method
     * @memberof Konva.Transform.prototype
     */
    getMatrix: function() {
      return this.m;
    },
    /**
     * set to absolute position via translation
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     * @author ericdrowell
     */
    setAbsolutePosition: function(x, y) {
      var m0 = this.m[0],
        m1 = this.m[1],
        m2 = this.m[2],
        m3 = this.m[3],
        m4 = this.m[4],
        m5 = this.m[5],
        yt = (m0 * (y - m5) - m1 * (x - m4)) / (m0 * m3 - m1 * m2),
        xt = (x - m4 - m2 * yt) / m0;

      return this.translate(xt, yt);
    }
  };

  // CONSTANTS
  var CONTEXT_2D = '2d',
    OBJECT_ARRAY = '[object Array]',
    OBJECT_NUMBER = '[object Number]',
    OBJECT_STRING = '[object String]',
    OBJECT_BOOLEAN = '[object Boolean]',
    PI_OVER_DEG180 = Math.PI / 180,
    DEG180_OVER_PI = 180 / Math.PI,
    HASH = '#',
    EMPTY_STRING = '',
    ZERO = '0',
    KONVA_WARNING = 'Konva warning: ',
    KONVA_ERROR = 'Konva error: ',
    RGB_PAREN = 'rgb(',
    COLORS = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    },
    RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;

  /**
   * @namespace Util
   * @memberof Konva
   */
  Konva.Util = {
    /*
    * cherry-picked utilities from underscore.js
    */
    _isElement: function(obj) {
      return !!(obj && obj.nodeType == 1);
    },
    _isFunction: function(obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isObject: function(obj) {
      return !!obj && obj.constructor === Object;
    },
    _isArray: function(obj) {
      return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
    },
    _isNumber: function(obj) {
      return (
        Object.prototype.toString.call(obj) === OBJECT_NUMBER &&
        !isNaN(obj) &&
        isFinite(obj)
      );
    },
    _isString: function(obj) {
      return Object.prototype.toString.call(obj) === OBJECT_STRING;
    },
    _isBoolean: function(obj) {
      return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
    },
    // arrays are objects too
    isObject: function(val) {
      return val instanceof Object;
    },
    isValidSelector: function(selector) {
      if (typeof selector !== 'string') {
        return false;
      }
      var firstChar = selector[0];
      return (
        firstChar === '#' ||
        firstChar === '.' ||
        firstChar === firstChar.toUpperCase()
      );
    },
    _sign: function(number) {
      if (number === 0) {
        return 0;
      }
      if (number > 0) {
        return 1;
      } else {
        return -1;
      }
    },
    createCanvasElement: function() {
      var canvas = Konva.isBrowser
        ? Konva.document.createElement('canvas')
        : new Konva._nodeCanvas();
      // on some environments canvas.style is readonly
      try {
        canvas.style = canvas.style || {};
      } catch (e) {}
      return canvas;
    },
    _isInDocument: function(el) {
      while ((el = el.parentNode)) {
        if (el == Konva.document) {
          return true;
        }
      }
      return false;
    },
    _simplifyArray: function(arr) {
      var retArr = [],
        len = arr.length,
        util = Konva.Util,
        n,
        val;

      for (n = 0; n < len; n++) {
        val = arr[n];
        if (util._isNumber(val)) {
          val = Math.round(val * 1000) / 1000;
        } else if (!util._isString(val)) {
          val = val.toString();
        }

        retArr.push(val);
      }

      return retArr;
    },
    /*
    * arg can be an image object or image data
    */
    _getImage: function(arg, callback) {
      var imageObj, canvas;

      // if arg is null or undefined
      if (!arg) {
        callback(null);
      } else if (this._isElement(arg)) {
        // if arg is already an image object
        callback(arg);
      } else if (this._isString(arg)) {
        // if arg is a string, then it's a data url
        imageObj = new Konva.window.Image();
        imageObj.onload = function() {
          callback(imageObj);
        };
        imageObj.src = arg;
      } else if (arg.data) {
        //if arg is an object that contains the data property, it's an image object
        canvas = Konva.Util.createCanvasElement();
        canvas.width = arg.width;
        canvas.height = arg.height;
        var _context = canvas.getContext(CONTEXT_2D);
        _context.putImageData(arg, 0, 0);
        this._getImage(canvas.toDataURL(), callback);
      } else {
        callback(null);
      }
    },
    _getRGBAString: function(obj) {
      var red = obj.red || 0,
        green = obj.green || 0,
        blue = obj.blue || 0,
        alpha = obj.alpha || 1;

      return ['rgba(', red, ',', green, ',', blue, ',', alpha, ')'].join(
        EMPTY_STRING
      );
    },
    _rgbToHex: function(r, g, b) {
      return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb: function(hex) {
      hex = hex.replace(HASH, EMPTY_STRING);
      var bigint = parseInt(hex, 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255
      };
    },
    /**
     * return random hex color
     * @method
     * @memberof Konva.Util.prototype
     */
    getRandomColor: function() {
      var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
      while (randColor.length < 6) {
        randColor = ZERO + randColor;
      }
      return HASH + randColor;
    },
    /**
     * return value with default fallback
     * @method
     * @memberof Konva.Util.prototype
     */
    get: function(val, def) {
      if (val === undefined) {
        return def;
      } else {
        return val;
      }
    },
    /**
     * get RGB components of a color
     * @method
     * @memberof Konva.Util.prototype
     * @param {String} color
     * @example
     * // each of the following examples return {r:0, g:0, b:255}
     * var rgb = Konva.Util.getRGB('blue');
     * var rgb = Konva.Util.getRGB('#0000ff');
     * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
     */
    getRGB: function(color) {
      var rgb;
      // color string
      if (color in COLORS) {
        rgb = COLORS[color];
        return {
          r: rgb[0],
          g: rgb[1],
          b: rgb[2]
        };
      } else if (color[0] === HASH) {
        // hex
        return this._hexToRgb(color.substring(1));
      } else if (color.substr(0, 4) === RGB_PAREN) {
        // rgb string
        rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
        return {
          r: parseInt(rgb[1], 10),
          g: parseInt(rgb[2], 10),
          b: parseInt(rgb[3], 10)
        };
      } else {
        // default
        return {
          r: 0,
          g: 0,
          b: 0
        };
      }
    },
    // convert any color string to RGBA object
    // from https://github.com/component/color-parser
    colorToRGBA: function(str) {
      str = str || 'black';
      return (
        Konva.Util._namedColorToRBA(str) ||
        Konva.Util._hex3ColorToRGBA(str) ||
        Konva.Util._hex6ColorToRGBA(str) ||
        Konva.Util._rgbColorToRGBA(str) ||
        Konva.Util._rgbaColorToRGBA(str)
      );
    },
    // Parse named css color. Like "green"
    _namedColorToRBA: function(str) {
      var c = COLORS[str.toLowerCase()];
      if (!c) {
        return null;
      }
      return {
        r: c[0],
        g: c[1],
        b: c[2],
        a: 1
      };
    },
    // Parse rgb(n, n, n)
    _rgbColorToRGBA: function(str) {
      if (str.indexOf('rgb(') === 0) {
        str = str.match(/rgb\(([^)]+)\)/)[1];
        var parts = str.split(/ *, */).map(Number);
        return {
          r: parts[0],
          g: parts[1],
          b: parts[2],
          a: 1
        };
      }
    },
    // Parse rgba(n, n, n, n)
    _rgbaColorToRGBA: function(str) {
      if (str.indexOf('rgba(') === 0) {
        str = str.match(/rgba\(([^)]+)\)/)[1];
        var parts = str.split(/ *, */).map(Number);
        return {
          r: parts[0],
          g: parts[1],
          b: parts[2],
          a: parts[3]
        };
      }
    },
    // Parse #nnnnnn
    _hex6ColorToRGBA: function(str) {
      if (str[0] === '#' && str.length === 7) {
        return {
          r: parseInt(str.slice(1, 3), 16),
          g: parseInt(str.slice(3, 5), 16),
          b: parseInt(str.slice(5, 7), 16),
          a: 1
        };
      }
    },
    // Parse #nnn
    _hex3ColorToRGBA: function(str) {
      if (str[0] === '#' && str.length === 4) {
        return {
          r: parseInt(str[1] + str[1], 16),
          g: parseInt(str[2] + str[2], 16),
          b: parseInt(str[3] + str[3], 16),
          a: 1
        };
      }
    },
    // o1 takes precedence over o2
    _merge: function(o1, o2) {
      var retObj = this._clone(o2);
      for (var key in o1) {
        if (this._isObject(o1[key])) {
          retObj[key] = this._merge(o1[key], retObj[key]);
        } else {
          retObj[key] = o1[key];
        }
      }
      return retObj;
    },
    trimRight: function(str) {
      return str.replace(/\s+$/, '');
    },
    trimLeft: function(str) {
      return str.replace(/^\s+/, '');
    },
    /**
     * check intersection of two client rectangles
     * @method
     * @memberof Konva.Util.prototype
     */
    haveIntersection: function(r1, r2) {
      return !(
        r2.x > r1.x + r1.width ||
        r2.x + r2.width < r1.x ||
        r2.y > r1.y + r1.height ||
        r2.y + r2.height < r1.y
      );
    },
    cloneObject: function(obj) {
      var retObj = {};
      for (var key in obj) {
        if (this._isObject(obj[key])) {
          retObj[key] = this.cloneObject(obj[key]);
        } else if (this._isArray(obj[key])) {
          retObj[key] = this.cloneArray(obj[key]);
        } else {
          retObj[key] = obj[key];
        }
      }
      return retObj;
    },
    cloneArray: function(arr) {
      return arr.slice(0);
    },
    _degToRad: function(deg) {
      return deg * PI_OVER_DEG180;
    },
    _radToDeg: function(rad) {
      return rad * DEG180_OVER_PI;
    },
    _capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw: function(str) {
      throw new Error(KONVA_ERROR + str);
    },
    error: function(str) {
      console.error(KONVA_ERROR + str);
    },
    warn: function(str) {
      /*
             * IE9 on Windows7 64bit will throw a JS error
             * if we don't use window.console in the conditional
             */
      if (Konva.global.console && console.warn && Konva.showWarnings) {
        console.warn(KONVA_WARNING + str);
      }
    },
    extend: function(child, parent) {
      function Ctor() {
        this.constructor = child;
      }
      Ctor.prototype = parent.prototype;
      var oldProto = child.prototype;
      child.prototype = new Ctor();
      for (var key in oldProto) {
        if (oldProto.hasOwnProperty(key)) {
          child.prototype[key] = oldProto[key];
        }
      }
      child.__super__ = parent.prototype;
      // create reference to parent
      child.super = parent;
    },
    /**
     * adds methods to a constructor prototype
     * @method
     * @memberof Konva.Util.prototype
     * @param {Function} constructor
     * @param {Object} methods
     */
    addMethods: function(constructor, methods) {
      var key;

      for (key in methods) {
        constructor.prototype[key] = methods[key];
      }
    },
    _getControlPoints: function(x0, y0, x1, y1, x2, y2, t) {
      var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)),
        d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)),
        fa = t * d01 / (d01 + d12),
        fb = t * d12 / (d01 + d12),
        p1x = x1 - fa * (x2 - x0),
        p1y = y1 - fa * (y2 - y0),
        p2x = x1 + fb * (x2 - x0),
        p2y = y1 + fb * (y2 - y0);

      return [p1x, p1y, p2x, p2y];
    },
    _expandPoints: function(p, tension) {
      var len = p.length,
        allPoints = [],
        n,
        cp;

      for (n = 2; n < len - 2; n += 2) {
        cp = Konva.Util._getControlPoints(
          p[n - 2],
          p[n - 1],
          p[n],
          p[n + 1],
          p[n + 2],
          p[n + 3],
          tension
        );
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
      }

      return allPoints;
    },
    _removeLastLetter: function(str) {
      return str.substring(0, str.length - 1);
    },
    each: function(obj, func) {
      for (var key in obj) {
        func(key, obj[key]);
      }
    },
    _inRange: function(val, left, right) {
      return left <= val && val < right;
    },
    _getProjectionToSegment: function(x1, y1, x2, y2, x3, y3) {
      var x, y, dist;

      var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
      if (pd2 == 0) {
        x = x1;
        y = y1;
        dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
      } else {
        var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
        if (u < 0) {
          x = x1;
          y = y1;
          dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
        } else if (u > 1.0) {
          x = x2;
          y = y2;
          dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
        } else {
          x = x1 + u * (x2 - x1);
          y = y1 + u * (y2 - y1);
          dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
        }
      }
      return [x, y, dist];
    },
    // line as array of points.
    // line might be closed
    _getProjectionToLine: function(pt, line, isClosed) {
      var pc = Konva.Util.cloneObject(pt);
      var dist = Number.MAX_VALUE;
      line.forEach(function(p1, i) {
        if (!isClosed && i === line.length - 1) {
          return;
        }
        var p2 = line[(i + 1) % line.length];
        var proj = Konva.Util._getProjectionToSegment(
          p1.x,
          p1.y,
          p2.x,
          p2.y,
          pt.x,
          pt.y
        );
        var px = proj[0],
          py = proj[1],
          pdist = proj[2];
        if (pdist < dist) {
          pc.x = px;
          pc.y = py;
          dist = pdist;
        }
      });
      return pc;
    },
    _prepareArrayForTween: function(startArray, endArray, isClosed) {
      var n,
        start = [],
        end = [];
      if (startArray.length > endArray.length) {
        var temp = endArray;
        endArray = startArray;
        startArray = temp;
      }
      for (n = 0; n < startArray.length; n += 2) {
        start.push({
          x: startArray[n],
          y: startArray[n + 1]
        });
      }
      for (n = 0; n < endArray.length; n += 2) {
        end.push({
          x: endArray[n],
          y: endArray[n + 1]
        });
      }

      var newStart = [];
      end.forEach(function(point) {
        var pr = Konva.Util._getProjectionToLine(point, start, isClosed);
        newStart.push(pr.x);
        newStart.push(pr.y);
      });
      return newStart;
    },
    _prepareToStringify: function(obj) {
      var desc;

      obj.visitedByCircularReferenceRemoval = true;

      for (var key in obj) {
        if (
          !(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')
        ) {
          continue;
        }
        desc = Object.getOwnPropertyDescriptor(obj, key);
        if (
          obj[key].visitedByCircularReferenceRemoval ||
          Konva.Util._isElement(obj[key])
        ) {
          if (desc.configurable) {
            delete obj[key];
          } else {
            return null;
          }
        } else if (Konva.Util._prepareToStringify(obj[key]) === null) {
          if (desc.configurable) {
            delete obj[key];
          } else {
            return null;
          }
        }
      }

      delete obj.visitedByCircularReferenceRemoval;

      return obj;
    }
  };
})();

(function() {
  'use strict';
  // calculate pixel ratio

  var _pixelRatio;
  function getDevicePixelRatio() {
    if (_pixelRatio) {
      return _pixelRatio;
    }
    var canvas = Konva.Util.createCanvasElement();
    var context = canvas.getContext('2d');
    _pixelRatio = (function() {
      var devicePixelRatio = Konva.window.devicePixelRatio || 1,
        backingStoreRatio =
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          1;
      return devicePixelRatio / backingStoreRatio;
    })();
    return _pixelRatio;
  }

  /**
   * Canvas Renderer constructor
   * @constructor
   * @abstract
   * @memberof Konva
   * @param {Object} config
   * @param {Number} config.width
   * @param {Number} config.height
   * @param {Number} config.pixelRatio KonvaJS automatically handles pixel ratio adjustments in order to render crisp drawings
   *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
   *  of 1.  Some high end tablets and phones, like iPhones and iPads (not the mini) have a device pixel ratio
   *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
   *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
   *  specified, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
   *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
   */
  Konva.Canvas = function(config) {
    this.init(config);
  };

  Konva.Canvas.prototype = {
    init: function(config) {
      var conf = config || {};

      var pixelRatio =
        conf.pixelRatio || Konva.pixelRatio || getDevicePixelRatio();

      this.pixelRatio = pixelRatio;
      this._canvas = Konva.Util.createCanvasElement();

      // set inline styles
      this._canvas.style.padding = 0;
      this._canvas.style.margin = 0;
      this._canvas.style.border = 0;
      this._canvas.style.background = 'transparent';
      this._canvas.style.position = 'absolute';
      this._canvas.style.top = 0;
      this._canvas.style.left = 0;
    },
    /**
     * get canvas context
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {CanvasContext} context
     */
    getContext: function() {
      return this.context;
    },
    /**
     * get pixel ratio
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} pixel ratio
     */
    getPixelRatio: function() {
      return this.pixelRatio;
    },
    /**
     * get pixel ratio
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} pixelRatio KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
     *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
     *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
     *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
     *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
     *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
     *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
     */
    setPixelRatio: function(pixelRatio) {
      var previousRatio = this.pixelRatio;
      this.pixelRatio = pixelRatio;
      this.setSize(
        this.getWidth() / previousRatio,
        this.getHeight() / previousRatio
      );
    },
    /**
     * set width
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} width
     */
    setWidth: function(width) {
      // take into account pixel ratio
      this.width = this._canvas.width = width * this.pixelRatio;
      this._canvas.style.width = width + 'px';

      var pixelRatio = this.pixelRatio,
        _context = this.getContext()._context;
      _context.scale(pixelRatio, pixelRatio);
    },
    /**
     * set height
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} height
     */
    setHeight: function(height) {
      // take into account pixel ratio
      this.height = this._canvas.height = height * this.pixelRatio;
      this._canvas.style.height = height + 'px';
      var pixelRatio = this.pixelRatio,
        _context = this.getContext()._context;
      _context.scale(pixelRatio, pixelRatio);
    },
    /**
     * get width
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} width
     */
    getWidth: function() {
      return this.width;
    },
    /**
     * get height
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} height
     */
    getHeight: function() {
      return this.height;
    },
    /**
     * set size
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} width
     * @param {Number} height
     */
    setSize: function(width, height) {
      this.setWidth(width);
      this.setHeight(height);
    },
    /**
     * to data url
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {String} mimeType
     * @param {Number} quality between 0 and 1 for jpg mime types
     * @returns {String} data url string
     */
    toDataURL: function(mimeType, quality) {
      try {
        // If this call fails (due to browser bug, like in Firefox 3.6),
        // then revert to previous no-parameter image/png behavior
        return this._canvas.toDataURL(mimeType, quality);
      } catch (e) {
        try {
          return this._canvas.toDataURL();
        } catch (err) {
          Konva.Util.warn('Unable to get data URL. ' + err.message);
          return '';
        }
      }
    }
  };

  Konva.SceneCanvas = function(config) {
    var conf = config || {};
    var width = conf.width || 0,
      height = conf.height || 0;

    Konva.Canvas.call(this, conf);
    this.context = new Konva.SceneContext(this);
    this.setSize(width, height);
  };

  Konva.Util.extend(Konva.SceneCanvas, Konva.Canvas);

  Konva.HitCanvas = function(config) {
    var conf = config || {};
    var width = conf.width || 0,
      height = conf.height || 0;

    Konva.Canvas.call(this, conf);
    this.context = new Konva.HitContext(this);
    this.setSize(width, height);
    this.hitCanvas = true;
  };
  Konva.Util.extend(Konva.HitCanvas, Konva.Canvas);
})();

(function() {
  'use strict';
  var COMMA = ',',
    OPEN_PAREN = '(',
    CLOSE_PAREN = ')',
    OPEN_PAREN_BRACKET = '([',
    CLOSE_BRACKET_PAREN = '])',
    SEMICOLON = ';',
    DOUBLE_PAREN = '()',
    // EMPTY_STRING = '',
    EQUALS = '=',
    // SET = 'set',
    CONTEXT_METHODS = [
      'arc',
      'arcTo',
      'beginPath',
      'bezierCurveTo',
      'clearRect',
      'clip',
      'closePath',
      'createLinearGradient',
      'createPattern',
      'createRadialGradient',
      'drawImage',
      'fill',
      'fillText',
      'getImageData',
      'createImageData',
      'lineTo',
      'moveTo',
      'putImageData',
      'quadraticCurveTo',
      'rect',
      'restore',
      'rotate',
      'save',
      'scale',
      'setLineDash',
      'setTransform',
      'stroke',
      'strokeText',
      'transform',
      'translate'
    ];

  var CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation'
  ];

  /**
   * Canvas Context constructor
   * @constructor
   * @abstract
   * @memberof Konva
   */
  Konva.Context = function(canvas) {
    this.init(canvas);
  };

  Konva.Context.prototype = {
    init: function(canvas) {
      this.canvas = canvas;
      this._context = canvas._canvas.getContext('2d');

      if (Konva.enableTrace) {
        this.traceArr = [];
        this._enableTrace();
      }
    },
    /**
     * fill shape
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */
    fillShape: function(shape) {
      if (shape.getFillEnabled()) {
        this._fill(shape);
      }
    },
    /**
     * stroke shape
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */
    strokeShape: function(shape) {
      if (shape.getStrokeEnabled()) {
        this._stroke(shape);
      }
    },
    /**
     * fill then stroke
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */
    fillStrokeShape: function(shape) {
      var fillEnabled = shape.getFillEnabled();
      if (fillEnabled) {
        this._fill(shape);
      }
      if (shape.getStrokeEnabled()) {
        this._stroke(shape);
      }
    },
    /**
     * get context trace if trace is enabled
     * @method
     * @memberof Konva.Context.prototype
     * @param {Boolean} relaxed if false, return strict context trace, which includes method names, method parameters
     *  properties, and property values.  If true, return relaxed context trace, which only returns method names and
     *  properites.
     * @returns {String}
     */
    getTrace: function(relaxed) {
      var traceArr = this.traceArr,
        len = traceArr.length,
        str = '',
        n,
        trace,
        method,
        args;

      for (n = 0; n < len; n++) {
        trace = traceArr[n];
        method = trace.method;

        // methods
        if (method) {
          args = trace.args;
          str += method;
          if (relaxed) {
            str += DOUBLE_PAREN;
          } else {
            if (Konva.Util._isArray(args[0])) {
              str +=
                OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
            } else {
              str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
            }
          }
        } else {
          // properties
          str += trace.property;
          if (!relaxed) {
            str += EQUALS + trace.val;
          }
        }

        str += SEMICOLON;
      }

      return str;
    },
    /**
     * clear trace if trace is enabled
     * @method
     * @memberof Konva.Context.prototype
     */
    clearTrace: function() {
      this.traceArr = [];
    },
    _trace: function(str) {
      var traceArr = this.traceArr,
        len;

      traceArr.push(str);
      len = traceArr.length;

      if (len >= Konva.traceArrMax) {
        traceArr.shift();
      }
    },
    /**
     * reset canvas context transform
     * @method
     * @memberof Konva.Context.prototype
     */
    reset: function() {
      var pixelRatio = this.getCanvas().getPixelRatio();
      this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    },
    /**
     * get canvas
     * @method
     * @memberof Konva.Context.prototype
     * @returns {Konva.Canvas}
     */
    getCanvas: function() {
      return this.canvas;
    },
    /**
     * clear canvas
     * @method
     * @memberof Konva.Context.prototype
     * @param {Object} [bounds]
     * @param {Number} [bounds.x]
     * @param {Number} [bounds.y]
     * @param {Number} [bounds.width]
     * @param {Number} [bounds.height]
     */
    clear: function(bounds) {
      var canvas = this.getCanvas();

      if (bounds) {
        this.clearRect(
          bounds.x || 0,
          bounds.y || 0,
          bounds.width || 0,
          bounds.height || 0
        );
      } else {
        this.clearRect(
          0,
          0,
          canvas.getWidth() / canvas.pixelRatio,
          canvas.getHeight() / canvas.pixelRatio
        );
      }
    },
    _applyLineCap: function(shape) {
      var lineCap = shape.getLineCap();
      if (lineCap) {
        this.setAttr('lineCap', lineCap);
      }
    },
    _applyOpacity: function(shape) {
      var absOpacity = shape.getAbsoluteOpacity();
      if (absOpacity !== 1) {
        this.setAttr('globalAlpha', absOpacity);
      }
    },
    _applyLineJoin: function(shape) {
      var lineJoin = shape.getLineJoin();
      if (lineJoin) {
        this.setAttr('lineJoin', lineJoin);
      }
    },
    setAttr: function(attr, val) {
      this._context[attr] = val;
    },

    // context pass through methods
    arc: function() {
      var a = arguments;
      this._context.arc(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    beginPath: function() {
      this._context.beginPath();
    },
    bezierCurveTo: function() {
      var a = arguments;
      this._context.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    clearRect: function() {
      var a = arguments;
      this._context.clearRect(a[0], a[1], a[2], a[3]);
    },
    clip: function() {
      this._context.clip();
    },
    closePath: function() {
      this._context.closePath();
    },
    createImageData: function() {
      var a = arguments;
      if (a.length === 2) {
        return this._context.createImageData(a[0], a[1]);
      } else if (a.length === 1) {
        return this._context.createImageData(a[0]);
      }
    },
    createLinearGradient: function() {
      var a = arguments;
      return this._context.createLinearGradient(a[0], a[1], a[2], a[3]);
    },
    createPattern: function() {
      var a = arguments;
      return this._context.createPattern(a[0], a[1]);
    },
    createRadialGradient: function() {
      var a = arguments;
      return this._context.createRadialGradient(
        a[0],
        a[1],
        a[2],
        a[3],
        a[4],
        a[5]
      );
    },
    drawImage: function() {
      var a = arguments,
        _context = this._context;

      if (a.length === 3) {
        _context.drawImage(a[0], a[1], a[2]);
      } else if (a.length === 5) {
        _context.drawImage(a[0], a[1], a[2], a[3], a[4]);
      } else if (a.length === 9) {
        _context.drawImage(
          a[0],
          a[1],
          a[2],
          a[3],
          a[4],
          a[5],
          a[6],
          a[7],
          a[8]
        );
      }
    },
    isPointInPath: function(x, y) {
      return this._context.isPointInPath(x, y);
    },
    fill: function() {
      this._context.fill();
    },
    fillRect: function(x, y, width, height) {
      this._context.fillRect(x, y, width, height);
    },
    strokeRect: function(x, y, width, height) {
      this._context.strokeRect(x, y, width, height);
    },
    fillText: function() {
      var a = arguments;
      this._context.fillText(a[0], a[1], a[2]);
    },
    measureText: function(text) {
      return this._context.measureText(text);
    },
    getImageData: function() {
      var a = arguments;
      return this._context.getImageData(a[0], a[1], a[2], a[3]);
    },
    lineTo: function() {
      var a = arguments;
      this._context.lineTo(a[0], a[1]);
    },
    moveTo: function() {
      var a = arguments;
      this._context.moveTo(a[0], a[1]);
    },
    rect: function() {
      var a = arguments;
      this._context.rect(a[0], a[1], a[2], a[3]);
    },
    putImageData: function() {
      var a = arguments;
      this._context.putImageData(a[0], a[1], a[2]);
    },
    quadraticCurveTo: function() {
      var a = arguments;
      this._context.quadraticCurveTo(a[0], a[1], a[2], a[3]);
    },
    restore: function() {
      this._context.restore();
    },
    rotate: function() {
      var a = arguments;
      this._context.rotate(a[0]);
    },
    save: function() {
      this._context.save();
    },
    scale: function() {
      var a = arguments;
      this._context.scale(a[0], a[1]);
    },
    setLineDash: function() {
      var a = arguments,
        _context = this._context;

      // works for Chrome and IE11
      if (this._context.setLineDash) {
        _context.setLineDash(a[0]);
      } else if ('mozDash' in _context) {
        // verified that this works in firefox
        _context.mozDash = a[0];
      } else if ('webkitLineDash' in _context) {
        // does not currently work for Safari
        _context.webkitLineDash = a[0];
      }

      // no support for IE9 and IE10
    },
    getLineDash: function() {
      return this._context.getLineDash();
    },
    setTransform: function() {
      var a = arguments;
      this._context.setTransform(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    stroke: function() {
      this._context.stroke();
    },
    strokeText: function() {
      var a = arguments;
      this._context.strokeText(a[0], a[1], a[2]);
    },
    transform: function() {
      var a = arguments;
      this._context.transform(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    translate: function() {
      var a = arguments;
      this._context.translate(a[0], a[1]);
    },
    _enableTrace: function() {
      var that = this,
        len = CONTEXT_METHODS.length,
        _simplifyArray = Konva.Util._simplifyArray,
        origSetter = this.setAttr,
        n,
        args;

      // to prevent creating scope function at each loop
      var func = function(methodName) {
        var origMethod = that[methodName],
          ret;

        that[methodName] = function() {
          args = _simplifyArray(Array.prototype.slice.call(arguments, 0));
          ret = origMethod.apply(that, arguments);

          that._trace({
            method: methodName,
            args: args
          });

          return ret;
        };
      };
      // methods
      for (n = 0; n < len; n++) {
        func(CONTEXT_METHODS[n]);
      }

      // attrs
      that.setAttr = function() {
        origSetter.apply(that, arguments);
        var prop = arguments[0];
        var val = arguments[1];
        if (
          prop === 'shadowOffsetX' ||
          prop === 'shadowOffsetY' ||
          prop === 'shadowBlur'
        ) {
          val = val / this.canvas.getPixelRatio();
        }
        that._trace({
          property: prop,
          val: val
        });
      };
    }
  };

  CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty(Konva.Context.prototype, prop, {
      get: function() {
        return this._context[prop];
      },
      set: function(val) {
        this._context[prop] = val;
      }
    });
  });

  Konva.SceneContext = function(canvas) {
    Konva.Context.call(this, canvas);
  };

  Konva.SceneContext.prototype = {
    _fillColor: function(shape) {
      var fill = shape.fill();

      this.setAttr('fillStyle', fill);
      shape._fillFunc(this);
    },
    _fillPattern: function(shape) {
      var fillPatternX = shape.getFillPatternX(),
        fillPatternY = shape.getFillPatternY(),
        fillPatternScale = shape.getFillPatternScale(),
        fillPatternRotation = Konva.getAngle(shape.getFillPatternRotation()),
        fillPatternOffset = shape.getFillPatternOffset();

      if (fillPatternX || fillPatternY) {
        this.translate(fillPatternX || 0, fillPatternY || 0);
      }
      if (fillPatternRotation) {
        this.rotate(fillPatternRotation);
      }
      if (fillPatternScale) {
        this.scale(fillPatternScale.x, fillPatternScale.y);
      }
      if (fillPatternOffset) {
        this.translate(-1 * fillPatternOffset.x, -1 * fillPatternOffset.y);
      }

      this.setAttr(
        'fillStyle',
        this.createPattern(
          shape.getFillPatternImage(),
          shape.getFillPatternRepeat() || 'repeat'
        )
      );
      this.fill();
    },
    _fillLinearGradient: function(shape) {
      var start = shape.getFillLinearGradientStartPoint(),
        end = shape.getFillLinearGradientEndPoint(),
        colorStops = shape.getFillLinearGradientColorStops(),
        grd = this.createLinearGradient(start.x, start.y, end.x, end.y);

      if (colorStops) {
        // build color stops
        for (var n = 0; n < colorStops.length; n += 2) {
          grd.addColorStop(colorStops[n], colorStops[n + 1]);
        }
        this.setAttr('fillStyle', grd);
        shape._fillFunc(this);
      }
    },
    _fillRadialGradient: function(shape) {
      var start = shape.getFillRadialGradientStartPoint(),
        end = shape.getFillRadialGradientEndPoint(),
        startRadius = shape.getFillRadialGradientStartRadius(),
        endRadius = shape.getFillRadialGradientEndRadius(),
        colorStops = shape.getFillRadialGradientColorStops(),
        grd = this.createRadialGradient(
          start.x,
          start.y,
          startRadius,
          end.x,
          end.y,
          endRadius
        );

      // build color stops
      for (var n = 0; n < colorStops.length; n += 2) {
        grd.addColorStop(colorStops[n], colorStops[n + 1]);
      }
      this.setAttr('fillStyle', grd);
      this.fill();
    },
    _fill: function(shape) {
      var hasColor = shape.fill(),
        fillPriority = shape.getFillPriority();

      // priority fills
      if (hasColor && fillPriority === 'color') {
        this._fillColor(shape);
        return;
      }

      var hasPattern = shape.getFillPatternImage();
      if (hasPattern && fillPriority === 'pattern') {
        this._fillPattern(shape);
        return;
      }

      var hasLinearGradient = shape.getFillLinearGradientColorStops();
      if (hasLinearGradient && fillPriority === 'linear-gradient') {
        this._fillLinearGradient(shape);
        return;
      }

      var hasRadialGradient = shape.getFillRadialGradientColorStops();
      if (hasRadialGradient && fillPriority === 'radial-gradient') {
        this._fillRadialGradient(shape);
        return;
      }

      // now just try and fill with whatever is available
      if (hasColor) {
        this._fillColor(shape);
      } else if (hasPattern) {
        this._fillPattern(shape);
      } else if (hasLinearGradient) {
        this._fillLinearGradient(shape);
      } else if (hasRadialGradient) {
        this._fillRadialGradient(shape);
      }
    },
    _strokeLinearGradient: function(shape) {
      var start = shape.getStrokeLinearGradientStartPoint(),
        end = shape.getStrokeLinearGradientEndPoint(),
        colorStops = shape.getStrokeLinearGradientColorStops(),
        grd = this.createLinearGradient(start.x, start.y, end.x, end.y);

      if (colorStops) {
        // build color stops
        for (var n = 0; n < colorStops.length; n += 2) {
          grd.addColorStop(colorStops[n], colorStops[n + 1]);
        }
        this.setAttr('strokeStyle', grd);
      }
    },
    _stroke: function(shape) {
      var dash = shape.dash(),
        // ignore strokeScaleEnabled for Text
        strokeScaleEnabled =
          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;

      if (shape.hasStroke()) {
        if (!strokeScaleEnabled) {
          this.save();
          var pixelRatio = this.getCanvas().getPixelRatio();
          this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        }

        this._applyLineCap(shape);
        if (dash && shape.dashEnabled()) {
          this.setLineDash(dash);
          this.setAttr('lineDashOffset', shape.dashOffset());
        }

        this.setAttr('lineWidth', shape.strokeWidth());

        if (!shape.getShadowForStrokeEnabled()) {
          this.setAttr('shadowColor', 'rgba(0,0,0,0)');
        }

        // TODO - do we need to make like a fill function?

        var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
        if (hasLinearGradient) {
          this._strokeLinearGradient(shape);
        } else {
          this.setAttr('strokeStyle', shape.stroke());
        }

        shape._strokeFunc(this);

        if (!strokeScaleEnabled) {
          this.restore();
        }
      }
    },
    _applyShadow: function(shape) {
      var util = Konva.Util,
        color = util.get(shape.getShadowRGBA(), 'black'),
        blur = util.get(shape.getShadowBlur(), 5),
        offset = util.get(shape.getShadowOffset(), {
          x: 0,
          y: 0
        }),
        scale = shape.getAbsoluteScale(),
        ratio = this.canvas.getPixelRatio(),
        scaleX = scale.x * ratio,
        scaleY = scale.y * ratio;

      this.setAttr('shadowColor', color);
      this.setAttr(
        'shadowBlur',
        blur * Math.min(Math.abs(scaleX), Math.abs(scaleY))
      );
      this.setAttr('shadowOffsetX', offset.x * scaleX);
      this.setAttr('shadowOffsetY', offset.y * scaleY);
    },
    _applyGlobalCompositeOperation: function(shape) {
      var globalCompositeOperation = shape.getGlobalCompositeOperation();
      if (globalCompositeOperation !== 'source-over') {
        this.setAttr('globalCompositeOperation', globalCompositeOperation);
      }
    }
  };
  Konva.Util.extend(Konva.SceneContext, Konva.Context);

  Konva.HitContext = function(canvas) {
    Konva.Context.call(this, canvas);
  };

  Konva.HitContext.prototype = {
    _fill: function(shape) {
      this.save();
      this.setAttr('fillStyle', shape.colorKey);
      shape._fillFuncHit(this);
      this.restore();
    },
    _stroke: function(shape) {
      if (shape.hasStroke() && shape.strokeHitEnabled()) {
        // ignore strokeScaleEnabled for Text
        var strokeScaleEnabled =
          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;
        if (!strokeScaleEnabled) {
          this.save();
          this.setTransform(1, 0, 0, 1, 0, 0);
        }
        this._applyLineCap(shape);
        this.setAttr('lineWidth', shape.strokeWidth());
        this.setAttr('strokeStyle', shape.colorKey);
        shape._strokeFuncHit(this);
        if (!strokeScaleEnabled) {
          this.restore();
        }
      }
    }
  };
  Konva.Util.extend(Konva.HitContext, Konva.Context);
})();

(function() {
  'use strict';
  // CONSTANTS
  var GET = 'get',
    SET = 'set';

  Konva.Factory = {
    addGetterSetter: function(constructor, attr, def, validator, after) {
      this.addGetter(constructor, attr, def);
      this.addSetter(constructor, attr, validator, after);
      this.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter: function(constructor, attr, def) {
      var method = GET + Konva.Util._capitalize(attr);

      constructor.prototype[method] = function() {
        var val = this.attrs[attr];
        return val === undefined ? def : val;
      };
    },
    addSetter: function(constructor, attr, validator, after) {
      // if (!validator && validator !== null) {
      //   console.error(constructor, attr, 'has no validator.');
      // }
      var method = SET + Konva.Util._capitalize(attr);

      constructor.prototype[method] = function(val) {
        if (validator && val !== undefined && val !== null) {
          val = validator.call(this, val, attr);
        }

        this._setAttr(attr, val);

        if (after) {
          after.call(this);
        }

        return this;
      };
    },
    addComponentsGetterSetter: function(
      constructor,
      attr,
      components,
      validator,
      after
    ) {
      var len = components.length,
        capitalize = Konva.Util._capitalize,
        getter = GET + capitalize(attr),
        setter = SET + capitalize(attr),
        n,
        component;

      // getter
      constructor.prototype[getter] = function() {
        var ret = {};

        for (n = 0; n < len; n++) {
          component = components[n];
          ret[component] = this.getAttr(attr + capitalize(component));
        }

        return ret;
      };

      // setter
      constructor.prototype[setter] = function(val) {
        var oldVal = this.attrs[attr],
          key;

        if (validator) {
          val = validator.call(this, val);
        }

        for (key in val) {
          if (!val.hasOwnProperty(key)) {
            continue;
          }
          this._setAttr(attr + capitalize(key), val[key]);
        }

        this._fireChangeEvent(attr, oldVal, val);

        if (after) {
          after.call(this);
        }

        return this;
      };

      this.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter: function(constructor, attr) {
      var capitalizedAttr = Konva.Util._capitalize(attr),
        setter = SET + capitalizedAttr,
        getter = GET + capitalizedAttr;

      constructor.prototype[attr] = function() {
        // setting
        if (arguments.length) {
          this[setter](arguments[0]);
          return this;
        }
        // getting
        return this[getter]();
      };
    },
    addDeprecatedGetterSetter: function(constructor, attr, def, validator) {
      Konva.Util.error('Adding deprecated ' + attr);

      var method = GET + Konva.Util._capitalize(attr);

      var message =
        attr +
        ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
      constructor.prototype[method] = function() {
        Konva.Util.error(message);
        var val = this.attrs[attr];
        return val === undefined ? def : val;
      };
      this.addSetter(constructor, attr, validator, function() {
        Konva.Util.error(message);
      });
      this.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat: function(constructor, methods) {
      Konva.Util.each(methods, function(oldMethodName, newMethodName) {
        var method = constructor.prototype[newMethodName];
        var oldGetter = GET + Konva.Util._capitalize(oldMethodName);
        var oldSetter = SET + Konva.Util._capitalize(oldMethodName);

        function deprecated() {
          method.apply(this, arguments);
          Konva.Util.error(
            '"' +
              oldMethodName +
              '" method is deprecated and will be removed soon. Use ""' +
              newMethodName +
              '" instead.'
          );
        }

        constructor.prototype[oldMethodName] = deprecated;
        constructor.prototype[oldGetter] = deprecated;
        constructor.prototype[oldSetter] = deprecated;
      });
    },
    afterSetFilter: function() {
      this._filterUpToDate = false;
    }
  };

  Konva.Validators = {
    /**
     * @return {number}
     */
    RGBComponent: function(val) {
      if (val > 255) {
        return 255;
      } else if (val < 0) {
        return 0;
      }
      return Math.round(val);
    },
    alphaComponent: function(val) {
      if (val > 1) {
        return 1;
      } else if (val < 0.0001) {
        // chrome does not honor alpha values of 0
        return 0.0001;
      }

      return val;
    },
    _formatValue: function(val) {
      if (Konva.Util._isString(val)) {
        return '"' + val + '"';
      }
      if (Object.prototype.toString.call(val) === '[object Number]') {
        return val;
      }
      if (Konva.Util._isBoolean(val)) {
        return val;
      }
      return Object.prototype.toString.call(val);
    },
    getNumberValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          if (!Konva.Util._isNumber(val)) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a number.'
            );
          }
          return val;
        };
      }
    },
    getNumberOrAutoValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          var isNumber = Konva.Util._isNumber(val);
          var isAuto = val === 'auto';

          if (!(isNumber || isAuto)) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a number or "auto".'
            );
          }
          return val;
        };
      }
    },
    getStringValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          if (!Konva.Util._isString(val)) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a string.'
            );
          }
          return val;
        };
      }
    },
    getFunctionValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          if (!Konva.Util._isFunction(val)) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a function.'
            );
          }
          return val;
        };
      }
    },
    getNumberArrayValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          if (!Konva.Util._isArray(val)) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a array of numbers.'
            );
          } else {
            val.forEach(function(item) {
              if (!Konva.Util._isNumber(item)) {
                Konva.Util.warn(
                  '"' +
                    attr +
                    '" attribute has non numeric element ' +
                    item +
                    '. Make sure that all elements are numbers.'
                );
              }
            });
          }
          return val;
        };
      }
    },
    getBooleanValidator: function() {
      if (Konva.isUnminified) {
        return function(val, attr) {
          var isBool = val === true || val === false;
          if (!isBool) {
            Konva.Util.warn(
              Konva.Validators._formatValue(val) +
                ' is a not valid value for "' +
                attr +
                '" attribute. The value should be a boolean.'
            );
          }
          return val;
        };
      }
    }
  };
})();

(function(Konva) {
  'use strict';
  // CONSTANTS
  var ABSOLUTE_OPACITY = 'absoluteOpacity',
    ABSOLUTE_TRANSFORM = 'absoluteTransform',
    ABSOLUTE_SCALE = 'absoluteScale',
    CHANGE = 'Change',
    CHILDREN = 'children',
    DOT = '.',
    EMPTY_STRING = '',
    GET = 'get',
    ID = 'id',
    KONVA = 'konva',
    LISTENING = 'listening',
    MOUSEENTER = 'mouseenter',
    MOUSELEAVE = 'mouseleave',
    NAME = 'name',
    SET = 'set',
    SHAPE = 'Shape',
    SPACE = ' ',
    STAGE = 'stage',
    TRANSFORM = 'transform',
    UPPER_STAGE = 'Stage',
    VISIBLE = 'visible',
    CLONE_BLACK_LIST = ['id'],
    TRANSFORM_CHANGE_STR = [
      'xChange.konva',
      'yChange.konva',
      'scaleXChange.konva',
      'scaleYChange.konva',
      'skewXChange.konva',
      'skewYChange.konva',
      'rotationChange.konva',
      'offsetXChange.konva',
      'offsetYChange.konva',
      'transformsEnabledChange.konva'
    ].join(SPACE),
    SCALE_CHANGE_STR = ['scaleXChange.konva', 'scaleYChange.konva'].join(SPACE);

  /**
   * Node constructor. Nodes are entities that can be transformed, layered,
   * and have bound events. The stage, layers, groups, and shapes all extend Node.
   * @constructor
   * @memberof Konva
   * @abstract
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   */
  Konva.Node = function(config) {
    this._init(config);
  };

  Konva.Util.addMethods(Konva.Node, {
    _init: function(config) {
      this._id = Konva.idCounter++;
      this.eventListeners = {};
      this.attrs = {};
      this._cache = {};
      this._filterUpToDate = false;
      this._isUnderCache = false;
      this.setAttrs(config);

      // event bindings for cache handling
      this.on(TRANSFORM_CHANGE_STR, function() {
        this._clearCache(TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
      });

      this.on(SCALE_CHANGE_STR, function() {
        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
      });

      this.on('visibleChange.konva', function() {
        this._clearSelfAndDescendantCache(VISIBLE);
      });
      this.on('listeningChange.konva', function() {
        this._clearSelfAndDescendantCache(LISTENING);
      });
      this.on('opacityChange.konva', function() {
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
      });
    },
    _clearCache: function(attr) {
      if (attr) {
        delete this._cache[attr];
      } else {
        this._cache = {};
      }
    },
    _getCache: function(attr, privateGetter) {
      var cache = this._cache[attr];

      // if not cached, we need to set it using the private getter method.
      if (cache === undefined) {
        this._cache[attr] = privateGetter.call(this);
      }

      return this._cache[attr];
    },
    /*
     * when the logic for a cached result depends on ancestor propagation, use this
     * method to clear self and children cache
     */
    _clearSelfAndDescendantCache: function(attr) {
      this._clearCache(attr);

      // skip clearing of node is cached with canvas
      if (this._cache.canvas) {
        return;
      }
      if (this.children) {
        this.getChildren().each(function(node) {
          node._clearSelfAndDescendantCache(attr);
        });
      }
    },
    /**
     * clear cached canvas
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     * @example
     * node.clearCache();
     */
    clearCache: function() {
      delete this._cache.canvas;
      this._filterUpToDate = false;
      this._clearSelfAndDescendantCache();
      return this;
    },
    /**
     *  cache node to improve drawing performance, apply filters, or create more accurate
     *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
     *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
     *  properties. Look at [https://konvajs.github.io/docs/performance/Shape_Caching.html](link to demo page) for more information.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} [config]
     * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
     * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
     *  region for debugging purposes
     * @param {Number} [config.pixelRatio] change quality (or pixel ratio) of cached image. pixelRatio = 2 will produce 2x sized cache.
     * @returns {Konva.Node}
     * @example
     * // cache a shape with the x,y position of the bounding box at the center and
     * // the width and height of the bounding box equal to the width and height of
     * // the shape obtained from shape.width() and shape.height()
     * image.cache();
     *
     * // cache a node and define the bounding box position and size
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200
     * });
     *
     * // cache a node and draw a red border around the bounding box
     * // for debugging purposes
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200,
     *   offset : 10,
     *   drawBorder: true
     * });
     */
    cache: function(config) {
      var conf = config || {};
      var rect = {};

      // don't call getClientRect if we have all attributes
      // it means call it only if have one undefined
      if (
        conf.x === undefined ||
        conf.y === undefined ||
        conf.width === undefined ||
        conf.height === undefined
      ) {
        rect = this.getClientRect({
          skipTransform: true,
          relativeTo: this.getParent()
        });
      }
      var width = conf.width || rect.width,
        height = conf.height || rect.height,
        pixelRatio = conf.pixelRatio,
        x = conf.x === undefined ? rect.x : conf.x,
        y = conf.y === undefined ? rect.y : conf.y,
        offset = conf.offset || 0,
        drawBorder = conf.drawBorder || false;

      if (!width || !height) {
        Konva.Util.error(
          'Can not cache the node. Width or height of the node equals 0. Caching is skipped.'
        );
        return;
      }

      width += offset * 2;
      height += offset * 2;

      x -= offset;
      y -= offset;

      var cachedSceneCanvas = new Konva.SceneCanvas({
          pixelRatio: pixelRatio,
          width: width,
          height: height
        }),
        cachedFilterCanvas = new Konva.SceneCanvas({
          pixelRatio: pixelRatio,
          width: width,
          height: height
        }),
        cachedHitCanvas = new Konva.HitCanvas({
          pixelRatio: 1,
          width: width,
          height: height
        }),
        sceneContext = cachedSceneCanvas.getContext(),
        hitContext = cachedHitCanvas.getContext();

      cachedHitCanvas.isCache = true;

      this.clearCache();

      sceneContext.save();
      hitContext.save();

      sceneContext.translate(-x, -y);
      hitContext.translate(-x, -y);

      // extra flag to skip on getAbsolute opacity calc
      this._isUnderCache = true;
      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
      this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);

      this.drawScene(cachedSceneCanvas, this, true);
      this.drawHit(cachedHitCanvas, this, true);
      this._isUnderCache = false;

      sceneContext.restore();
      hitContext.restore();

      // this will draw a red border around the cached box for
      // debugging purposes
      if (drawBorder) {
        sceneContext.save();
        sceneContext.beginPath();
        sceneContext.rect(0, 0, width, height);
        sceneContext.closePath();
        sceneContext.setAttr('strokeStyle', 'red');
        sceneContext.setAttr('lineWidth', 5);
        sceneContext.stroke();
        sceneContext.restore();
      }

      this._cache.canvas = {
        scene: cachedSceneCanvas,
        filter: cachedFilterCanvas,
        hit: cachedHitCanvas,
        x: x,
        y: y
      };

      return this;
    },
    /**
     * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
     * The rectangle position is relative to parent container.
     * The purpose of the method is similar to getBoundingClientRect API of the DOM.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
     * @param {Boolean} [config.skipShadow] should we apply shadow to the node for calculating bound box?
     * @param {Boolean} [config.skipStroke] should we apply stroke to the node for calculating bound box?
     * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     * var rect = new Konva.Rect({
     *      width : 100,
     *      height : 100,
     *      x : 50,
     *      y : 50,
     *      strokeWidth : 4,
     *      stroke : 'black',
     *      offsetX : 50,
     *      scaleY : 2
     * });
     *
     * // get client rect without think off transformations (position, rotation, scale, offset, etc)
     * rect.getClientRect({ skipTransform: true});
     * // returns {
     * //     x : -2,   // two pixels for stroke / 2
     * //     y : -2,
     * //     width : 104, // increased by 4 for stroke
     * //     height : 104
     * //}
     *
     * // get client rect with transformation applied
     * rect.getClientRect();
     * // returns Object {x: -2, y: 46, width: 104, height: 208}
     */
    getClientRect: function() {
      // abstract method
      // redefine in Container and Shape
      throw new Error('abstract "getClientRect" method call');
    },
    _transformedRect: function(rect, top) {
      var points = [
        { x: rect.x, y: rect.y },
        { x: rect.x + rect.width, y: rect.y },
        { x: rect.x + rect.width, y: rect.y + rect.height },
        { x: rect.x, y: rect.y + rect.height }
      ];
      var minX, minY, maxX, maxY;
      var trans = this.getAbsoluteTransform(top);
      points.forEach(function(point) {
        var transformed = trans.point(point);
        if (minX === undefined) {
          minX = maxX = transformed.x;
          minY = maxY = transformed.y;
        }
        minX = Math.min(minX, transformed.x);
        minY = Math.min(minY, transformed.y);
        maxX = Math.max(maxX, transformed.x);
        maxY = Math.max(maxY, transformed.y);
      });
      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      };
    },
    _drawCachedSceneCanvas: function(context) {
      context.save();
      context._applyOpacity(this);
      context._applyGlobalCompositeOperation(this);
      context.translate(this._cache.canvas.x, this._cache.canvas.y);

      var cacheCanvas = this._getCachedSceneCanvas();
      var ratio = cacheCanvas.pixelRatio;

      context.drawImage(
        cacheCanvas._canvas,
        0,
        0,
        cacheCanvas.width / ratio,
        cacheCanvas.height / ratio
      );
      context.restore();
    },
    _drawCachedHitCanvas: function(context) {
      var cachedCanvas = this._cache.canvas,
        hitCanvas = cachedCanvas.hit;
      context.save();
      context.translate(this._cache.canvas.x, this._cache.canvas.y);
      context.drawImage(hitCanvas._canvas, 0, 0);
      context.restore();
    },
    _getCachedSceneCanvas: function() {
      var filters = this.filters(),
        cachedCanvas = this._cache.canvas,
        sceneCanvas = cachedCanvas.scene,
        filterCanvas = cachedCanvas.filter,
        filterContext = filterCanvas.getContext(),
        len,
        imageData,
        n,
        filter;

      if (filters) {
        if (!this._filterUpToDate) {
          var ratio = sceneCanvas.pixelRatio;

          try {
            len = filters.length;
            filterContext.clear();

            // copy cached canvas onto filter context
            filterContext.drawImage(
              sceneCanvas._canvas,
              0,
              0,
              sceneCanvas.getWidth() / ratio,
              sceneCanvas.getHeight() / ratio
            );
            imageData = filterContext.getImageData(
              0,
              0,
              filterCanvas.getWidth(),
              filterCanvas.getHeight()
            );

            // apply filters to filter context
            for (n = 0; n < len; n++) {
              filter = filters[n];
              if (typeof filter !== 'function') {
                Konva.Util.error(
                  'Filter should be type of function, but got ' +
                    typeof filter +
                    ' insted. Please check correct filters'
                );
                continue;
              }
              filter.call(this, imageData);
              filterContext.putImageData(imageData, 0, 0);
            }
          } catch (e) {
            Konva.Util.error('Unable to apply filter. ' + e.message);
          }

          this._filterUpToDate = true;
        }

        return filterCanvas;
      }
      return sceneCanvas;
    },
    /**
     * bind events to the node. KonvaJS supports mouseover, mousemove,
     *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, contextmenu, click, dblclick, touchstart, touchmove,
     *  touchend, tap, dbltap, dragstart, dragmove, and dragend events. The Konva Stage supports
     *  contentMouseover, contentMousemove, contentMouseout, contentMousedown, contentMouseup, contentWheel, contentContextmenu
     *  contentClick, contentDblclick, contentTouchstart, contentTouchmove, contentTouchend, contentTap,
     *  and contentDblTap.  Pass in a string of events delimited by a space to bind multiple events at once
     *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
     *  event by name such as 'click.foobar'.
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
     * @param {Function} handler The handler function is passed an event object
     * @returns {Konva.Node}
     * @example
     * // add click listener
     * node.on('click', function() {
     *   console.log('you clicked me!');
     * });
     *
     * // get the target node
     * node.on('click', function(evt) {
     *   console.log(evt.target);
     * });
     *
     * // stop event propagation
     * node.on('click', function(evt) {
     *   evt.cancelBubble = true;
     * });
     *
     * // bind multiple listeners
     * node.on('click touchstart', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // namespace listener
     * node.on('click.foo', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // get the event type
     * node.on('click tap', function(evt) {
     *   var eventType = evt.type;
     * });
     *
     * // get native event object
     * node.on('click tap', function(evt) {
     *   var nativeEvent = evt.evt;
     * });
     *
     * // for change events, get the old and new val
     * node.on('xChange', function(evt) {
     *   var oldVal = evt.oldVal;
     *   var newVal = evt.newVal;
     * });
     *
     * // get event targets
     * // with event delegations
     * layer.on('click', 'Group', function(evt) {
     *   var shape = evt.target;
     *   var group = evtn.currentTarger;
     * });
     */
    on: function(evtStr, handler) {
      if (arguments.length === 3) {
        return this._delegate.apply(this, arguments);
      }
      var events = evtStr.split(SPACE),
        len = events.length,
        n,
        event,
        parts,
        baseEvent,
        name;

      /*
       * loop through types and attach event listeners to
       * each one.  eg. 'click mouseover.namespace mouseout'
       * will create three event bindings
       */
      for (n = 0; n < len; n++) {
        event = events[n];
        parts = event.split(DOT);
        baseEvent = parts[0];
        name = parts[1] || EMPTY_STRING;

        // create events array if it doesn't exist
        if (!this.eventListeners[baseEvent]) {
          this.eventListeners[baseEvent] = [];
        }

        this.eventListeners[baseEvent].push({
          name: name,
          handler: handler
        });
      }

      return this;
    },
    /**
     * remove event bindings from the node. Pass in a string of
     *  event types delimmited by a space to remove multiple event
     *  bindings at once such as 'mousedown mouseup mousemove'.
     *  include a namespace to remove an event binding by name
     *  such as 'click.foobar'. If you only give a name like '.foobar',
     *  all events in that namespace will be removed.
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
     * @returns {Konva.Node}
     * @example
     * // remove listener
     * node.off('click');
     *
     * // remove multiple listeners
     * node.off('click touchstart');
     *
     * // remove listener by name
     * node.off('click.foo');
     */
    off: function(evtStr, callback) {
      var events = (evtStr || '').split(SPACE),
        len = events.length,
        n,
        t,
        event,
        parts,
        baseEvent,
        name;

      if (!evtStr) {
        // remove all events
        for (t in this.eventListeners) {
          this._off(t);
        }
      }
      for (n = 0; n < len; n++) {
        event = events[n];
        parts = event.split(DOT);
        baseEvent = parts[0];
        name = parts[1];

        if (baseEvent) {
          if (this.eventListeners[baseEvent]) {
            this._off(baseEvent, name, callback);
          }
        } else {
          for (t in this.eventListeners) {
            this._off(t, name, callback);
          }
        }
      }
      return this;
    },
    // some event aliases for third party integration like HammerJS
    dispatchEvent: function(evt) {
      var e = {
        target: this,
        type: evt.type,
        evt: evt
      };
      this.fire(evt.type, e);
      return this;
    },
    addEventListener: function(type, handler) {
      // we have to pass native event to handler
      this.on(type, function(evt) {
        handler.call(this, evt.evt);
      });
      return this;
    },
    removeEventListener: function(type) {
      this.off(type);
      return this;
    },
    // like node.on
    _delegate: function(event, selector, handler) {
      var stopNode = this;
      this.on(event, function(evt) {
        var targets = evt.target.findAncestors(selector, true, stopNode);
        for (var i = 0; i < targets.length; i++) {
          evt = Konva.Util.cloneObject(evt);
          evt.currentTarget = targets[i];
          handler.call(targets[i], evt);
        }
      });
    },
    /**
     * remove self from parent, but don't destroy. You can reuse node later.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     * @example
     * node.remove();
     */
    remove: function() {
      var parent = this.getParent();

      if (parent && parent.children) {
        parent.children.splice(this.index, 1);
        parent._setChildrenIndices();
        delete this.parent;
      }

      // every cached attr that is calculated via node tree
      // traversal must be cleared when removing a node
      this._clearSelfAndDescendantCache(STAGE);
      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
      this._clearSelfAndDescendantCache(VISIBLE);
      this._clearSelfAndDescendantCache(LISTENING);
      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);

      return this;
    },
    /**
     * remove and destroy a node. Kill it and delete forever! You should not reuse node after destroy().
     * @method
     * @memberof Konva.Node.prototype
     * @example
     * node.destroy();
     */
    destroy: function() {
      // remove from ids and names hashes
      Konva._removeId(this.getId());

      // remove all names
      var names = (this.getName() || '').split(/\s/g);
      for (var i = 0; i < names.length; i++) {
        var subname = names[i];
        Konva._removeName(subname, this._id);
      }

      this.remove();
      return this;
    },
    /**
     * get attr
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} attr
     * @returns {Integer|String|Object|Array}
     * @example
     * var x = node.getAttr('x');
     */
    getAttr: function(attr) {
      var method = GET + Konva.Util._capitalize(attr);
      if (Konva.Util._isFunction(this[method])) {
        return this[method]();
      }
      // otherwise get directly
      return this.attrs[attr];
    },
    /**
     * get ancestors
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Collection}
     * @example
     * shape.getAncestors().each(function(node) {
     *   console.log(node.getId());
     * })
     */
    getAncestors: function() {
      var parent = this.getParent(),
        ancestors = new Konva.Collection();

      while (parent) {
        ancestors.push(parent);
        parent = parent.getParent();
      }

      return ancestors;
    },
    /**
     * get attrs object literal
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */
    getAttrs: function() {
      return this.attrs || {};
    },
    /**
     * set multiple attrs at once using an object literal
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config object containing key value pairs
     * @returns {Konva.Node}
     * @example
     * node.setAttrs({
     *   x: 5,
     *   fill: 'red'
     * });
     */
    setAttrs: function(config) {
      var key, method;

      if (!config) {
        return this;
      }
      for (key in config) {
        if (key === CHILDREN) {
          continue;
        }
        method = SET + Konva.Util._capitalize(key);
        // use setter if available
        if (Konva.Util._isFunction(this[method])) {
          this[method](config[key]);
        } else {
          // otherwise set directly
          this._setAttr(key, config[key]);
        }
      }
      return this;
    },
    /**
     * determine if node is listening for events by taking into account ancestors.
     *
     * Parent    | Self      | isListening
     * listening | listening |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | T
     * F         | F         | F
     * ----------+-----------+------------
     * T         | I         | T
     * F         | I         | F
     * I         | I         | T
     *
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */
    isListening: function() {
      return this._getCache(LISTENING, this._isListening);
    },
    _isListening: function() {
      var listening = this.getListening(),
        parent = this.getParent();

      // the following conditions are a simplification of the truth table above.
      // please modify carefully
      if (listening === 'inherit') {
        if (parent) {
          return parent.isListening();
        } else {
          return true;
        }
      } else {
        return listening;
      }
    },
    /**
     * determine if node is visible by taking into account ancestors.
     *
     * Parent    | Self      | isVisible
     * visible   | visible   |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | T
     * F         | F         | F
     * ----------+-----------+------------
     * T         | I         | T
     * F         | I         | F
     * I         | I         | T

      * @method
      * @memberof Konva.Node.prototype
      * @returns {Boolean}
      */
    isVisible: function() {
      return this._getCache(VISIBLE, this._isVisible);
    },
    _isVisible: function(relativeTo) {
      var visible = this.getVisible(),
        parent = this.getParent();

      if (relativeTo === parent && visible === 'inherit') {
        return true;
      } else if (relativeTo === parent) {
        return visible;
      }
      // the following conditions are a simplification of the truth table above.
      // please modify carefully
      if (visible === 'inherit') {
        if (parent) {
          return parent._isVisible(relativeTo);
        } else {
          return true;
        }
      } else {
        return visible;
      }
    },
    /**
     * determine if listening is enabled by taking into account descendants.  If self or any children
     * have _isListeningEnabled set to true, then self also has listening enabled.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */
    shouldDrawHit: function() {
      var layer = this.getLayer();

      return (
        (!layer && this.isListening() && this.isVisible()) ||
        (layer &&
          layer.hitGraphEnabled() &&
          this.isListening() &&
          this.isVisible())
      );
    },
    /**
     * show node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */
    show: function() {
      this.setVisible(true);
      return this;
    },
    /**
     * hide node.  Hidden nodes are no longer detectable
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */
    hide: function() {
      this.setVisible(false);
      return this;
    },
    /**
     * get zIndex relative to the node's siblings who share the same parent
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */
    getZIndex: function() {
      return this.index || 0;
    },
    /**
     * get absolute z-index which takes into account sibling
     *  and ancestor indices
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */
    getAbsoluteZIndex: function() {
      var depth = this.getDepth(),
        that = this,
        index = 0,
        nodes,
        len,
        n,
        child;

      function addChildren(children) {
        nodes = [];
        len = children.length;
        for (n = 0; n < len; n++) {
          child = children[n];
          index++;

          if (child.nodeType !== SHAPE) {
            nodes = nodes.concat(child.getChildren().toArray());
          }

          if (child._id === that._id) {
            n = len;
          }
        }

        if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
          addChildren(nodes);
        }
      }
      if (that.nodeType !== UPPER_STAGE) {
        addChildren(that.getStage().getChildren());
      }

      return index;
    },
    /**
     * get node depth in node tree.  Returns an integer.
     *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
     *  be >= 2
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */
    getDepth: function() {
      var depth = 0,
        parent = this.parent;

      while (parent) {
        depth++;
        parent = parent.parent;
      }
      return depth;
    },
    setPosition: function(pos) {
      this.setX(pos.x);
      this.setY(pos.y);
      return this;
    },
    getPosition: function() {
      return {
        x: this.getX(),
        y: this.getY()
      };
    },
    /**
     * get absolute position relative to the top left corner of the stage container div
     * or relative to passed node
     * @method
     * @param {Object} [top] optional parent node
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */
    getAbsolutePosition: function(top) {
      var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(),
        absoluteTransform = new Konva.Transform(),
        offset = this.offset();

      // clone the matrix array
      absoluteTransform.m = absoluteMatrix.slice();
      absoluteTransform.translate(offset.x, offset.y);

      return absoluteTransform.getTranslation();
    },
    /**
     * set absolute position
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Konva.Node}
     */
    setAbsolutePosition: function(pos) {
      var origTrans = this._clearTransform(),
        it;

      // don't clear translation
      this.attrs.x = origTrans.x;
      this.attrs.y = origTrans.y;
      delete origTrans.x;
      delete origTrans.y;

      // unravel transform
      it = this.getAbsoluteTransform();

      it.invert();
      it.translate(pos.x, pos.y);
      pos = {
        x: this.attrs.x + it.getTranslation().x,
        y: this.attrs.y + it.getTranslation().y
      };

      this.setPosition({ x: pos.x, y: pos.y });
      this._setTransform(origTrans);

      return this;
    },
    _setTransform: function(trans) {
      var key;

      for (key in trans) {
        this.attrs[key] = trans[key];
      }

      this._clearCache(TRANSFORM);
      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
    },
    _clearTransform: function() {
      var trans = {
        x: this.getX(),
        y: this.getY(),
        rotation: this.getRotation(),
        scaleX: this.getScaleX(),
        scaleY: this.getScaleY(),
        offsetX: this.getOffsetX(),
        offsetY: this.getOffsetY(),
        skewX: this.getSkewX(),
        skewY: this.getSkewY()
      };

      this.attrs.x = 0;
      this.attrs.y = 0;
      this.attrs.rotation = 0;
      this.attrs.scaleX = 1;
      this.attrs.scaleY = 1;
      this.attrs.offsetX = 0;
      this.attrs.offsetY = 0;
      this.attrs.skewX = 0;
      this.attrs.skewY = 0;

      this._clearCache(TRANSFORM);
      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);

      // return original transform
      return trans;
    },
    /**
     * move node by an amount relative to its current position
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} change
     * @param {Number} change.x
     * @param {Number} change.y
     * @returns {Konva.Node}
     * @example
     * // move node in x direction by 1px and y direction by 2px
     * node.move({
     *   x: 1,
     *   y: 2)
     * });
     */
    move: function(change) {
      var changeX = change.x,
        changeY = change.y,
        x = this.getX(),
        y = this.getY();

      if (changeX !== undefined) {
        x += changeX;
      }

      if (changeY !== undefined) {
        y += changeY;
      }

      this.setPosition({ x: x, y: y });
      return this;
    },
    _eachAncestorReverse: function(func, top) {
      var family = [],
        parent = this.getParent(),
        len,
        n;

      // if top node is defined, and this node is top node,
      // there's no need to build a family tree.  just execute
      // func with this because it will be the only node
      if (top && top._id === this._id) {
        func(this);
        return;
      }

      family.unshift(this);

      while (parent && (!top || parent._id !== top._id)) {
        family.unshift(parent);
        parent = parent.parent;
      }

      len = family.length;
      for (n = 0; n < len; n++) {
        func(family[n]);
      }
    },
    /**
     * rotate node by an amount in degrees relative to its current rotation
     * @method
     * @memberof Konva.Node.prototype
     * @param {Number} theta
     * @returns {Konva.Node}
     */
    rotate: function(theta) {
      this.setRotation(this.getRotation() + theta);
      return this;
    },
    /**
     * move node to the top of its siblings
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */
    moveToTop: function() {
      if (!this.parent) {
        Konva.Util.warn('Node has no parent. moveToTop function is ignored.');
        return false;
      }
      var index = this.index;
      this.parent.children.splice(index, 1);
      this.parent.children.push(this);
      this.parent._setChildrenIndices();
      return true;
    },
    /**
     * move node up
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean} flag is moved or not
     */
    moveUp: function() {
      if (!this.parent) {
        Konva.Util.warn('Node has no parent. moveUp function is ignored.');
        return false;
      }
      var index = this.index,
        len = this.parent.getChildren().length;
      if (index < len - 1) {
        this.parent.children.splice(index, 1);
        this.parent.children.splice(index + 1, 0, this);
        this.parent._setChildrenIndices();
        return true;
      }
      return false;
    },
    /**
     * move node down
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */
    moveDown: function() {
      if (!this.parent) {
        Konva.Util.warn('Node has no parent. moveDown function is ignored.');
        return false;
      }
      var index = this.index;
      if (index > 0) {
        this.parent.children.splice(index, 1);
        this.parent.children.splice(index - 1, 0, this);
        this.parent._setChildrenIndices();
        return true;
      }
      return false;
    },
    /**
     * move node to the bottom of its siblings
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */
    moveToBottom: function() {
      if (!this.parent) {
        Konva.Util.warn(
          'Node has no parent. moveToBottom function is ignored.'
        );
        return false;
      }
      var index = this.index;
      if (index > 0) {
        this.parent.children.splice(index, 1);
        this.parent.children.unshift(this);
        this.parent._setChildrenIndices();
        return true;
      }
      return false;
    },
    /**
     * set zIndex relative to siblings
     * @method
     * @memberof Konva.Node.prototype
     * @param {Integer} zIndex
     * @returns {Konva.Node}
     */
    setZIndex: function(zIndex) {
      if (!this.parent) {
        Konva.Util.warn('Node has no parent. zIndex parameter is ignored.');
        return false;
      }
      var index = this.index;
      this.parent.children.splice(index, 1);
      this.parent.children.splice(zIndex, 0, this);
      this.parent._setChildrenIndices();
      return this;
    },
    /**
     * get absolute opacity
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Number}
     */
    getAbsoluteOpacity: function() {
      return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    },
    _getAbsoluteOpacity: function() {
      var absOpacity = this.getOpacity();
      var parent = this.getParent();
      if (parent && !parent._isUnderCache) {
        absOpacity *= this.getParent().getAbsoluteOpacity();
      }
      return absOpacity;
    },
    /**
     * move node to another container
     * @method
     * @memberof Konva.Node.prototype
     * @param {Container} newContainer
     * @returns {Konva.Node}
     * @example
     * // move node from current layer into layer2
     * node.moveTo(layer2);
     */
    moveTo: function(newContainer) {
      // do nothing if new container is already parent
      if (this.getParent() !== newContainer) {
        // this.remove my be overrided by drag and drop
        // buy we need original
        (this.__originalRemove || this.remove).call(this);
        newContainer.add(this);
      }
      return this;
    },
    /**
     * convert Node into an object for serialization.  Returns an object.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */
    toObject: function() {
      var obj = {},
        attrs = this.getAttrs(),
        key,
        val,
        getter,
        defaultValue;

      obj.attrs = {};

      for (key in attrs) {
        val = attrs[key];
        getter = typeof this[key] === 'function' && this[key];
        // remove attr value so that we can extract the default value from the getter
        delete attrs[key];
        defaultValue = getter ? getter.call(this) : null;
        // restore attr value
        attrs[key] = val;
        if (defaultValue !== val) {
          obj.attrs[key] = val;
        }
      }

      obj.className = this.getClassName();
      return Konva.Util._prepareToStringify(obj);
    },
    /**
     * convert Node into a JSON string.  Returns a JSON string.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}}
     */
    toJSON: function() {
      return JSON.stringify(this.toObject());
    },
    /**
     * get parent container
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */
    getParent: function() {
      return this.parent;
    },
    /**
     * get all ancestros (parent then parent of the parent, etc) of the node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} [selector] selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Array} [ancestors]
     * @example
     * // get one of the parent group
     * var parentGroups = node.findAncestors('Group');
     */
    findAncestors: function(selector, includeSelf, stopNode) {
      var res = [];

      if (includeSelf && this._isMatch(selector)) {
        res.push(this);
      }
      var ancestor = this.parent;
      while (ancestor) {
        if (ancestor === stopNode) {
          return res;
        }
        if (ancestor._isMatch(selector)) {
          res.push(ancestor);
        }
        ancestor = ancestor.parent;
      }
      return res;
    },
    /**
     * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} [selector] selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Konva.Node} ancestor
     * @example
     * // get one of the parent group
     * var group = node.findAncestors('.mygroup');
     */
    findAncestor: function(selector, includeSelf, stopNode) {
      return this.findAncestors(selector, includeSelf, stopNode)[0];
    },
    // is current node match passed selector?
    _isMatch: function(selector) {
      if (!selector) {
        return false;
      }
      var selectorArr = selector.replace(/ /g, '').split(','),
        len = selectorArr.length,
        n,
        sel;

      for (n = 0; n < len; n++) {
        sel = selectorArr[n];
        if (!Konva.Util.isValidSelector(sel)) {
          Konva.Util.warn(
            'Selector "' +
              sel +
              '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'
          );
          Konva.Util.warn(
            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
          );
          Konva.Util.warn('Konva is awesome, right?');
        }
        // id selector
        if (sel.charAt(0) === '#') {
          if (this.id() === sel.slice(1)) {
            return true;
          }
        } else if (sel.charAt(0) === '.') {
          // name selector
          if (this.hasName(sel.slice(1))) {
            return true;
          }
        } else if (this._get(sel).length !== 0) {
          return true;
        }
      }
      return false;
    },
    /**
     * get layer ancestor
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Layer}
     */
    getLayer: function() {
      var parent = this.getParent();
      return parent ? parent.getLayer() : null;
    },
    /**
     * get stage ancestor
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Stage}
     */
    getStage: function() {
      return this._getCache(STAGE, this._getStage);
    },
    _getStage: function() {
      var parent = this.getParent();
      if (parent) {
        return parent.getStage();
      } else {
        return undefined;
      }
    },
    /**
     * fire event
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
     * @param {Event} [evt] event object
     * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
     *  not bubbling.  Setting the value to true will result in the event bubbling.
     * @returns {Konva.Node}
     * @example
     * // manually fire click event
     * node.fire('click');
     *
     * // fire custom event
     * node.fire('foo');
     *
     * // fire custom event with custom event object
     * node.fire('foo', {
     *   bar: 10
     * });
     *
     * // fire click event that bubbles
     * node.fire('click', null, true);
     */
    fire: function(eventType, evt, bubble) {
      evt = evt || {};
      evt.target = evt.target || this;
      // bubble
      if (bubble) {
        this._fireAndBubble(eventType, evt);
      } else {
        // no bubble
        this._fire(eventType, evt);
      }
      return this;
    },
    /**
     * get absolute transform of the node which takes into
     *  account its ancestor transforms
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */
    getAbsoluteTransform: function(top) {
      // if using an argument, we can't cache the result.
      if (top) {
        return this._getAbsoluteTransform(top);
      } else {
        // if no argument, we can cache the result
        return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
      }
    },
    _getAbsoluteTransform: function(top) {
      var at = new Konva.Transform();

      // start with stage and traverse downwards to self
      this._eachAncestorReverse(function(node) {
        var transformsEnabled = node.transformsEnabled();

        if (transformsEnabled === 'all') {
          at.multiply(node.getTransform());
        } else if (transformsEnabled === 'position') {
          at.translate(
            node.getX() - node.getOffsetX(),
            node.getY() - node.getOffsetY()
          );
        }
      }, top);
      return at;
    },
    /**
     * get absolute scale of the node which takes into
     *  account its ancestor scales
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */
    getAbsoluteScale: function(top) {
      // if using an argument, we can't cache the result.
      if (top) {
        return this._getAbsoluteScale(top);
      } else {
        // if no argument, we can cache the result
        return this._getCache(ABSOLUTE_SCALE, this._getAbsoluteScale);
      }
    },
    _getAbsoluteScale: function(top) {
      // this is special logic for caching with some shapes with shadow
      var parent = this;
      while (parent) {
        if (parent._isUnderCache) {
          top = parent;
        }
        parent = parent.getParent();
      }

      var scaleX = 1,
        scaleY = 1;

      // start with stage and traverse downwards to self
      this._eachAncestorReverse(function(node) {
        scaleX *= node.scaleX();
        scaleY *= node.scaleY();
      }, top);
      return {
        x: scaleX,
        y: scaleY
      };
    },
    /**
     * get transform of the node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */
    getTransform: function() {
      return this._getCache(TRANSFORM, this._getTransform);
    },
    _getTransform: function() {
      var m = new Konva.Transform(),
        x = this.getX(),
        y = this.getY(),
        rotation = Konva.getAngle(this.getRotation()),
        scaleX = this.getScaleX(),
        scaleY = this.getScaleY(),
        skewX = this.getSkewX(),
        skewY = this.getSkewY(),
        offsetX = this.getOffsetX(),
        offsetY = this.getOffsetY();

      if (x !== 0 || y !== 0) {
        m.translate(x, y);
      }
      if (rotation !== 0) {
        m.rotate(rotation);
      }
      if (skewX !== 0 || skewY !== 0) {
        m.skew(skewX, skewY);
      }
      if (scaleX !== 1 || scaleY !== 1) {
        m.scale(scaleX, scaleY);
      }
      if (offsetX !== 0 || offsetY !== 0) {
        m.translate(-1 * offsetX, -1 * offsetY);
      }

      return m;
    },
    /**
     * clone node.  Returns a new Node instance with identical attributes.  You can also override
     *  the node properties with an object literal, enabling you to use an existing node as a template
     *  for another node
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} obj override attrs
     * @returns {Konva.Node}
     * @example
     * // simple clone
     * var clone = node.clone();
     *
     * // clone a node and override the x position
     * var clone = rect.clone({
     *   x: 5
     * });
     */
    clone: function(obj) {
      // instantiate new node
      var attrs = Konva.Util.cloneObject(this.attrs),
        key,
        allListeners,
        len,
        n,
        listener;
      // filter black attrs
      for (var i in CLONE_BLACK_LIST) {
        var blockAttr = CLONE_BLACK_LIST[i];
        delete attrs[blockAttr];
      }
      // apply attr overrides
      for (key in obj) {
        attrs[key] = obj[key];
      }

      var node = new this.constructor(attrs);
      // copy over listeners
      for (key in this.eventListeners) {
        allListeners = this.eventListeners[key];
        len = allListeners.length;
        for (n = 0; n < len; n++) {
          listener = allListeners[n];
          /*
           * don't include konva namespaced listeners because
           *  these are generated by the constructors
           */
          if (listener.name.indexOf(KONVA) < 0) {
            // if listeners array doesn't exist, then create it
            if (!node.eventListeners[key]) {
              node.eventListeners[key] = [];
            }
            node.eventListeners[key].push(listener);
          }
        }
      }
      return node;
    },
    _toKonvaCanvas: function(config) {
      config = config || {};

      var box = this.getClientRect();

      var stage = this.getStage(),
        x = config.x !== undefined ? config.x : box.x,
        y = config.y !== undefined ? config.y : box.y,
        pixelRatio = config.pixelRatio || 1,
        canvas = new Konva.SceneCanvas({
          width: config.width || box.width || (stage ? stage.getWidth() : 0),
          height:
            config.height || box.height || (stage ? stage.getHeight() : 0),
          pixelRatio: pixelRatio
        }),
        context = canvas.getContext();

      context.save();

      if (x || y) {
        context.translate(-1 * x, -1 * y);
      }

      this.drawScene(canvas);
      context.restore();

      return canvas;
    },
    /**
     * converts node into an canvas element.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
     * @example
     * var canvas = node.toCanvas();
     */
    toCanvas: function(config) {
      return this._toKonvaCanvas(config)._canvas;
    },
    /**
     * Creates a composite data URL (base64 string). If MIME type is not
     * specified, then "image/png" will result. For "image/jpeg", specify a quality
     * level as quality (range 0.0 - 1.0)
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @param {Number} [config.pixelRatio] pixelRatio of output image url. Default is 1
     * @returns {String}
     */
    toDataURL: function(config) {
      config = config || {};
      var mimeType = config.mimeType || null,
        quality = config.quality || null;
      var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
      if (config.callback) {
        config.callback(url);
      }
      return url;
    },
    /**
     * converts node into an image.  Since the toImage
     *  method is asynchronous, a callback is required.  toImage is most commonly used
     *  to cache complex drawings as an image so that they don't have to constantly be redrawn
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
     * @example
     * var image = node.toImage({
     *   callback: function(img) {
     *     // do stuff with img
     *   }
     * });
     */
    toImage: function(config) {
      if (!config || !config.callback) {
        throw 'callback required for toImage method config argument';
      }
      var callback = config.callback;
      delete config.callback;
      Konva.Util._getImage(this.toDataURL(config), function(img) {
        callback(img);
      });
    },
    setSize: function(size) {
      this.setWidth(size.width);
      this.setHeight(size.height);
      return this;
    },
    getSize: function() {
      return {
        width: this.getWidth(),
        height: this.getHeight()
      };
    },
    getWidth: function() {
      return this.attrs.width || 0;
    },
    getHeight: function() {
      return this.attrs.height || 0;
    },
    /**
     * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}
     */
    getClassName: function() {
      return this.className || this.nodeType;
    },
    /**
     * get the node type, which may return Stage, Layer, Group, or Node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}
     */
    getType: function() {
      return this.nodeType;
    },
    getDragDistance: function() {
      // compare with undefined because we need to track 0 value
      if (this.attrs.dragDistance !== undefined) {
        return this.attrs.dragDistance;
      } else if (this.parent) {
        return this.parent.getDragDistance();
      } else {
        return Konva.dragDistance;
      }
    },
    _get: function(selector) {
      return this.className === selector || this.nodeType === selector
        ? [this]
        : [];
    },
    _off: function(type, name, callback) {
      var evtListeners = this.eventListeners[type],
        i,
        evtName,
        handler;

      for (i = 0; i < evtListeners.length; i++) {
        evtName = evtListeners[i].name;
        handler = evtListeners[i].handler;

        // the following two conditions must be true in order to remove a handler:
        // 1) the current event name cannot be konva unless the event name is konva
        //    this enables developers to force remove a konva specific listener for whatever reason
        // 2) an event name is not specified, or if one is specified, it matches the current event name
        if (
          (evtName !== 'konva' || name === 'konva') &&
          (!name || evtName === name) &&
          (!callback || callback === handler)
        ) {
          evtListeners.splice(i, 1);
          if (evtListeners.length === 0) {
            delete this.eventListeners[type];
            break;
          }
          i--;
        }
      }
    },
    _fireChangeEvent: function(attr, oldVal, newVal) {
      this._fire(attr + CHANGE, {
        oldVal: oldVal,
        newVal: newVal
      });
    },
    setId: function(id) {
      var oldId = this.getId();

      Konva._removeId(oldId);
      Konva._addId(this, id);
      this._setAttr(ID, id);
      return this;
    },
    setName: function(name) {
      var oldNames = (this.getName() || '').split(/\s/g);
      var newNames = (name || '').split(/\s/g);
      var subname, i;
      // remove all subnames
      for (i = 0; i < oldNames.length; i++) {
        subname = oldNames[i];
        if (newNames.indexOf(subname) === -1 && subname) {
          Konva._removeName(subname, this._id);
        }
      }

      // add new names
      for (i = 0; i < newNames.length; i++) {
        subname = newNames[i];
        if (oldNames.indexOf(subname) === -1 && subname) {
          Konva._addName(this, subname);
        }
      }

      this._setAttr(NAME, name);
      return this;
    },
    // naming methods
    /**
     * add name to node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red');
     * node.addName('selected');
     * node.name(); // return 'red selected'
     */
    addName: function(name) {
      if (!this.hasName(name)) {
        var oldName = this.name();
        var newName = oldName ? oldName + ' ' + name : name;
        this.setName(newName);
      }
      return this;
    },
    /**
     * check is node has name
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Boolean}
     * @example
     * node.name('red');
     * node.hasName('red');   // return true
     * node.hasName('selected'); // return false
     */
    hasName: function(name) {
      var names = (this.name() || '').split(/\s/g);
      return names.indexOf(name) !== -1;
    },
    /**
     * remove name from node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red selected');
     * node.removeName('selected');
     * node.hasName('selected'); // return false
     * node.name(); // return 'red'
     */
    removeName: function(name) {
      var names = (this.name() || '').split(/\s/g);
      var index = names.indexOf(name);
      if (index !== -1) {
        names.splice(index, 1);
        this.setName(names.join(' '));
      }
      return this;
    },
    /**
     * set attr
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} attr
     * @param {*} val
     * @returns {Konva.Node}
     * @example
     * node.setAttr('x', 5);
     */
    setAttr: function(attr, val) {
      var method = SET + Konva.Util._capitalize(attr),
        func = this[method];

      if (Konva.Util._isFunction(func)) {
        func.call(this, val);
      } else {
        // otherwise set directly
        this._setAttr(attr, val);
      }
      return this;
    },
    _setAttr: function(key, val) {
      var oldVal;
      oldVal = this.attrs[key];
      var same = oldVal === val;
      if (same && !Konva.Util.isObject(val)) {
        return;
      }
      if (val === undefined || val === null) {
        delete this.attrs[key];
      } else {
        this.attrs[key] = val;
      }
      this._fireChangeEvent(key, oldVal, val);
    },
    _setComponentAttr: function(key, component, val) {
      var oldVal;
      if (val !== undefined) {
        oldVal = this.attrs[key];

        if (!oldVal) {
          // set value to default value using getAttr
          this.attrs[key] = this.getAttr(key);
        }

        this.attrs[key][component] = val;
        this._fireChangeEvent(key, oldVal, val);
      }
    },
    _fireAndBubble: function(eventType, evt, compareShape) {
      var okayToRun = true;

      if (evt && this.nodeType === SHAPE) {
        evt.target = this;
      }

      if (
        eventType === MOUSEENTER &&
        compareShape &&
        (this._id === compareShape._id ||
          (this.isAncestorOf && this.isAncestorOf(compareShape)))
      ) {
        okayToRun = false;
      } else if (
        eventType === MOUSELEAVE &&
        compareShape &&
        (this._id === compareShape._id ||
          (this.isAncestorOf && this.isAncestorOf(compareShape)))
      ) {
        okayToRun = false;
      }
      if (okayToRun) {
        this._fire(eventType, evt);

        // simulate event bubbling
        var stopBubble =
          (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
          (compareShape &&
            compareShape.isAncestorOf &&
            compareShape.isAncestorOf(this) &&
            !compareShape.isAncestorOf(this.parent));
        if (
          ((evt && !evt.cancelBubble) || !evt) &&
          this.parent &&
          this.parent.isListening() &&
          !stopBubble
        ) {
          if (compareShape && compareShape.parent) {
            this._fireAndBubble.call(
              this.parent,
              eventType,
              evt,
              compareShape.parent
            );
          } else {
            this._fireAndBubble.call(this.parent, eventType, evt);
          }
        }
      }
    },
    _fire: function(eventType, evt) {
      var events = this.eventListeners[eventType],
        i;

      evt = evt || {};
      evt.currentTarget = this;
      evt.type = eventType;

      if (events) {
        for (i = 0; i < events.length; i++) {
          events[i].handler.call(this, evt);
        }
      }
    },
    /**
     * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */
    draw: function() {
      this.drawScene();
      this.drawHit();
      return this;
    }
  });

  /**
   * create node with JSON string or an Object.  De-serializtion does not generate custom
   *  shape drawing functions, images, or event handlers (this would make the
   *  serialized object huge).  If your app uses custom shapes, images, and
   *  event handlers (it probably does), then you need to select the appropriate
   *  shapes after loading the stage and set these properties via on(), setSceneFunc(),
   *  and setImage() methods
   * @method
   * @memberof Konva.Node
   * @param {String|Object} json string or object
   * @param {Element} [container] optional container dom element used only if you're
   *  creating a stage node
   */
  Konva.Node.create = function(data, container) {
    if (Konva.Util._isString(data)) {
      data = JSON.parse(data);
    }
    return this._createNode(data, container);
  };
  Konva.Node._createNode = function(obj, container) {
    var className = Konva.Node.prototype.getClassName.call(obj),
      children = obj.children,
      no,
      len,
      n;

    // if container was passed in, add it to attrs
    if (container) {
      obj.attrs.container = container;
    }

    no = new Konva[className](obj.attrs);
    if (children) {
      len = children.length;
      for (n = 0; n < len; n++) {
        no.add(this._createNode(children[n]));
      }
    }

    return no;
  };

  // =========================== add getters setters ===========================

  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'position');
  /**
   * get/set node position relative to parent
   * @name position
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} pos
   * @param {Number} pos.x
   * @param {Number} pos.y
   * @returns {Object}
   * @example
   * // get position
   * var position = node.position();
   *
   * // set position
   * node.position({
   *   x: 5
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'x',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set x position
   * @name x
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} x
   * @returns {Object}
   * @example
   * // get x
   * var x = node.x();
   *
   * // set x
   * node.x(5);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'y',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set y position
   * @name y
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} y
   * @returns {Integer}
   * @example
   * // get y
   * var y = node.y();
   *
   * // set y
   * node.y(5);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'globalCompositeOperation',
    'source-over',
    Konva.Validators.getStringValidator()
  );

  /**
   * get/set globalCompositeOperation of a shape
   * @name globalCompositeOperation
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} type
   * @returns {String}
   * @example
   * // get globalCompositeOperation
   * var globalCompositeOperation = shape.globalCompositeOperation();
   *
   * // set globalCompositeOperation
   * shape.globalCompositeOperation('source-in');
   */
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'opacity',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set opacity.  Opacity values range from 0 to 1.
   *  A node with an opacity of 0 is fully transparent, and a node
   *  with an opacity of 1 is fully opaque
   * @name opacity
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} opacity
   * @returns {Number}
   * @example
   * // get opacity
   * var opacity = node.opacity();
   *
   * // set opacity
   * node.opacity(0.5);
   */

  Konva.Factory.addGetter(Konva.Node, 'name');
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'name');

  /**
   * get/set name
   * @name name
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} name
   * @returns {String}
   * @example
   * // get name
   * var name = node.name();
   *
   * // set name
   * node.name('foo');
   *
   * // also node may have multiple names (as css classes)
   * node.name('foo bar');
   */

  Konva.Factory.addGetter(Konva.Node, 'id');
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'id');

  /**
   * get/set id. Id is global for whole page.
   * @name id
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} id
   * @returns {String}
   * @example
   * // get id
   * var name = node.id();
   *
   * // set id
   * node.id('foo');
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'rotation',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set rotation in degrees
   * @name rotation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} rotation
   * @returns {Number}
   * @example
   * // get rotation in degrees
   * var rotation = node.rotation();
   *
   * // set rotation in degrees
   * node.rotation(45);
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'scale', ['x', 'y']);

  /**
   * get/set scale
   * @name scale
   * @param {Object} scale
   * @param {Number} scale.x
   * @param {Number} scale.y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Object}
   * @example
   * // get scale
   * var scale = node.scale();
   *
   * // set scale
   * shape.scale({
   *   x: 2
   *   y: 3
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'scaleX',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set scale x
   * @name scaleX
   * @param {Number} x
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get scale x
   * var scaleX = node.scaleX();
   *
   * // set scale x
   * node.scaleX(2);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'scaleY',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set scale y
   * @name scaleY
   * @param {Number} y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get scale y
   * var scaleY = node.scaleY();
   *
   * // set scale y
   * node.scaleY(2);
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'skew', ['x', 'y']);

  /**
   * get/set skew
   * @name skew
   * @param {Object} skew
   * @param {Number} skew.x
   * @param {Number} skew.y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Object}
   * @example
   * // get skew
   * var skew = node.skew();
   *
   * // set skew
   * node.skew({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'skewX',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set skew x
   * @name skewX
   * @param {Number} x
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get skew x
   * var skewX = node.skewX();
   *
   * // set skew x
   * node.skewX(3);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'skewY',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set skew y
   * @name skewY
   * @param {Number} y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get skew y
   * var skewY = node.skewY();
   *
   * // set skew y
   * node.skewY(3);
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'offset', ['x', 'y']);

  /**
   * get/set offset.  Offsets the default position and rotation point
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get offset
   * var offset = node.offset();
   *
   * // set offset
   * node.offset({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'offsetX',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set offset x
   * @name offsetX
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get offset x
   * var offsetX = node.offsetX();
   *
   * // set offset x
   * node.offsetX(3);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'offsetY',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set offset y
   * @name offsetY
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get offset y
   * var offsetY = node.offsetY();
   *
   * // set offset y
   * node.offsetY(3);
   */

  Konva.Factory.addSetter(
    Konva.Node,
    'dragDistance',
    Konva.Validators.getNumberValidator()
  );
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'dragDistance');

  /**
   * get/set drag distance
   * @name dragDistance
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} distance
   * @returns {Number}
   * @example
   * // get drag distance
   * var dragDistance = node.dragDistance();
   *
   * // set distance
   * // node starts dragging only if pointer moved more then 3 pixels
   * node.dragDistance(3);
   * // or set globally
   * Konva.dragDistance = 3;
   */

  Konva.Factory.addSetter(
    Konva.Node,
    'width',
    Konva.Validators.getNumberValidator()
  );
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'width');
  /**
   * get/set width
   * @name width
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get width
   * var width = node.width();
   *
   * // set width
   * node.width(100);
   */

  Konva.Factory.addSetter(
    Konva.Node,
    'height',
    Konva.Validators.getNumberValidator()
  );
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'height');
  /**
   * get/set height
   * @name height
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get height
   * var height = node.height();
   *
   * // set height
   * node.height(100);
   */

  Konva.Factory.addGetterSetter(Konva.Node, 'listening', 'inherit', function(
    val
  ) {
    var isValid = val === true || val === false || val === 'inherit';
    if (!isValid) {
      Konva.Util.warn(
        val +
          ' is a not valid value for "listening" attribute. The value may be true, false or "inherit".'
      );
    }
    return val;
  });
  /**
   * get/set listenig attr.  If you need to determine if a node is listening or not
   *   by taking into account its parents, use the isListening() method
   * @name listening
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean|String} listening Can be "inherit", true, or false.  The default is "inherit".
   * @returns {Boolean|String}
   * @example
   * // get listening attr
   * var listening = node.listening();
   *
   * // stop listening for events
   * node.listening(false);
   *
   * // listen for events
   * node.listening(true);
   *
   * // listen to events according to the parent
   * node.listening('inherit');
   */

  /**
   * get/set preventDefault
   * By default all shapes will prevent default behaviour
   * of a browser on a pointer move or tap.
   * that will prevent native scrolling when you are trying to drag&drop a node
   * but sometimes you may need to enable default actions
   * in that case you can set the property to false
   * @name preventDefault
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} preventDefault
   * @returns {Number}
   * @example
   * // get preventDefault
   * var shouldPrevent = shape.preventDefault();
   *
   * // set preventDefault
   * shape.preventDefault(false);
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'preventDefault',
    true,
    Konva.Validators.getBooleanValidator()
  );

  Konva.Factory.addGetterSetter(Konva.Node, 'filters', null, function(val) {
    this._filterUpToDate = false;
    return val;
  });
  /**
   * get/set filters.  Filters are applied to cached canvases
   * @name filters
   * @method
   * @memberof Konva.Node.prototype
   * @param {Array} filters array of filters
   * @returns {Array}
   * @example
   * // get filters
   * var filters = node.filters();
   *
   * // set a single filter
   * node.cache();
   * node.filters([Konva.Filters.Blur]);
   *
   * // set multiple filters
   * node.cache();
   * node.filters([
   *   Konva.Filters.Blur,
   *   Konva.Filters.Sepia,
   *   Konva.Filters.Invert
   * ]);
   */

  Konva.Factory.addGetterSetter(Konva.Node, 'visible', 'inherit', function(
    val
  ) {
    var isValid = val === true || val === false || val === 'inherit';
    if (!isValid) {
      Konva.Util.warn(
        val +
          ' is a not valid value for "visible" attribute. The value may be true, false or "inherit".'
      );
    }
    return val;
  });
  /**
   * get/set visible attr.  Can be "inherit", true, or false.  The default is "inherit".
   *   If you need to determine if a node is visible or not
   *   by taking into account its parents, use the isVisible() method
   * @name visible
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean|String} visible
   * @returns {Boolean|String}
   * @example
   * // get visible attr
   * var visible = node.visible();
   *
   * // make invisible
   * node.visible(false);
   *
   * // make visible
   * node.visible(true);
   *
   * // make visible according to the parent
   * node.visible('inherit');
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'transformsEnabled',
    'all',
    Konva.Validators.getStringValidator()
  );

  /**
   * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
   *  is "all"
   * @name transformsEnabled
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} enabled
   * @returns {String}
   * @example
   * // enable position transform only to improve draw performance
   * node.transformsEnabled('position');
   *
   * // enable all transforms
   * node.transformsEnabled('all');
   */

  /**
   * get/set node size
   * @name size
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} size
   * @param {Number} size.width
   * @param {Number} size.height
   * @returns {Object}
   * @example
   * // get node size
   * var size = node.size();
   * var x = size.x;
   * var y = size.y;
   *
   * // set size
   * node.size({
   *   width: 100,
   *   height: 200
   * });
   */
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'size');

  Konva.Factory.backCompat(Konva.Node, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
  });

  Konva.Collection.mapMethods(Konva.Node);
})(Konva);

(function() {
  'use strict';
  /**
   * Grayscale Filter
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Grayscale]);
   */
  Konva.Filters.Grayscale = function(imageData) {
    var data = imageData.data,
      len = data.length,
      i,
      brightness;

    for (i = 0; i < len; i += 4) {
      brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
      // red
      data[i] = brightness;
      // green
      data[i + 1] = brightness;
      // blue
      data[i + 2] = brightness;
    }
  };
})();

(function(Konva) {
  'use strict';
  /**
   * Brighten Filter.
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Brighten]);
   * node.brightness(0.8);
   */
  Konva.Filters.Brighten = function(imageData) {
    var brightness = this.brightness() * 255,
      data = imageData.data,
      len = data.length,
      i;

    for (i = 0; i < len; i += 4) {
      // red
      data[i] += brightness;
      // green
      data[i + 1] += brightness;
      // blue
      data[i + 2] += brightness;
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'brightness',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set filter brightness.  The brightness is a number between -1 and 1.&nbsp; Positive values
   *  brighten the pixels and negative values darken them. Use with {@link Konva.Filters.Brighten} filter.
   * @name brightness
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} brightness value between -1 and 1
   * @returns {Number}
   */
})(Konva);

(function() {
  'use strict';
  /**
   * Invert Filter
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Invert]);
   */
  Konva.Filters.Invert = function(imageData) {
    var data = imageData.data,
      len = data.length,
      i;

    for (i = 0; i < len; i += 4) {
      // red
      data[i] = 255 - data[i];
      // green
      data[i + 1] = 255 - data[i + 1];
      // blue
      data[i + 2] = 255 - data[i + 2];
    }
  };
})();

/*
 the Gauss filter
 master repo: https://github.com/pavelpower/kineticjsGaussFilter
*/
(function(Konva) {
  'use strict';
  /*

     StackBlur - a fast almost Gaussian Blur For Canvas

     Version:   0.5
     Author:    Mario Klingemann
     Contact:   mario@quasimondo.com
     Website:   http://www.quasimondo.com/StackBlurForCanvas
     Twitter:   @quasimondo

     In case you find this class useful - especially in commercial projects -
     I am not totally unhappy for a small donation to my PayPal account
     mario@quasimondo.de

     Or support me on flattr:
     https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

     Copyright (c) 2010 Mario Klingemann

     Permission is hereby granted, free of charge, to any person
     obtaining a copy of this software and associated documentation
     files (the "Software"), to deal in the Software without
     restriction, including without limitation the rights to use,
     copy, modify, merge, publish, distribute, sublicense, and/or sell
     copies of the Software, and to permit persons to whom the
     Software is furnished to do so, subject to the following
     conditions:

     The above copyright notice and this permission notice shall be
     included in all copies or substantial portions of the Software.

     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
     OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
     HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
     WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
     FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
     OTHER DEALINGS IN THE SOFTWARE.
     */

  function BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
  }

  var mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ];

  var shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];

  function filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data,
      width = imageData.width,
      height = imageData.height;

    var x,
      y,
      i,
      p,
      yp,
      yi,
      yw,
      r_sum,
      g_sum,
      b_sum,
      a_sum,
      r_out_sum,
      g_out_sum,
      b_out_sum,
      a_out_sum,
      r_in_sum,
      g_in_sum,
      b_in_sum,
      a_in_sum,
      pr,
      pg,
      pb,
      pa,
      rbs;

    var div = radius + radius + 1,
      widthMinus1 = width - 1,
      heightMinus1 = height - 1,
      radiusPlus1 = radius + 1,
      sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2,
      stackStart = new BlurStack(),
      stackEnd = null,
      stack = stackStart,
      stackIn = null,
      stackOut = null,
      mul_sum = mul_table[radius],
      shg_sum = shg_table[radius];

    for (i = 1; i < div; i++) {
      stack = stack.next = new BlurStack();
      if (i === radiusPlus1) {
        stackEnd = stack;
      }
    }

    stack.next = stackStart;

    yw = yi = 0;

    for (y = 0; y < height; y++) {
      r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;

      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

      r_sum += sumFactor * pr;
      g_sum += sumFactor * pg;
      b_sum += sumFactor * pb;
      a_sum += sumFactor * pa;

      stack = stackStart;

      for (i = 0; i < radiusPlus1; i++) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack.a = pa;
        stack = stack.next;
      }

      for (i = 1; i < radiusPlus1; i++) {
        p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
        r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
        g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
        b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
        a_sum += (stack.a = pa = pixels[p + 3]) * rbs;

        r_in_sum += pr;
        g_in_sum += pg;
        b_in_sum += pb;
        a_in_sum += pa;

        stack = stack.next;
      }

      stackIn = stackStart;
      stackOut = stackEnd;
      for (x = 0; x < width; x++) {
        pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
        if (pa !== 0) {
          pa = 255 / pa;
          pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
          pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
          pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
        } else {
          pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
        }

        r_sum -= r_out_sum;
        g_sum -= g_out_sum;
        b_sum -= b_out_sum;
        a_sum -= a_out_sum;

        r_out_sum -= stackIn.r;
        g_out_sum -= stackIn.g;
        b_out_sum -= stackIn.b;
        a_out_sum -= stackIn.a;

        p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

        r_in_sum += stackIn.r = pixels[p];
        g_in_sum += stackIn.g = pixels[p + 1];
        b_in_sum += stackIn.b = pixels[p + 2];
        a_in_sum += stackIn.a = pixels[p + 3];

        r_sum += r_in_sum;
        g_sum += g_in_sum;
        b_sum += b_in_sum;
        a_sum += a_in_sum;

        stackIn = stackIn.next;

        r_out_sum += pr = stackOut.r;
        g_out_sum += pg = stackOut.g;
        b_out_sum += pb = stackOut.b;
        a_out_sum += pa = stackOut.a;

        r_in_sum -= pr;
        g_in_sum -= pg;
        b_in_sum -= pb;
        a_in_sum -= pa;

        stackOut = stackOut.next;

        yi += 4;
      }
      yw += width;
    }

    for (x = 0; x < width; x++) {
      g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;

      yi = x << 2;
      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

      r_sum += sumFactor * pr;
      g_sum += sumFactor * pg;
      b_sum += sumFactor * pb;
      a_sum += sumFactor * pa;

      stack = stackStart;

      for (i = 0; i < radiusPlus1; i++) {
        stack.r = pr;
        stack.g = pg;
        stack.b = pb;
        stack.a = pa;
        stack = stack.next;
      }

      yp = width;

      for (i = 1; i <= radius; i++) {
        yi = (yp + x) << 2;

        r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
        g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
        b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
        a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;

        r_in_sum += pr;
        g_in_sum += pg;
        b_in_sum += pb;
        a_in_sum += pa;

        stack = stack.next;

        if (i < heightMinus1) {
          yp += width;
        }
      }

      yi = x;
      stackIn = stackStart;
      stackOut = stackEnd;
      for (y = 0; y < height; y++) {
        p = yi << 2;
        pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
        if (pa > 0) {
          pa = 255 / pa;
          pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
          pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
          pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
        } else {
          pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
        }

        r_sum -= r_out_sum;
        g_sum -= g_out_sum;
        b_sum -= b_out_sum;
        a_sum -= a_out_sum;

        r_out_sum -= stackIn.r;
        g_out_sum -= stackIn.g;
        b_out_sum -= stackIn.b;
        a_out_sum -= stackIn.a;

        p =
          (x +
            ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) *
              width) <<
          2;

        r_sum += r_in_sum += stackIn.r = pixels[p];
        g_sum += g_in_sum += stackIn.g = pixels[p + 1];
        b_sum += b_in_sum += stackIn.b = pixels[p + 2];
        a_sum += a_in_sum += stackIn.a = pixels[p + 3];

        stackIn = stackIn.next;

        r_out_sum += pr = stackOut.r;
        g_out_sum += pg = stackOut.g;
        b_out_sum += pb = stackOut.b;
        a_out_sum += pa = stackOut.a;

        r_in_sum -= pr;
        g_in_sum -= pg;
        b_in_sum -= pb;
        a_in_sum -= pa;

        stackOut = stackOut.next;

        yi += width;
      }
    }
  }

  /**
   * Blur Filter
   * @function
   * @name Blur
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Blur]);
   * node.blurRadius(10);
   */
  Konva.Filters.Blur = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());

    if (radius > 0) {
      filterGaussBlurRGBA(imageData, radius);
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'blurRadius',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );

  /**
   * get/set blur radius. Use with {@link Konva.Filters.Blur} filter
   * @name blurRadius
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} radius
   * @returns {Integer}
   */
})(Konva);

/*eslint-disable  max-depth */
(function() {
  'use strict';
  function pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(
      idata.data[idx++],
      idata.data[idx++],
      idata.data[idx++],
      idata.data[idx++]
    );
    return d;
  }

  function rgbDistance(p1, p2) {
    return Math.sqrt(
      Math.pow(p1[0] - p2[0], 2) +
        Math.pow(p1[1] - p2[1], 2) +
        Math.pow(p1[2] - p2[2], 2)
    );
  }

  function rgbMean(pTab) {
    var m = [0, 0, 0];

    for (var i = 0; i < pTab.length; i++) {
      m[0] += pTab[i][0];
      m[1] += pTab[i][1];
      m[2] += pTab[i][2];
    }

    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;

    return m;
  }

  function backgroundMask(idata, threshold) {
    var rgbv_no = pixelAt(idata, 0, 0);
    var rgbv_ne = pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);

    var thres = threshold || 10;
    if (
      rgbDistance(rgbv_no, rgbv_ne) < thres &&
      rgbDistance(rgbv_ne, rgbv_se) < thres &&
      rgbDistance(rgbv_se, rgbv_so) < thres &&
      rgbDistance(rgbv_so, rgbv_no) < thres
    ) {
      // Mean color
      var mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);

      // Mask based on color distance
      var mask = [];
      for (var i = 0; i < idata.width * idata.height; i++) {
        var d = rgbDistance(mean, [
          idata.data[i * 4],
          idata.data[i * 4 + 1],
          idata.data[i * 4 + 2]
        ]);
        mask[i] = d < thres ? 0 : 255;
      }

      return mask;
    }
  }

  function applyMask(idata, mask) {
    for (var i = 0; i < idata.width * idata.height; i++) {
      idata.data[4 * i + 3] = mask[i];
    }
  }

  function erodeMask(mask, sw, sh) {
    var weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);

    var maskResult = [];
    for (var y = 0; y < sh; y++) {
      for (var x = 0; x < sw; x++) {
        var so = y * sw + x;
        var a = 0;
        for (var cy = 0; cy < side; cy++) {
          for (var cx = 0; cx < side; cx++) {
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;

            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              var srcOff = scy * sw + scx;
              var wt = weights[cy * side + cx];

              a += mask[srcOff] * wt;
            }
          }
        }

        maskResult[so] = a === 255 * 8 ? 255 : 0;
      }
    }

    return maskResult;
  }

  function dilateMask(mask, sw, sh) {
    var weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);

    var maskResult = [];
    for (var y = 0; y < sh; y++) {
      for (var x = 0; x < sw; x++) {
        var so = y * sw + x;
        var a = 0;
        for (var cy = 0; cy < side; cy++) {
          for (var cx = 0; cx < side; cx++) {
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;

            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              var srcOff = scy * sw + scx;
              var wt = weights[cy * side + cx];

              a += mask[srcOff] * wt;
            }
          }
        }

        maskResult[so] = a >= 255 * 4 ? 255 : 0;
      }
    }

    return maskResult;
  }

  function smoothEdgeMask(mask, sw, sh) {
    var weights = [
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);

    var maskResult = [];
    for (var y = 0; y < sh; y++) {
      for (var x = 0; x < sw; x++) {
        var so = y * sw + x;
        var a = 0;
        for (var cy = 0; cy < side; cy++) {
          for (var cx = 0; cx < side; cx++) {
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;

            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              var srcOff = scy * sw + scx;
              var wt = weights[cy * side + cx];

              a += mask[srcOff] * wt;
            }
          }
        }

        maskResult[so] = a;
      }
    }

    return maskResult;
  }

  /**
   * Mask Filter
   * @function
   * @name Mask
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Mask]);
   * node.threshold(200);
   */
  Konva.Filters.Mask = function(imageData) {
    // Detect pixels close to the background color
    var threshold = this.threshold(),
      mask = backgroundMask(imageData, threshold);
    if (mask) {
      // Erode
      mask = erodeMask(mask, imageData.width, imageData.height);

      // Dilate
      mask = dilateMask(mask, imageData.width, imageData.height);

      // Gradient
      mask = smoothEdgeMask(mask, imageData.width, imageData.height);

      // Apply mask
      applyMask(imageData, mask);

      // todo : Update hit region function according to mask
    }

    return imageData;
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'threshold',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
})();

(function() {
  'use strict';
  /**
   * RGB Filter
   * @function
   * @name RGB
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.RGB]);
   * node.blue(120);
   * node.green(200);
   */
  Konva.Filters.RGB = function(imageData) {
    var data = imageData.data,
      nPixels = data.length,
      red = this.red(),
      green = this.green(),
      blue = this.blue(),
      i,
      brightness;

    for (i = 0; i < nPixels; i += 4) {
      brightness =
        (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
      data[i] = brightness * red; // r
      data[i + 1] = brightness * green; // g
      data[i + 2] = brightness * blue; // b
      data[i + 3] = data[i + 3]; // alpha
    }
  };

  Konva.Factory.addGetterSetter(Konva.Node, 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) {
      return 255;
    } else if (val < 0) {
      return 0;
    } else {
      return Math.round(val);
    }
  });
  /**
   * get/set filter red value. Use with {@link Konva.Filters.RGB} filter.
   * @name red
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} red value between 0 and 255
   * @returns {Integer}
   */

  Konva.Factory.addGetterSetter(Konva.Node, 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) {
      return 255;
    } else if (val < 0) {
      return 0;
    } else {
      return Math.round(val);
    }
  });
  /**
   * get/set filter green value. Use with {@link Konva.Filters.RGB} filter.
   * @name green
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} green value between 0 and 255
   * @returns {Integer}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'blue',
    0,
    Konva.Validators.RGBComponent,
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set filter blue value. Use with {@link Konva.Filters.RGB} filter.
   * @name blue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} blue value between 0 and 255
   * @returns {Integer}
   */
})();

(function() {
  'use strict';
  /**
   * RGBA Filter
   * @function
   * @name RGBA
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author codefo
   * @example
   * node.cache();
   * node.filters([Konva.Filters.RGBA]);
   * node.blue(120);
   * node.green(200);
   * node.alpha(0.3);
   */
  Konva.Filters.RGBA = function(imageData) {
    var data = imageData.data,
      nPixels = data.length,
      red = this.red(),
      green = this.green(),
      blue = this.blue(),
      alpha = this.alpha(),
      i,
      ia;

    for (i = 0; i < nPixels; i += 4) {
      ia = 1 - alpha;

      data[i] = red * alpha + data[i] * ia; // r
      data[i + 1] = green * alpha + data[i + 1] * ia; // g
      data[i + 2] = blue * alpha + data[i + 2] * ia; // b
    }
  };

  Konva.Factory.addGetterSetter(Konva.Node, 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) {
      return 255;
    } else if (val < 0) {
      return 0;
    } else {
      return Math.round(val);
    }
  });
  /**
   * get/set filter red value. Use with {@link Konva.Filters.RGBA} filter.
   * @name red
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} red value between 0 and 255
   * @returns {Integer}
   */

  Konva.Factory.addGetterSetter(Konva.Node, 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) {
      return 255;
    } else if (val < 0) {
      return 0;
    } else {
      return Math.round(val);
    }
  });
  /**
   * get/set filter green value. Use with {@link Konva.Filters.RGBA} filter.
   * @name green
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} green value between 0 and 255
   * @returns {Integer}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'blue',
    0,
    Konva.Validators.RGBComponent,
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set filter blue value. Use with {@link Konva.Filters.RGBA} filter.
   * @name blue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} blue value between 0 and 255
   * @returns {Integer}
   */

  Konva.Factory.addGetterSetter(Konva.Node, 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) {
      return 1;
    } else if (val < 0) {
      return 0;
    } else {
      return val;
    }
  });
  /**
   * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
   * @name alpha
   * @method
   * @memberof Konva.Node.prototype
   * @param {Float} alpha value between 0 and 1
   * @returns {Float}
   */
})();

(function() {
  'use strict';
  /**
   * HSV Filter. Adjusts the hue, saturation and value
   * @function
   * @name HSV
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * image.filters([Konva.Filters.HSV]);
   * image.value(200);
   */

  Konva.Filters.HSV = function(imageData) {
    var data = imageData.data,
      nPixels = data.length,
      v = Math.pow(2, this.value()),
      s = Math.pow(2, this.saturation()),
      h = Math.abs(this.hue() + 360) % 360,
      i;

    // Basis for the technique used:
    // http://beesbuzz.biz/code/hsv_color_transforms.php
    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
    // H is the hue shift in degrees (0 to 360)
    // vsu = V*S*cos(H*PI/180);
    // vsw = V*S*sin(H*PI/180);
    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]

    // Precompute the values in the matrix:
    var vsu = v * s * Math.cos(h * Math.PI / 180),
      vsw = v * s * Math.sin(h * Math.PI / 180);
    // (result spot)(source spot)
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw,
      rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw,
      rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw,
      gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw,
      gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw,
      bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw,
      bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;

    var r, g, b, a;

    for (i = 0; i < nPixels; i += 4) {
      r = data[i + 0];
      g = data[i + 1];
      b = data[i + 2];
      a = data[i + 3];

      data[i + 0] = rr * r + rg * g + rb * b;
      data[i + 1] = gr * r + gg * g + gb * b;
      data[i + 2] = br * r + bg * g + bb * b;
      data[i + 3] = a; // alpha
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'hue',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name hue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} hue value between 0 and 359
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'saturation',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name saturation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'value',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsv value. Use with {@link Konva.Filters.HSV} filter.
   * @name value
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
   * @returns {Number}
   */
})();

(function() {
  'use strict';
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'hue',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name hue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} hue value between 0 and 359
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'saturation',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name saturation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'luminance',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set hsl luminance. Use with {@link Konva.Filters.HSL} filter.
   * @name luminance
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} value from -1 to 1
   * @returns {Number}
   */

  /**
   * HSL Filter. Adjusts the hue, saturation and luminance (or lightness)
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * image.filters([Konva.Filters.HSL]);
   * image.luminance(0.2);
   */

  Konva.Filters.HSL = function(imageData) {
    var data = imageData.data,
      nPixels = data.length,
      v = 1,
      s = Math.pow(2, this.saturation()),
      h = Math.abs(this.hue() + 360) % 360,
      l = this.luminance() * 127,
      i;

    // Basis for the technique used:
    // http://beesbuzz.biz/code/hsv_color_transforms.php
    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
    // H is the hue shift in degrees (0 to 360)
    // vsu = V*S*cos(H*PI/180);
    // vsw = V*S*sin(H*PI/180);
    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]

    // Precompute the values in the matrix:
    var vsu = v * s * Math.cos((h * Math.PI) / 180),
      vsw = v * s * Math.sin((h * Math.PI) / 180);
    // (result spot)(source spot)
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw,
      rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw,
      rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw,
      gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw,
      gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw,
      bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw,
      bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;

    var r, g, b, a;

    for (i = 0; i < nPixels; i += 4) {
      r = data[i + 0];
      g = data[i + 1];
      b = data[i + 2];
      a = data[i + 3];

      data[i + 0] = rr * r + rg * g + rb * b + l;
      data[i + 1] = gr * r + gg * g + gb * b + l;
      data[i + 2] = br * r + bg * g + bb * b + l;
      data[i + 3] = a; // alpha
    }
  };
})();

(function() {
  'use strict';
  /**
   * Emboss Filter.
   * Pixastic Lib - Emboss filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * License: [http://www.pixastic.com/lib/license.txt]
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Emboss]);
   * node.embossStrength(0.8);
   * node.embossWhiteLevel(0.3);
   * node.embossDirection('right');
   * node.embossBlend(true);
   */
  Konva.Filters.Emboss = function(imageData) {
    // pixastic strength is between 0 and 10.  I want it between 0 and 1
    // pixastic greyLevel is between 0 and 255.  I want it between 0 and 1.  Also,
    // a max value of greyLevel yields a white emboss, and the min value yields a black
    // emboss.  Therefore, I changed greyLevel to whiteLevel
    var strength = this.embossStrength() * 10,
      greyLevel = this.embossWhiteLevel() * 255,
      direction = this.embossDirection(),
      blend = this.embossBlend(),
      dirY = 0,
      dirX = 0,
      data = imageData.data,
      w = imageData.width,
      h = imageData.height,
      w4 = w * 4,
      y = h;

    switch (direction) {
      case 'top-left':
        dirY = -1;
        dirX = -1;
        break;
      case 'top':
        dirY = -1;
        dirX = 0;
        break;
      case 'top-right':
        dirY = -1;
        dirX = 1;
        break;
      case 'right':
        dirY = 0;
        dirX = 1;
        break;
      case 'bottom-right':
        dirY = 1;
        dirX = 1;
        break;
      case 'bottom':
        dirY = 1;
        dirX = 0;
        break;
      case 'bottom-left':
        dirY = 1;
        dirX = -1;
        break;
      case 'left':
        dirY = 0;
        dirX = -1;
        break;
      default:
        Konva.Util.error('Unknown emboss direction: ' + direction);
    }

    do {
      var offsetY = (y - 1) * w4;

      var otherY = dirY;
      if (y + otherY < 1) {
        otherY = 0;
      }
      if (y + otherY > h) {
        otherY = 0;
      }

      var offsetYOther = (y - 1 + otherY) * w * 4;

      var x = w;
      do {
        var offset = offsetY + (x - 1) * 4;

        var otherX = dirX;
        if (x + otherX < 1) {
          otherX = 0;
        }
        if (x + otherX > w) {
          otherX = 0;
        }

        var offsetOther = offsetYOther + (x - 1 + otherX) * 4;

        var dR = data[offset] - data[offsetOther];
        var dG = data[offset + 1] - data[offsetOther + 1];
        var dB = data[offset + 2] - data[offsetOther + 2];

        var dif = dR;
        var absDif = dif > 0 ? dif : -dif;

        var absG = dG > 0 ? dG : -dG;
        var absB = dB > 0 ? dB : -dB;

        if (absG > absDif) {
          dif = dG;
        }
        if (absB > absDif) {
          dif = dB;
        }

        dif *= strength;

        if (blend) {
          var r = data[offset] + dif;
          var g = data[offset + 1] + dif;
          var b = data[offset + 2] + dif;

          data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
          data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
          data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
        } else {
          var grey = greyLevel - dif;
          if (grey < 0) {
            grey = 0;
          } else if (grey > 255) {
            grey = 255;
          }

          data[offset] = data[offset + 1] = data[offset + 2] = grey;
        }
      } while (--x);
    } while (--y);
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'embossStrength',
    0.5,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set emboss strength. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossStrength
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} level between 0 and 1.  Default is 0.5
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'embossWhiteLevel',
    0.5,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set emboss white level. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossWhiteLevel
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} embossWhiteLevel between 0 and 1.  Default is 0.5
   * @returns {Number}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'embossDirection',
    'top-left',
    null,
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set emboss direction. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossDirection
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} embossDirection can be top-left, top, top-right, right, bottom-right, bottom, bottom-left or left
   *   The default is top-left
   * @returns {String}
   */

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'embossBlend',
    false,
    null,
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set emboss blend. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossBlend
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean} embossBlend
   * @returns {Boolean}
   */
})();

(function() {
  'use strict';
  function remap(fromValue, fromMin, fromMax, toMin, toMax) {
    // Compute the range of the data
    var fromRange = fromMax - fromMin,
      toRange = toMax - toMin,
      toValue;

    // If either range is 0, then the value can only be mapped to 1 value
    if (fromRange === 0) {
      return toMin + toRange / 2;
    }
    if (toRange === 0) {
      return toMin;
    }

    // (1) untranslate, (2) unscale, (3) rescale, (4) retranslate
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;

    return toValue;
  }

  /**
   * Enhance Filter. Adjusts the colors so that they span the widest
   *  possible range (ie 0-255). Performs w*h pixel reads and w*h pixel
   *  writes.
   * @function
   * @name Enhance
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Enhance]);
   * node.enhance(0.4);
   */
  Konva.Filters.Enhance = function(imageData) {
    var data = imageData.data,
      nSubPixels = data.length,
      rMin = data[0],
      rMax = rMin,
      r,
      gMin = data[1],
      gMax = gMin,
      g,
      bMin = data[2],
      bMax = bMin,
      b,
      i;

    // If we are not enhancing anything - don't do any computation
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) {
      return;
    }

    // 1st Pass - find the min and max for each channel:
    for (i = 0; i < nSubPixels; i += 4) {
      r = data[i + 0];
      if (r < rMin) {
        rMin = r;
      } else if (r > rMax) {
        rMax = r;
      }
      g = data[i + 1];
      if (g < gMin) {
        gMin = g;
      } else if (g > gMax) {
        gMax = g;
      }
      b = data[i + 2];
      if (b < bMin) {
        bMin = b;
      } else if (b > bMax) {
        bMax = b;
      }
      //a = data[i + 3];
      //if (a < aMin) { aMin = a; } else
      //if (a > aMax) { aMax = a; }
    }

    // If there is only 1 level - don't remap
    if (rMax === rMin) {
      rMax = 255;
      rMin = 0;
    }
    if (gMax === gMin) {
      gMax = 255;
      gMin = 0;
    }
    if (bMax === bMin) {
      bMax = 255;
      bMin = 0;
    }

    var rMid,
      rGoalMax,
      rGoalMin,
      gMid,
      gGoalMax,
      gGoalMin,
      bMid,
      bGoalMax,
      bGoalMin;

    // If the enhancement is positive - stretch the histogram
    if (enhanceAmount > 0) {
      rGoalMax = rMax + enhanceAmount * (255 - rMax);
      rGoalMin = rMin - enhanceAmount * (rMin - 0);
      gGoalMax = gMax + enhanceAmount * (255 - gMax);
      gGoalMin = gMin - enhanceAmount * (gMin - 0);
      bGoalMax = bMax + enhanceAmount * (255 - bMax);
      bGoalMin = bMin - enhanceAmount * (bMin - 0);
      // If the enhancement is negative -   compress the histogram
    } else {
      rMid = (rMax + rMin) * 0.5;
      rGoalMax = rMax + enhanceAmount * (rMax - rMid);
      rGoalMin = rMin + enhanceAmount * (rMin - rMid);
      gMid = (gMax + gMin) * 0.5;
      gGoalMax = gMax + enhanceAmount * (gMax - gMid);
      gGoalMin = gMin + enhanceAmount * (gMin - gMid);
      bMid = (bMax + bMin) * 0.5;
      bGoalMax = bMax + enhanceAmount * (bMax - bMid);
      bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }

    // Pass 2 - remap everything, except the alpha
    for (i = 0; i < nSubPixels; i += 4) {
      data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
      data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
      data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
      //data[i + 3] = remap(data[i + 3], aMin, aMax, aGoalMin, aGoalMax);
    }
  };

  /**
   * get/set enhance. Use with {@link Konva.Filters.Enhance} filter. -1 to 1 values
   * @name enhance
   * @method
   * @memberof Konva.Node.prototype
   * @param {Float} amount
   * @returns {Float}
   */
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'enhance',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
})();

(function() {
  'use strict';
  /**
   * Posterize Filter. Adjusts the channels so that there are no more
   *  than n different values for that channel. This is also applied
   *  to the alpha channel.
   * @function
   * @name Posterize
   * @author ippo615
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Posterize]);
   * node.levels(0.8); // between 0 and 1
   */

  Konva.Filters.Posterize = function(imageData) {
    // level must be between 1 and 255
    var levels = Math.round(this.levels() * 254) + 1,
      data = imageData.data,
      len = data.length,
      scale = 255 / levels,
      i;

    for (i = 0; i < len; i += 1) {
      data[i] = Math.floor(data[i] / scale) * scale;
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'levels',
    0.5,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );

  /**
   * get/set levels.  Must be a number between 0 and 1.  Use with {@link Konva.Filters.Posterize} filter.
   * @name levels
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} level between 0 and 1
   * @returns {Number}
   */
})();

(function() {
  'use strict';
  /**
   * Noise Filter. Randomly adds or substracts to the color channels
   * @function
   * @name Noise
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Noise]);
   * node.noise(0.8);
   */
  Konva.Filters.Noise = function(imageData) {
    var amount = this.noise() * 255,
      data = imageData.data,
      nPixels = data.length,
      half = amount / 2,
      i;

    for (i = 0; i < nPixels; i += 4) {
      data[i + 0] += half - 2 * half * Math.random();
      data[i + 1] += half - 2 * half * Math.random();
      data[i + 2] += half - 2 * half * Math.random();
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'noise',
    0.2,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set noise amount.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Noise} filter.
   * @name noise
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} noise
   * @returns {Number}
   */
})();

/*eslint-disable max-depth */
(function() {
  'use strict';
  /**
   * Pixelate Filter. Averages groups of pixels and redraws
   *  them as larger pixels
   * @function
   * @name Pixelate
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Pixelate]);
   * node.pixelSize(10);
   */

  Konva.Filters.Pixelate = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()),
      width = imageData.width,
      height = imageData.height,
      x,
      y,
      i,
      //pixelsPerBin = pixelSize * pixelSize,
      red,
      green,
      blue,
      alpha,
      nBinsX = Math.ceil(width / pixelSize),
      nBinsY = Math.ceil(height / pixelSize),
      xBinStart,
      xBinEnd,
      yBinStart,
      yBinEnd,
      xBin,
      yBin,
      pixelsInBin;
    imageData = imageData.data;

    if (pixelSize <= 0) {
      Konva.Util.error('pixelSize value can not be <= 0');
      return;
    }

    for (xBin = 0; xBin < nBinsX; xBin += 1) {
      for (yBin = 0; yBin < nBinsY; yBin += 1) {
        // Initialize the color accumlators to 0
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;

        // Determine which pixels are included in this bin
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;

        // Add all of the pixels to this bin!
        pixelsInBin = 0;
        for (x = xBinStart; x < xBinEnd; x += 1) {
          if (x >= width) {
            continue;
          }
          for (y = yBinStart; y < yBinEnd; y += 1) {
            if (y >= height) {
              continue;
            }
            i = (width * y + x) * 4;
            red += imageData[i + 0];
            green += imageData[i + 1];
            blue += imageData[i + 2];
            alpha += imageData[i + 3];
            pixelsInBin += 1;
          }
        }

        // Make sure the channels are between 0-255
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;

        // Draw this bin
        for (x = xBinStart; x < xBinEnd; x += 1) {
          if (x >= width) {
            continue;
          }
          for (y = yBinStart; y < yBinEnd; y += 1) {
            if (y >= height) {
              continue;
            }
            i = (width * y + x) * 4;
            imageData[i + 0] = red;
            imageData[i + 1] = green;
            imageData[i + 2] = blue;
            imageData[i + 3] = alpha;
          }
        }
      }
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'pixelSize',
    8,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set pixel size. Use with {@link Konva.Filters.Pixelate} filter.
   * @name pixelSize
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} pixelSize
   * @returns {Integer}
   */
})();

(function() {
  'use strict';
  /**
   * Threshold Filter. Pushes any value above the mid point to
   *  the max and any value below the mid point to the min.
   *  This affects the alpha channel.
   * @function
   * @name Threshold
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Threshold]);
   * node.threshold(0.1);
   */

  Konva.Filters.Threshold = function(imageData) {
    var level = this.threshold() * 255,
      data = imageData.data,
      len = data.length,
      i;

    for (i = 0; i < len; i += 1) {
      data[i] = data[i] < level ? 0 : 255;
    }
  };

  Konva.Factory.addGetterSetter(
    Konva.Node,
    'threshold',
    0.5,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
  /**
   * get/set threshold.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Threshold} or {@link Konva.Filters.Mask} filter.
   * @name threshold
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} threshold
   * @returns {Number}
   */
})();

(function() {
  'use strict';
  /**
   * Sepia Filter
   * Based on: Pixastic Lib - Sepia filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * @function
   * @name Sepia
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author Jacob Seidelin <jseidelin@nihilogic.dk>
   * @license MPL v1.1 [http://www.pixastic.com/lib/license.txt]
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Sepia]);
   */
  Konva.Filters.Sepia = function(imageData) {
    var data = imageData.data,
      w = imageData.width,
      y = imageData.height,
      w4 = w * 4,
      offsetY,
      x,
      offset,
      or,
      og,
      ob,
      r,
      g,
      b;

    do {
      offsetY = (y - 1) * w4;
      x = w;
      do {
        offset = offsetY + (x - 1) * 4;

        or = data[offset];
        og = data[offset + 1];
        ob = data[offset + 2];

        r = or * 0.393 + og * 0.769 + ob * 0.189;
        g = or * 0.349 + og * 0.686 + ob * 0.168;
        b = or * 0.272 + og * 0.534 + ob * 0.131;

        data[offset] = r > 255 ? 255 : r;
        data[offset + 1] = g > 255 ? 255 : g;
        data[offset + 2] = b > 255 ? 255 : b;
        data[offset + 3] = data[offset + 3];
      } while (--x);
    } while (--y);
  };
})();

(function() {
  'use strict';
  /**
   * Solarize Filter
   * Pixastic Lib - Solarize filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * License: [http://www.pixastic.com/lib/license.txt]
   * @function
   * @name Solarize
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Solarize]);
   */
  Konva.Filters.Solarize = function(imageData) {
    var data = imageData.data,
      w = imageData.width,
      h = imageData.height,
      w4 = w * 4,
      y = h;

    do {
      var offsetY = (y - 1) * w4;
      var x = w;
      do {
        var offset = offsetY + (x - 1) * 4;
        var r = data[offset];
        var g = data[offset + 1];
        var b = data[offset + 2];

        if (r > 127) {
          r = 255 - r;
        }
        if (g > 127) {
          g = 255 - g;
        }
        if (b > 127) {
          b = 255 - b;
        }

        data[offset] = r;
        data[offset + 1] = g;
        data[offset + 2] = b;
      } while (--x);
    } while (--y);
  };
})();

(function() {
  'use strict';
  /*
   * ToPolar Filter. Converts image data to polar coordinates. Performs
   *  w*h*4 pixel reads and w*h pixel writes. The r axis is placed along
   *  what would be the y axis and the theta axis along the x axis.
   * @function
   * @author ippo615
   * @memberof Konva.Filters
   * @param {ImageData} src, the source image data (what will be transformed)
   * @param {ImageData} dst, the destination image data (where it will be saved)
   * @param {Object} opt
   * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
   *  default is in the middle
   * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
   *  default is in the middle
   */

  var ToPolar = function(src, dst, opt) {
    var srcPixels = src.data,
      dstPixels = dst.data,
      xSize = src.width,
      ySize = src.height,
      xMid = opt.polarCenterX || xSize / 2,
      yMid = opt.polarCenterY || ySize / 2,
      i,
      x,
      y,
      r = 0,
      g = 0,
      b = 0,
      a = 0;

    // Find the largest radius
    var rad,
      rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;

    // We'll be uisng y as the radius, and x as the angle (theta=t)
    var rSize = ySize,
      tSize = xSize,
      radius,
      theta;

    // We want to cover all angles (0-360) and we need to convert to
    // radians (*PI/180)
    var conversion = 360 / tSize * Math.PI / 180,
      sin,
      cos;

    // var x1, x2, x1i, x2i, y1, y2, y1i, y2i, scale;

    for (theta = 0; theta < tSize; theta += 1) {
      sin = Math.sin(theta * conversion);
      cos = Math.cos(theta * conversion);
      for (radius = 0; radius < rSize; radius += 1) {
        x = Math.floor(xMid + rMax * radius / rSize * cos);
        y = Math.floor(yMid + rMax * radius / rSize * sin);
        i = (y * xSize + x) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];

        // Store it
        //i = (theta * xSize  +  radius) * 4;
        i = (theta + radius * xSize) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
      }
    }
  };

  /*
     * FromPolar Filter. Converts image data from polar coordinates back to rectangular.
     *  Performs w*h*4 pixel reads and w*h pixel writes.
     * @function
     * @author ippo615
     * @memberof Konva.Filters
     * @param {ImageData} src, the source image data (what will be transformed)
     * @param {ImageData} dst, the destination image data (where it will be saved)
     * @param {Object} opt
     * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
     *  default is in the middle
     * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
     *  default is in the middle
     * @param {Number} [opt.polarRotation] amount to rotate the image counterclockwis,
     *  0 is no rotation, 360 degrees is a full rotation
     */

  var FromPolar = function(src, dst, opt) {
    var srcPixels = src.data,
      dstPixels = dst.data,
      xSize = src.width,
      ySize = src.height,
      xMid = opt.polarCenterX || xSize / 2,
      yMid = opt.polarCenterY || ySize / 2,
      i,
      x,
      y,
      dx,
      dy,
      r = 0,
      g = 0,
      b = 0,
      a = 0;

    // Find the largest radius
    var rad,
      rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;

    // We'll be uisng x as the radius, and y as the angle (theta=t)
    var rSize = ySize,
      tSize = xSize,
      radius,
      theta,
      phaseShift = opt.polarRotation || 0;

    // We need to convert to degrees and we need to make sure
    // it's between (0-360)
    // var conversion = tSize/360*180/Math.PI;
    //var conversion = tSize/360*180/Math.PI;

    var x1, y1;

    for (x = 0; x < xSize; x += 1) {
      for (y = 0; y < ySize; y += 1) {
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];

        // Store it
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
      }
    }
  };

  //Konva.Filters.ToPolar = Konva.Util._FilterWrapDoubleBuffer(ToPolar);
  //Konva.Filters.FromPolar = Konva.Util._FilterWrapDoubleBuffer(FromPolar);

  // create a temporary canvas for working - shared between multiple calls

  /*
     * Kaleidoscope Filter.
     * @function
     * @name Kaleidoscope
     * @author ippo615
     * @memberof Konva.Filters
     * @example
     * node.cache();
     * node.filters([Konva.Filters.Kaleidoscope]);
     * node.kaleidoscopePower(3);
     * node.kaleidoscopeAngle(45);
     */
  Konva.Filters.Kaleidoscope = function(imageData) {
    var xSize = imageData.width,
      ySize = imageData.height;

    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);

    if (power < 1) {
      return;
    }

    // Work with our shared buffer canvas
    var tempCanvas = Konva.Util.createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas
      .getContext('2d')
      .getImageData(0, 0, xSize, ySize);

    // Convert thhe original to polar coordinates
    ToPolar(imageData, scratchData, {
      polarCenterX: xSize / 2,
      polarCenterY: ySize / 2
    });

    // Determine how big each section will be, if it's too small
    // make it bigger
    var minSectionSize = xSize / Math.pow(2, power);
    while (minSectionSize <= 8) {
      minSectionSize = minSectionSize * 2;
      power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;

    // Copy the offset region to 0
    // Depending on the size of filter and location of the offset we may need
    // to copy the section backwards to prevent it from rewriting itself
    var xStart = 0,
      xEnd = sectionSize,
      xDelta = 1;
    if (offset + minSectionSize > xSize) {
      xStart = sectionSize;
      xEnd = 0;
      xDelta = -1;
    }
    for (y = 0; y < ySize; y += 1) {
      for (x = xStart; x !== xEnd; x += xDelta) {
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
      }
    }

    // Perform the actual effect
    for (y = 0; y < ySize; y += 1) {
      sectionSize = Math.floor(minSectionSize);
      for (i = 0; i < power; i += 1) {
        for (x = 0; x < sectionSize + 1; x += 1) {
          srcPos = (xSize * y + x) * 4;
          r = scratchData.data[srcPos + 0];
          g = scratchData.data[srcPos + 1];
          b = scratchData.data[srcPos + 2];
          a = scratchData.data[srcPos + 3];
          dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
          scratchData.data[dstPos + 0] = r;
          scratchData.data[dstPos + 1] = g;
          scratchData.data[dstPos + 2] = b;
          scratchData.data[dstPos + 3] = a;
        }
        sectionSize *= 2;
      }
    }

    // Convert back from polar coordinates
    FromPolar(scratchData, imageData, { polarRotation: 0 });
  };

  /**
   * get/set kaleidoscope power. Use with {@link Konva.Filters.Kaleidoscope} filter.
   * @name kaleidoscopePower
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} power of kaleidoscope
   * @returns {Integer}
   */
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'kaleidoscopePower',
    2,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );

  /**
   * get/set kaleidoscope angle. Use with {@link Konva.Filters.Kaleidoscope} filter.
   * @name kaleidoscopeAngle
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} degrees
   * @returns {Integer}
   */
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'kaleidoscopeAngle',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
})();

(function(Konva) {
  'use strict';
  /**
   * Contrast Filter.
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Contrast]);
   * node.contrast(10);
   */

  Konva.Filters.Contrast = function(imageData) {
    var adjust = Math.pow((parseInt(this.contrast()) + 100) / 100, 2);

    var data = imageData.data,
      nPixels = data.length,
      red = 150,
      green = 150,
      blue = 150,
      i;

    for (i = 0; i < nPixels; i += 4) {
      red = data[i];
      green = data[i + 1];
      blue = data[i + 2];

      //Red channel
      red /= 255;
      red -= 0.5;
      red *= adjust;
      red += 0.5;
      red *= 255;

      //Green channel
      green /= 255;
      green -= 0.5;
      green *= adjust;
      green += 0.5;
      green *= 255;

      //Blue channel
      blue /= 255;
      blue -= 0.5;
      blue *= adjust;
      blue += 0.5;
      blue *= 255;

      red = red < 0 ? 0 : red > 255 ? 255 : red;
      green = green < 0 ? 0 : green > 255 ? 255 : green;
      blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;

      data[i] = red;
      data[i + 1] = green;
      data[i + 2] = blue;
    }
  };

  /**
   * get/set filter contrast.  The contrast is a number between -100 and 100.
   * Use with {@link Konva.Filters.Contrast} filter.
   * @name contrast
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} contrast value between -100 and 100
   * @returns {Number}
   */
  Konva.Factory.addGetterSetter(
    Konva.Node,
    'contrast',
    0,
    Konva.Validators.getNumberValidator(),
    Konva.Factory.afterSetFilter
  );
})(Konva);

(function() {
  'use strict';
  /**
   * Container constructor.&nbsp; Containers are used to contain nodes or other containers
   * @constructor
   * @memberof Konva
   * @augments Konva.Node
   * @abstract
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   */
  Konva.Container = function(config) {
    this.__init(config);
  };

  Konva.Util.addMethods(Konva.Container, {
    __init: function(config) {
      this.children = new Konva.Collection();
      Konva.Node.call(this, config);
    },
    /**
     * returns a {@link Konva.Collection} of direct descendant nodes
     * @method
     * @memberof Konva.Container.prototype
     * @param {Function} [filterFunc] filter function
     * @returns {Konva.Collection}
     * @example
     * // get all children
     * var children = layer.getChildren();
     *
     * // get only circles
     * var circles = layer.getChildren(function(node){
     *    return node.getClassName() === 'Circle';
     * });
     */
    getChildren: function(filterFunc) {
      if (!filterFunc) {
        return this.children;
      }

      var results = new Konva.Collection();
      this.children.each(function(child) {
        if (filterFunc(child)) {
          results.push(child);
        }
      });
      return results;
    },
    /**
     * determine if node has children
     * @method
     * @memberof Konva.Container.prototype
     * @returns {Boolean}
     */
    hasChildren: function() {
      return this.getChildren().length > 0;
    },
    /**
     * remove all children
     * @method
     * @memberof Konva.Container.prototype
     */
    removeChildren: function() {
      var children = Konva.Collection.toCollection(this.children);
      var child;
      for (var i = 0; i < children.length; i++) {
        child = children[i];
        // reset parent to prevent many _setChildrenIndices calls
        delete child.parent;
        child.index = 0;
        child.remove();
      }
      children = null;
      this.children = new Konva.Collection();
      return this;
    },
    /**
     * destroy all children
     * @method
     * @memberof Konva.Container.prototype
     */
    destroyChildren: function() {
      var children = Konva.Collection.toCollection(this.children);
      var child;
      for (var i = 0; i < children.length; i++) {
        child = children[i];
        // reset parent to prevent many _setChildrenIndices calls
        delete child.parent;
        child.index = 0;
        child.destroy();
      }
      children = null;
      this.children = new Konva.Collection();
      return this;
    },
    /**
     * Add node or nodes to container.
     * @method
     * @memberof Konva.Container.prototype
     * @param {...Konva.Node} child
     * @returns {Container}
     * @example
     * layer.add(shape1, shape2, shape3);
     */
    add: function(child) {
      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length; i++) {
          this.add(arguments[i]);
        }
        return this;
      }
      if (child.getParent()) {
        child.moveTo(this);
        return this;
      }
      var children = this.children;
      this._validateAdd(child);
      child.index = children.length;
      child.parent = this;
      children.push(child);
      this._fire('add', {
        child: child
      });

      // if node under drag we need to update drag animation
      if (Konva.DD && child.isDragging()) {
        Konva.DD.anim.setLayers(child.getLayer());
      }

      // chainable
      return this;
    },
    destroy: function() {
      // destroy children
      if (this.hasChildren()) {
        this.destroyChildren();
      }
      // then destroy self
      Konva.Node.prototype.destroy.call(this);
      return this;
    },
    /**
     * return a {@link Konva.Collection} of nodes that match the selector.
     * You can provide a string with '#' for id selections and '.' for name selections.
     * Or a function that will return true/false when a node is passed through.  See example below.
     * With strings you can also select by type or class name. Pass multiple selectors
     * separated by a space.
     * @method
     * @memberof Konva.Container.prototype
     * @param {String | Function} selector
     * @returns {Collection}
     * @example
     *
     * Passing a string as a selector
     * // select node with id foo
     * var node = stage.find('#foo');
     *
     * // select nodes with name bar inside layer
     * var nodes = layer.find('.bar');
     *
     * // select all groups inside layer
     * var nodes = layer.find('Group');
     *
     * // select all rectangles inside layer
     * var nodes = layer.find('Rect');
     *
     * // select node with an id of foo or a name of bar inside layer
     * var nodes = layer.find('#foo, .bar');
     *
     * Passing a function as a selector
     *
     * // get all Groups
     * var groups = stage.find(node => {
     *  return node.getType() === 'Group';
     * });
     *
     * // get only Nodes with partial opacity
     * var alphaNodes = layer.find(node => {
     *  return node.getType() === 'Node' && node.getAbsoluteOpacity() < 1;
     * });
     */
    find: function(selector) {
      // protecting _generalFind to prevent user from accidentally adding
      // second argument and getting unexpected `findOne` result
      return this._generalFind(selector, false);
    },
    /**
     * return a first node from `find` method
     * @method
     * @memberof Konva.Container.prototype
     * @param {String | Function} selector
     * @returns {Konva.Node | Undefined}
     * @example
     * // select node with id foo
     * var node = stage.findOne('#foo');
     *
     * // select node with name bar inside layer
     * var nodes = layer.findOne('.bar');
     *
     * // select the first node to return true in a function
     * var node = stage.findOne(node => {
     *  return node.getType() === 'Shape'
     * })
     */
    findOne: function(selector) {
      var result = this._generalFind(selector, true);
      return result.length > 0 ? result[0] : undefined;
    },
    _generalFind: function(selector, findOne) {
      var retArr = [];

      if (typeof selector === 'string') {
        retArr = this._findByString(selector, findOne);
      } else if (typeof selector === 'function') {
        retArr = this._findByFunction(selector, findOne);
      }

      return Konva.Collection.toCollection(retArr);
    },
    _findByString: function(selector) {
      var retArr = [],
        selectorArr = selector.replace(/ /g, '').split(','),
        len = selectorArr.length,
        n,
        i,
        sel,
        arr,
        node,
        children,
        clen;

      for (n = 0; n < len; n++) {
        sel = selectorArr[n];
        if (!Konva.Util.isValidSelector(sel)) {
          var message =
            'Selector "' +
            sel +
            '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".\n' +
            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".\n' +
            'Konva is awesome, right?';
          Konva.Util.warn(message);
        }
        // id selector
        if (sel.charAt(0) === '#') {
          node = this._getNodeById(sel.slice(1));
          if (node) {
            retArr.push(node);
          }
        } else if (sel.charAt(0) === '.') {
          // name selector
          arr = this._getNodesByName(sel.slice(1));
          retArr = retArr.concat(arr);
        } else {
          // unrecognized selector, pass to children
          children = this.getChildren();
          clen = children.length;
          for (i = 0; i < clen; i++) {
            retArr = retArr.concat(children[i]._get(sel));
          }
        }
      }

      return retArr;
    },
    // (fn: ((Node) => boolean, findOne?: boolean)
    _findByFunction: function(fn, findOne) {
      var retArr = [];

      var addItems = function(el) {
        // escape function if we've already found one.
        if (findOne && retArr.length > 0) {
          return;
        }

        var children = el.getChildren();
        var clen = children.length;

        if (fn(el)) {
          retArr = retArr.concat(el);
        }

        for (var i = 0; i < clen; i++) {
          addItems(children[i]);
        }
      };

      addItems(this);

      return retArr;
    },
    _getNodeById: function(key) {
      var node = Konva.ids[key];

      if (node !== undefined && this.isAncestorOf(node)) {
        return node;
      }
      return null;
    },
    _getNodesByName: function(key) {
      var arr = Konva.names[key] || [];
      return this._getDescendants(arr);
    },
    _get: function(selector) {
      var retArr = Konva.Node.prototype._get.call(this, selector);
      var children = this.getChildren();
      var len = children.length;
      for (var n = 0; n < len; n++) {
        retArr = retArr.concat(children[n]._get(selector));
      }
      return retArr;
    },
    // extenders
    toObject: function() {
      var obj = Konva.Node.prototype.toObject.call(this);

      obj.children = [];

      var children = this.getChildren();
      var len = children.length;
      for (var n = 0; n < len; n++) {
        var child = children[n];
        obj.children.push(child.toObject());
      }

      return obj;
    },
    _getDescendants: function(arr) {
      var retArr = [];
      var len = arr.length;
      for (var n = 0; n < len; n++) {
        var node = arr[n];
        if (this.isAncestorOf(node)) {
          retArr.push(node);
        }
      }

      return retArr;
    },
    /**
     * determine if node is an ancestor
     * of descendant
     * @method
     * @memberof Konva.Container.prototype
     * @param {Konva.Node} node
     */
    isAncestorOf: function(node) {
      var parent = node.getParent();
      while (parent) {
        if (parent._id === this._id) {
          return true;
        }
        parent = parent.getParent();
      }

      return false;
    },
    clone: function(obj) {
      // call super method
      var node = Konva.Node.prototype.clone.call(this, obj);

      this.getChildren().each(function(no) {
        node.add(no.clone());
      });
      return node;
    },
    /**
     * get all shapes that intersect a point.  Note: because this method must clear a temporary
     * canvas and redraw every shape inside the container, it should only be used for special sitations
     * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     * because it performs much better
     * @method
     * @memberof Konva.Container.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Array} array of shapes
     */
    getAllIntersections: function(pos) {
      var arr = [];

      this.find('Shape').each(function(shape) {
        if (shape.isVisible() && shape.intersects(pos)) {
          arr.push(shape);
        }
      });

      return arr;
    },
    _setChildrenIndices: function() {
      this.children.each(function(child, n) {
        child.index = n;
      });
    },
    drawScene: function(can, top, caching) {
      var layer = this.getLayer(),
        canvas = can || (layer && layer.getCanvas()),
        context = canvas && canvas.getContext(),
        cachedCanvas = this._cache.canvas,
        cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;

      if (this.isVisible() || caching) {
        if (!caching && cachedSceneCanvas) {
          context.save();
          layer._applyTransform(this, context, top);
          this._drawCachedSceneCanvas(context);
          context.restore();
        } else {
          this._drawChildren(canvas, 'drawScene', top, false, caching);
        }
      }
      return this;
    },
    drawHit: function(can, top, caching) {
      var layer = this.getLayer(),
        canvas = can || (layer && layer.hitCanvas),
        context = canvas && canvas.getContext(),
        cachedCanvas = this._cache.canvas,
        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;

      if (this.shouldDrawHit(canvas) || caching) {
        if (layer) {
          layer.clearHitCache();
        }
        if (!caching && cachedHitCanvas) {
          context.save();
          layer._applyTransform(this, context, top);
          this._drawCachedHitCanvas(context);
          context.restore();
        } else {
          this._drawChildren(canvas, 'drawHit', top);
        }
      }
      return this;
    },
    _drawChildren: function(canvas, drawMethod, top, caching, skipBuffer) {
      var layer = this.getLayer(),
        context = canvas && canvas.getContext(),
        clipWidth = this.getClipWidth(),
        clipHeight = this.getClipHeight(),
        clipFunc = this.getClipFunc(),
        hasClip = (clipWidth && clipHeight) || clipFunc,
        clipX,
        clipY;

      if (hasClip && layer) {
        context.save();
        var transform = this.getAbsoluteTransform(top);
        var m = transform.getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        context.beginPath();
        if (clipFunc) {
          clipFunc.call(this, context, this);
        } else {
          clipX = this.getClipX();
          clipY = this.getClipY();
          context.rect(clipX, clipY, clipWidth, clipHeight);
        }
        context.clip();
        m = transform
          .copy()
          .invert()
          .getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }

      this.children.each(function(child) {
        child[drawMethod](canvas, top, caching, skipBuffer);
      });

      if (hasClip) {
        context.restore();
      }
    },
    shouldDrawHit: function(canvas) {
      var layer = this.getLayer();
      var dd = Konva.DD;
      var layerUnderDrag =
        dd &&
        Konva.isDragging() &&
        Konva.DD.anim.getLayers().indexOf(layer) !== -1;
      return (
        (canvas && canvas.isCache) ||
        (layer &&
          layer.hitGraphEnabled() &&
          this.isVisible() &&
          !layerUnderDrag)
      );
    },
    getClientRect: function(attrs) {
      attrs = attrs || {};
      var skipTransform = attrs.skipTransform;
      var relativeTo = attrs.relativeTo;

      var minX, minY, maxX, maxY;
      var selfRect = {
        x: Infinity,
        y: Infinity,
        width: 0,
        height: 0
      };
      var that = this;
      this.children.each(function(child) {
        // skip invisible children
        if (!child.getVisible()) {
          return;
        }

        var rect = child.getClientRect({
          relativeTo: that,
          skipShadow: attrs.skipShadow,
          skipStroke: attrs.skipStroke
        });

        // skip invisible children (like empty groups)
        if (rect.width === 0 && rect.height === 0) {
          return;
        }

        if (minX === undefined) {
          // initial value for first child
          minX = rect.x;
          minY = rect.y;
          maxX = rect.x + rect.width;
          maxY = rect.y + rect.height;
        } else {
          minX = Math.min(minX, rect.x);
          minY = Math.min(minY, rect.y);
          maxX = Math.max(maxX, rect.x + rect.width);
          maxY = Math.max(maxY, rect.y + rect.height);
        }
      });

      // if child is group we need to make sure it has visible shapes inside
      var shapes = this.find('Shape');
      var hasVisible = false;
      for (var i = 0; i < shapes.length; i++) {
        var shape = shapes[i];
        if (shape._isVisible(this)) {
          hasVisible = true;
          break;
        }
      }

      if (hasVisible) {
        selfRect = {
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY
        };
      } else {
        selfRect = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (!skipTransform) {
        return this._transformedRect(selfRect, relativeTo);
      }
      return selfRect;
    }
  });

  Konva.Util.extend(Konva.Container, Konva.Node);
  // deprecated methods
  Konva.Container.prototype.get = Konva.Container.prototype.find;

  // add getters setters
  Konva.Factory.addComponentsGetterSetter(Konva.Container, 'clip', [
    'x',
    'y',
    'width',
    'height'
  ]);
  /**
   * get/set clip
   * @method
   * @name clip
   * @memberof Konva.Container.prototype
   * @param {Object} clip
   * @param {Number} clip.x
   * @param {Number} clip.y
   * @param {Number} clip.width
   * @param {Number} clip.height
   * @returns {Object}
   * @example
   * // get clip
   * var clip = container.clip();
   *
   * // set clip
   * container.setClip({
   *   x: 20,
   *   y: 20,
   *   width: 20,
   *   height: 20
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Container,
    'clipX',
    undefined,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set clip x
   * @name clipX
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get clip x
   * var clipX = container.clipX();
   *
   * // set clip x
   * container.clipX(10);
   */

  Konva.Factory.addGetterSetter(
    Konva.Container,
    'clipY',
    undefined,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set clip y
   * @name clipY
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get clip y
   * var clipY = container.clipY();
   *
   * // set clip y
   * container.clipY(10);
   */

  Konva.Factory.addGetterSetter(
    Konva.Container,
    'clipWidth',
    undefined,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set clip width
   * @name clipWidth
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get clip width
   * var clipWidth = container.clipWidth();
   *
   * // set clip width
   * container.clipWidth(100);
   */

  Konva.Factory.addGetterSetter(
    Konva.Container,
    'clipHeight',
    undefined,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set clip height
   * @name clipHeight
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get clip height
   * var clipHeight = container.clipHeight();
   *
   * // set clip height
   * container.clipHeight(100);
   */

  Konva.Factory.addGetterSetter(Konva.Container, 'clipFunc');
  /**
   * get/set clip function
   * @name clipFunc
   * @method
   * @memberof Konva.Container.prototype
   * @param {Function} function
   * @returns {Function}
   * @example
   * // get clip function
   * var clipFunction = container.clipFunc();
   *
   * // set clip height
   * container.clipFunc(function(ctx) {
   *   ctx.rect(0, 0, 100, 100);
   * });
   */

  Konva.Collection.mapMethods(Konva.Container);
})();

(function(Konva) {
  'use strict';
  var HAS_SHADOW = 'hasShadow';
  var SHADOW_RGBA = 'shadowRGBA';

  function _fillFunc(context) {
    context.fill();
  }
  function _strokeFunc(context) {
    context.stroke();
  }
  function _fillFuncHit(context) {
    context.fill();
  }
  function _strokeFuncHit(context) {
    context.stroke();
  }

  function _clearHasShadowCache() {
    this._clearCache(HAS_SHADOW);
  }

  function _clearGetShadowRGBACache() {
    this._clearCache(SHADOW_RGBA);
  }

  /**
   * Shape constructor.  Shapes are primitive objects such as rectangles,
   *  circles, text, lines, etc.
   * @constructor
   * @memberof Konva
   * @augments Konva.Node
   * @param {Object} config
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var customShape = new Konva.Shape({
   *   x: 5,
   *   y: 10,
   *   fill: 'red',
   *   // a Konva.Canvas renderer is passed into the sceneFunc function
   *   sceneFunc: function(context, shape) {
   *     context.beginPath();
   *     context.moveTo(200, 50);
   *     context.lineTo(420, 80);
   *     context.quadraticCurveTo(300, 100, 260, 170);
   *     context.closePath();
   *     // Konva specific method
   *     context.fillStrokeShape(shape);
   *   }
   *});
   */
  Konva.Shape = function(config) {
    this.__init(config);
  };

  Konva.Util.addMethods(Konva.Shape, {
    __init: function(config) {
      this.nodeType = 'Shape';
      this._fillFunc = _fillFunc;
      this._strokeFunc = _strokeFunc;
      this._fillFuncHit = _fillFuncHit;
      this._strokeFuncHit = _strokeFuncHit;

      // set colorKey
      var shapes = Konva.shapes;
      var key;

      while (true) {
        key = Konva.Util.getRandomColor();
        if (key && !(key in shapes)) {
          break;
        }
      }

      this.colorKey = key;
      shapes[key] = this;

      // call super constructor
      Konva.Node.call(this, config);

      this.on(
        'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
        _clearHasShadowCache
      );

      this.on(
        'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
        _clearGetShadowRGBACache
      );
    },
    hasChildren: function() {
      return false;
    },
    getChildren: function() {
      return [];
    },
    /**
     * get canvas context tied to the layer
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Konva.Context}
     */
    getContext: function() {
      return this.getLayer().getContext();
    },
    /**
     * get canvas renderer tied to the layer.  Note that this returns a canvas renderer, not a canvas element
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Konva.Canvas}
     */
    getCanvas: function() {
      return this.getLayer().getCanvas();
    },
    /**
     * returns whether or not a shadow will be rendered
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */
    hasShadow: function() {
      return this._getCache(HAS_SHADOW, this._hasShadow);
    },
    _hasShadow: function() {
      return (
        this.getShadowEnabled() &&
        (this.getShadowOpacity() !== 0 &&
          !!(
            this.getShadowColor() ||
            this.getShadowBlur() ||
            this.getShadowOffsetX() ||
            this.getShadowOffsetY()
          ))
      );
    },
    getShadowRGBA: function() {
      return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
    },
    _getShadowRGBA: function() {
      if (this.hasShadow()) {
        var rgba = Konva.Util.colorToRGBA(this.shadowColor());
        return (
          'rgba(' +
          rgba.r +
          ',' +
          rgba.g +
          ',' +
          rgba.b +
          ',' +
          rgba.a * (this.getShadowOpacity() || 1) +
          ')'
        );
      }
    },
    /**
     * returns whether or not the shape will be filled
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */
    hasFill: function() {
      return !!(
        this.getFill() ||
        this.getFillPatternImage() ||
        this.getFillLinearGradientColorStops() ||
        this.getFillRadialGradientColorStops()
      );
    },
    /**
     * returns whether or not the shape will be stroked
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */
    hasStroke: function() {
      return (
        this.strokeEnabled() &&
        !!(this.stroke() || this.getStrokeLinearGradientColorStops())
        // TODO: do we need radial gradient
        // this.getStrokeRadialGradientColorStops()
      );
    },
    /**
     * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
     *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
     *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     *  because it performs much better
     * @method
     * @memberof Konva.Shape.prototype
     * @param {Object} point
     * @param {Number} point.x
     * @param {Number} point.y
     * @returns {Boolean}
     */
    intersects: function(point) {
      var stage = this.getStage(),
        bufferHitCanvas = stage.bufferHitCanvas,
        p;

      bufferHitCanvas.getContext().clear();
      this.drawHit(bufferHitCanvas);
      p = bufferHitCanvas.context.getImageData(
        Math.round(point.x),
        Math.round(point.y),
        1,
        1
      ).data;
      return p[3] > 0;
    },
    // extends Node.prototype.destroy
    destroy: function() {
      Konva.Node.prototype.destroy.call(this);
      delete Konva.shapes[this.colorKey];
      return this;
    },
    _useBufferCanvas: function(caching) {
      return (
        (!caching &&
          (this.perfectDrawEnabled() &&
            this.getAbsoluteOpacity() !== 1 &&
            this.hasFill() &&
            this.hasStroke() &&
            this.getStage())) ||
        (this.perfectDrawEnabled() &&
          this.hasShadow() &&
          this.getAbsoluteOpacity() !== 1 &&
          this.hasFill() &&
          this.hasStroke() &&
          this.getStage())
      );
    },
    /**
     * return self rectangle (x, y, width, height) of shape.
     * This method are not taken into account transformation and styles.
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     *
     * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
     * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
     *
     */
    getSelfRect: function() {
      var size = this.getSize();
      return {
        x: this._centroid ? Math.round(-size.width / 2) : 0,
        y: this._centroid ? Math.round(-size.height / 2) : 0,
        width: size.width,
        height: size.height
      };
    },
    getClientRect: function(attrs) {
      attrs = attrs || {};
      var skipTransform = attrs.skipTransform;

      var relativeTo = attrs.relativeTo;

      var fillRect = this.getSelfRect();

      var applyStroke = !attrs.skipStroke && this.hasStroke();
      var strokeWidth = (applyStroke && this.strokeWidth()) || 0;

      // var scale = {
      //   x: 1,
      //   y: 1
      // };
      // if (!this.strokeScaleEnabled()) {
      //   var scale = this.getAbsoluteScale();
      //   // scale = {
      //   //   x: Math.abs(scale.x)
      //   // }
      // }

      var fillAndStrokeWidth = fillRect.width + strokeWidth;
      var fillAndStrokeHeight = fillRect.height + strokeWidth;

      var applyShadow = !attrs.skipShadow && this.hasShadow();
      var shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
      var shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;

      var preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
      var preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);

      var blurRadius = (applyShadow && this.shadowBlur()) || 0;

      var width = preWidth + blurRadius * 2;
      var height = preHeight + blurRadius * 2;

      // if stroke, for example = 3
      // we need to set x to 1.5, but after Math.round it will be 2
      // as we have additional offset we need to increase width and height by 1 pixel
      var roundingOffset = 0;
      if (Math.round(strokeWidth / 2) !== strokeWidth / 2) {
        roundingOffset = 1;
      }
      var rect = {
        width: width + roundingOffset,
        height: height + roundingOffset,
        x:
          -Math.round(strokeWidth / 2 + blurRadius) +
          Math.min(shadowOffsetX, 0) +
          fillRect.x,
        y:
          -Math.round(strokeWidth / 2 + blurRadius) +
          Math.min(shadowOffsetY, 0) +
          fillRect.y
      };
      if (!skipTransform) {
        return this._transformedRect(rect, relativeTo);
      }
      return rect;
    },
    drawScene: function(can, top, caching, skipBuffer) {
      var layer = this.getLayer(),
        canvas = can || layer.getCanvas(),
        context = canvas.getContext(),
        cachedCanvas = this._cache.canvas,
        drawFunc = this.sceneFunc(),
        hasShadow = this.hasShadow(),
        hasStroke = this.hasStroke(),
        stage,
        bufferCanvas,
        bufferContext;

      if (!this.isVisible() && !caching) {
        return this;
      }
      if (cachedCanvas) {
        context.save();
        layer._applyTransform(this, context, top);
        this._drawCachedSceneCanvas(context);
        context.restore();
        return this;
      }
      if (!drawFunc) {
        return this;
      }
      context.save();
      // if buffer canvas is needed
      if (this._useBufferCanvas(caching) && !skipBuffer) {
        stage = this.getStage();
        bufferCanvas = stage.bufferCanvas;
        bufferContext = bufferCanvas.getContext();
        bufferContext.clear();
        bufferContext.save();
        bufferContext._applyLineJoin(this);
        // layer might be undefined if we are using cache before adding to layer
        if (!caching) {
          if (layer) {
            layer._applyTransform(this, bufferContext, top);
          } else {
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
          }
        }

        drawFunc.call(this, bufferContext, this);
        bufferContext.restore();

        var ratio = bufferCanvas.pixelRatio;
        if (hasShadow && !canvas.hitCanvas) {
          context.save();

          context._applyShadow(this);
          context._applyOpacity(this);
          context._applyGlobalCompositeOperation(this);
          context.drawImage(
            bufferCanvas._canvas,
            0,
            0,
            bufferCanvas.width / ratio,
            bufferCanvas.height / ratio
          );
          context.restore();
        } else {
          context._applyOpacity(this);
          context._applyGlobalCompositeOperation(this);
          context.drawImage(
            bufferCanvas._canvas,
            0,
            0,
            bufferCanvas.width / ratio,
            bufferCanvas.height / ratio
          );
        }
      } else {
        // if buffer canvas is not needed
        context._applyLineJoin(this);
        // layer might be undefined if we are using cache before adding to layer
        if (!caching) {
          if (layer) {
            layer._applyTransform(this, context, top);
          } else {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
          }
        }

        if (hasShadow && hasStroke && !canvas.hitCanvas) {
          context.save();
          // apply shadow
          if (!caching) {
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
          }
          context._applyShadow(this);

          drawFunc.call(this, context, this);
          context.restore();
          // if shape has stroke we need to redraw shape
          // otherwise we will see a shadow under stroke (and over fill)
          // but I think this is unexpected behavior
          if (this.hasFill() && this.getShadowForStrokeEnabled()) {
            drawFunc.call(this, context, this);
          }
        } else if (hasShadow && !canvas.hitCanvas) {
          context.save();
          if (!caching) {
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
          }
          context._applyShadow(this);
          drawFunc.call(this, context, this);
          context.restore();
        } else {
          if (!caching) {
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
          }
          drawFunc.call(this, context, this);
        }
      }
      context.restore();
      return this;
    },
    drawHit: function(can, top, caching) {
      var layer = this.getLayer(),
        canvas = can || layer.hitCanvas,
        context = canvas.getContext(),
        drawFunc = this.hitFunc() || this.sceneFunc(),
        cachedCanvas = this._cache.canvas,
        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;

      if (!this.shouldDrawHit(canvas) && !caching) {
        return this;
      }
      if (layer) {
        layer.clearHitCache();
      }
      if (cachedHitCanvas) {
        context.save();
        layer._applyTransform(this, context, top);
        this._drawCachedHitCanvas(context);
        context.restore();
        return this;
      }
      if (!drawFunc) {
        return this;
      }
      context.save();
      context._applyLineJoin(this);
      if (!caching) {
        if (layer) {
          layer._applyTransform(this, context, top);
        } else {
          var o = this.getAbsoluteTransform(top).getMatrix();
          context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
      }
      drawFunc.call(this, context, this);
      context.restore();
      return this;
    },
    /**
     * draw hit graph using the cached scene canvas
     * @method
     * @memberof Konva.Shape.prototype
     * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
     *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
     *  The default is 0
     * @returns {Konva.Shape}
     * @example
     * shape.cache();
     * shape.drawHitFromCache();
     */
    drawHitFromCache: function(alphaThreshold) {
      var threshold = alphaThreshold || 0,
        cachedCanvas = this._cache.canvas,
        sceneCanvas = this._getCachedSceneCanvas(),
        hitCanvas = cachedCanvas.hit,
        hitContext = hitCanvas.getContext(),
        hitWidth = hitCanvas.getWidth(),
        hitHeight = hitCanvas.getHeight(),
        hitImageData,
        hitData,
        len,
        rgbColorKey,
        i,
        alpha;

      hitContext.clear();
      hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);

      try {
        hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
        hitData = hitImageData.data;
        len = hitData.length;
        rgbColorKey = Konva.Util._hexToRgb(this.colorKey);

        // replace non transparent pixels with color key
        for (i = 0; i < len; i += 4) {
          alpha = hitData[i + 3];
          if (alpha > threshold) {
            hitData[i] = rgbColorKey.r;
            hitData[i + 1] = rgbColorKey.g;
            hitData[i + 2] = rgbColorKey.b;
            hitData[i + 3] = 255;
          } else {
            hitData[i + 3] = 0;
          }
        }
        hitContext.putImageData(hitImageData, 0, 0);
      } catch (e) {
        Konva.Util.error(
          'Unable to draw hit graph from cached scene canvas. ' + e.message
        );
      }

      return this;
    }
  });
  Konva.Util.extend(Konva.Shape, Konva.Node);

  // add getters and setters
  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'stroke',
    undefined,
    Konva.Validators.getStringValidator()
  );

  /**
   * get/set stroke color
   * @name stroke
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get stroke color
   * var stroke = shape.stroke();
   *
   * // set stroke color with color string
   * shape.stroke('green');
   *
   * // set stroke color with hex
   * shape.stroke('#00ff00');
   *
   * // set stroke color with rgb
   * shape.stroke('rgb(0,255,0)');
   *
   * // set stroke color with rgba and make it 50% opaque
   * shape.stroke('rgba(0,255,0,0.5');
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeWidth',
    2,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set stroke width
   * @name strokeWidth
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} strokeWidth
   * @returns {Number}
   * @example
   * // get stroke width
   * var strokeWidth = shape.strokeWidth();
   *
   * // set stroke width
   * shape.strokeWidth();
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeHitEnabled',
    true,
    Konva.Validators.getBooleanValidator()
  );

  /**
   * get/set strokeHitEnabled property. Useful for performance optimization.
   * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
   * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
   * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
   * Default value is true
   * @name strokeHitEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} strokeHitEnabled
   * @returns {Boolean}
   * @example
   * // get strokeHitEnabled
   * var strokeHitEnabled = shape.strokeHitEnabled();
   *
   * // set strokeHitEnabled
   * shape.strokeHitEnabled();
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'perfectDrawEnabled',
    true,
    Konva.Validators.getBooleanValidator()
  );

  /**
   * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
   * See http://konvajs.github.io/docs/performance/Disable_Perfect_Draw.html for more information.
   * Default value is true
   * @name perfectDrawEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} perfectDrawEnabled
   * @returns {Boolean}
   * @example
   * // get perfectDrawEnabled
   * var perfectDrawEnabled = shape.perfectDrawEnabled();
   *
   * // set perfectDrawEnabled
   * shape.perfectDrawEnabled();
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowForStrokeEnabled',
    true,
    Konva.Validators.getBooleanValidator()
  );

  /**
   * get/set shadowForStrokeEnabled. Useful for performance optimization.
   * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will be no draw shadow for stroke.
   * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line with have no shadow!.
   * Default value is true
   * @name shadowForStrokeEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} shadowForStrokeEnabled
   * @returns {Boolean}
   * @example
   * // get shadowForStrokeEnabled
   * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
   *
   * // set shadowForStrokeEnabled
   * shape.shadowForStrokeEnabled();
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'lineJoin');

  /**
   * get/set line join.  Can be miter, round, or bevel.  The
   *  default is miter
   * @name lineJoin
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} lineJoin
   * @returns {String}
   * @example
   * // get line join
   * var lineJoin = shape.lineJoin();
   *
   * // set line join
   * shape.lineJoin('round');
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'lineCap');

  /**
   * get/set line cap.  Can be butt, round, or square
   * @name lineCap
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} lineCap
   * @returns {String}
   * @example
   * // get line cap
   * var lineCap = shape.lineCap();
   *
   * // set line cap
   * shape.lineCap('round');
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'sceneFunc');

  /**
   * get/set scene draw function
   * @name sceneFunc
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Function} drawFunc drawing function
   * @returns {Function}
   * @example
   * // get scene draw function
   * var sceneFunc = shape.sceneFunc();
   *
   * // set scene draw function
   * shape.sceneFunc(function(context) {
   *   context.beginPath();
   *   context.rect(0, 0, this.width(), this.height());
   *   context.closePath();
   *   context.fillStrokeShape(this);
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'hitFunc');

  /**
   * get/set hit draw function
   * @name hitFunc
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Function} drawFunc drawing function
   * @returns {Function}
   * @example
   * // get hit draw function
   * var hitFunc = shape.hitFunc();
   *
   * // set hit draw function
   * shape.hitFunc(function(context) {
   *   context.beginPath();
   *   context.rect(0, 0, this.width(), this.height());
   *   context.closePath();
   *   context.fillStrokeShape(this);
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'dash');

  /**
   * get/set dash array for stroke.
   * @name dash
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} dash
   * @returns {Array}
   * @example
   *  // apply dashed stroke that is 10px long and 5 pixels apart
   *  line.dash([10, 5]);
   *  // apply dashed stroke that is made up of alternating dashed
   *  // lines that are 10px long and 20px apart, and dots that have
   *  // a radius of 5px and are 20px apart
   *  line.dash([10, 20, 0.001, 20]);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'dashOffset',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set dash offset for stroke.
   * @name dash
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} dash offset
   * @returns {Number}
   * @example
   *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
   *  line.dash([10, 5]);
   *  line.dashOffset(5);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowColor',
    undefined,
    Konva.Validators.getStringValidator()
  );

  /**
   * get/set shadow color
   * @name shadowColor
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get shadow color
   * var shadow = shape.shadowColor();
   *
   * // set shadow color with color string
   * shape.shadowColor('green');
   *
   * // set shadow color with hex
   * shape.shadowColor('#00ff00');
   *
   * // set shadow color with rgb
   * shape.shadowColor('rgb(0,255,0)');
   *
   * // set shadow color with rgba and make it 50% opaque
   * shape.shadowColor('rgba(0,255,0,0.5');
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowBlur',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set shadow blur
   * @name shadowBlur
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} blur
   * @returns {Number}
   * @example
   * // get shadow blur
   * var shadowBlur = shape.shadowBlur();
   *
   * // set shadow blur
   * shape.shadowBlur(10);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowOpacity',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set shadow opacity.  must be a value between 0 and 1
   * @name shadowOpacity
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} opacity
   * @returns {Number}
   * @example
   * // get shadow opacity
   * var shadowOpacity = shape.shadowOpacity();
   *
   * // set shadow opacity
   * shape.shadowOpacity(0.5);
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'shadowOffset', [
    'x',
    'y'
  ]);

  /**
   * get/set shadow offset
   * @name shadowOffset
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get shadow offset
   * var shadowOffset = shape.shadowOffset();
   *
   * // set shadow offset
   * shape.shadowOffset({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowOffsetX',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set shadow offset x
   * @name shadowOffsetX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get shadow offset x
   * var shadowOffsetX = shape.shadowOffsetX();
   *
   * // set shadow offset x
   * shape.shadowOffsetX(5);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'shadowOffsetY',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set shadow offset y
   * @name shadowOffsetY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get shadow offset y
   * var shadowOffsetY = shape.shadowOffsetY();
   *
   * // set shadow offset y
   * shape.shadowOffsetY(5);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternImage');

  /**
   * get/set fill pattern image
   * @name fillPatternImage
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Image} image object
   * @returns {Image}
   * @example
   * // get fill pattern image
   * var fillPatternImage = shape.fillPatternImage();
   *
   * // set fill pattern image
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   shape.fillPatternImage(imageObj);
   * };
   * imageObj.src = 'path/to/image/jpg';
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fill',
    undefined,
    Konva.Validators.getStringValidator()
  );

  /**
   * get/set fill color
   * @name fill
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get fill color
   * var fill = shape.fill();
   *
   * // set fill color with color string
   * shape.fill('green');
   *
   * // set fill color with hex
   * shape.fill('#00ff00');
   *
   * // set fill color with rgb
   * shape.fill('rgb(0,255,0)');
   *
   * // set fill color with rgba and make it 50% opaque
   * shape.fill('rgba(0,255,0,0.5');
   *
   * // shape without fill
   * shape.fill(null);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternX',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern x
   * @name fillPatternX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern x
   * var fillPatternX = shape.fillPatternX();
   * // set fill pattern x
   * shape.fillPatternX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternY',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern y
   * @name fillPatternY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern y
   * var fillPatternY = shape.fillPatternY();
   * // set fill pattern y
   * shape.fillPatternY(20);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientColorStops');

  /**
   * get/set fill linear gradient color stops
   * @name fillLinearGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} colorStops
   * @returns {Array} colorStops
   * @example
   * // get fill linear gradient color stops
   * var colorStops = shape.fillLinearGradientColorStops();
   *
   * // create a linear gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeLinearGradientColorStops');

  /**
   * get/set stroke linear gradient color stops
   * @name strokeLinearGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} colorStops
   * @returns {Array} colorStops
   * @example
   * // get stroke linear gradient color stops
   * var colorStops = shape.strokeLinearGradientColorStops();
   *
   * // create a linear gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.strokeLinearGradientColorStops([0, 'red', 0.5, 'blue', 1, 'green']);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillRadialGradientStartRadius',
    0
  );

  /**
   * get/set fill radial gradient start radius
   * @name fillRadialGradientStartRadius
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radial gradient start radius
   * var startRadius = shape.fillRadialGradientStartRadius();
   *
   * // set radial gradient start radius
   * shape.fillRadialGradientStartRadius(0);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndRadius', 0);

  /**
   * get/set fill radial gradient end radius
   * @name fillRadialGradientEndRadius
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radial gradient end radius
   * var endRadius = shape.fillRadialGradientEndRadius();
   *
   * // set radial gradient end radius
   * shape.fillRadialGradientEndRadius(100);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientColorStops');

  /**
   * get/set fill radial gradient color stops
   * @name fillRadialGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} colorStops
   * @returns {Array}
   * @example
   * // get fill radial gradient color stops
   * var colorStops = shape.fillRadialGradientColorStops();
   *
   * // create a radial gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRepeat', 'repeat');

  /**
   * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
   * @name fillPatternRepeat
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} repeat
   * @returns {String}
   * @example
   * // get fill pattern repeat
   * var repeat = shape.fillPatternRepeat();
   *
   * // repeat pattern in x direction only
   * shape.fillPatternRepeat('repeat-x');
   *
   * // do not repeat the pattern
   * shape.fillPatternRepeat('no repeat');
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillEnabled', true);

  /**
   * get/set fill enabled flag
   * @name fillEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get fill enabled flag
   * var fillEnabled = shape.fillEnabled();
   *
   * // disable fill
   * shape.fillEnabled(false);
   *
   * // enable fill
   * shape.fillEnabled(true);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeEnabled', true);

  /**
   * get/set stroke enabled flag
   * @name strokeEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get stroke enabled flag
   * var strokeEnabled = shape.strokeEnabled();
   *
   * // disable stroke
   * shape.strokeEnabled(false);
   *
   * // enable stroke
   * shape.strokeEnabled(true);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowEnabled', true);

  /**
   * get/set shadow enabled flag
   * @name shadowEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get shadow enabled flag
   * var shadowEnabled = shape.shadowEnabled();
   *
   * // disable shadow
   * shape.shadowEnabled(false);
   *
   * // enable shadow
   * shape.shadowEnabled(true);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'dashEnabled', true);

  /**
   * get/set dash enabled flag
   * @name dashEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get dash enabled flag
   * var dashEnabled = shape.dashEnabled();
   *
   * // disable dash
   * shape.dashEnabled(false);
   *
   * // enable dash
   * shape.dashEnabled(true);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeScaleEnabled', true);

  /**
   * get/set strokeScale enabled flag
   * @name strokeScaleEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get stroke scale enabled flag
   * var strokeScaleEnabled = shape.strokeScaleEnabled();
   *
   * // disable stroke scale
   * shape.strokeScaleEnabled(false);
   *
   * // enable stroke scale
   * shape.strokeScaleEnabled(true);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPriority', 'color');

  /**
   * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
   *   This is handy if you want to toggle between different fill types.
   * @name fillPriority
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} priority
   * @returns {String}
   * @example
   * // get fill priority
   * var fillPriority = shape.fillPriority();
   *
   * // set fill priority
   * shape.fillPriority('linear-gradient');
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternOffset', [
    'x',
    'y'
  ]);

  /**
   * get/set fill pattern offset
   * @name fillPatternOffset
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get fill pattern offset
   * var patternOffset = shape.fillPatternOffset();
   *
   * // set fill pattern offset
   * shape.fillPatternOffset({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternOffsetX',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern offset x
   * @name fillPatternOffsetX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern offset x
   * var patternOffsetX = shape.fillPatternOffsetX();
   *
   * // set fill pattern offset x
   * shape.fillPatternOffsetX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternOffsetY',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern offset y
   * @name fillPatternOffsetY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern offset y
   * var patternOffsetY = shape.fillPatternOffsetY();
   *
   * // set fill pattern offset y
   * shape.fillPatternOffsetY(10);
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternScale', [
    'x',
    'y'
  ]);

  /**
   * get/set fill pattern scale
   * @name fillPatternScale
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} scale
   * @param {Number} scale.x
   * @param {Number} scale.y
   * @returns {Object}
   * @example
   * // get fill pattern scale
   * var patternScale = shape.fillPatternScale();
   *
   * // set fill pattern scale
   * shape.fillPatternScale({
   *   x: 2
   *   y: 2
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternScaleX',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern scale x
   * @name fillPatternScaleX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern scale x
   * var patternScaleX = shape.fillPatternScaleX();
   *
   * // set fill pattern scale x
   * shape.fillPatternScaleX(2);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillPatternScaleY',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set fill pattern scale y
   * @name fillPatternScaleY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern scale y
   * var patternScaleY = shape.fillPatternScaleY();
   *
   * // set fill pattern scale y
   * shape.fillPatternScaleY(2);
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'fillLinearGradientStartPoint',
    ['x', 'y']
  );

  /**
   * get/set fill linear gradient start point
   * @name fillLinearGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get fill linear gradient start point
   * var startPoint = shape.fillLinearGradientStartPoint();
   *
   * // set fill linear gradient start point
   * shape.fillLinearGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'strokeLinearGradientStartPoint',
    ['x', 'y']
  );

  /**
   * get/set stroke linear gradient start point
   * @name strokeLinearGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get stroke linear gradient start point
   * var startPoint = shape.strokeLinearGradientStartPoint();
   *
   * // set stroke linear gradient start point
   * shape.strokeLinearGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillLinearGradientStartPointX',
    0
  );

  /**
   * get/set fill linear gradient start point x
   * @name fillLinearGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill linear gradient start point x
   * var startPointX = shape.fillLinearGradientStartPointX();
   *
   * // set fill linear gradient start point x
   * shape.fillLinearGradientStartPointX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeLinearGradientStartPointX',
    0
  );

  /**
   * get/set stroke linear gradient start point x
   * @name linearLinearGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get stroke linear gradient start point x
   * var startPointX = shape.strokeLinearGradientStartPointX();
   *
   * // set stroke linear gradient start point x
   * shape.strokeLinearGradientStartPointX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillLinearGradientStartPointY',
    0
  );

  /**
   * get/set fill linear gradient start point y
   * @name fillLinearGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill linear gradient start point y
   * var startPointY = shape.fillLinearGradientStartPointY();
   *
   * // set fill linear gradient start point y
   * shape.fillLinearGradientStartPointY(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeLinearGradientStartPointY',
    0
  );
  /**
   * get/set stroke linear gradient start point y
   * @name strokeLinearGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get stroke linear gradient start point y
   * var startPointY = shape.strokeLinearGradientStartPointY();
   *
   * // set stroke linear gradient start point y
   * shape.strokeLinearGradientStartPointY(20);
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'fillLinearGradientEndPoint',
    ['x', 'y']
  );

  /**
   * get/set fill linear gradient end point
   * @name fillLinearGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get fill linear gradient end point
   * var endPoint = shape.fillLinearGradientEndPoint();
   *
   * // set fill linear gradient end point
   * shape.fillLinearGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'strokeLinearGradientEndPoint',
    ['x', 'y']
  );

  /**
   * get/set stroke linear gradient end point
   * @name strokeLinearGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get stroke linear gradient end point
   * var endPoint = shape.strokeLinearGradientEndPoint();
   *
   * // set stroke linear gradient end point
   * shape.strokeLinearGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointX', 0);
  /**
   * get/set fill linear gradient end point x
   * @name fillLinearGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill linear gradient end point x
   * var endPointX = shape.fillLinearGradientEndPointX();
   *
   * // set fill linear gradient end point x
   * shape.fillLinearGradientEndPointX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeLinearGradientEndPointX',
    0
  );
  /**
   * get/set fill linear gradient end point x
   * @name strokeLinearGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get stroke linear gradient end point x
   * var endPointX = shape.strokeLinearGradientEndPointX();
   *
   * // set stroke linear gradient end point x
   * shape.strokeLinearGradientEndPointX(20);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointY', 0);
  /**
   * get/set fill linear gradient end point y
   * @name fillLinearGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill linear gradient end point y
   * var endPointY = shape.fillLinearGradientEndPointY();
   *
   * // set fill linear gradient end point y
   * shape.fillLinearGradientEndPointY(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'strokeLinearGradientEndPointY',
    0
  );
  /**
   * get/set stroke linear gradient end point y
   * @name strokeLinearGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get stroke linear gradient end point y
   * var endPointY = shape.strokeLinearGradientEndPointY();
   *
   * // set stroke linear gradient end point y
   * shape.strokeLinearGradientEndPointY(20);
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'fillRadialGradientStartPoint',
    ['x', 'y']
  );

  /**
   * get/set fill radial gradient start point
   * @name fillRadialGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get fill radial gradient start point
   * var startPoint = shape.fillRadialGradientStartPoint();
   *
   * // set fill radial gradient start point
   * shape.fillRadialGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillRadialGradientStartPointX',
    0
  );
  /**
   * get/set fill radial gradient start point x
   * @name fillRadialGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill radial gradient start point x
   * var startPointX = shape.fillRadialGradientStartPointX();
   *
   * // set fill radial gradient start point x
   * shape.fillRadialGradientStartPointX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Shape,
    'fillRadialGradientStartPointY',
    0
  );
  /**
   * get/set fill radial gradient start point y
   * @name fillRadialGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill radial gradient start point y
   * var startPointY = shape.fillRadialGradientStartPointY();
   *
   * // set fill radial gradient start point y
   * shape.fillRadialGradientStartPointY(20);
   */

  Konva.Factory.addComponentsGetterSetter(
    Konva.Shape,
    'fillRadialGradientEndPoint',
    ['x', 'y']
  );

  /**
   * get/set fill radial gradient end point
   * @name fillRadialGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get fill radial gradient end point
   * var endPoint = shape.fillRadialGradientEndPoint();
   *
   * // set fill radial gradient end point
   * shape.fillRadialGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointX', 0);
  /**
   * get/set fill radial gradient end point x
   * @name fillRadialGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill radial gradient end point x
   * var endPointX = shape.fillRadialGradientEndPointX();
   *
   * // set fill radial gradient end point x
   * shape.fillRadialGradientEndPointX(20);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointY', 0);
  /**
   * get/set fill radial gradient end point y
   * @name fillRadialGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill radial gradient end point y
   * var endPointY = shape.fillRadialGradientEndPointY();
   *
   * // set fill radial gradient end point y
   * shape.fillRadialGradientEndPointY(20);
   */

  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRotation', 0);

  /**
   * get/set fill pattern rotation in degrees
   * @name fillPatternRotation
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} rotation
   * @returns {Konva.Shape}
   * @example
   * // get fill pattern rotation
   * var patternRotation = shape.fillPatternRotation();
   *
   * // set fill pattern rotation
   * shape.fillPatternRotation(20);
   */

  Konva.Factory.backCompat(Konva.Shape, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',

    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',

    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
  });

  Konva.Collection.mapMethods(Konva.Shape);
})(Konva);

(function() {
  'use strict';
  // CONSTANTS
  var STAGE = 'Stage',
    STRING = 'string',
    PX = 'px',
    MOUSEOUT = 'mouseout',
    MOUSELEAVE = 'mouseleave',
    MOUSEOVER = 'mouseover',
    MOUSEENTER = 'mouseenter',
    MOUSEMOVE = 'mousemove',
    MOUSEDOWN = 'mousedown',
    MOUSEUP = 'mouseup',
    CONTEXTMENU = 'contextmenu',
    CLICK = 'click',
    DBL_CLICK = 'dblclick',
    TOUCHSTART = 'touchstart',
    TOUCHEND = 'touchend',
    TAP = 'tap',
    DBL_TAP = 'dbltap',
    TOUCHMOVE = 'touchmove',
    WHEEL = 'wheel',
    CONTENT_MOUSEOUT = 'contentMouseout',
    CONTENT_MOUSEOVER = 'contentMouseover',
    CONTENT_MOUSEMOVE = 'contentMousemove',
    CONTENT_MOUSEDOWN = 'contentMousedown',
    CONTENT_MOUSEUP = 'contentMouseup',
    CONTENT_CONTEXTMENU = 'contentContextmenu',
    CONTENT_CLICK = 'contentClick',
    CONTENT_DBL_CLICK = 'contentDblclick',
    CONTENT_TOUCHSTART = 'contentTouchstart',
    CONTENT_TOUCHEND = 'contentTouchend',
    CONTENT_DBL_TAP = 'contentDbltap',
    CONTENT_TAP = 'contentTap',
    CONTENT_TOUCHMOVE = 'contentTouchmove',
    CONTENT_WHEEL = 'contentWheel',
    DIV = 'div',
    RELATIVE = 'relative',
    KONVA_CONTENT = 'konvajs-content',
    SPACE = ' ',
    UNDERSCORE = '_',
    CONTAINER = 'container',
    EMPTY_STRING = '',
    EVENTS = [
      MOUSEDOWN,
      MOUSEMOVE,
      MOUSEUP,
      MOUSEOUT,
      TOUCHSTART,
      TOUCHMOVE,
      TOUCHEND,
      MOUSEOVER,
      WHEEL,
      CONTEXTMENU
    ],
    // cached variables
    eventsLength = EVENTS.length;

  function addEvent(ctx, eventName) {
    ctx.content.addEventListener(
      eventName,
      function(evt) {
        ctx[UNDERSCORE + eventName](evt);
      },
      false
    );
  }

  /**
   * Stage constructor.  A stage is used to contain multiple layers
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {String|Element} config.container Container selector or DOM element
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var stage = new Konva.Stage({
   *   width: 500,
   *   height: 800,
   *   container: 'containerId' // or "#containerId" or ".containerClass"
   * });
   */
  Konva.Stage = function(config) {
    this.___init(config);
  };

  Konva.Util.addMethods(Konva.Stage, {
    ___init: function(config) {
      this.nodeType = STAGE;
      // call super constructor
      Konva.Container.call(this, config);
      this._id = Konva.idCounter++;
      this._buildDOM();
      this._bindContentEvents();
      this._enableNestedTransforms = false;
      Konva.stages.push(this);
    },
    _validateAdd: function(child) {
      if (child.getType() !== 'Layer') {
        Konva.Util.throw('You may only add layers to the stage.');
      }
    },
    /**
     * set container dom element which contains the stage wrapper div element
     * @method
     * @memberof Konva.Stage.prototype
     * @param {DomElement} container can pass in a dom element or id string
     */
    setContainer: function(container) {
      if (typeof container === STRING) {
        if (container.charAt(0) === '.') {
          var className = container.slice(1);
          container = Konva.document.getElementsByClassName(className)[0];
        } else {
          var id;
          if (container.charAt(0) !== '#') {
            id = container;
          } else {
            id = container.slice(1);
          }
          container = Konva.document.getElementById(id);
        }
        if (!container) {
          throw 'Can not find container in document with id ' + id;
        }
      }
      this._setAttr(CONTAINER, container);
      return this;
    },
    shouldDrawHit: function() {
      return true;
    },
    draw: function() {
      Konva.Node.prototype.draw.call(this);
      return this;
    },
    /**
     * draw layer scene graphs
     * @name draw
     * @method
     * @memberof Konva.Stage.prototype
     */

    /**
     * draw layer hit graphs
     * @name drawHit
     * @method
     * @memberof Konva.Stage.prototype
     */

    /**
     * set height
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Number} height
     */
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      this._resizeDOM();
      return this;
    },
    /**
     * set width
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Number} width
     */
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      this._resizeDOM();
      return this;
    },
    /**
     * clear all layers
     * @method
     * @memberof Konva.Stage.prototype
     */
    clear: function() {
      var layers = this.children,
        len = layers.length,
        n;

      for (n = 0; n < len; n++) {
        layers[n].clear();
      }
      return this;
    },
    clone: function(obj) {
      if (!obj) {
        obj = {};
      }
      obj.container = Konva.document.createElement(DIV);
      return Konva.Container.prototype.clone.call(this, obj);
    },
    /**
     * destroy stage
     * @method
     * @memberof Konva.Stage.prototype
     */
    destroy: function() {
      var content = this.content;
      Konva.Container.prototype.destroy.call(this);

      if (content && Konva.Util._isInDocument(content)) {
        this.getContainer().removeChild(content);
      }
      var index = Konva.stages.indexOf(this);
      if (index > -1) {
        Konva.stages.splice(index, 1);
      }
      return this;
    },
    /**
     * get pointer position which can be a touch position or mouse position
     * @method
     * @memberof Konva.Stage.prototype
     * @returns {Object}
     */
    getPointerPosition: function() {
      return this.pointerPos;
    },
    getStage: function() {
      return this;
    },
    /**
     * get stage content div element which has the
     *  the class name "konvajs-content"
     * @method
     * @memberof Konva.Stage.prototype
     */
    getContent: function() {
      return this.content;
    },
    _toKonvaCanvas: function(config) {
      config = config || {};

      var x = config.x || 0,
        y = config.y || 0,
        canvas = new Konva.SceneCanvas({
          width: config.width || this.getWidth(),
          height: config.height || this.getHeight(),
          pixelRatio: config.pixelRatio || 1
        }),
        _context = canvas.getContext()._context,
        layers = this.children;

      if (x || y) {
        _context.translate(-1 * x, -1 * y);
      }

      layers.each(function(layer) {
        if (!layer.isVisible()) {
          return;
        }
        var layerCanvas = layer._toKonvaCanvas(config);
        _context.drawImage(
          layerCanvas._canvas,
          x,
          y,
          layerCanvas.getWidth() / layerCanvas.getPixelRatio(),
          layerCanvas.getHeight() / layerCanvas.getPixelRatio()
        );
      });
      return canvas;
    },
    /**
     * converts stage into an image.
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     */
    toImage: function(config) {
      var cb = config.callback;

      config.callback = function(dataUrl) {
        Konva.Util._getImage(dataUrl, function(img) {
          cb(img);
        });
      };
      this.toDataURL(config);
    },
    /**
     * get visible intersection shape. This is the preferred
     *  method for determining if a point intersects a shape or not
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @param {String} [selector]
     * @returns {Konva.Node}
     * @example
     * var shape = stage.getIntersection({x: 50, y: 50});
     * // or if you interested in shape parent:
     * var group = stage.getIntersection({x: 50, y: 50}, 'Group');
     */
    getIntersection: function(pos, selector) {
      var layers = this.getChildren(),
        len = layers.length,
        end = len - 1,
        n,
        shape;

      for (n = end; n >= 0; n--) {
        shape = layers[n].getIntersection(pos, selector);
        if (shape) {
          return shape;
        }
      }

      return null;
    },
    _resizeDOM: function() {
      if (this.content) {
        var width = this.getWidth(),
          height = this.getHeight(),
          layers = this.getChildren(),
          len = layers.length,
          n,
          layer;

        // set content dimensions
        this.content.style.width = width + PX;
        this.content.style.height = height + PX;

        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);

        // set layer dimensions
        for (n = 0; n < len; n++) {
          layer = layers[n];
          layer.setSize(width, height);
          layer.draw();
        }
      }
    },
    /**
     * add layer or layers to stage
     * @method
     * @memberof Konva.Stage.prototype
     * @param {...Konva.Layer} layer
     * @example
     * stage.add(layer1, layer2, layer3);
     */
    add: function(layer) {
      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length; i++) {
          this.add(arguments[i]);
        }
        return this;
      }
      Konva.Container.prototype.add.call(this, layer);
      layer._setCanvasSize(this.width(), this.height());

      // draw layer and append canvas to container
      layer.draw();

      if (Konva.isBrowser) {
        this.content.appendChild(layer.canvas._canvas);
      }

      // chainable
      return this;
    },
    getParent: function() {
      return null;
    },
    getLayer: function() {
      return null;
    },
    /**
     * returns a {@link Konva.Collection} of layers
     * @method
     * @memberof Konva.Stage.prototype
     */
    getLayers: function() {
      return this.getChildren();
    },
    _bindContentEvents: function() {
      if (!Konva.isBrowser) {
        return;
      }
      for (var n = 0; n < eventsLength; n++) {
        addEvent(this, EVENTS[n]);
      }
    },
    _mouseover: function(evt) {
      if (!Konva.UA.mobile) {
        this._setPointerPosition(evt);
        this._fire(CONTENT_MOUSEOVER, { evt: evt });
      }
    },
    _mouseout: function(evt) {
      if (!Konva.UA.mobile) {
        this._setPointerPosition(evt);
        var targetShape = this.targetShape;

        if (targetShape && !Konva.isDragging()) {
          targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
          targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
          this.targetShape = null;
        }
        this.pointerPos = undefined;

        this._fire(CONTENT_MOUSEOUT, { evt: evt });
      }
    },
    _mousemove: function(evt) {
      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
      if (Konva.UA.ieMobile) {
        return this._touchmove(evt);
      }
      // workaround fake mousemove event in chrome browser https://code.google.com/p/chromium/issues/detail?id=161464
      if (
        (typeof evt.movementX !== 'undefined' ||
          typeof evt.movementY !== 'undefined') &&
        evt.movementY === 0 &&
        evt.movementX === 0
      ) {
        return null;
      }
      if (Konva.UA.mobile) {
        return null;
      }
      this._setPointerPosition(evt);
      var shape;

      if (!Konva.isDragging()) {
        shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
          if (
            !Konva.isDragging() &&
            (!this.targetShape || this.targetShape._id !== shape._id)
          ) {
            if (this.targetShape) {
              this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt }, shape);
              this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt }, shape);
            }
            shape._fireAndBubble(MOUSEOVER, { evt: evt }, this.targetShape);
            shape._fireAndBubble(MOUSEENTER, { evt: evt }, this.targetShape);
            this.targetShape = shape;
          } else {
            shape._fireAndBubble(MOUSEMOVE, { evt: evt });
          }
        } else {
          /*
                 * if no shape was detected, clear target shape and try
                 * to run mouseout from previous target shape
                 */
          if (this.targetShape && !Konva.isDragging()) {
            this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
            this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
            this.targetShape = null;
          }
          this._fire(MOUSEMOVE, {
            evt: evt,
            target: this,
            currentTarget: this
          });
        }

        // content event
        this._fire(CONTENT_MOUSEMOVE, { evt: evt });
      }

      // always call preventDefault for desktop events because some browsers
      // try to drag and drop the canvas element
      if (evt.cancelable) {
        evt.preventDefault();
      }
    },
    _mousedown: function(evt) {
      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
      if (Konva.UA.ieMobile) {
        return this._touchstart(evt);
      }
      if (!Konva.UA.mobile) {
        this._setPointerPosition(evt);
        var shape = this.getIntersection(this.getPointerPosition());

        Konva.listenClickTap = true;

        if (shape && shape.isListening()) {
          this.clickStartShape = shape;
          shape._fireAndBubble(MOUSEDOWN, { evt: evt });
        } else {
          this._fire(MOUSEDOWN, {
            evt: evt,
            target: this,
            currentTarget: this
          });
        }

        // content event
        this._fire(CONTENT_MOUSEDOWN, { evt: evt });
      }

      // always call preventDefault for desktop events because some browsers
      // try to drag and drop the canvas element
      // TODO: if we preventDefault() it will cancel event detection outside of window inside iframe
      // but we need it for better drag&drop
      // can we disable native drag&drop somehow differently?
      // if (evt.cancelable) {
      // evt.preventDefault();
      // }
    },
    _mouseup: function(evt) {
      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
      if (Konva.UA.ieMobile) {
        return this._touchend(evt);
      }
      if (!Konva.UA.mobile) {
        this._setPointerPosition(evt);
        var shape = this.getIntersection(this.getPointerPosition()),
          clickStartShape = this.clickStartShape,
          clickEndShape = this.clickEndShape,
          fireDblClick = false,
          dd = Konva.DD;

        if (Konva.inDblClickWindow) {
          fireDblClick = true;
          clearTimeout(this.dblTimeout);
          // Konva.inDblClickWindow = false;
        } else if (!dd || !dd.justDragged) {
          // don't set inDblClickWindow after dragging
          Konva.inDblClickWindow = true;
          clearTimeout(this.dblTimeout);
        } else if (dd) {
          dd.justDragged = false;
        }

        this.dblTimeout = setTimeout(function() {
          Konva.inDblClickWindow = false;
        }, Konva.dblClickWindow);

        if (shape && shape.isListening()) {
          this.clickEndShape = shape;
          shape._fireAndBubble(MOUSEUP, { evt: evt });

          // detect if click or double click occurred
          if (
            Konva.listenClickTap &&
            clickStartShape &&
            clickStartShape._id === shape._id
          ) {
            shape._fireAndBubble(CLICK, { evt: evt });

            if (
              fireDblClick &&
              clickEndShape &&
              clickEndShape._id === shape._id
            ) {
              shape._fireAndBubble(DBL_CLICK, { evt: evt });
            }
          }
        } else {
          this._fire(MOUSEUP, { evt: evt, target: this, currentTarget: this });
          if (Konva.listenClickTap) {
            this._fire(CLICK, { evt: evt, target: this, currentTarget: this });
          }

          if (fireDblClick) {
            this._fire(DBL_CLICK, {
              evt: evt,
              target: this,
              currentTarget: this
            });
          }
        }
        // content events
        this._fire(CONTENT_MOUSEUP, { evt: evt });
        if (Konva.listenClickTap) {
          this._fire(CONTENT_CLICK, { evt: evt });
          if (fireDblClick) {
            this._fire(CONTENT_DBL_CLICK, { evt: evt });
          }
        }

        Konva.listenClickTap = false;
      }

      // always call preventDefault for desktop events because some browsers
      // try to drag and drop the canvas element
      if (evt.cancelable) {
        evt.preventDefault();
      }
    },
    _contextmenu: function(evt) {
      this._setPointerPosition(evt);
      var shape = this.getIntersection(this.getPointerPosition());

      if (shape && shape.isListening()) {
        shape._fireAndBubble(CONTEXTMENU, { evt: evt });
      } else {
        this._fire(CONTEXTMENU, {
          evt: evt,
          target: this,
          currentTarget: this
        });
      }
      this._fire(CONTENT_CONTEXTMENU, { evt: evt });
    },
    _touchstart: function(evt) {
      this._setPointerPosition(evt);
      var shape = this.getIntersection(this.getPointerPosition());

      Konva.listenClickTap = true;

      if (shape && shape.isListening()) {
        this.tapStartShape = shape;
        shape._fireAndBubble(TOUCHSTART, { evt: evt });

        // only call preventDefault if the shape is listening for events
        if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
          evt.preventDefault();
        }
      } else {
        this._fire(TOUCHSTART, {
          evt: evt,
          target: this,
          currentTarget: this
        });
      }
      // content event
      this._fire(CONTENT_TOUCHSTART, { evt: evt });
    },
    _touchend: function(evt) {
      this._setPointerPosition(evt);
      var shape = this.getIntersection(this.getPointerPosition()),
        fireDblClick = false;

      if (Konva.inDblClickWindow) {
        fireDblClick = true;
        clearTimeout(this.dblTimeout);
        // Konva.inDblClickWindow = false;
      } else {
        Konva.inDblClickWindow = true;
        clearTimeout(this.dblTimeout);
      }

      this.dblTimeout = setTimeout(function() {
        Konva.inDblClickWindow = false;
      }, Konva.dblClickWindow);

      if (shape && shape.isListening()) {
        shape._fireAndBubble(TOUCHEND, { evt: evt });

        // detect if tap or double tap occurred
        if (
          Konva.listenClickTap &&
          this.tapStartShape &&
          shape._id === this.tapStartShape._id
        ) {
          shape._fireAndBubble(TAP, { evt: evt });

          if (fireDblClick) {
            shape._fireAndBubble(DBL_TAP, { evt: evt });
          }
        }
        // only call preventDefault if the shape is listening for events
        if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
          evt.preventDefault();
        }
      } else {
        this._fire(TOUCHEND, { evt: evt, target: this, currentTarget: this });
        if (Konva.listenClickTap) {
          this._fire(TAP, { evt: evt, target: this, currentTarget: this });
        }
        if (fireDblClick) {
          this._fire(DBL_TAP, {
            evt: evt,
            target: this,
            currentTarget: this
          });
        }
      }
      // content events
      this._fire(CONTENT_TOUCHEND, { evt: evt });
      if (Konva.listenClickTap) {
        this._fire(CONTENT_TAP, { evt: evt });
        if (fireDblClick) {
          this._fire(CONTENT_DBL_TAP, { evt: evt });
        }
      }

      Konva.listenClickTap = false;
    },
    _touchmove: function(evt) {
      this._setPointerPosition(evt);
      var dd = Konva.DD,
        shape;
      if (!Konva.isDragging()) {
        shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
          shape._fireAndBubble(TOUCHMOVE, { evt: evt });
          // only call preventDefault if the shape is listening for events
          if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
            evt.preventDefault();
          }
        } else {
          this._fire(TOUCHMOVE, {
            evt: evt,
            target: this,
            currentTarget: this
          });
        }
        this._fire(CONTENT_TOUCHMOVE, { evt: evt });
      }
      if (dd) {
        if (
          Konva.isDragging() &&
          Konva.DD.node.preventDefault() &&
          evt.cancelable
        ) {
          evt.preventDefault();
        }
      }
    },
    _wheel: function(evt) {
      this._setPointerPosition(evt);
      var shape = this.getIntersection(this.getPointerPosition());

      if (shape && shape.isListening()) {
        shape._fireAndBubble(WHEEL, { evt: evt });
      } else {
        this._fire(WHEEL, {
          evt: evt,
          target: this,
          currentTarget: this
        });
      }
      this._fire(CONTENT_WHEEL, { evt: evt });
    },
    _setPointerPosition: function(evt) {
      var contentPosition = this._getContentPosition(),
        x = null,
        y = null;
      evt = evt ? evt : window.event;

      // touch events
      if (evt.touches !== undefined) {
        // currently, only handle one finger
        if (evt.touches.length > 0) {
          var touch = evt.touches[0];
          // get the information for finger #1
          x = touch.clientX - contentPosition.left;
          y = touch.clientY - contentPosition.top;
        }
      } else {
        // mouse events
        x = evt.clientX - contentPosition.left;
        y = evt.clientY - contentPosition.top;
      }
      if (x !== null && y !== null) {
        this.pointerPos = {
          x: x,
          y: y
        };
      }
    },
    _getContentPosition: function() {
      var rect = this.content.getBoundingClientRect
        ? this.content.getBoundingClientRect()
        : { top: 0, left: 0 };
      return {
        top: rect.top,
        left: rect.left
      };
    },
    _buildDOM: function() {
      // the buffer canvas pixel ratio must be 1 because it is used as an
      // intermediate canvas before copying the result onto a scene canvas.
      // not setting it to 1 will result in an over compensation
      this.bufferCanvas = new Konva.SceneCanvas();
      this.bufferHitCanvas = new Konva.HitCanvas({ pixelRatio: 1 });

      if (!Konva.isBrowser) {
        return;
      }
      var container = this.getContainer();
      if (!container) {
        throw 'Stage has no container. A container is required.';
      }
      // clear content inside container
      container.innerHTML = EMPTY_STRING;

      // content
      this.content = Konva.document.createElement(DIV);
      this.content.style.position = RELATIVE;
      this.content.style.userSelect = 'none';
      this.content.className = KONVA_CONTENT;

      this.content.setAttribute('role', 'presentation');

      container.appendChild(this.content);

      this._resizeDOM();
    },
    _onContent: function(typesStr, handler) {
      var types = typesStr.split(SPACE),
        len = types.length,
        n,
        baseEvent;

      for (n = 0; n < len; n++) {
        baseEvent = types[n];
        this.content.addEventListener(baseEvent, handler, false);
      }
    },
    // currently cache function is now working for stage, because stage has no its own canvas element
    // TODO: may be it is better to cache all children layers?
    cache: function() {
      Konva.Util.warn(
        'Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.'
      );
    },
    clearCache: function() {}
  });
  Konva.Util.extend(Konva.Stage, Konva.Container);

  // add getters and setters
  Konva.Factory.addGetter(Konva.Stage, 'container');
  Konva.Factory.addOverloadedGetterSetter(Konva.Stage, 'container');

  /**
   * get container DOM element
   * @name container
   * @method
   * @memberof Konva.Stage.prototype
   * @returns {DomElement} container
   * @example
   * // get container
   * var container = stage.container();
   * // set container
   * var container = document.createElement('div');
   * body.appendChild(container);
   * stage.container(container);
   */
})();

(function(Konva) {
  'use strict';
  /**
   * BaseLayer constructor.
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   */
  Konva.BaseLayer = function(config) {
    this.___init(config);
  };

  Konva.Util.addMethods(Konva.BaseLayer, {
    ___init: function(config) {
      this.nodeType = 'Layer';
      Konva.Container.call(this, config);
    },
    createPNGStream: function() {
      return this.canvas._canvas.createPNGStream();
    },
    /**
     * get layer canvas
     * @method
     * @memberof Konva.BaseLayer.prototype
     */
    getCanvas: function() {
      return this.canvas;
    },
    /**
     * get layer hit canvas
     * @method
     * @memberof Konva.BaseLayer.prototype
     */
    getHitCanvas: function() {
      return this.hitCanvas;
    },
    /**
     * get layer canvas context
     * @method
     * @memberof Konva.BaseLayer.prototype
     */
    getContext: function() {
      return this.getCanvas().getContext();
    },
    /**
     * clear scene and hit canvas contexts tied to the layer
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @param {Object} [bounds]
     * @param {Number} [bounds.x]
     * @param {Number} [bounds.y]
     * @param {Number} [bounds.width]
     * @param {Number} [bounds.height]
     * @example
     * layer.clear();
     * layer.clear({
     *   x : 0,
     *   y : 0,
     *   width : 100,
     *   height : 100
     * });
     */
    clear: function(bounds) {
      this.getContext().clear(bounds);
      return this;
    },
    clearHitCache: function() {
      this._hitImageData = undefined;
    },
    // extend Node.prototype.setZIndex
    setZIndex: function(index) {
      Konva.Node.prototype.setZIndex.call(this, index);
      var stage = this.getStage();
      if (stage) {
        stage.content.removeChild(this.getCanvas()._canvas);

        if (index < stage.getChildren().length - 1) {
          stage.content.insertBefore(
            this.getCanvas()._canvas,
            stage.getChildren()[index + 1].getCanvas()._canvas
          );
        } else {
          stage.content.appendChild(this.getCanvas()._canvas);
        }
      }
      return this;
    },
    // extend Node.prototype.moveToTop
    moveToTop: function() {
      Konva.Node.prototype.moveToTop.call(this);
      var stage = this.getStage();
      if (stage) {
        stage.content.removeChild(this.getCanvas()._canvas);
        stage.content.appendChild(this.getCanvas()._canvas);
      }
      return this;
    },
    // extend Node.prototype.moveUp
    moveUp: function() {
      var moved = Konva.Node.prototype.moveUp.call(this);
      if (!moved) {
        return this;
      }
      var stage = this.getStage();
      if (!stage) {
        return this;
      }
      stage.content.removeChild(this.getCanvas()._canvas);

      if (this.index < stage.getChildren().length - 1) {
        stage.content.insertBefore(
          this.getCanvas()._canvas,
          stage.getChildren()[this.index + 1].getCanvas()._canvas
        );
      } else {
        stage.content.appendChild(this.getCanvas()._canvas);
      }
      return this;
    },
    // extend Node.prototype.moveDown
    moveDown: function() {
      if (Konva.Node.prototype.moveDown.call(this)) {
        var stage = this.getStage();
        if (stage) {
          var children = stage.getChildren();
          stage.content.removeChild(this.getCanvas()._canvas);
          stage.content.insertBefore(
            this.getCanvas()._canvas,
            children[this.index + 1].getCanvas()._canvas
          );
        }
      }
      return this;
    },
    // extend Node.prototype.moveToBottom
    moveToBottom: function() {
      if (Konva.Node.prototype.moveToBottom.call(this)) {
        var stage = this.getStage();
        if (stage) {
          var children = stage.getChildren();
          stage.content.removeChild(this.getCanvas()._canvas);
          stage.content.insertBefore(
            this.getCanvas()._canvas,
            children[1].getCanvas()._canvas
          );
        }
      }
      return this;
    },
    getLayer: function() {
      return this;
    },
    remove: function() {
      var _canvas = this.getCanvas()._canvas;

      Konva.Node.prototype.remove.call(this);

      if (_canvas && _canvas.parentNode && Konva.Util._isInDocument(_canvas)) {
        _canvas.parentNode.removeChild(_canvas);
      }
      return this;
    },
    getStage: function() {
      return this.parent;
    },
    setSize: function(width, height) {
      this.canvas.setSize(width, height);
      return this;
    },
    _toKonvaCanvas: function(config) {
      config = config || {};
      config.width = config.width || this.getWidth();
      config.height = config.height || this.getHeight();
      config.x = config.x !== undefined ? config.x : this.getX();
      config.y = config.y !== undefined ? config.y : this.getY();

      return Konva.Node.prototype._toKonvaCanvas.call(this, config);
    },
    /**
     * get/set width of layer.getter return width of stage. setter doing nothing.
     * if you want change width use `stage.width(value);`
     * @name width
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @returns {Number}
     * @example
     * var width = layer.width();
     */
    getWidth: function() {
      if (this.parent) {
        return this.parent.getWidth();
      }
    },
    setWidth: function() {
      Konva.Util.warn(
        'Can not change width of layer. Use "stage.width(value)" function instead.'
      );
    },
    /**
     * get/set height of layer.getter return height of stage. setter doing nothing.
     * if you want change height use `stage.height(value);`
     * @name height
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @returns {Number}
     * @example
     * var height = layer.height();
     */
    getHeight: function() {
      if (this.parent) {
        return this.parent.getHeight();
      }
    },
    setHeight: function() {
      Konva.Util.warn(
        'Can not change height of layer. Use "stage.height(value)" function instead.'
      );
    },
    // the apply transform method is handled by the Layer and FastLayer class
    // because it is up to the layer to decide if an absolute or relative transform
    // should be used
    _applyTransform: function(shape, context, top) {
      var m = shape.getAbsoluteTransform(top).getMatrix();
      context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    }
  });
  Konva.Util.extend(Konva.BaseLayer, Konva.Container);

  // add getters and setters
  Konva.Factory.addGetterSetter(Konva.BaseLayer, 'clearBeforeDraw', true);
  /**
   * get/set clearBeforeDraw flag which determines if the layer is cleared or not
   *  before drawing
   * @name clearBeforeDraw
   * @method
   * @memberof Konva.BaseLayer.prototype
   * @param {Boolean} clearBeforeDraw
   * @returns {Boolean}
   * @example
   * // get clearBeforeDraw flag
   * var clearBeforeDraw = layer.clearBeforeDraw();
   *
   * // disable clear before draw
   * layer.clearBeforeDraw(false);
   *
   * // enable clear before draw
   * layer.clearBeforeDraw(true);
   */

  Konva.Collection.mapMethods(Konva.BaseLayer);
})(Konva);

(function() {
  'use strict';
  // constants
  var HASH = '#',
    BEFORE_DRAW = 'beforeDraw',
    DRAW = 'draw',
    /*
         * 2 - 3 - 4
         * |       |
         * 1 - 0   5
         *         |
         * 8 - 7 - 6
         */
    INTERSECTION_OFFSETS = [
      { x: 0, y: 0 }, // 0
      { x: -1, y: -1 }, // 2
      { x: 1, y: -1 }, // 4
      { x: 1, y: 1 }, // 6
      { x: -1, y: 1 } // 8
    ],
    INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;

  /**
   * Layer constructor.  Layers are tied to their own canvas element and are used
   * to contain groups or shapes.
   * @constructor
   * @memberof Konva
   * @augments Konva.BaseLayer
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var layer = new Konva.Layer();
   */
  Konva.Layer = function(config) {
    this.____init(config);
  };

  Konva.Util.addMethods(Konva.Layer, {
    ____init: function(config) {
      this.nodeType = 'Layer';
      this.canvas = new Konva.SceneCanvas();
      this.hitCanvas = new Konva.HitCanvas({
        pixelRatio: 1
      });
      // call super constructor
      Konva.BaseLayer.call(this, config);
    },
    _setCanvasSize: function(width, height) {
      this.canvas.setSize(width, height);
      this.hitCanvas.setSize(width, height);
    },
    _validateAdd: function(child) {
      var type = child.getType();
      if (type !== 'Group' && type !== 'Shape') {
        Konva.Util.throw('You may only add groups and shapes to a layer.');
      }
    },
    /**
     * get visible intersection shape. This is the preferred
     * method for determining if a point intersects a shape or not
     * also you may pass optional selector parametr to return ancestor of intersected shape
     * @method
     * @memberof Konva.Layer.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @param {String} [selector]
     * @returns {Konva.Node}
     * @example
     * var shape = layer.getIntersection({x: 50, y: 50});
     * // or if you interested in shape parent:
     * var group = layer.getIntersection({x: 50, y: 50}, 'Group');
     */
    getIntersection: function(pos, selector) {
      var obj, i, intersectionOffset, shape;

      if (!this.hitGraphEnabled() || !this.isVisible()) {
        return null;
      }
      // in some cases antialiased area may be bigger than 1px
      // it is possible if we will cache node, then scale it a lot
      // TODO: check { 0; 0 } point before loop, and remove it from INTERSECTION_OFFSETS.
      var spiralSearchDistance = 1;
      var continueSearch = false;
      while (true) {
        for (i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
          intersectionOffset = INTERSECTION_OFFSETS[i];
          obj = this._getIntersection({
            x: pos.x + intersectionOffset.x * spiralSearchDistance,
            y: pos.y + intersectionOffset.y * spiralSearchDistance
          });
          shape = obj.shape;
          if (shape && selector) {
            return shape.findAncestor(selector, true);
          } else if (shape) {
            return shape;
          }
          // we should continue search if we found antialiased pixel
          // that means our node somewhere very close
          continueSearch = !!obj.antialiased;
          // stop search if found empty pixel
          if (!obj.antialiased) {
            break;
          }
        }
        // if no shape, and no antialiased pixel, we should end searching
        if (continueSearch) {
          spiralSearchDistance += 1;
        } else {
          return null;
        }
      }
    },
    _getImageData: function(x, y) {
      var width = this.hitCanvas.width || 1,
        height = this.hitCanvas.height || 1,
        index = Math.round(y) * width + Math.round(x);

      if (!this._hitImageData) {
        this._hitImageData = this.hitCanvas.context.getImageData(
          0,
          0,
          width,
          height
        );
      }

      return [
        this._hitImageData.data[4 * index + 0], // Red
        this._hitImageData.data[4 * index + 1], // Green
        this._hitImageData.data[4 * index + 2], // Blue
        this._hitImageData.data[4 * index + 3] // Alpha
      ];
    },
    _getIntersection: function(pos) {
      var ratio = this.hitCanvas.pixelRatio;
      var p = this.hitCanvas.context.getImageData(
          Math.round(pos.x * ratio),
          Math.round(pos.y * ratio),
          1,
          1
        ).data,
        p3 = p[3],
        colorKey,
        shape;
      // fully opaque pixel
      if (p3 === 255) {
        colorKey = Konva.Util._rgbToHex(p[0], p[1], p[2]);
        shape = Konva.shapes[HASH + colorKey];
        if (shape) {
          return {
            shape: shape
          };
        }
        return {
          antialiased: true
        };
      } else if (p3 > 0) {
        // antialiased pixel
        return {
          antialiased: true
        };
      }
      // empty pixel
      return {};
    },
    drawScene: function(can, top) {
      var layer = this.getLayer(),
        canvas = can || (layer && layer.getCanvas());

      this._fire(BEFORE_DRAW, {
        node: this
      });

      if (this.getClearBeforeDraw()) {
        canvas.getContext().clear();
      }

      Konva.Container.prototype.drawScene.call(this, canvas, top);

      this._fire(DRAW, {
        node: this
      });

      return this;
    },
    drawHit: function(can, top) {
      var layer = this.getLayer(),
        canvas = can || (layer && layer.hitCanvas);

      if (layer && layer.getClearBeforeDraw()) {
        layer
          .getHitCanvas()
          .getContext()
          .clear();
      }

      Konva.Container.prototype.drawHit.call(this, canvas, top);
      this.imageData = null; // Clear imageData cache
      return this;
    },
    clear: function(bounds) {
      Konva.BaseLayer.prototype.clear.call(this, bounds);
      this.getHitCanvas()
        .getContext()
        .clear(bounds);
      this.imageData = null; // Clear getImageData cache
      return this;
    },
    // extend Node.prototype.setVisible
    setVisible: function(visible) {
      Konva.Node.prototype.setVisible.call(this, visible);
      if (visible) {
        this.getCanvas()._canvas.style.display = 'block';
        this.hitCanvas._canvas.style.display = 'block';
      } else {
        this.getCanvas()._canvas.style.display = 'none';
        this.hitCanvas._canvas.style.display = 'none';
      }
      return this;
    },
    /**
     * enable hit graph
     * @name enableHitGraph
     * @method
     * @memberof Konva.Layer.prototype
     * @returns {Layer}
     */
    enableHitGraph: function() {
      this.setHitGraphEnabled(true);
      return this;
    },
    /**
     * disable hit graph
     * @name disableHitGraph
     * @method
     * @memberof Konva.Layer.prototype
     * @returns {Layer}
     */
    disableHitGraph: function() {
      this.setHitGraphEnabled(false);
      return this;
    },
    setSize: function(width, height) {
      Konva.BaseLayer.prototype.setSize.call(this, width, height);
      this.hitCanvas.setSize(width, height);
      return this;
    }
  });
  Konva.Util.extend(Konva.Layer, Konva.BaseLayer);

  Konva.Factory.addGetterSetter(Konva.Layer, 'hitGraphEnabled', true);
  /**
   * get/set hitGraphEnabled flag.  Disabling the hit graph will greatly increase
   *  draw performance because the hit graph will not be redrawn each time the layer is
   *  drawn.  This, however, also disables mouse/touch event detection
   * @name hitGraphEnabled
   * @method
   * @memberof Konva.Layer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get hitGraphEnabled flag
   * var hitGraphEnabled = layer.hitGraphEnabled();
   *
   * // disable hit graph
   * layer.hitGraphEnabled(false);
   *
   * // enable hit graph
   * layer.hitGraphEnabled(true);
   */
  Konva.Collection.mapMethods(Konva.Layer);
})();

(function() {
  'use strict';
  /**
   * FastLayer constructor. Layers are tied to their own canvas element and are used
   * to contain shapes only.  If you don't need node nesting, mouse and touch interactions,
   * or event pub/sub, you should use FastLayer instead of Layer to create your layers.
   * It renders about 2x faster than normal layers.
   * @constructor
   * @memberof Konva
   * @augments Konva.BaseLayer
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Boolean} [config.visible]
   * @param {String} [config.id] unique id
   * @param {String} [config.name] non-unique name
   * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var layer = new Konva.FastLayer();
   */
  Konva.FastLayer = function(config) {
    this.____init(config);
  };

  Konva.Util.addMethods(Konva.FastLayer, {
    ____init: function(config) {
      this.nodeType = 'Layer';
      this.canvas = new Konva.SceneCanvas();
      // call super constructor
      Konva.BaseLayer.call(this, config);
    },
    _validateAdd: function(child) {
      var type = child.getType();
      if (type !== 'Shape') {
        Konva.Util.throw('You may only add shapes to a fast layer.');
      }
    },
    _setCanvasSize: function(width, height) {
      this.canvas.setSize(width, height);
    },
    hitGraphEnabled: function() {
      return false;
    },
    getIntersection: function() {
      return null;
    },
    drawScene: function(can) {
      var layer = this.getLayer(),
        canvas = can || (layer && layer.getCanvas());

      if (this.getClearBeforeDraw()) {
        canvas.getContext().clear();
      }

      Konva.Container.prototype.drawScene.call(this, canvas);

      return this;
    },
    draw: function() {
      this.drawScene();
      return this;
    },
    // extend Node.prototype.setVisible
    setVisible: function(visible) {
      Konva.Node.prototype.setVisible.call(this, visible);
      if (visible) {
        this.getCanvas()._canvas.style.display = 'block';
      } else {
        this.getCanvas()._canvas.style.display = 'none';
      }
      return this;
    }
  });
  Konva.Util.extend(Konva.FastLayer, Konva.BaseLayer);

  Konva.Collection.mapMethods(Konva.FastLayer);
})();

(function() {
  'use strict';
  /**
   * Group constructor.  Groups are used to contain shapes or other groups.
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var group = new Konva.Group();
   */
  Konva.Group = function(config) {
    this.___init(config);
  };

  Konva.Util.addMethods(Konva.Group, {
    ___init: function(config) {
      this.nodeType = 'Group';
      // call super constructor
      Konva.Container.call(this, config);
    },
    _validateAdd: function(child) {
      var type = child.getType();
      if (type !== 'Group' && type !== 'Shape') {
        Konva.Util.throw('You may only add groups and shapes to groups.');
      }
    }
  });
  Konva.Util.extend(Konva.Group, Konva.Container);

  Konva.Collection.mapMethods(Konva.Group);
})();

(function(Konva) {
  'use strict';
  var now = (function() {
    if (Konva.global.performance && Konva.global.performance.now) {
      return function() {
        return Konva.global.performance.now();
      };
    }

    return function() {
      return new Date().getTime();
    };
  })();

  function FRAF(callback) {
    setTimeout(callback, 1000 / 60);
  }

  var RAF = (function() {
    return (
      Konva.global.requestAnimationFrame ||
      Konva.global.webkitRequestAnimationFrame ||
      Konva.global.mozRequestAnimationFrame ||
      Konva.global.oRequestAnimationFrame ||
      Konva.global.msRequestAnimationFrame ||
      FRAF
    );
  })();

  function requestAnimFrame() {
    return RAF.apply(Konva.global, arguments);
  }

  /**
   * Animation constructor.  A stage is used to contain multiple layers and handle
   * @constructor
   * @memberof Konva
   * @param {Function} func function executed on each animation frame.  The function is passed a frame object, which contains
   *  timeDiff, lastTime, time, and frameRate properties.  The timeDiff property is the number of milliseconds that have passed
   *  since the last animation frame.  The lastTime property is time in milliseconds that elapsed from the moment the animation started
   *  to the last animation frame.  The time property is the time in milliseconds that ellapsed from the moment the animation started
   *  to the current animation frame.  The frameRate property is the current frame rate in frames / second. Return false from function,
   *  if you don't need to redraw layer/layers on some frames.
   * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn on each animation frame. Can be a layer, an array of layers, or null.
   *  Not specifying a node will result in no redraw.
   * @example
   * // move a node to the right at 50 pixels / second
   * var velocity = 50;
   *
   * var anim = new Konva.Animation(function(frame) {
   *   var dist = velocity * (frame.timeDiff / 1000);
   *   node.move(dist, 0);
   * }, layer);
   *
   * anim.start();
   */
  Konva.Animation = function(func, layers) {
    var Anim = Konva.Animation;
    this.func = func;
    this.setLayers(layers);
    this.id = Anim.animIdCounter++;
    this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: now()
    };
  };
  /*
   * Animation methods
   */
  Konva.Animation.prototype = {
    /**
     * set layers to be redrawn on each animation frame
     * @method
     * @memberof Konva.Animation.prototype
     * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn.&nbsp; Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
     * @return {Konva.Animation} this
     */
    setLayers: function(layers) {
      var lays = [];
      // if passing in no layers
      if (!layers) {
        lays = [];
      } else if (layers.length > 0) {
        // if passing in an array of Layers
        // NOTE: layers could be an array or Konva.Collection.  for simplicity, I'm just inspecting
        // the length property to check for both cases
        lays = layers;
      } else {
        // if passing in a Layer
        lays = [layers];
      }

      this.layers = lays;
      return this;
    },
    /**
     * get layers
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Array} Array of Konva.Layer
     */
    getLayers: function() {
      return this.layers;
    },
    /**
     * add layer.  Returns true if the layer was added, and false if it was not
     * @method
     * @memberof Konva.Animation.prototype
     * @param {Konva.Layer} layer to add
     * @return {Bool} true if layer is added to animation, otherwise false
     */
    addLayer: function(layer) {
      var layers = this.layers,
        len = layers.length,
        n;

      // don't add the layer if it already exists
      for (n = 0; n < len; n++) {
        if (layers[n]._id === layer._id) {
          return false;
        }
      }

      this.layers.push(layer);
      return true;
    },
    /**
     * determine if animation is running or not.  returns true or false
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Bool} is animation running?
     */
    isRunning: function() {
      var a = Konva.Animation,
        animations = a.animations,
        len = animations.length,
        n;

      for (n = 0; n < len; n++) {
        if (animations[n].id === this.id) {
          return true;
        }
      }
      return false;
    },
    /**
     * start animation
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Konva.Animation} this
     */
    start: function() {
      var Anim = Konva.Animation;
      this.stop();
      this.frame.timeDiff = 0;
      this.frame.lastTime = now();
      Anim._addAnimation(this);
      return this;
    },
    /**
     * stop animation
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Konva.Animation} this
     */
    stop: function() {
      Konva.Animation._removeAnimation(this);
      return this;
    },
    _updateFrameObject: function(time) {
      this.frame.timeDiff = time - this.frame.lastTime;
      this.frame.lastTime = time;
      this.frame.time += this.frame.timeDiff;
      this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
  };
  Konva.Animation.animations = [];
  Konva.Animation.animIdCounter = 0;
  Konva.Animation.animRunning = false;

  Konva.Animation._addAnimation = function(anim) {
    this.animations.push(anim);
    this._handleAnimation();
  };
  Konva.Animation._removeAnimation = function(anim) {
    var id = anim.id,
      animations = this.animations,
      len = animations.length,
      n;

    for (n = 0; n < len; n++) {
      if (animations[n].id === id) {
        this.animations.splice(n, 1);
        break;
      }
    }
  };

  Konva.Animation._runFrames = function() {
    var layerHash = {},
      animations = this.animations,
      anim,
      layers,
      func,
      n,
      i,
      layersLen,
      layer,
      key,
      needRedraw;
    /*
     * loop through all animations and execute animation
     *  function.  if the animation object has specified node,
     *  we can add the node to the nodes hash to eliminate
     *  drawing the same node multiple times.  The node property
     *  can be the stage itself or a layer
     */
    /*
     * WARNING: don't cache animations.length because it could change while
     * the for loop is running, causing a JS error
     */

    for (n = 0; n < animations.length; n++) {
      anim = animations[n];
      layers = anim.layers;
      func = anim.func;

      anim._updateFrameObject(now());
      layersLen = layers.length;

      // if animation object has a function, execute it
      if (func) {
        // allow anim bypassing drawing
        needRedraw = func.call(anim, anim.frame) !== false;
      } else {
        needRedraw = true;
      }
      if (!needRedraw) {
        continue;
      }
      for (i = 0; i < layersLen; i++) {
        layer = layers[i];

        if (layer._id !== undefined) {
          layerHash[layer._id] = layer;
        }
      }
    }

    for (key in layerHash) {
      if (!layerHash.hasOwnProperty(key)) {
        continue;
      }
      layerHash[key].draw();
    }
  };
  Konva.Animation._animationLoop = function() {
    var Anim = Konva.Animation;
    if (Anim.animations.length) {
      Anim._runFrames();
      requestAnimFrame(Anim._animationLoop);
    } else {
      Anim.animRunning = false;
    }
  };
  Konva.Animation._handleAnimation = function() {
    if (!this.animRunning) {
      this.animRunning = true;
      requestAnimFrame(this._animationLoop);
    }
  };

  /**
   * batch draw. this function will not do immediate draw
   * but it will schedule drawing to next tick (requestAnimFrame)
   * @method
   * @name batchDraw
   * @return {Konva.Layer} this
   * @memberof Konva.BaseLayer.prototype
   */
  Konva.BaseLayer.prototype.batchDraw = function() {
    var that = this,
      Anim = Konva.Animation;

    if (!this.batchAnim) {
      this.batchAnim = new Anim(function() {
        // stop animation after first tick
        that.batchAnim.stop();
      }, this);
    }

    if (!this.batchAnim.isRunning()) {
      this.batchAnim.start();
    }
    return this;
  };

  /**
   * batch draw
   * @method
   * @name batchDraw
   * @return {Konva.Stage} this
   * @memberof Konva.Stage.prototype
   */
  Konva.Stage.prototype.batchDraw = function() {
    this.getChildren().each(function(layer) {
      layer.batchDraw();
    });
    return this;
  };
})(Konva);

(function() {
  'use strict';
  var blacklist = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    },
    PAUSED = 1,
    PLAYING = 2,
    REVERSING = 3,
    idCounter = 0,
    colorAttrs = ['fill', 'stroke', 'shadowColor'];

  var Tween = function(prop, propFunc, func, begin, finish, duration, yoyo) {
    this.prop = prop;
    this.propFunc = propFunc;
    this.begin = begin;
    this._pos = begin;
    this.duration = duration;
    this._change = 0;
    this.prevPos = 0;
    this.yoyo = yoyo;
    this._time = 0;
    this._position = 0;
    this._startTime = 0;
    this._finish = 0;
    this.func = func;
    this._change = finish - this.begin;
    this.pause();
  };
  /*
     * Tween methods
     */
  Tween.prototype = {
    fire: function(str) {
      var handler = this[str];
      if (handler) {
        handler();
      }
    },
    setTime: function(t) {
      if (t > this.duration) {
        if (this.yoyo) {
          this._time = this.duration;
          this.reverse();
        } else {
          this.finish();
        }
      } else if (t < 0) {
        if (this.yoyo) {
          this._time = 0;
          this.play();
        } else {
          this.reset();
        }
      } else {
        this._time = t;
        this.update();
      }
    },
    getTime: function() {
      return this._time;
    },
    setPosition: function(p) {
      this.prevPos = this._pos;
      this.propFunc(p);
      this._pos = p;
    },
    getPosition: function(t) {
      if (t === undefined) {
        t = this._time;
      }
      return this.func(t, this.begin, this._change, this.duration);
    },
    play: function() {
      this.state = PLAYING;
      this._startTime = this.getTimer() - this._time;
      this.onEnterFrame();
      this.fire('onPlay');
    },
    reverse: function() {
      this.state = REVERSING;
      this._time = this.duration - this._time;
      this._startTime = this.getTimer() - this._time;
      this.onEnterFrame();
      this.fire('onReverse');
    },
    seek: function(t) {
      this.pause();
      this._time = t;
      this.update();
      this.fire('onSeek');
    },
    reset: function() {
      this.pause();
      this._time = 0;
      this.update();
      this.fire('onReset');
    },
    finish: function() {
      this.pause();
      this._time = this.duration;
      this.update();
      this.fire('onFinish');
    },
    update: function() {
      this.setPosition(this.getPosition(this._time));
    },
    onEnterFrame: function() {
      var t = this.getTimer() - this._startTime;
      if (this.state === PLAYING) {
        this.setTime(t);
      } else if (this.state === REVERSING) {
        this.setTime(this.duration - t);
      }
    },
    pause: function() {
      this.state = PAUSED;
      this.fire('onPause');
    },
    getTimer: function() {
      return new Date().getTime();
    }
  };

  /**
   * Tween constructor.  Tweens enable you to animate a node between the current state and a new state.
   *  You can play, pause, reverse, seek, reset, and finish tweens.  By default, tweens are animated using
   *  a linear easing.  For more tweening options, check out {@link Konva.Easings}
   * @constructor
   * @memberof Konva
   * @example
   * // instantiate new tween which fully rotates a node in 1 second
   * var tween = new Konva.Tween({
   *   node: node,
   *   rotationDeg: 360,
   *   duration: 1,
   *   easing: Konva.Easings.EaseInOut
   * });
   *
   * // play tween
   * tween.play();
   *
   * // pause tween
   * tween.pause();
   */
  Konva.Tween = function(config) {
    var that = this,
      node = config.node,
      nodeId = node._id,
      duration,
      easing = config.easing || Konva.Easings.Linear,
      yoyo = !!config.yoyo,
      key;

    if (typeof config.duration === 'undefined') {
      duration = 0.3;
    } else if (config.duration === 0) {
      // zero is bad value for duration
      duration = 0.001;
    } else {
      duration = config.duration;
    }
    this.node = node;
    this._id = idCounter++;

    var layers =
      node.getLayer() ||
      (node instanceof Konva.Stage ? node.getLayers() : null);
    if (!layers) {
      Konva.Util.error(
        'Tween constructor have `node` that is not in a layer. Please add node into layer first.'
      );
    }
    this.anim = new Konva.Animation(function() {
      that.tween.onEnterFrame();
    }, layers);

    this.tween = new Tween(
      key,
      function(i) {
        that._tweenFunc(i);
      },
      easing,
      0,
      1,
      duration * 1000,
      yoyo
    );

    this._addListeners();

    // init attrs map
    if (!Konva.Tween.attrs[nodeId]) {
      Konva.Tween.attrs[nodeId] = {};
    }
    if (!Konva.Tween.attrs[nodeId][this._id]) {
      Konva.Tween.attrs[nodeId][this._id] = {};
    }
    // init tweens map
    if (!Konva.Tween.tweens[nodeId]) {
      Konva.Tween.tweens[nodeId] = {};
    }

    for (key in config) {
      if (blacklist[key] === undefined) {
        this._addAttr(key, config[key]);
      }
    }

    this.reset();

    // callbacks
    this.onFinish = config.onFinish;
    this.onReset = config.onReset;
  };

  // start/diff object = attrs.nodeId.tweenId.attr
  Konva.Tween.attrs = {};
  // tweenId = tweens.nodeId.attr
  Konva.Tween.tweens = {};

  Konva.Tween.prototype = {
    _addAttr: function(key, end) {
      var node = this.node,
        nodeId = node._id,
        start,
        diff,
        tweenId,
        n,
        len,
        trueEnd,
        trueStart,
        endRGBA;

      // remove conflict from tween map if it exists
      tweenId = Konva.Tween.tweens[nodeId][key];

      if (tweenId) {
        delete Konva.Tween.attrs[nodeId][tweenId][key];
      }

      // add to tween map
      start = node.getAttr(key);

      if (Konva.Util._isArray(end)) {
        diff = [];
        len = Math.max(end.length, start.length);

        if (key === 'points' && end.length !== start.length) {
          // before tweening points we need to make sure that start.length === end.length
          // Konva.Util._prepareArrayForTween thinking that end.length > start.length

          if (end.length > start.length) {
            // so in this case we will increase number of starting points
            trueStart = start;
            start = Konva.Util._prepareArrayForTween(start, end, node.closed());
          } else {
            // in this case we will increase number of eding points
            trueEnd = end;
            end = Konva.Util._prepareArrayForTween(end, start, node.closed());
          }
        }

        if (key.indexOf('fill') === 0) {
          for (n = 0; n < len; n++) {
            if (n % 2 === 0) {
              diff.push(end[n] - start[n]);
            } else {
              var startRGBA = Konva.Util.colorToRGBA(start[n]);
              endRGBA = Konva.Util.colorToRGBA(end[n]);
              start[n] = startRGBA;
              diff.push({
                r: endRGBA.r - startRGBA.r,
                g: endRGBA.g - startRGBA.g,
                b: endRGBA.b - startRGBA.b,
                a: endRGBA.a - startRGBA.a
              });
            }
          }
        } else {
          for (n = 0; n < len; n++) {
            diff.push(end[n] - start[n]);
          }
        }
      } else if (colorAttrs.indexOf(key) !== -1) {
        start = Konva.Util.colorToRGBA(start);
        endRGBA = Konva.Util.colorToRGBA(end);
        diff = {
          r: endRGBA.r - start.r,
          g: endRGBA.g - start.g,
          b: endRGBA.b - start.b,
          a: endRGBA.a - start.a
        };
      } else {
        diff = end - start;
      }

      Konva.Tween.attrs[nodeId][this._id][key] = {
        start: start,
        diff: diff,
        end: end,
        trueEnd: trueEnd,
        trueStart: trueStart
      };
      Konva.Tween.tweens[nodeId][key] = this._id;
    },
    _tweenFunc: function(i) {
      var node = this.node,
        attrs = Konva.Tween.attrs[node._id][this._id],
        key,
        attr,
        start,
        diff,
        newVal,
        n,
        len,
        end;

      for (key in attrs) {
        attr = attrs[key];
        start = attr.start;
        diff = attr.diff;
        end = attr.end;

        if (Konva.Util._isArray(start)) {
          newVal = [];
          len = Math.max(start.length, end.length);
          if (key.indexOf('fill') === 0) {
            for (n = 0; n < len; n++) {
              if (n % 2 === 0) {
                newVal.push((start[n] || 0) + diff[n] * i);
              } else {
                newVal.push(
                  'rgba(' +
                    Math.round(start[n].r + diff[n].r * i) +
                    ',' +
                    Math.round(start[n].g + diff[n].g * i) +
                    ',' +
                    Math.round(start[n].b + diff[n].b * i) +
                    ',' +
                    (start[n].a + diff[n].a * i) +
                    ')'
                );
              }
            }
          } else {
            for (n = 0; n < len; n++) {
              newVal.push((start[n] || 0) + diff[n] * i);
            }
          }
        } else if (colorAttrs.indexOf(key) !== -1) {
          newVal =
            'rgba(' +
            Math.round(start.r + diff.r * i) +
            ',' +
            Math.round(start.g + diff.g * i) +
            ',' +
            Math.round(start.b + diff.b * i) +
            ',' +
            (start.a + diff.a * i) +
            ')';
        } else {
          newVal = start + diff * i;
        }

        node.setAttr(key, newVal);
      }
    },
    _addListeners: function() {
      var that = this;

      // start listeners
      this.tween.onPlay = function() {
        that.anim.start();
      };
      this.tween.onReverse = function() {
        that.anim.start();
      };

      // stop listeners
      this.tween.onPause = function() {
        that.anim.stop();
      };
      this.tween.onFinish = function() {
        var node = that.node;

        // after tweening  points of line we need to set original end
        var attrs = Konva.Tween.attrs[node._id][that._id];
        if (attrs.points && attrs.points.trueEnd) {
          node.points(attrs.points.trueEnd);
        }

        if (that.onFinish) {
          that.onFinish.call(that);
        }
      };
      this.tween.onReset = function() {
        var node = that.node;
        // after tweening  points of line we need to set original start
        var attrs = Konva.Tween.attrs[node._id][that._id];
        if (attrs.points && attrs.points.trueStart) {
          node.points(attrs.points.trueStart);
        }

        if (that.onReset) {
          that.onReset();
        }
      };
    },
    /**
     * play
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */
    play: function() {
      this.tween.play();
      return this;
    },
    /**
     * reverse
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */
    reverse: function() {
      this.tween.reverse();
      return this;
    },
    /**
     * reset
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */
    reset: function() {
      this.tween.reset();
      return this;
    },
    /**
     * seek
     * @method
     * @memberof Konva.Tween.prototype
     * @param {Integer} t time in seconds between 0 and the duration
     * @returns {Tween}
     */
    seek: function(t) {
      this.tween.seek(t * 1000);
      return this;
    },
    /**
     * pause
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */
    pause: function() {
      this.tween.pause();
      return this;
    },
    /**
     * finish
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */
    finish: function() {
      this.tween.finish();
      return this;
    },
    /**
     * destroy
     * @method
     * @memberof Konva.Tween.prototype
     */
    destroy: function() {
      var nodeId = this.node._id,
        thisId = this._id,
        attrs = Konva.Tween.tweens[nodeId],
        key;

      this.pause();

      for (key in attrs) {
        delete Konva.Tween.tweens[nodeId][key];
      }

      delete Konva.Tween.attrs[nodeId][thisId];
    }
  };

  /**
   * Tween node properties. Shorter usage of {@link Konva.Tween} object.
   *
   * @method Konva.Node#to
   * @memberof Konva.Node
   * @param {Object} [params] tween params
   * @example
   *
   * circle.to({
   *  x : 50,
   *  duration : 0.5
   * });
   */
  Konva.Node.prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
      this.destroy();
      if (onFinish) {
        onFinish();
      }
    };
    var tween = new Konva.Tween(params);
    tween.play();
  };

  /*
    * These eases were ported from an Adobe Flash tweening library to JavaScript
    * by Xaric
    */

  /**
   * @namespace Easings
   * @memberof Konva
   */
  Konva.Easings = {
    /**
     * back ease in
     * @function
     * @memberof Konva.Easings
     */
    BackEaseIn: function(t, b, c, d) {
      var s = 1.70158;
      return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    /**
     * back ease out
     * @function
     * @memberof Konva.Easings
     */
    BackEaseOut: function(t, b, c, d) {
      var s = 1.70158;
      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    /**
     * back ease in out
     * @function
     * @memberof Konva.Easings
     */
    BackEaseInOut: function(t, b, c, d) {
      var s = 1.70158;
      if ((t /= d / 2) < 1) {
        return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
      }
      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    /**
     * elastic ease in
     * @function
     * @memberof Konva.Easings
     */
    ElasticEaseIn: function(t, b, c, d, a, p) {
      // added s = 0
      var s = 0;
      if (t === 0) {
        return b;
      }
      if ((t /= d) === 1) {
        return b + c;
      }
      if (!p) {
        p = d * 0.3;
      }
      if (!a || a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return (
        -(
          a *
          Math.pow(2, 10 * (t -= 1)) *
          Math.sin((t * d - s) * (2 * Math.PI) / p)
        ) + b
      );
    },
    /**
     * elastic ease out
     * @function
     * @memberof Konva.Easings
     */
    ElasticEaseOut: function(t, b, c, d, a, p) {
      // added s = 0
      var s = 0;
      if (t === 0) {
        return b;
      }
      if ((t /= d) === 1) {
        return b + c;
      }
      if (!p) {
        p = d * 0.3;
      }
      if (!a || a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      return (
        a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) +
        c +
        b
      );
    },
    /**
     * elastic ease in out
     * @function
     * @memberof Konva.Easings
     */
    ElasticEaseInOut: function(t, b, c, d, a, p) {
      // added s = 0
      var s = 0;
      if (t === 0) {
        return b;
      }
      if ((t /= d / 2) === 2) {
        return b + c;
      }
      if (!p) {
        p = d * (0.3 * 1.5);
      }
      if (!a || a < Math.abs(c)) {
        a = c;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
      if (t < 1) {
        return (
          -0.5 *
            (a *
              Math.pow(2, 10 * (t -= 1)) *
              Math.sin((t * d - s) * (2 * Math.PI) / p)) +
          b
        );
      }
      return (
        a *
          Math.pow(2, -10 * (t -= 1)) *
          Math.sin((t * d - s) * (2 * Math.PI) / p) *
          0.5 +
        c +
        b
      );
    },
    /**
     * bounce ease out
     * @function
     * @memberof Konva.Easings
     */
    BounceEaseOut: function(t, b, c, d) {
      if ((t /= d) < 1 / 2.75) {
        return c * (7.5625 * t * t) + b;
      } else if (t < 2 / 2.75) {
        return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
      } else if (t < 2.5 / 2.75) {
        return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
      } else {
        return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
      }
    },
    /**
     * bounce ease in
     * @function
     * @memberof Konva.Easings
     */
    BounceEaseIn: function(t, b, c, d) {
      return c - Konva.Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    /**
     * bounce ease in out
     * @function
     * @memberof Konva.Easings
     */
    BounceEaseInOut: function(t, b, c, d) {
      if (t < d / 2) {
        return Konva.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
      } else {
        return (
          Konva.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b
        );
      }
    },
    /**
     * ease in
     * @function
     * @memberof Konva.Easings
     */
    EaseIn: function(t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    /**
     * ease out
     * @function
     * @memberof Konva.Easings
     */
    EaseOut: function(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    /**
     * ease in out
     * @function
     * @memberof Konva.Easings
     */
    EaseInOut: function(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t + b;
      }
      return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    /**
     * strong ease in
     * @function
     * @memberof Konva.Easings
     */
    StrongEaseIn: function(t, b, c, d) {
      return c * (t /= d) * t * t * t * t + b;
    },
    /**
     * strong ease out
     * @function
     * @memberof Konva.Easings
     */
    StrongEaseOut: function(t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    /**
     * strong ease in out
     * @function
     * @memberof Konva.Easings
     */
    StrongEaseInOut: function(t, b, c, d) {
      if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t * t * t + b;
      }
      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    /**
     * linear
     * @function
     * @memberof Konva.Easings
     */
    Linear: function(t, b, c, d) {
      return c * t / d + b;
    }
  };
})();

(function() {
  'use strict';
  Konva.DD = {
    // properties
    anim: new Konva.Animation(function() {
      var b = this.dirty;
      this.dirty = false;
      return b;
    }),
    isDragging: false,
    justDragged: false,
    offset: {
      x: 0,
      y: 0
    },
    node: null,

    // methods
    _drag: function(evt) {
      var dd = Konva.DD,
        node = dd.node;
      if (node) {
        if (!dd.isDragging) {
          var pos = node.getStage().getPointerPosition();
          // it is possible that pos is undefined
          // reattach it
          if (!pos) {
            node.getStage()._setPointerPosition(evt);
            pos = node.getStage().getPointerPosition();
          }
          var dragDistance = node.dragDistance();
          var distance = Math.max(
            Math.abs(pos.x - dd.startPointerPos.x),
            Math.abs(pos.y - dd.startPointerPos.y)
          );
          if (distance < dragDistance) {
            return;
          }
        }

        node.getStage()._setPointerPosition(evt);
        if (!dd.isDragging) {
          dd.isDragging = true;
          node.fire(
            'dragstart',
            {
              type: 'dragstart',
              target: node,
              evt: evt
            },
            true
          );
          // a user can stop dragging inside `dragstart`
          if (!node.isDragging()) {
            return;
          }
        }
        node._setDragPosition(evt);

        // execute ondragmove if defined
        node.fire(
          'dragmove',
          {
            type: 'dragmove',
            target: node,
            evt: evt
          },
          true
        );
      }
    },
    _endDragBefore: function(evt) {
      var dd = Konva.DD,
        node = dd.node,
        layer;

      if (node) {
        layer = node.getLayer();
        dd.anim.stop();

        // only fire dragend event if the drag and drop
        // operation actually started.
        if (dd.isDragging) {
          dd.isDragging = false;
          dd.justDragged = true;
          Konva.listenClickTap = false;

          if (evt) {
            evt.dragEndNode = node;
          }
        }

        delete dd.node;

        if (node.getLayer() || layer || node instanceof Konva.Stage) {
          (layer || node).draw();
        }
      }
    },
    _endDragAfter: function(evt) {
      evt = evt || {};
      var dragEndNode = evt.dragEndNode;

      if (evt && dragEndNode) {
        dragEndNode.fire(
          'dragend',
          {
            type: 'dragend',
            target: dragEndNode,
            evt: evt
          },
          true
        );
      }
    }
  };

  // Node extenders

  /**
   * initiate drag and drop
   * @method
   * @memberof Konva.Node.prototype
   */
  Konva.Node.prototype.startDrag = function() {
    var dd = Konva.DD,
      stage = this.getStage(),
      layer = this.getLayer(),
      pos = stage.getPointerPosition(),
      ap = this.getAbsolutePosition();

    if (pos) {
      if (dd.node) {
        dd.node.stopDrag();
      }

      dd.node = this;
      dd.startPointerPos = pos;
      dd.offset.x = pos.x - ap.x;
      dd.offset.y = pos.y - ap.y;
      dd.anim.setLayers(layer || this.getLayers());
      dd.anim.start();

      this._setDragPosition();
    }
  };

  Konva.Node.prototype._setDragPosition = function(evt) {
    var dd = Konva.DD,
      pos = this.getStage().getPointerPosition(),
      dbf = this.getDragBoundFunc();
    if (!pos) {
      return;
    }
    var newNodePos = {
      x: pos.x - dd.offset.x,
      y: pos.y - dd.offset.y
    };

    if (dbf !== undefined) {
      newNodePos = dbf.call(this, newNodePos, evt);
    }
    this.setAbsolutePosition(newNodePos);

    if (
      !this._lastPos ||
      this._lastPos.x !== newNodePos.x ||
      this._lastPos.y !== newNodePos.y
    ) {
      dd.anim.dirty = true;
    }

    this._lastPos = newNodePos;
  };

  /**
   * stop drag and drop
   * @method
   * @memberof Konva.Node.prototype
   */
  Konva.Node.prototype.stopDrag = function() {
    var dd = Konva.DD,
      evt = {};
    dd._endDragBefore(evt);
    dd._endDragAfter(evt);
  };

  Konva.Node.prototype.setDraggable = function(draggable) {
    this._setAttr('draggable', draggable);
    this._dragChange();
  };

  var origRemove = Konva.Node.prototype.remove;

  Konva.Node.prototype.__originalRemove = origRemove;
  Konva.Node.prototype.remove = function() {
    var dd = Konva.DD;

    // stop DD
    if (dd.node && dd.node._id === this._id) {
      this.stopDrag();
    }

    origRemove.call(this);
  };

  /**
   * determine if node is currently in drag and drop mode
   * @method
   * @memberof Konva.Node.prototype
   */
  Konva.Node.prototype.isDragging = function() {
    var dd = Konva.DD;
    return !!(dd.node && dd.node._id === this._id && dd.isDragging);
  };

  Konva.Node.prototype._listenDrag = function() {
    var that = this;

    this._dragCleanup();

    if (this.getClassName() === 'Stage') {
      this.on('contentMousedown.konva contentTouchstart.konva', function(evt) {
        if (!Konva.DD.node) {
          that.startDrag(evt);
        }
      });
    } else {
      this.on('mousedown.konva touchstart.konva', function(evt) {
        // ignore right and middle buttons
        if (evt.evt.button === 1 || evt.evt.button === 2) {
          return;
        }
        if (!Konva.DD.node) {
          that.startDrag(evt);
        }
      });
    }

    // listening is required for drag and drop
    /*
        this._listeningEnabled = true;
        this._clearSelfAndAncestorCache('listeningEnabled');
        */
  };

  Konva.Node.prototype._dragChange = function() {
    if (this.attrs.draggable) {
      this._listenDrag();
    } else {
      // remove event listeners
      this._dragCleanup();

      /*
             * force drag and drop to end
             * if this node is currently in
             * drag and drop mode
             */
      var stage = this.getStage();
      var dd = Konva.DD;
      if (stage && dd.node && dd.node._id === this._id) {
        dd.node.stopDrag();
      }
    }
  };

  Konva.Node.prototype._dragCleanup = function() {
    if (this.getClassName() === 'Stage') {
      this.off('contentMousedown.konva');
      this.off('contentTouchstart.konva');
    } else {
      this.off('mousedown.konva');
      this.off('touchstart.konva');
    }
  };

  Konva.Factory.addGetterSetter(Konva.Node, 'dragBoundFunc');

  /**
   * get/set drag bound function.  This is used to override the default
   *  drag and drop position.
   * @name dragBoundFunc
   * @method
   * @memberof Konva.Node.prototype
   * @param {Function} dragBoundFunc
   * @returns {Function}
   * @example
   * // get drag bound function
   * var dragBoundFunc = node.dragBoundFunc();
   *
   * // create vertical drag and drop
   * node.dragBoundFunc(function(pos){
   *   // important pos - is absolute position of the node
   *   // you should return absolute position too
   *   return {
   *     x: this.getAbsolutePosition().x,
   *     y: pos.y
   *   };
   * });
   */

  Konva.Factory.addGetter(Konva.Node, 'draggable', false);
  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'draggable');

  /**
   * get/set draggable flag
   * @name draggable
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean} draggable
   * @returns {Boolean}
   * @example
   * // get draggable flag
   * var draggable = node.draggable();
   *
   * // enable drag and drop
   * node.draggable(true);
   *
   * // disable drag and drop
   * node.draggable(false);
   */

  if (Konva.isBrowser) {
    window.addEventListener('mouseup', Konva.DD._endDragBefore, true);
    window.addEventListener('touchend', Konva.DD._endDragBefore, true);

    window.addEventListener('mousemove', Konva.DD._drag);
    window.addEventListener('touchmove', Konva.DD._drag);

    window.addEventListener('mouseup', Konva.DD._endDragAfter, false);
    window.addEventListener('touchend', Konva.DD._endDragAfter, false);
  }
})();

(function() {
  'use strict';
  /**
   * Rect constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} [config.cornerRadius]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var rect = new Konva.Rect({
   *   width: 100,
   *   height: 50,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 5
   * });
   */
  Konva.Rect = function(config) {
    this.___init(config);
  };

  Konva.Rect.prototype = {
    ___init: function(config) {
      Konva.Shape.call(this, config);
      this.className = 'Rect';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var cornerRadius = this.getCornerRadius(),
        width = this.getWidth(),
        height = this.getHeight();

      context.beginPath();

      if (!cornerRadius) {
        // simple rect - don't bother doing all that complicated maths stuff.
        context.rect(0, 0, width, height);
      } else {
        // arcTo would be nicer, but browser support is patchy (Opera)
        cornerRadius = Math.min(cornerRadius, width / 2, height / 2);
        context.moveTo(cornerRadius, 0);
        context.lineTo(width - cornerRadius, 0);
        context.arc(
          width - cornerRadius,
          cornerRadius,
          cornerRadius,
          Math.PI * 3 / 2,
          0,
          false
        );
        context.lineTo(width, height - cornerRadius);
        context.arc(
          width - cornerRadius,
          height - cornerRadius,
          cornerRadius,
          0,
          Math.PI / 2,
          false
        );
        context.lineTo(cornerRadius, height);
        context.arc(
          cornerRadius,
          height - cornerRadius,
          cornerRadius,
          Math.PI / 2,
          Math.PI,
          false
        );
        context.lineTo(0, cornerRadius);
        context.arc(
          cornerRadius,
          cornerRadius,
          cornerRadius,
          Math.PI,
          Math.PI * 3 / 2,
          false
        );
      }
      context.closePath();
      context.fillStrokeShape(this);
    }
  };

  Konva.Util.extend(Konva.Rect, Konva.Shape);

  Konva.Factory.addGetterSetter(
    Konva.Rect,
    'cornerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set corner radius
   * @name cornerRadius
   * @method
   * @memberof Konva.Rect.prototype
   * @param {Number} cornerRadius
   * @returns {Number}
   * @example
   * // get corner radius
   * var cornerRadius = rect.cornerRadius();
   *
   * // set corner radius
   * rect.cornerRadius(10);
   */

  Konva.Collection.mapMethods(Konva.Rect);
})();

(function(Konva) {
  'use strict';
  // the 0.0001 offset fixes a bug in Chrome 27
  var PIx2 = Math.PI * 2 - 0.0001,
    CIRCLE = 'Circle';

  /**
   * Circle constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // create circle
   * var circle = new Konva.Circle({
   *   radius: 40,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5
   * });
   */
  Konva.Circle = function(config) {
    this.___init(config);
  };

  Konva.Circle.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = CIRCLE;
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      context.beginPath();
      context.arc(0, 0, this.getRadius(), 0, PIx2, false);
      context.closePath();
      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.radius() !== width / 2) {
        this.setRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.radius() !== height / 2) {
        this.setRadius(height / 2);
      }
    }
  };
  Konva.Util.extend(Konva.Circle, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.Circle,
    'radius',
    0,
    Konva.Validators.getNumberValidator()
  );
  Konva.Factory.addOverloadedGetterSetter(Konva.Circle, 'radius');

  /**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Circle.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radius
   * var radius = circle.radius();
   *
   * // set radius
   * circle.radius(10);
   */

  Konva.Collection.mapMethods(Konva.Circle);
})(Konva);

(function() {
  'use strict';
  // the 0.0001 offset fixes a bug in Chrome 27
  var PIx2 = Math.PI * 2 - 0.0001,
    ELLIPSE = 'Ellipse';

  /**
   * Ellipse constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Object} config.radius defines x and y radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var ellipse = new Konva.Ellipse({
   *   radius : {
   *     x : 50,
   *     y : 50
   *   },
   *   fill: 'red'
   * });
   */
  Konva.Ellipse = function(config) {
    this.___init(config);
  };

  Konva.Ellipse.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = ELLIPSE;
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var rx = this.getRadiusX(),
        ry = this.getRadiusY();

      context.beginPath();
      context.save();
      if (rx !== ry) {
        context.scale(1, ry / rx);
      }
      context.arc(0, 0, rx, 0, PIx2, false);
      context.restore();
      context.closePath();
      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getRadiusX() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getRadiusY() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      this.setRadius({
        x: width / 2
      });
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      this.setRadius({
        y: height / 2
      });
    }
  };
  Konva.Util.extend(Konva.Ellipse, Konva.Shape);

  // add getters setters
  Konva.Factory.addComponentsGetterSetter(Konva.Ellipse, 'radius', ['x', 'y']);

  /**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Object} radius
   * @param {Number} radius.x
   * @param {Number} radius.y
   * @returns {Object}
   * @example
   * // get radius
   * var radius = ellipse.radius();
   *
   * // set radius
   * ellipse.radius({
   *   x: 200,
   *   y: 100
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Ellipse,
    'radiusX',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set radius x
   * @name radiusX
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get radius x
   * var radiusX = ellipse.radiusX();
   *
   * // set radius x
   * ellipse.radiusX(200);
   */

  Konva.Factory.addGetterSetter(
    Konva.Ellipse,
    'radiusY',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set radius y
   * @name radiusY
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get radius y
   * var radiusY = ellipse.radiusY();
   *
   * // set radius y
   * ellipse.radiusY(200);
   */

  Konva.Collection.mapMethods(Konva.Ellipse);
})();

(function() {
  'use strict';
  // the 0.0001 offset fixes a bug in Chrome 27
  var PIx2 = Math.PI * 2 - 0.0001;
  /**
   * Ring constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var ring = new Konva.Ring({
   *   innerRadius: 40,
   *   outerRadius: 80,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 5
   * });
   */
  Konva.Ring = function(config) {
    this.___init(config);
  };

  Konva.Ring.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Ring';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      context.beginPath();
      context.arc(0, 0, this.getInnerRadius(), 0, PIx2, false);
      context.moveTo(this.getOuterRadius(), 0);
      context.arc(0, 0, this.getOuterRadius(), PIx2, 0, true);
      context.closePath();
      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.outerRadius() !== width / 2) {
        this.setOuterRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.outerRadius() !== height / 2) {
        this.setOuterRadius(height / 2);
      }
    },
    setOuterRadius: function(val) {
      this._setAttr('outerRadius', val);
      this.setWidth(val * 2);
      this.setHeight(val * 2);
    }
  };
  Konva.Util.extend(Konva.Ring, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.Ring,
    'innerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set innerRadius
   * @name innerRadius
   * @method
   * @memberof Konva.Ring.prototype
   * @param {Number} innerRadius
   * @returns {Number}
   * @example
   * // get inner radius
   * var innerRadius = ring.innerRadius();
   *
   * // set inner radius
   * ring.innerRadius(20);
   */
  Konva.Factory.addGetter(
    Konva.Ring,
    'outerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );
  Konva.Factory.addOverloadedGetterSetter(Konva.Ring, 'outerRadius');

  /**
   * get/set outerRadius
   * @name outerRadius
   * @method
   * @memberof Konva.Ring.prototype
   * @param {Number} outerRadius
   * @returns {Number}
   * @example
   * // get outer radius
   * var outerRadius = ring.outerRadius();
   *
   * // set outer radius
   * ring.outerRadius(20);
   */

  Konva.Collection.mapMethods(Konva.Ring);
})();

(function() {
  'use strict';
  /**
   * Wedge constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.angle in degrees
   * @param {Number} config.radius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // draw a wedge that's pointing downwards
   * var wedge = new Konva.Wedge({
   *   radius: 40,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5,
   *   angleDeg: 60,
   *   rotationDeg: -120
   * });
   */
  Konva.Wedge = function(config) {
    this.___init(config);
  };

  Konva.Wedge.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Wedge';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      context.beginPath();
      context.arc(
        0,
        0,
        this.getRadius(),
        0,
        Konva.getAngle(this.getAngle()),
        this.getClockwise()
      );
      context.lineTo(0, 0);
      context.closePath();
      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.radius() !== width / 2) {
        this.setRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.radius() !== height / 2) {
        this.setRadius(height / 2);
      }
    }
  };
  Konva.Util.extend(Konva.Wedge, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.Wedge,
    'radius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radius
   * var radius = wedge.radius();
   *
   * // set radius
   * wedge.radius(10);
   */

  Konva.Factory.addGetterSetter(
    Konva.Wedge,
    'angle',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set angle in degrees
   * @name angle
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} angle
   * @returns {Number}
   * @example
   * // get angle
   * var angle = wedge.angle();
   *
   * // set angle
   * wedge.angle(20);
   */

  Konva.Factory.addGetterSetter(Konva.Wedge, 'clockwise', false);

  /**
   * get/set clockwise flag
   * @name clockwise
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} clockwise
   * @returns {Number}
   * @example
   * // get clockwise flag
   * var clockwise = wedge.clockwise();
   *
   * // draw wedge counter-clockwise
   * wedge.clockwise(false);
   *
   * // draw wedge clockwise
   * wedge.clockwise(true);
   */

  Konva.Factory.backCompat(Konva.Wedge, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
  });

  Konva.Collection.mapMethods(Konva.Wedge);
})();

(function(Konva) {
  'use strict';
  /**
   * Arc constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.angle in degrees
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // draw a Arc that's pointing downwards
   * var arc = new Konva.Arc({
   *   innerRadius: 40,
   *   outerRadius: 80,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5,
   *   angle: 60,
   *   rotationDeg: -120
   * });
   */
  Konva.Arc = function(config) {
    this.___init(config);
  };

  Konva.Arc.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Arc';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var angle = Konva.getAngle(this.angle()),
        clockwise = this.clockwise();

      context.beginPath();
      context.arc(0, 0, this.getOuterRadius(), 0, angle, clockwise);
      context.arc(0, 0, this.getInnerRadius(), angle, 0, !clockwise);
      context.closePath();
      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.getOuterRadius() !== width / 2) {
        this.setOuterRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.getOuterRadius() !== height / 2) {
        this.setOuterRadius(height / 2);
      }
    }
  };
  Konva.Util.extend(Konva.Arc, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.Arc,
    'innerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set innerRadius
   * @name innerRadius
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} innerRadius
   * @returns {Number}
   * @example
   * // get inner radius
   * var innerRadius = arc.innerRadius();
   *
   * // set inner radius
   * arc.innerRadius(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Arc,
    'outerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set outerRadius
   * @name outerRadius
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} outerRadius
   * @returns {Number}
   * @example
   * // get outer radius
   * var outerRadius = arc.outerRadius();
   *
   * // set outer radius
   * arc.outerRadius(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Arc,
    'angle',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set angle in degrees
   * @name angle
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} angle
   * @returns {Number}
   * @example
   * // get angle
   * var angle = arc.angle();
   *
   * // set angle
   * arc.angle(20);
   */

  Konva.Factory.addGetterSetter(Konva.Arc, 'clockwise', false);

  /**
   * get/set clockwise flag
   * @name clockwise
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Boolean} clockwise
   * @returns {Boolean}
   * @example
   * // get clockwise flag
   * var clockwise = arc.clockwise();
   *
   * // draw arc counter-clockwise
   * arc.clockwise(false);
   *
   * // draw arc clockwise
   * arc.clockwise(true);
   */

  Konva.Collection.mapMethods(Konva.Arc);
})(Konva);

(function() {
  'use strict';
  // CONSTANTS
  var IMAGE = 'Image';

  /**
   * Image constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Image} config.image
   * @param {Object} [config.crop]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   var image = new Konva.Image({
   *     x: 200,
   *     y: 50,
   *     image: imageObj,
   *     width: 100,
   *     height: 100
   *   });
   * };
   * imageObj.src = '/path/to/image.jpg'
   */
  Konva.Image = function(config) {
    this.___init(config);
  };

  Konva.Image.prototype = {
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = IMAGE;
      this.sceneFunc(this._sceneFunc);
      this.hitFunc(this._hitFunc);
    },
    _useBufferCanvas: function() {
      return (
        (this.hasShadow() || this.getAbsoluteOpacity() !== 1) &&
        this.hasStroke() &&
        this.getStage()
      );
    },
    _sceneFunc: function(context) {
      var width = this.getWidth(),
        height = this.getHeight(),
        image = this.getImage(),
        cropWidth,
        cropHeight,
        params;

      if (image) {
        cropWidth = this.getCropWidth();
        cropHeight = this.getCropHeight();
        if (cropWidth && cropHeight) {
          params = [
            image,
            this.getCropX(),
            this.getCropY(),
            cropWidth,
            cropHeight,
            0,
            0,
            width,
            height
          ];
        } else {
          params = [image, 0, 0, width, height];
        }
      }

      if (this.hasFill() || this.hasStroke()) {
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
      }

      if (image) {
        context.drawImage.apply(context, params);
      }
    },
    _hitFunc: function(context) {
      var width = this.getWidth(),
        height = this.getHeight();

      context.beginPath();
      context.rect(0, 0, width, height);
      context.closePath();
      context.fillStrokeShape(this);
    },
    getWidth: function() {
      var image = this.getImage();
      return this.attrs.width || (image ? image.width : 0);
    },
    getHeight: function() {
      var image = this.getImage();
      return this.attrs.height || (image ? image.height : 0);
    }
  };
  Konva.Util.extend(Konva.Image, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(Konva.Image, 'image');

  /**
   * set image
   * @name setImage
   * @method
   * @memberof Konva.Image.prototype
   * @param {Image} image
   */

  /**
   * get image
   * @name getImage
   * @method
   * @memberof Konva.Image.prototype
   * @returns {Image}
   */

  Konva.Factory.addComponentsGetterSetter(Konva.Image, 'crop', [
    'x',
    'y',
    'width',
    'height'
  ]);
  /**
   * get/set crop
   * @method
   * @name crop
   * @memberof Konva.Image.prototype
   * @param {Object} crop
   * @param {Number} crop.x
   * @param {Number} crop.y
   * @param {Number} crop.width
   * @param {Number} crop.height
   * @returns {Object}
   * @example
   * // get crop
   * var crop = image.crop();
   *
   * // set crop
   * image.crop({
   *   x: 20,
   *   y: 20,
   *   width: 20,
   *   height: 20
   * });
   */

  Konva.Factory.addGetterSetter(
    Konva.Image,
    'cropX',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set crop x
   * @method
   * @name cropX
   * @memberof Konva.Image.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get crop x
   * var cropX = image.cropX();
   *
   * // set crop x
   * image.cropX(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Image,
    'cropY',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set crop y
   * @name cropY
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get crop y
   * var cropY = image.cropY();
   *
   * // set crop y
   * image.cropY(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Image,
    'cropWidth',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set crop width
   * @name cropWidth
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get crop width
   * var cropWidth = image.cropWidth();
   *
   * // set crop width
   * image.cropWidth(20);
   */

  Konva.Factory.addGetterSetter(
    Konva.Image,
    'cropHeight',
    0,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set crop height
   * @name cropHeight
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get crop height
   * var cropHeight = image.cropHeight();
   *
   * // set crop height
   * image.cropHeight(20);
   */

  Konva.Collection.mapMethods(Konva.Image);

  /**
   * load image from given url and create `Konva.Image` instance
   * @method
   * @memberof Konva.Image
   * @param {String} url image source
   * @param {Function} callback with Konva.Image instance as first argument
   * @example
   *  Konva.Image.fromURL(imageURL, function(image){
   *    // image is Konva.Image instance
   *    layer.add(image);
   *    layer.draw();
   *  });
   */
  Konva.Image.fromURL = function(url, callback) {
    var img = new Image();
    img.onload = function() {
      var image = new Konva.Image({
        image: img
      });
      callback(image);
    };
    img.crossOrigin = 'Anonymous';
    img.src = url;
  };
})();

/*eslint-disable max-depth */
(function() {
  'use strict';
  // var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  // constants
  var AUTO = 'auto',
    //CANVAS = 'canvas',
    CENTER = 'center',
    JUSTIFY = 'justify',
    CHANGE_KONVA = 'Change.konva',
    CONTEXT_2D = '2d',
    DASH = '-',
    EMPTY_STRING = '',
    LEFT = 'left',
    TEXT = 'text',
    TEXT_UPPER = 'Text',
    TOP = 'top',
    BOTTOM = 'bottom',
    MIDDLE = 'middle',
    NORMAL = 'normal',
    PX_SPACE = 'px ',
    SPACE = ' ',
    RIGHT = 'right',
    WORD = 'word',
    CHAR = 'char',
    NONE = 'none',
    ELLIPSIS = '…',
    ATTR_CHANGE_LIST = [
      'fontFamily',
      'fontSize',
      'fontStyle',
      'fontVariant',
      'padding',
      'align',
      'verticalAlign',
      'lineHeight',
      'text',
      'width',
      'height',
      'wrap',
      'ellipsis',
      'letterSpacing'
    ],
    // cached variables
    attrChangeListLen = ATTR_CHANGE_LIST.length;
  var dummyContext;
  function getDummyContext() {
    if (dummyContext) {
      return dummyContext;
    }
    dummyContext = Konva.Util.createCanvasElement().getContext(CONTEXT_2D);
    return dummyContext;
  }

  /**
   * Text constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} [config.fontFamily] default is Arial
   * @param {Number} [config.fontSize] in pixels.  Default is 12
   * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
   * @param {String} config.text
   * @param {String} [config.align] can be left, center, or right
   * @param {String} [config.verticalAlign] can be top, middle or bottom
   * @param {Number} [config.padding]
   * @param {Number} [config.lineHeight] default is 1
   * @param {String} [config.wrap] can be word, char, or none. Default is word
   * @param {Boolean} [config.ellipsis] can be true or false. Default is false. if Konva.Text config is set to wrap="none" and ellipsis=true, then it will add "..." to the end
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var text = new Konva.Text({
   *   x: 10,
   *   y: 15,
   *   text: 'Simple Text',
   *   fontSize: 30,
   *   fontFamily: 'Calibri',
   *   fill: 'green'
   * });
   */
  Konva.Text = function(config) {
    this.___init(config);
  };
  function _fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
  }
  function _strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
  }

  Konva.Text.prototype = {
    ___init: function(config) {
      config = config || {};

      // set default color to black
      if (
        !config.fillLinearGradientColorStops &&
        !config.fillRadialGradientColorStops
      ) {
        config.fill = config.fill || 'black';
      }
      //
      // if (config.width === undefined) {
      //     config.width = AUTO;
      // }
      // if (config.height === undefined) {
      //     config.height = AUTO;
      // }

      // call super constructor
      Konva.Shape.call(this, config);

      this._fillFunc = _fillFunc;
      this._strokeFunc = _strokeFunc;
      this.className = TEXT_UPPER;

      // update text data for certain attr changes
      for (var n = 0; n < attrChangeListLen; n++) {
        this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, this._setTextData);
      }

      this._setTextData();
      this.sceneFunc(this._sceneFunc);
      this.hitFunc(this._hitFunc);
    },
    _sceneFunc: function(context) {
      var padding = this.getPadding(),
        textHeight = this.getTextHeight(),
        lineHeightPx = this.getLineHeight() * textHeight,
        textArr = this.textArr,
        textArrLen = textArr.length,
        verticalAlign = this.getVerticalAlign(),
        alignY = 0,
        align = this.getAlign(),
        totalWidth = this.getWidth(),
        letterSpacing = this.getLetterSpacing(),
        textDecoration = this.textDecoration(),
        fill = this.fill(),
        fontSize = this.fontSize(),
        n;

      context.setAttr('font', this._getContextFont());

      context.setAttr('textBaseline', MIDDLE);
      context.setAttr('textAlign', LEFT);

      // handle vertical alignment
      if (verticalAlign === MIDDLE) {
        alignY =
          (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
      } else if (verticalAlign === BOTTOM) {
        alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
      }

      if (padding) {
        context.translate(padding, 0);
        context.translate(0, alignY + padding + lineHeightPx / 2);
      } else {
        context.translate(0, alignY + lineHeightPx / 2);
      }

      // draw text lines
      for (n = 0; n < textArrLen; n++) {
        var obj = textArr[n],
          text = obj.text,
          width = obj.width,
          lastLine = n !== textArrLen - 1,
          spacesNumber,
          oneWord,
          lineWidth;

        // horizontal alignment
        context.save();
        if (align === RIGHT) {
          context.translate(totalWidth - width - padding * 2, 0);
        } else if (align === CENTER) {
          context.translate((totalWidth - width - padding * 2) / 2, 0);
        }

        if (textDecoration.indexOf('underline') !== -1) {
          context.save();
          context.beginPath();

          context.moveTo(0, Math.round(lineHeightPx / 2));
          spacesNumber = text.split(' ').length - 1;
          oneWord = spacesNumber === 0;
          lineWidth =
            align === JUSTIFY && lastLine && !oneWord
              ? totalWidth - padding * 2
              : width;
          context.lineTo(Math.round(lineWidth), Math.round(lineHeightPx / 2));
          // TODO: I have no idea what is real ratio
          // just /15 looks good enough
          context.lineWidth = fontSize / 15;
          context.strokeStyle = fill;
          context.stroke();
          context.restore();
        }
        if (textDecoration.indexOf('line-through') !== -1) {
          context.save();
          context.beginPath();
          context.moveTo(0, 0);
          spacesNumber = text.split(' ').length - 1;
          oneWord = spacesNumber === 0;
          lineWidth =
            align === JUSTIFY && lastLine && !oneWord
              ? totalWidth - padding * 2
              : width;
          context.lineTo(Math.round(lineWidth), 0);
          context.lineWidth = fontSize / 15;
          context.strokeStyle = fill;
          context.stroke();
          context.restore();
        }
        if (letterSpacing !== 0 || align === JUSTIFY) {
          //   var words = text.split(' ');
          spacesNumber = text.split(' ').length - 1;
          for (var li = 0; li < text.length; li++) {
            var letter = text[li];
            // skip justify for the last line
            if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
              context.translate(
                Math.floor((totalWidth - padding * 2 - width) / spacesNumber),
                0
              );
            }
            this.partialText = letter;
            context.fillStrokeShape(this);
            context.translate(
              Math.round(this._getTextSize(letter).width) + letterSpacing,
              0
            );
          }
        } else {
          this.partialText = text;

          context.fillStrokeShape(this);
        }
        context.restore();
        if (textArrLen > 1) {
          context.translate(0, lineHeightPx);
        }
      }
    },
    _hitFunc: function(context) {
      var width = this.getWidth(),
        height = this.getHeight();

      context.beginPath();
      context.rect(0, 0, width, height);
      context.closePath();
      context.fillStrokeShape(this);
    },
    setText: function(text) {
      var str = Konva.Util._isString(text) ? text : (text || '').toString();
      this._setAttr(TEXT, str);
      return this;
    },
    /**
     * get width of text area, which includes padding
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */
    getWidth: function() {
      var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
      return isAuto
        ? this.getTextWidth() + this.getPadding() * 2
        : this.attrs.width;
    },
    /**
     * get the height of the text area, which takes into account multi-line text, line heights, and padding
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */
    getHeight: function() {
      var isAuto =
        this.attrs.height === AUTO || this.attrs.height === undefined;
      return isAuto
        ? this.getTextHeight() * this.textArr.length * this.getLineHeight() +
            this.getPadding() * 2
        : this.attrs.height;
    },
    /**
     * get text width
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */
    getTextWidth: function() {
      return this.textWidth;
    },
    /**
     * get height of one line text
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */
    getTextHeight: function() {
      return this.textHeight;
    },
    _getTextSize: function(text) {
      var _context = getDummyContext(),
        fontSize = this.getFontSize(),
        metrics;

      _context.save();
      _context.font = this._getContextFont();

      metrics = _context.measureText(text);
      _context.restore();
      return {
        width: metrics.width,
        height: parseInt(fontSize, 10)
      };
    },
    _getContextFont: function() {
      // IE don't want to work with usual font style
      // bold was not working
      // removing font variant will solve
      // fix for: https://github.com/konvajs/konva/issues/94
      if (Konva.UA.isIE) {
        return (
          this.getFontStyle() +
          SPACE +
          this.getFontSize() +
          PX_SPACE +
          this.getFontFamily()
        );
      }
      return (
        this.getFontStyle() +
        SPACE +
        this.getFontVariant() +
        SPACE +
        this.getFontSize() +
        PX_SPACE +
        this.getFontFamily()
      );
    },
    _addTextLine: function(line) {
      if (this.align() === JUSTIFY) {
        line = line.trim();
      }
      var width = this._getTextWidth(line);
      return this.textArr.push({ text: line, width: width });
    },
    _getTextWidth: function(text) {
      var latterSpacing = this.getLetterSpacing();
      var length = text.length;
      return (
        getDummyContext().measureText(text).width +
        (length ? latterSpacing * (length - 1) : 0)
      );
    },
    _setTextData: function() {
      var lines = this.getText().split('\n'),
        fontSize = +this.getFontSize(),
        textWidth = 0,
        lineHeightPx = this.getLineHeight() * fontSize,
        width = this.attrs.width,
        height = this.attrs.height,
        fixedWidth = width !== AUTO,
        fixedHeight = height !== AUTO,
        padding = this.getPadding(),
        maxWidth = width - padding * 2,
        maxHeightPx = height - padding * 2,
        currentHeightPx = 0,
        wrap = this.getWrap(),
        // align = this.getAlign(),
        shouldWrap = wrap !== NONE,
        wrapAtWord = wrap !== CHAR && shouldWrap,
        shouldAddEllipsis = this.getEllipsis() && !shouldWrap;

      this.textArr = [];
      getDummyContext().font = this._getContextFont();
      for (var i = 0, max = lines.length; i < max; ++i) {
        var line = lines[i];
        var additionalWidth = shouldAddEllipsis
          ? this._getTextWidth(ELLIPSIS)
          : 0;

        var lineWidth = this._getTextWidth(line);
        if (fixedWidth && lineWidth > maxWidth) {
          /*
          * if width is fixed and line does not fit entirely
          * break the line into multiple fitting lines
          */
          while (line.length > 0) {
            /*
            * use binary search to find the longest substring that
            * that would fit in the specified width
            */
            var low = 0,
              high = line.length,
              match = '',
              matchWidth = 0;
            while (low < high) {
              var mid = (low + high) >>> 1,
                substr = line.slice(0, mid + 1),
                substrWidth = this._getTextWidth(substr) + additionalWidth;
              if (substrWidth <= maxWidth) {
                low = mid + 1;
                match = substr + (shouldAddEllipsis ? ELLIPSIS : '');
                matchWidth = substrWidth;
              } else {
                high = mid;
              }
            }
            /*
            * 'low' is now the index of the substring end
            * 'match' is the substring
            * 'matchWidth' is the substring width in px
            */
            if (match) {
              // a fitting substring was found
              if (wrapAtWord) {
                // try to find a space or dash where wrapping could be done
                var wrapIndex;
                var nextChar = line[match.length];
                var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
                if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
                  wrapIndex = match.length;
                } else {
                  wrapIndex =
                    Math.max(
                      match.lastIndexOf(SPACE),
                      match.lastIndexOf(DASH)
                    ) + 1;
                }
                if (wrapIndex > 0) {
                  // re-cut the substring found at the space/dash position
                  low = wrapIndex;
                  match = match.slice(0, low);
                  matchWidth = this._getTextWidth(match);
                }
              }
              // if (align === 'right') {
              match = Konva.Util.trimRight(match);
              // }
              this._addTextLine(match);
              textWidth = Math.max(textWidth, matchWidth);
              currentHeightPx += lineHeightPx;
              if (
                !shouldWrap ||
                (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx)
              ) {
                /*
                * stop wrapping if wrapping is disabled or if adding
                * one more line would overflow the fixed height
                */
                break;
              }
              line = line.slice(low);
              line = Konva.Util.trimLeft(line);
              if (line.length > 0) {
                // Check if the remaining text would fit on one line
                lineWidth = this._getTextWidth(line);
                if (lineWidth <= maxWidth) {
                  // if it does, add the line and break out of the loop
                  this._addTextLine(line);
                  currentHeightPx += lineHeightPx;
                  textWidth = Math.max(textWidth, lineWidth);
                  break;
                }
              }
            } else {
              // not even one character could fit in the element, abort
              break;
            }
          }
        } else {
          // element width is automatically adjusted to max line width
          this._addTextLine(line);
          currentHeightPx += lineHeightPx;
          textWidth = Math.max(textWidth, lineWidth);
        }
        // if element height is fixed, abort if adding one more line would overflow
        if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
          break;
        }
      }
      this.textHeight = fontSize;
      // var maxTextWidth = 0;
      // for(var j = 0; j < this.textArr.length; j++) {
      //     maxTextWidth = Math.max(maxTextWidth, this.textArr[j].width);
      // }
      this.textWidth = textWidth;
    }
  };
  Konva.Util.extend(Konva.Text, Konva.Shape);

  Konva.Factory.addSetter(
    Konva.Node,
    'width',
    Konva.Validators.getNumberOrAutoValidator()
  );

  Konva.Factory.addSetter(
    Konva.Node,
    'height',
    Konva.Validators.getNumberOrAutoValidator()
  );

  // add getters setters
  Konva.Factory.addGetterSetter(Konva.Text, 'fontFamily', 'Arial');

  /**
   * get/set font family
   * @name fontFamily
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontFamily
   * @returns {String}
   * @example
   * // get font family
   * var fontFamily = text.fontFamily();
   *
   * // set font family
   * text.fontFamily('Arial');
   */

  Konva.Factory.addGetterSetter(
    Konva.Text,
    'fontSize',
    12,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set font size in pixels
   * @name fontSize
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} fontSize
   * @returns {Number}
   * @example
   * // get font size
   * var fontSize = text.fontSize();
   *
   * // set font size to 22px
   * text.fontSize(22);
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'fontStyle', NORMAL);

  /**
   * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
   * @name fontStyle
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontStyle
   * @returns {String}
   * @example
   * // get font style
   * var fontStyle = text.fontStyle();
   *
   * // set font style
   * text.fontStyle('bold');
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'fontVariant', NORMAL);

  /**
   * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
   * @name fontVariant
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontVariant
   * @returns {String}
   * @example
   * // get font variant
   * var fontVariant = text.fontVariant();
   *
   * // set font variant
   * text.fontVariant('small-caps');
   */

  Konva.Factory.addGetterSetter(
    Konva.Text,
    'padding',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set padding
   * @name padding
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} padding
   * @returns {Number}
   * @example
   * // get padding
   * var padding = text.padding();
   *
   * // set padding to 10 pixels
   * text.padding(10);
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'align', LEFT);

  /**
   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
   * @name align
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} align
   * @returns {String}
   * @example
   * // get text align
   * var align = text.align();
   *
   * // center text
   * text.align('center');
   *
   * // align text to right
   * text.align('right');
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'verticalAlign', TOP);

  /**
   * get/set vertical align of text.  Can be 'top', 'middle', 'bottom'.
   * @name verticalAlign
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} verticalAlign
   * @returns {String}
   * @example
   * // get text vertical align
   * var verticalAlign = text.verticalAlign();
   *
   * // center text
   * text.verticalAlign('middle');
   */

  Konva.Factory.addGetterSetter(
    Konva.Text,
    'lineHeight',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set line height.  The default is 1.
   * @name lineHeight
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} lineHeight
   * @returns {Number}
   * @example
   * // get line height
   * var lineHeight = text.lineHeight();
   *
   * // set the line height
   * text.lineHeight(2);
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'wrap', WORD);

  /**
   * get/set wrap.  Can be word, char, or none. Default is word.
   * @name wrap
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} wrap
   * @returns {String}
   * @example
   * // get wrap
   * var wrap = text.wrap();
   *
   * // set wrap
   * text.wrap('word');
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'ellipsis', false);

  /**
   * get/set ellipsis.  Can be true or false. Default is false.
   * if Konva.Text config is set to wrap="none" and ellipsis=true, then it will add "..." to the end
   * @name ellipsis
   * @method
   * @memberof Konva.Text.prototype
   * @param {Boolean} ellipsis
   * @returns {Boolean}
   * @example
   * // get ellipsis
   * var ellipsis = text.ellipsis();
   *
   * // set ellipsis
   * text.ellipsis(true);
   */

  Konva.Factory.addGetterSetter(
    Konva.Text,
    'letterSpacing',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set letter spacing property. Default value is 0.
   * @name letterSpacing
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} letterSpacing
   */

  Konva.Factory.addGetter(Konva.Text, 'text', EMPTY_STRING);
  Konva.Factory.addOverloadedGetterSetter(Konva.Text, 'text');

  /**
   * get/set text
   * @name getText
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} text
   * @returns {String}
   * @example
   * // get text
   * var text = text.text();
   *
   * // set text
   * text.text('Hello world!');
   */

  Konva.Factory.addGetterSetter(Konva.Text, 'textDecoration', EMPTY_STRING);

  /**
   * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
   * @name textDecoration
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} textDecoration
   * @returns {String}
   * @example
   * // get text decoration
   * var textDecoration = text.textDecoration();
   *
   * // underline text
   * text.textDecoration('underline');
   *
   * // strike text
   * text.textDecoration('line-through');
   *
   * // underline and strike text
   * text.textDecoration('underline line-through');
   */

  Konva.Collection.mapMethods(Konva.Text);
})();

(function() {
  'use strict';
  /**
   * Line constructor.&nbsp; Lines are defined by an array of points and
   *  a tension
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @param {Boolean} [config.closed] defines whether or not the line shape is closed, creating a polygon or blob
   * @param {Boolean} [config.bezier] if no tension is provided but bezier=true, we draw the line as a bezier using the passed points
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var line = new Konva.Line({
   *   x: 100,
   *   y: 50,
   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
   *   stroke: 'red',
   *   tension: 1
   * });
   */
  Konva.Line = function(config) {
    this.___init(config);
  };

  Konva.Line.prototype = {
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Line';

      this.on(
        'pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva',
        function() {
          this._clearCache('tensionPoints');
        }
      );

      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var points = this.getPoints(),
        length = points.length,
        tension = this.getTension(),
        closed = this.getClosed(),
        bezier = this.getBezier(),
        tp,
        len,
        n;

      if (!length) {
        return;
      }

      context.beginPath();
      context.moveTo(points[0], points[1]);

      // tension
      if (tension !== 0 && length > 4) {
        tp = this.getTensionPoints();
        len = tp.length;
        n = closed ? 0 : 4;

        if (!closed) {
          context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
        }

        while (n < len - 2) {
          context.bezierCurveTo(
            tp[n++],
            tp[n++],
            tp[n++],
            tp[n++],
            tp[n++],
            tp[n++]
          );
        }

        if (!closed) {
          context.quadraticCurveTo(
            tp[len - 2],
            tp[len - 1],
            points[length - 2],
            points[length - 1]
          );
        }
      } else if (bezier) {
        // no tension but bezier
        n = 2;

        while (n < length) {
          context.bezierCurveTo(
            points[n++],
            points[n++],
            points[n++],
            points[n++],
            points[n++],
            points[n++]
          );
        }
      } else {
        // no tension
        for (n = 2; n < length; n += 2) {
          context.lineTo(points[n], points[n + 1]);
        }
      }

      // closed e.g. polygons and blobs
      if (closed) {
        context.closePath();
        context.fillStrokeShape(this);
      } else {
        // open e.g. lines and splines
        context.strokeShape(this);
      }
    },
    getTensionPoints: function() {
      return this._getCache('tensionPoints', this._getTensionPoints);
    },
    _getTensionPoints: function() {
      if (this.getClosed()) {
        return this._getTensionPointsClosed();
      } else {
        return Konva.Util._expandPoints(this.getPoints(), this.getTension());
      }
    },
    _getTensionPointsClosed: function() {
      var p = this.getPoints(),
        len = p.length,
        tension = this.getTension(),
        util = Konva.Util,
        firstControlPoints = util._getControlPoints(
          p[len - 2],
          p[len - 1],
          p[0],
          p[1],
          p[2],
          p[3],
          tension
        ),
        lastControlPoints = util._getControlPoints(
          p[len - 4],
          p[len - 3],
          p[len - 2],
          p[len - 1],
          p[0],
          p[1],
          tension
        ),
        middle = Konva.Util._expandPoints(p, tension),
        tp = [firstControlPoints[2], firstControlPoints[3]]
          .concat(middle)
          .concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
          ]);

      return tp;
    },
    getWidth: function() {
      return this.getSelfRect().width;
    },
    getHeight: function() {
      return this.getSelfRect().height;
    },
    // overload size detection
    getSelfRect: function() {
      var points;
      if (this.getTension() !== 0) {
        points = this._getTensionPoints();
      } else {
        points = this.getPoints();
      }
      var minX = points[0];
      var maxX = points[0];
      var minY = points[1];
      var maxY = points[1];
      var x, y;
      for (var i = 0; i < points.length / 2; i++) {
        x = points[i * 2];
        y = points[i * 2 + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
      }
      return {
        x: Math.round(minX),
        y: Math.round(minY),
        width: Math.round(maxX - minX),
        height: Math.round(maxY - minY)
      };
    }
  };
  Konva.Util.extend(Konva.Line, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(Konva.Line, 'closed', false);

  /**
   * get/set closed flag.  The default is false
   * @name closed
   * @method
   * @memberof Konva.Line.prototype
   * @param {Boolean} closed
   * @returns {Boolean}
   * @example
   * // get closed flag
   * var closed = line.closed();
   *
   * // close the shape
   * line.closed(true);
   *
   * // open the shape
   * line.closed(false);
   */

  Konva.Factory.addGetterSetter(Konva.Line, 'bezier', false);

  /**
   * get/set bezier flag.  The default is false
   * @name bezier
   * @method
   * @memberof Konva.Line.prototype
   * @param {Boolean} bezier
   * @returns {Boolean}
   * @example
   * // get whether the line is a bezier
   * var isBezier = line.bezier();
   *
   * // set whether the line is a bezier
   * line.bezier(true);
   */

  Konva.Factory.addGetterSetter(
    Konva.Line,
    'tension',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set tension
   * @name tension
   * @method
   * @memberof Konva.Line.prototype
   * @param {Number} Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @returns {Number}
   * @example
   * // get tension
   * var tension = line.tension();
   *
   * // set tension
   * line.tension(3);
   */

  Konva.Factory.addGetterSetter(
    Konva.Line,
    'points',
    [],
    Konva.Validators.getNumberArrayValidator()
  );
  /**
   * get/set points array
   * @name points
   * @method
   * @memberof Konva.Line.prototype
   * @param {Array} points
   * @returns {Array}
   * @example
   * // get points
   * var points = line.points();
   *
   * // set points
   * line.points([10, 20, 30, 40, 50, 60]);
   *
   * // push a new point
   * line.points(line.points().concat([70, 80]));
   */

  Konva.Collection.mapMethods(Konva.Line);
})();

(function() {
  'use strict';
  /**
   * Sprite constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} config.animation animation key
   * @param {Object} config.animations animation map
   * @param {Integer} [config.frameIndex] animation frame index
   * @param {Image} config.image image object
   * @param {Integer} [config.frameRate] animation frame rate
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   var sprite = new Konva.Sprite({
   *     x: 200,
   *     y: 100,
   *     image: imageObj,
   *     animation: 'standing',
   *     animations: {
   *       standing: [
   *         // x, y, width, height (6 frames)
   *         0, 0, 49, 109,
   *         52, 0, 49, 109,
   *         105, 0, 49, 109,
   *         158, 0, 49, 109,
   *         210, 0, 49, 109,
   *         262, 0, 49, 109
   *       ],
   *       kicking: [
   *         // x, y, width, height (6 frames)
   *         0, 109, 45, 98,
   *         45, 109, 45, 98,
   *         95, 109, 63, 98,
   *         156, 109, 70, 98,
   *         229, 109, 60, 98,
   *         287, 109, 41, 98
   *       ]
   *     },
   *     frameRate: 7,
   *     frameIndex: 0
   *   });
   * };
   * imageObj.src = '/path/to/image.jpg'
   */
  Konva.Sprite = function(config) {
    this.___init(config);
  };

  Konva.Sprite.prototype = {
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Sprite';

      this._updated = true;
      var that = this;
      this.anim = new Konva.Animation(function() {
        // if we don't need to redraw layer we should return false
        var updated = that._updated;
        that._updated = false;
        return updated;
      });
      this.on('animationChange.konva', function() {
        // reset index when animation changes
        this.frameIndex(0);
      });
      this.on('frameIndexChange.konva', function() {
        this._updated = true;
      });
      // smooth change for frameRate
      this.on('frameRateChange.konva', function() {
        if (!this.anim.isRunning()) {
          return;
        }
        clearInterval(this.interval);
        this._setInterval();
      });

      this.sceneFunc(this._sceneFunc);
      this.hitFunc(this._hitFunc);
    },
    _sceneFunc: function(context) {
      var anim = this.getAnimation(),
        index = this.frameIndex(),
        ix4 = index * 4,
        set = this.getAnimations()[anim],
        offsets = this.frameOffsets(),
        x = set[ix4 + 0],
        y = set[ix4 + 1],
        width = set[ix4 + 2],
        height = set[ix4 + 3],
        image = this.getImage();

      if (this.hasFill() || this.hasStroke()) {
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
      }

      if (image) {
        if (offsets) {
          var offset = offsets[anim],
            ix2 = index * 2;
          context.drawImage(
            image,
            x,
            y,
            width,
            height,
            offset[ix2 + 0],
            offset[ix2 + 1],
            width,
            height
          );
        } else {
          context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
      }
    },
    _hitFunc: function(context) {
      var anim = this.getAnimation(),
        index = this.frameIndex(),
        ix4 = index * 4,
        set = this.getAnimations()[anim],
        offsets = this.frameOffsets(),
        width = set[ix4 + 2],
        height = set[ix4 + 3];

      context.beginPath();
      if (offsets) {
        var offset = offsets[anim];
        var ix2 = index * 2;
        context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
      } else {
        context.rect(0, 0, width, height);
      }
      context.closePath();
      context.fillShape(this);
    },
    _useBufferCanvas: function() {
      return (
        (this.hasShadow() || this.getAbsoluteOpacity() !== 1) &&
        this.hasStroke()
      );
    },
    _setInterval: function() {
      var that = this;
      this.interval = setInterval(function() {
        that._updateIndex();
      }, 1000 / this.getFrameRate());
    },
    /**
     * start sprite animation
     * @method
     * @memberof Konva.Sprite.prototype
     */
    start: function() {
      if (this.isRunning()) {
        return;
      }
      var layer = this.getLayer();

      /*
       * animation object has no executable function because
       *  the updates are done with a fixed FPS with the setInterval
       *  below.  The anim object only needs the layer reference for
       *  redraw
       */
      this.anim.setLayers(layer);
      this._setInterval();
      this.anim.start();
    },
    /**
     * stop sprite animation
     * @method
     * @memberof Konva.Sprite.prototype
     */
    stop: function() {
      this.anim.stop();
      clearInterval(this.interval);
    },
    /**
     * determine if animation of sprite is running or not.  returns true or false
     * @method
     * @memberof Konva.Sprite.prototype
     * @returns {Boolean}
     */
    isRunning: function() {
      return this.anim.isRunning();
    },
    _updateIndex: function() {
      var index = this.frameIndex(),
        animation = this.getAnimation(),
        animations = this.getAnimations(),
        anim = animations[animation],
        len = anim.length / 4;

      if (index < len - 1) {
        this.frameIndex(index + 1);
      } else {
        this.frameIndex(0);
      }
    }
  };
  Konva.Util.extend(Konva.Sprite, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(Konva.Sprite, 'animation');

  /**
   * get/set animation key
   * @name animation
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {String} anim animation key
   * @returns {String}
   * @example
   * // get animation key
   * var animation = sprite.animation();
   *
   * // set animation key
   * sprite.animation('kicking');
   */

  Konva.Factory.addGetterSetter(Konva.Sprite, 'animations');

  /**
   * get/set animations map
   * @name animations
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Object} animations
   * @returns {Object}
   * @example
   * // get animations map
   * var animations = sprite.animations();
   *
   * // set animations map
   * sprite.animations({
   *   standing: [
   *     // x, y, width, height (6 frames)
   *     0, 0, 49, 109,
   *     52, 0, 49, 109,
   *     105, 0, 49, 109,
   *     158, 0, 49, 109,
   *     210, 0, 49, 109,
   *     262, 0, 49, 109
   *   ],
   *   kicking: [
   *     // x, y, width, height (6 frames)
   *     0, 109, 45, 98,
   *     45, 109, 45, 98,
   *     95, 109, 63, 98,
   *     156, 109, 70, 98,
   *     229, 109, 60, 98,
   *     287, 109, 41, 98
   *   ]
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Sprite, 'frameOffsets');

  /**
   * get/set offsets map
   * @name offsets
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Object} offsets
   * @returns {Object}
   * @example
   * // get offsets map
   * var offsets = sprite.offsets();
   *
   * // set offsets map
   * sprite.offsets({
   *   standing: [
   *     // x, y (6 frames)
   *     0, 0,
   *     0, 0,
   *     5, 0,
   *     0, 0,
   *     0, 3,
   *     2, 0
   *   ],
   *   kicking: [
   *     // x, y (6 frames)
   *     0, 5,
   *     5, 0,
   *     10, 0,
   *     0, 0,
   *     2, 1,
   *     0, 0
   *   ]
   * });
   */

  Konva.Factory.addGetterSetter(Konva.Sprite, 'image');

  /**
   * get/set image
   * @name image
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Image} image
   * @returns {Image}
   * @example
   * // get image
   * var image = sprite.image();
   *
   * // set image
   * sprite.image(imageObj);
   */

  Konva.Factory.addGetterSetter(
    Konva.Sprite,
    'frameIndex',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set/set animation frame index
   * @name frameIndex
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Integer} frameIndex
   * @returns {Integer}
   * @example
   * // get animation frame index
   * var frameIndex = sprite.frameIndex();
   *
   * // set animation frame index
   * sprite.frameIndex(3);
   */

  Konva.Factory.addGetterSetter(
    Konva.Sprite,
    'frameRate',
    17,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set frame rate in frames per second.  Increase this number to make the sprite
   *  animation run faster, and decrease the number to make the sprite animation run slower
   *  The default is 17 frames per second
   * @name frameRate
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Integer} frameRate
   * @returns {Integer}
   * @example
   * // get frame rate
   * var frameRate = sprite.frameRate();
   *
   * // set frame rate to 2 frames per second
   * sprite.frameRate(2);
   */

  Konva.Factory.backCompat(Konva.Sprite, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
  });

  Konva.Collection.mapMethods(Konva.Sprite);
})();

/*eslint-disable  no-shadow, max-len, max-depth */
(function() {
  'use strict';
  /**
   * Path constructor.
   * @author Jason Follas
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} config.data SVG data string
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var path = new Konva.Path({
   *   x: 240,
   *   y: 40,
   *   data: 'M12.582,9.551C3.251,16.237,0.921,29.021,7.08,38.564l-2.36,1.689l4.893,2.262l4.893,2.262l-0.568-5.36l-0.567-5.359l-2.365,1.694c-4.657-7.375-2.83-17.185,4.352-22.33c7.451-5.338,17.817-3.625,23.156,3.824c5.337,7.449,3.625,17.813-3.821,23.152l2.857,3.988c9.617-6.893,11.827-20.277,4.935-29.896C35.591,4.87,22.204,2.658,12.582,9.551z',
   *   fill: 'green',
   *   scale: 2
   * });
   */
  Konva.Path = function(config) {
    this.___init(config);
  };

  Konva.Path.prototype = {
    ___init: function(config) {
      this.dataArray = [];
      var that = this;

      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Path';

      this.dataArray = Konva.Path.parsePathData(this.getData());
      this.pathLength = 0;
      for (var i = 0; i < this.dataArray.length; ++i) {
        this.pathLength += this.dataArray[i].pathLength;
      }
      this.on('dataChange.konva', function() {
        that.dataArray = Konva.Path.parsePathData(this.getData());
        this.pathLength = 0;
        for (var i = 0; i < this.dataArray.length; ++i) {
          this.pathLength += this.dataArray[i].pathLength;
        }
      });

      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var ca = this.dataArray;

      // context position
      context.beginPath();
      for (var n = 0; n < ca.length; n++) {
        var c = ca[n].command;
        var p = ca[n].points;
        switch (c) {
          case 'L':
            context.lineTo(p[0], p[1]);
            break;
          case 'M':
            context.moveTo(p[0], p[1]);
            break;
          case 'C':
            context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
            break;
          case 'Q':
            context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
            break;
          case 'A':
            var cx = p[0],
              cy = p[1],
              rx = p[2],
              ry = p[3],
              theta = p[4],
              dTheta = p[5],
              psi = p[6],
              fs = p[7];

            var r = rx > ry ? rx : ry;
            var scaleX = rx > ry ? 1 : rx / ry;
            var scaleY = rx > ry ? ry / rx : 1;

            context.translate(cx, cy);
            context.rotate(psi);
            context.scale(scaleX, scaleY);
            context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
            context.scale(1 / scaleX, 1 / scaleY);
            context.rotate(-psi);
            context.translate(-cx, -cy);

            break;
          case 'z':
            context.closePath();
            break;
        }
      }

      context.fillStrokeShape(this);
    },
    getSelfRect: function() {
      var points = [];
      this.dataArray.forEach(function(data) {
        points = points.concat(data.points);
      });
      var minX = points[0];
      var maxX = points[0];
      var minY = points[1];
      var maxY = points[1];
      var x, y;
      for (var i = 0; i < points.length / 2; i++) {
        x = points[i * 2];
        y = points[i * 2 + 1];

        // skip bad values
        // TODO: prevent them from parsing function
        if (!isNaN(x)) {
          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x);
        }
        if (!isNaN(y)) {
          minY = Math.min(minY, y);
          maxY = Math.max(maxY, y);
        }
      }
      return {
        x: Math.round(minX),
        y: Math.round(minY),
        width: Math.round(maxX - minX),
        height: Math.round(maxY - minY)
      };
    },
    /**
     * Return length of the path.
     * @method
     * @memberof Konva.Path.prototype
     * @returns {Number} length
     * @example
     * var length = path.getLength();
     */
    getLength: function() {
      return this.pathLength;
    },
    /**
     * Get point on path at specific length of the path
     * @method
     * @memberof Konva.Path.prototype
     * @param {Number} length length
     * @returns {Object} point {x,y} point
     * @example
     * var point = path.getPointAtLength(10);
     */
    getPointAtLength: function(length) {
      var point,
        i = 0,
        ii = this.dataArray.length;

      if (!ii) {
        return null;
      }

      while (i < ii && length > this.dataArray[i].pathLength) {
        length -= this.dataArray[i].pathLength;
        ++i;
      }

      if (i === ii) {
        point = this.dataArray[i - 1].points.slice(-2);
        return {
          x: point[0],
          y: point[1]
        };
      }

      if (length < 0.01) {
        point = this.dataArray[i].points.slice(0, 2);
        return {
          x: point[0],
          y: point[1]
        };
      }

      var cp = this.dataArray[i];
      var p = cp.points;
      switch (cp.command) {
        case 'L':
          return Konva.Path.getPointOnLine(
            length,
            cp.start.x,
            cp.start.y,
            p[0],
            p[1]
          );
        case 'C':
          return Konva.Path.getPointOnCubicBezier(
            length / cp.pathLength,
            cp.start.x,
            cp.start.y,
            p[0],
            p[1],
            p[2],
            p[3],
            p[4],
            p[5]
          );
        case 'Q':
          return Konva.Path.getPointOnQuadraticBezier(
            length / cp.pathLength,
            cp.start.x,
            cp.start.y,
            p[0],
            p[1],
            p[2],
            p[3]
          );
        case 'A':
          var cx = p[0],
            cy = p[1],
            rx = p[2],
            ry = p[3],
            theta = p[4],
            dTheta = p[5],
            psi = p[6];
          theta += dTheta * length / cp.pathLength;
          return Konva.Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
      }

      return null;
    }
  };
  Konva.Util.extend(Konva.Path, Konva.Shape);

  Konva.Path.getLineLength = function(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  };
  Konva.Path.getPointOnLine = function(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
    if (fromX === undefined) {
      fromX = P1x;
    }
    if (fromY === undefined) {
      fromY = P1y;
    }

    var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
    var run = Math.sqrt(dist * dist / (1 + m * m));
    if (P2x < P1x) {
      run *= -1;
    }
    var rise = m * run;
    var pt;

    if (P2x === P1x) {
      // vertical line
      pt = {
        x: fromX,
        y: fromY + rise
      };
    } else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) {
      pt = {
        x: fromX + run,
        y: fromY + rise
      };
    } else {
      var ix, iy;

      var len = this.getLineLength(P1x, P1y, P2x, P2y);
      if (len < 0.00000001) {
        return undefined;
      }
      var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
      u = u / (len * len);
      ix = P1x + u * (P2x - P1x);
      iy = P1y + u * (P2y - P1y);

      var pRise = this.getLineLength(fromX, fromY, ix, iy);
      var pRun = Math.sqrt(dist * dist - pRise * pRise);
      run = Math.sqrt(pRun * pRun / (1 + m * m));
      if (P2x < P1x) {
        run *= -1;
      }
      rise = m * run;
      pt = {
        x: ix + run,
        y: iy + rise
      };
    }

    return pt;
  };

  Konva.Path.getPointOnCubicBezier = function(
    pct,
    P1x,
    P1y,
    P2x,
    P2y,
    P3x,
    P3y,
    P4x,
    P4y
  ) {
    function CB1(t) {
      return t * t * t;
    }
    function CB2(t) {
      return 3 * t * t * (1 - t);
    }
    function CB3(t) {
      return 3 * t * (1 - t) * (1 - t);
    }
    function CB4(t) {
      return (1 - t) * (1 - t) * (1 - t);
    }
    var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
    var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);

    return {
      x: x,
      y: y
    };
  };
  Konva.Path.getPointOnQuadraticBezier = function(
    pct,
    P1x,
    P1y,
    P2x,
    P2y,
    P3x,
    P3y
  ) {
    function QB1(t) {
      return t * t;
    }
    function QB2(t) {
      return 2 * t * (1 - t);
    }
    function QB3(t) {
      return (1 - t) * (1 - t);
    }
    var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
    var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);

    return {
      x: x,
      y: y
    };
  };
  Konva.Path.getPointOnEllipticalArc = function(cx, cy, rx, ry, theta, psi) {
    var cosPsi = Math.cos(psi),
      sinPsi = Math.sin(psi);
    var pt = {
      x: rx * Math.cos(theta),
      y: ry * Math.sin(theta)
    };
    return {
      x: cx + (pt.x * cosPsi - pt.y * sinPsi),
      y: cy + (pt.x * sinPsi + pt.y * cosPsi)
    };
  };
  /*
     * get parsed data array from the data
     *  string.  V, v, H, h, and l data are converted to
     *  L data for the purpose of high performance Path
     *  rendering
     */
  Konva.Path.parsePathData = function(data) {
    // Path Data Segment must begin with a moveTo
    //m (x y)+  Relative moveTo (subsequent points are treated as lineTo)
    //M (x y)+  Absolute moveTo (subsequent points are treated as lineTo)
    //l (x y)+  Relative lineTo
    //L (x y)+  Absolute LineTo
    //h (x)+    Relative horizontal lineTo
    //H (x)+    Absolute horizontal lineTo
    //v (y)+    Relative vertical lineTo
    //V (y)+    Absolute vertical lineTo
    //z (closepath)
    //Z (closepath)
    //c (x1 y1 x2 y2 x y)+ Relative Bezier curve
    //C (x1 y1 x2 y2 x y)+ Absolute Bezier curve
    //q (x1 y1 x y)+       Relative Quadratic Bezier
    //Q (x1 y1 x y)+       Absolute Quadratic Bezier
    //t (x y)+    Shorthand/Smooth Relative Quadratic Bezier
    //T (x y)+    Shorthand/Smooth Absolute Quadratic Bezier
    //s (x2 y2 x y)+       Shorthand/Smooth Relative Bezier curve
    //S (x2 y2 x y)+       Shorthand/Smooth Absolute Bezier curve
    //a (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+     Relative Elliptical Arc
    //A (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+  Absolute Elliptical Arc

    // return early if data is not defined
    if (!data) {
      return [];
    }

    // command string
    var cs = data;

    // command chars
    var cc = [
      'm',
      'M',
      'l',
      'L',
      'v',
      'V',
      'h',
      'H',
      'z',
      'Z',
      'c',
      'C',
      'q',
      'Q',
      't',
      'T',
      's',
      'S',
      'a',
      'A'
    ];
    // convert white spaces to commas
    cs = cs.replace(new RegExp(' ', 'g'), ',');
    // create pipes so that we can split the data
    for (var n = 0; n < cc.length; n++) {
      cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
    }
    // create array
    var arr = cs.split('|');
    var ca = [];
    var coords = [];
    // init context point
    var cpx = 0;
    var cpy = 0;

    var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
    var match;
    for (n = 1; n < arr.length; n++) {
      var str = arr[n];
      var c = str.charAt(0);
      str = str.slice(1);

      coords.length = 0;
      while ((match = re.exec(str))) {
        coords.push(match[0]);
      }

      // while ((match = re.exec(str))) {
      //   coords.push(match[0]);
      // }
      var p = [];

      for (var j = 0, jlen = coords.length; j < jlen; j++) {
        var parsed = parseFloat(coords[j]);
        if (!isNaN(parsed)) {
          p.push(parsed);
        } else {
          p.push(0);
        }
      }

      while (p.length > 0) {
        if (isNaN(p[0])) {
          // case for a trailing comma before next command
          break;
        }

        var cmd = null;
        var points = [];
        var startX = cpx,
          startY = cpy;
        // Move var from within the switch to up here (jshint)
        var prevCmd, ctlPtx, ctlPty; // Ss, Tt
        var rx, ry, psi, fa, fs, x1, y1; // Aa

        // convert l, H, h, V, and v to L
        switch (c) {
          // Note: Keep the lineTo's above the moveTo's in this switch
          case 'l':
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'L';
            points.push(cpx, cpy);
            break;
          case 'L':
            cpx = p.shift();
            cpy = p.shift();
            points.push(cpx, cpy);
            break;
          // Note: lineTo handlers need to be above this point
          case 'm':
            var dx = p.shift();
            var dy = p.shift();
            cpx += dx;
            cpy += dy;
            cmd = 'M';
            // After closing the path move the current position
            // to the the first point of the path (if any).
            if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
              for (var idx = ca.length - 2; idx >= 0; idx--) {
                if (ca[idx].command === 'M') {
                  cpx = ca[idx].points[0] + dx;
                  cpy = ca[idx].points[1] + dy;
                  break;
                }
              }
            }
            points.push(cpx, cpy);
            c = 'l';
            // subsequent points are treated as relative lineTo
            break;
          case 'M':
            cpx = p.shift();
            cpy = p.shift();
            cmd = 'M';
            points.push(cpx, cpy);
            c = 'L';
            // subsequent points are treated as absolute lineTo
            break;

          case 'h':
            cpx += p.shift();
            cmd = 'L';
            points.push(cpx, cpy);
            break;
          case 'H':
            cpx = p.shift();
            cmd = 'L';
            points.push(cpx, cpy);
            break;
          case 'v':
            cpy += p.shift();
            cmd = 'L';
            points.push(cpx, cpy);
            break;
          case 'V':
            cpy = p.shift();
            cmd = 'L';
            points.push(cpx, cpy);
            break;
          case 'C':
            points.push(p.shift(), p.shift(), p.shift(), p.shift());
            cpx = p.shift();
            cpy = p.shift();
            points.push(cpx, cpy);
            break;
          case 'c':
            points.push(
              cpx + p.shift(),
              cpy + p.shift(),
              cpx + p.shift(),
              cpy + p.shift()
            );
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'C';
            points.push(cpx, cpy);
            break;
          case 'S':
            ctlPtx = cpx;
            ctlPty = cpy;
            prevCmd = ca[ca.length - 1];
            if (prevCmd.command === 'C') {
              ctlPtx = cpx + (cpx - prevCmd.points[2]);
              ctlPty = cpy + (cpy - prevCmd.points[3]);
            }
            points.push(ctlPtx, ctlPty, p.shift(), p.shift());
            cpx = p.shift();
            cpy = p.shift();
            cmd = 'C';
            points.push(cpx, cpy);
            break;
          case 's':
            ctlPtx = cpx;
            ctlPty = cpy;
            prevCmd = ca[ca.length - 1];
            if (prevCmd.command === 'C') {
              ctlPtx = cpx + (cpx - prevCmd.points[2]);
              ctlPty = cpy + (cpy - prevCmd.points[3]);
            }
            points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'C';
            points.push(cpx, cpy);
            break;
          case 'Q':
            points.push(p.shift(), p.shift());
            cpx = p.shift();
            cpy = p.shift();
            points.push(cpx, cpy);
            break;
          case 'q':
            points.push(cpx + p.shift(), cpy + p.shift());
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'Q';
            points.push(cpx, cpy);
            break;
          case 'T':
            ctlPtx = cpx;
            ctlPty = cpy;
            prevCmd = ca[ca.length - 1];
            if (prevCmd.command === 'Q') {
              ctlPtx = cpx + (cpx - prevCmd.points[0]);
              ctlPty = cpy + (cpy - prevCmd.points[1]);
            }
            cpx = p.shift();
            cpy = p.shift();
            cmd = 'Q';
            points.push(ctlPtx, ctlPty, cpx, cpy);
            break;
          case 't':
            ctlPtx = cpx;
            ctlPty = cpy;
            prevCmd = ca[ca.length - 1];
            if (prevCmd.command === 'Q') {
              ctlPtx = cpx + (cpx - prevCmd.points[0]);
              ctlPty = cpy + (cpy - prevCmd.points[1]);
            }
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'Q';
            points.push(ctlPtx, ctlPty, cpx, cpy);
            break;
          case 'A':
            rx = p.shift();
            ry = p.shift();
            psi = p.shift();
            fa = p.shift();
            fs = p.shift();
            x1 = cpx;
            y1 = cpy;
            cpx = p.shift();
            cpy = p.shift();
            cmd = 'A';
            points = this.convertEndpointToCenterParameterization(
              x1,
              y1,
              cpx,
              cpy,
              fa,
              fs,
              rx,
              ry,
              psi
            );
            break;
          case 'a':
            rx = p.shift();
            ry = p.shift();
            psi = p.shift();
            fa = p.shift();
            fs = p.shift();
            x1 = cpx;
            y1 = cpy;
            cpx += p.shift();
            cpy += p.shift();
            cmd = 'A';
            points = this.convertEndpointToCenterParameterization(
              x1,
              y1,
              cpx,
              cpy,
              fa,
              fs,
              rx,
              ry,
              psi
            );
            break;
        }

        ca.push({
          command: cmd || c,
          points: points,
          start: {
            x: startX,
            y: startY
          },
          pathLength: this.calcLength(startX, startY, cmd || c, points)
        });
      }

      if (c === 'z' || c === 'Z') {
        ca.push({
          command: 'z',
          points: [],
          start: undefined,
          pathLength: 0
        });
      }
    }

    return ca;
  };
  Konva.Path.calcLength = function(x, y, cmd, points) {
    var len, p1, p2, t;
    var path = Konva.Path;

    switch (cmd) {
      case 'L':
        return path.getLineLength(x, y, points[0], points[1]);
      case 'C':
        // Approximates by breaking curve into 100 line segments
        len = 0.0;
        p1 = path.getPointOnCubicBezier(
          0,
          x,
          y,
          points[0],
          points[1],
          points[2],
          points[3],
          points[4],
          points[5]
        );
        for (t = 0.01; t <= 1; t += 0.01) {
          p2 = path.getPointOnCubicBezier(
            t,
            x,
            y,
            points[0],
            points[1],
            points[2],
            points[3],
            points[4],
            points[5]
          );
          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }
        return len;
      case 'Q':
        // Approximates by breaking curve into 100 line segments
        len = 0.0;
        p1 = path.getPointOnQuadraticBezier(
          0,
          x,
          y,
          points[0],
          points[1],
          points[2],
          points[3]
        );
        for (t = 0.01; t <= 1; t += 0.01) {
          p2 = path.getPointOnQuadraticBezier(
            t,
            x,
            y,
            points[0],
            points[1],
            points[2],
            points[3]
          );
          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }
        return len;
      case 'A':
        // Approximates by breaking curve into line segments
        len = 0.0;
        var start = points[4];
        // 4 = theta
        var dTheta = points[5];
        // 5 = dTheta
        var end = points[4] + dTheta;
        var inc = Math.PI / 180.0;
        // 1 degree resolution
        if (Math.abs(start - end) < inc) {
          inc = Math.abs(start - end);
        }
        // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
        p1 = path.getPointOnEllipticalArc(
          points[0],
          points[1],
          points[2],
          points[3],
          start,
          0
        );
        if (dTheta < 0) {
          // clockwise
          for (t = start - inc; t > end; t -= inc) {
            p2 = path.getPointOnEllipticalArc(
              points[0],
              points[1],
              points[2],
              points[3],
              t,
              0
            );
            len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }
        } else {
          // counter-clockwise
          for (t = start + inc; t < end; t += inc) {
            p2 = path.getPointOnEllipticalArc(
              points[0],
              points[1],
              points[2],
              points[3],
              t,
              0
            );
            len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }
        }
        p2 = path.getPointOnEllipticalArc(
          points[0],
          points[1],
          points[2],
          points[3],
          end,
          0
        );
        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);

        return len;
    }

    return 0;
  };
  Konva.Path.convertEndpointToCenterParameterization = function(
    x1,
    y1,
    x2,
    y2,
    fa,
    fs,
    rx,
    ry,
    psiDeg
  ) {
    // Derived from: http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
    var psi = psiDeg * (Math.PI / 180.0);
    var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
    var yp =
      -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;

    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);

    if (lambda > 1) {
      rx *= Math.sqrt(lambda);
      ry *= Math.sqrt(lambda);
    }

    var f = Math.sqrt(
      (rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
        (rx * rx * (yp * yp) + ry * ry * (xp * xp))
    );

    if (fa === fs) {
      f *= -1;
    }
    if (isNaN(f)) {
      f = 0;
    }

    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;

    var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;

    var vMag = function(v) {
      return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    };
    var vRatio = function(u, v) {
      return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
    };
    var vAngle = function(u, v) {
      return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
    };
    var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
    var u = [(xp - cxp) / rx, (yp - cyp) / ry];
    var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
    var dTheta = vAngle(u, v);

    if (vRatio(u, v) <= -1) {
      dTheta = Math.PI;
    }
    if (vRatio(u, v) >= 1) {
      dTheta = 0;
    }
    if (fs === 0 && dTheta > 0) {
      dTheta = dTheta - 2 * Math.PI;
    }
    if (fs === 1 && dTheta < 0) {
      dTheta = dTheta + 2 * Math.PI;
    }
    return [cx, cy, rx, ry, theta, dTheta, psi, fs];
  };
  // add getters setters
  Konva.Factory.addGetterSetter(Konva.Path, 'data');

  /**
   * set SVG path data string.  This method
   *  also automatically parses the data string
   *  into a data array.  Currently supported SVG data:
   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
   * @name setData
   * @method
   * @memberof Konva.Path.prototype
   * @param {String} SVG path command string
   */

  /**
   * get SVG path data string
   * @name getData
   * @method
   * @memberof Konva.Path.prototype
   */

  Konva.Collection.mapMethods(Konva.Path);
})();

(function() {
  'use strict';
  var EMPTY_STRING = '',
    //CALIBRI = 'Calibri',
    NORMAL = 'normal';

  /**
   * Path constructor.
   * @author Jason Follas
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} [config.fontFamily] default is Calibri
   * @param {Number} [config.fontSize] default is 12
   * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
   * @param {String} config.text
   * @param {String} config.data SVG data string
   * @param {Function} config.getKerning a getter for kerning values for the specified characters
   * @param {Function} config.kerningFunc a getter for kerning values for the specified characters
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var kerningPairs = {
   *   'A': {
   *     ' ': -0.05517578125,
   *     'T': -0.07421875,
   *     'V': -0.07421875,
   *   },
   *   'V': {
   *     ',': -0.091796875,
   *     ":": -0.037109375,
   *     ";": -0.037109375,
   *     "A": -0.07421875,
   *   }
   * }
   * var textpath = new Konva.TextPath({
   *   x: 100,
   *   y: 50,
   *   fill: '#333',
   *   fontSize: '24',
   *   fontFamily: 'Arial',
   *   text: 'All the world\'s a stage, and all the men and women merely players.',
   *   data: 'M10,10 C0,0 10,150 100,100 S300,150 400,50',
   *   kerningFunc: function(leftChar, rightChar) {
   *     return kerningPairs.hasOwnProperty(leftChar) ? pairs[leftChar][rightChar] || 0 : 0
   *   }
   * });
   */
  Konva.TextPath = function(config) {
    this.___init(config);
  };

  function _fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
  }
  function _strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
  }

  Konva.TextPath.prototype = {
    ___init: function(config) {
      var that = this;
      this.dummyCanvas = Konva.Util.createCanvasElement();
      this.dataArray = [];

      // call super constructor
      Konva.Shape.call(this, config);

      // overrides
      // TODO: shouldn't this be on the prototype?
      this._fillFunc = _fillFunc;
      this._strokeFunc = _strokeFunc;
      this._fillFuncHit = _fillFunc;
      this._strokeFuncHit = _strokeFunc;

      this.className = 'TextPath';

      this.dataArray = Konva.Path.parsePathData(this.attrs.data);
      this.on('dataChange.konva', function() {
        that.dataArray = Konva.Path.parsePathData(this.attrs.data);
        that._setTextData();
      });

      // update text data for certain attr changes
      this.on(
        'textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva',
        that._setTextData
      );

      if (config && config.getKerning) {
        Konva.Util.warn(
          'getKerning TextPath API is deprecated. Please use "kerningFunc" instead.'
        );
        this.setKerningFunc(config.getKerning);
      }

      that._setTextData();
      this.sceneFunc(this._sceneFunc);
      this.hitFunc(this._hitFunc);
    },
    _sceneFunc: function(context) {
      context.setAttr('font', this._getContextFont());
      context.setAttr('textBaseline', this.getTextBaseline());
      context.setAttr('textAlign', 'left');
      context.save();

      var textDecoration = this.textDecoration();
      var fill = this.fill();
      var fontSize = this.fontSize();

      var glyphInfo = this.glyphInfo;
      if (textDecoration === 'underline') {
        context.beginPath();
      }
      for (var i = 0; i < glyphInfo.length; i++) {
        context.save();

        var p0 = glyphInfo[i].p0;

        context.translate(p0.x, p0.y);
        context.rotate(glyphInfo[i].rotation);
        this.partialText = glyphInfo[i].text;

        context.fillStrokeShape(this);
        if (textDecoration === 'underline') {
          if (i === 0) {
            context.moveTo(0, fontSize / 2 + 1);
          }

          context.lineTo(fontSize, fontSize / 2 + 1);
        }
        context.restore();

        //// To assist with debugging visually, uncomment following
        //
        // if (i % 2)
        // context.strokeStyle = 'cyan';
        // else
        // context.strokeStyle = 'green';
        // var p1 = glyphInfo[i].p1;
        // context.moveTo(p0.x, p0.y);
        // context.lineTo(p1.x, p1.y);
        // context.stroke();
      }
      if (textDecoration === 'underline') {
        context.strokeStyle = fill;
        context.lineWidth = fontSize / 20;
        context.stroke();
      }

      context.restore();
    },
    _hitFunc: function(context) {
      context.beginPath();

      var glyphInfo = this.glyphInfo;
      if (glyphInfo.length >= 1) {
        var p0 = glyphInfo[0].p0;
        context.moveTo(p0.x, p0.y);
      }
      for (var i = 0; i < glyphInfo.length; i++) {
        var p1 = glyphInfo[i].p1;
        context.lineTo(p1.x, p1.y);
      }
      context.setAttr('lineWidth', this.getFontSize());
      context.setAttr('strokeStyle', this.colorKey);
      context.stroke();
    },
    /**
     * get text width in pixels
     * @method
     * @memberof Konva.TextPath.prototype
     */
    getTextWidth: function() {
      return this.textWidth;
    },
    /**
     * get text height in pixels
     * @method
     * @memberof Konva.TextPath.prototype
     */
    getTextHeight: function() {
      return this.textHeight;
    },
    /**
     * set text
     * @method
     * @memberof Konva.TextPath.prototype
     * @param {String} text
     */
    setText: function(text) {
      Konva.Text.prototype.setText.call(this, text);
    },
    _getTextSize: function(text) {
      var dummyCanvas = this.dummyCanvas;
      var _context = dummyCanvas.getContext('2d');

      _context.save();

      _context.font = this._getContextFont();
      var metrics = _context.measureText(text);

      _context.restore();

      return {
        width: metrics.width,
        height: parseInt(this.attrs.fontSize, 10)
      };
    },
    _setTextData: function() {
      var that = this;
      var size = this._getTextSize(this.attrs.text);
      var letterSpacing = this.getLetterSpacing();
      var align = this.align();
      var kerningFunc = this.getKerningFunc();

      this.textWidth = size.width;
      this.textHeight = size.height;

      var textFullWidth = Math.max(
        this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing,
        0
      );

      this.glyphInfo = [];

      var fullPathWidth = 0;
      for (var l = 0; l < that.dataArray.length; l++) {
        if (that.dataArray[l].pathLength > 0) {
          fullPathWidth += that.dataArray[l].pathLength;
        }
      }

      var offset = 0;
      if (align === 'center') {
        offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
      }
      if (align === 'right') {
        offset = Math.max(0, fullPathWidth - textFullWidth);
      }

      var charArr = this.getText().split('');
      var spacesNumber = this.getText().split(' ').length - 1;

      var p0, p1, pathCmd;

      var pIndex = -1;
      var currentT = 0;
      // var sumLength = 0;
      // for(var j = 0; j < that.dataArray.length; j++) {
      //   if(that.dataArray[j].pathLength > 0) {
      //
      //     if (sumLength + that.dataArray[j].pathLength > offset) {}
      //       fullPathWidth += that.dataArray[j].pathLength;
      //   }
      // }

      var getNextPathSegment = function() {
        currentT = 0;
        var pathData = that.dataArray;

        for (var j = pIndex + 1; j < pathData.length; j++) {
          if (pathData[j].pathLength > 0) {
            pIndex = j;

            return pathData[j];
          } else if (pathData[j].command === 'M') {
            p0 = {
              x: pathData[j].points[0],
              y: pathData[j].points[1]
            };
          }
        }

        return {};
      };

      var findSegmentToFitCharacter = function(c) {
        var glyphWidth = that._getTextSize(c).width + letterSpacing;

        if (c === ' ' && align === 'justify') {
          glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
        }

        var currLen = 0;
        var attempts = 0;

        p1 = undefined;
        while (
          Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 &&
          attempts < 25
        ) {
          attempts++;
          var cumulativePathLength = currLen;
          while (pathCmd === undefined) {
            pathCmd = getNextPathSegment();

            if (
              pathCmd &&
              cumulativePathLength + pathCmd.pathLength < glyphWidth
            ) {
              cumulativePathLength += pathCmd.pathLength;
              pathCmd = undefined;
            }
          }

          if (pathCmd === {} || p0 === undefined) {
            return undefined;
          }

          var needNewSegment = false;

          switch (pathCmd.command) {
            case 'L':
              if (
                Konva.Path.getLineLength(
                  p0.x,
                  p0.y,
                  pathCmd.points[0],
                  pathCmd.points[1]
                ) > glyphWidth
              ) {
                p1 = Konva.Path.getPointOnLine(
                  glyphWidth,
                  p0.x,
                  p0.y,
                  pathCmd.points[0],
                  pathCmd.points[1],
                  p0.x,
                  p0.y
                );
              } else {
                pathCmd = undefined;
              }
              break;
            case 'A':
              var start = pathCmd.points[4];
              // 4 = theta
              var dTheta = pathCmd.points[5];
              // 5 = dTheta
              var end = pathCmd.points[4] + dTheta;

              if (currentT === 0) {
                currentT = start + 0.00000001;
              } else if (glyphWidth > currLen) {
                // Just in case start is 0
                currentT += ((Math.PI / 180.0) * dTheta) / Math.abs(dTheta);
              } else {
                currentT -= ((Math.PI / 360.0) * dTheta) / Math.abs(dTheta);
              }

              // Credit for bug fix: @therth https://github.com/ericdrowell/KonvaJS/issues/249
              // Old code failed to render text along arc of this path: "M 50 50 a 150 50 0 0 1 250 50 l 50 0"
              if (
                (dTheta < 0 && currentT < end) ||
                (dTheta >= 0 && currentT > end)
              ) {
                currentT = end;
                needNewSegment = true;
              }
              p1 = Konva.Path.getPointOnEllipticalArc(
                pathCmd.points[0],
                pathCmd.points[1],
                pathCmd.points[2],
                pathCmd.points[3],
                currentT,
                pathCmd.points[6]
              );
              break;
            case 'C':
              if (currentT === 0) {
                if (glyphWidth > pathCmd.pathLength) {
                  currentT = 0.00000001;
                } else {
                  currentT = glyphWidth / pathCmd.pathLength;
                }
              } else if (glyphWidth > currLen) {
                currentT += (glyphWidth - currLen) / pathCmd.pathLength;
              } else {
                currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
              }

              if (currentT > 1.0) {
                currentT = 1.0;
                needNewSegment = true;
              }
              p1 = Konva.Path.getPointOnCubicBezier(
                currentT,
                pathCmd.start.x,
                pathCmd.start.y,
                pathCmd.points[0],
                pathCmd.points[1],
                pathCmd.points[2],
                pathCmd.points[3],
                pathCmd.points[4],
                pathCmd.points[5]
              );
              break;
            case 'Q':
              if (currentT === 0) {
                currentT = glyphWidth / pathCmd.pathLength;
              } else if (glyphWidth > currLen) {
                currentT += (glyphWidth - currLen) / pathCmd.pathLength;
              } else {
                currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
              }

              if (currentT > 1.0) {
                currentT = 1.0;
                needNewSegment = true;
              }
              p1 = Konva.Path.getPointOnQuadraticBezier(
                currentT,
                pathCmd.start.x,
                pathCmd.start.y,
                pathCmd.points[0],
                pathCmd.points[1],
                pathCmd.points[2],
                pathCmd.points[3]
              );
              break;
          }

          if (p1 !== undefined) {
            currLen = Konva.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
          }

          if (needNewSegment) {
            needNewSegment = false;
            pathCmd = undefined;
          }
        }
      };

      // fake search for offset, this is very bad approach
      // TODO: find other way to add offset from start (for align)
      var testChar = 'C';
      var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
      for (var k = 0; k < offset / glyphWidth; k++) {
        findSegmentToFitCharacter(testChar);
        if (p0 === undefined || p1 === undefined) {
          break;
        }
        p0 = p1;
      }

      for (var i = 0; i < charArr.length; i++) {
        // Find p1 such that line segment between p0 and p1 is approx. width of glyph
        findSegmentToFitCharacter(charArr[i]);

        if (p0 === undefined || p1 === undefined) {
          break;
        }

        var width = Konva.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);

        var kern = 0;
        if (kerningFunc) {
          try {
            // getKerning is a user provided getter. Make sure it never breaks our logic
            kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
          } catch (e) {
            kern = 0;
          }
        }

        p0.x += kern;
        p1.x += kern;
        this.textWidth += kern;

        var midpoint = Konva.Path.getPointOnLine(
          kern + width / 2.0,
          p0.x,
          p0.y,
          p1.x,
          p1.y
        );

        var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
        this.glyphInfo.push({
          transposeX: midpoint.x,
          transposeY: midpoint.y,
          text: charArr[i],
          rotation: rotation,
          p0: p0,
          p1: p1
        });
        p0 = p1;
      }
    },
    getSelfRect: function() {
      var points = [];

      this.glyphInfo.forEach(function(info) {
        points.push(info.p0.x);
        points.push(info.p0.y);
        points.push(info.p1.x);
        points.push(info.p1.y);
      });
      var minX = points[0];
      var maxX = points[0];
      var minY = points[0];
      var maxY = points[0];
      var x, y;
      for (var i = 0; i < points.length / 2; i++) {
        x = points[i * 2];
        y = points[i * 2 + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
      }
      var fontSize = this.fontSize();
      return {
        x: Math.round(minX) - fontSize / 2,
        y: Math.round(minY) - fontSize / 2,
        width: Math.round(maxX - minX) + fontSize,
        height: Math.round(maxY - minY) + fontSize
      };
    }
  };

  // map TextPath methods to Text
  Konva.TextPath.prototype._getContextFont =
    Konva.Text.prototype._getContextFont;

  Konva.Util.extend(Konva.TextPath, Konva.Shape);

  // add setters and getters
  Konva.Factory.addGetterSetter(Konva.TextPath, 'data');

  /**
   * set SVG path data string.  This method
   *  also automatically parses the data string
   *  into a data array.  Currently supported SVG data:
   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
   * @name setData
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} SVG path command string
   */

  /**
   * get SVG path data string
   * @name getData
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontFamily', 'Arial');

  /**
   * set font family
   * @name setFontFamily
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontFamily
   */

  /**
   * get font family
   * @name getFontFamily
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.TextPath,
    'fontSize',
    12,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set font size
   * @name setFontSize
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {int} fontSize
   */

  /**
   * get font size
   * @name getFontSize
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontStyle', NORMAL);

  /**
   * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
   * @name setFontStyle
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontStyle
   */
  Konva.Factory.addGetterSetter(Konva.TextPath, 'align', 'left');

  /**
   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
   * @name align
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} align
   * @returns {String}
   * @example
   * // get text align
   * var align = text.align();
   *
   * // center text
   * text.align('center');
   *
   * // align text to right
   * text.align('right');
   */

  Konva.Factory.addGetterSetter(
    Konva.TextPath,
    'letterSpacing',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set letter spacing property. Default value is 0.
   * @name letterSpacing
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} letterSpacing
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'textBaseline', 'middle');

  /**
   * set textBaseline property. Default value is 'middle'.
   * Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'
   * @name textBaseline
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} textBaseline
   */

  /**
   * get font style
   * @name getFontStyle
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontVariant', NORMAL);

  /**
   * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
   * @name setFontVariant
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontVariant
   */

  /**
   * @get font variant
   * @name getFontVariant
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetter(Konva.TextPath, 'text', EMPTY_STRING);

  /**
   * get text
   * @name getText
   * @method
   * @memberof Konva.TextPath.prototype
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'textDecoration', null);

  /**
   * get/set text decoration of a text.  Can be '' or 'underline'
   * @name textDecoration
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} textDecoration
   * @returns {String}
   * @example
   * // get text decoration
   * var textDecoration = text.textDecoration();
   *
   * // center text
   * text.textDecoration('underline');
   */

  Konva.Factory.addGetterSetter(Konva.TextPath, 'kerningFunc', null);

  /**
   * get/set kerning function.
   * @name kerningFunc
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} kerningFunc
   * @returns {String}
   * @example
   * // get text decoration
   * var kerningFunc = text.kerningFunc();
   *
   * // center text
   * text.kerningFunc(function(leftChar, rightChar) {
   *   return 1;
   * });
   */

  Konva.Collection.mapMethods(Konva.TextPath);
})();

(function() {
  'use strict';
  /**
   * RegularPolygon constructor.&nbsp; Examples include triangles, squares, pentagons, hexagons, etc.
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.sides
   * @param {Number} config.radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var hexagon = new Konva.RegularPolygon({
   *   x: 100,
   *   y: 200,
   *   sides: 6,
   *   radius: 70,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 4
   * });
   */
  Konva.RegularPolygon = function(config) {
    this.___init(config);
  };

  Konva.RegularPolygon.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'RegularPolygon';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var sides = this.attrs.sides,
        radius = this.attrs.radius,
        n,
        x,
        y;

      context.beginPath();
      context.moveTo(0, 0 - radius);

      for (n = 1; n < sides; n++) {
        x = radius * Math.sin(n * 2 * Math.PI / sides);
        y = -1 * radius * Math.cos(n * 2 * Math.PI / sides);
        context.lineTo(x, y);
      }
      context.closePath();
      context.fillStrokeShape(this);
    },
    getWidth: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.radius() !== width / 2) {
        this.setRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.radius() !== height / 2) {
        this.setRadius(height / 2);
      }
    }
  };
  Konva.Util.extend(Konva.RegularPolygon, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.RegularPolygon,
    'radius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set radius
   * @name setRadius
   * @method
   * @memberof Konva.RegularPolygon.prototype
   * @param {Number} radius
   */

  /**
   * get radius
   * @name getRadius
   * @method
   * @memberof Konva.RegularPolygon.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.RegularPolygon,
    'sides',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set number of sides
   * @name setSides
   * @method
   * @memberof Konva.RegularPolygon.prototype
   * @param {int} sides
   */

  /**
   * get number of sides
   * @name getSides
   * @method
   * @memberof Konva.RegularPolygon.prototype
   */

  Konva.Collection.mapMethods(Konva.RegularPolygon);
})();

(function() {
  'use strict';
  /**
   * Star constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Integer} config.numPoints
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var star = new Konva.Star({
   *   x: 100,
   *   y: 200,
   *   numPoints: 5,
   *   innerRadius: 70,
   *   outerRadius: 70,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 4
   * });
   */
  Konva.Star = function(config) {
    this.___init(config);
  };

  Konva.Star.prototype = {
    _centroid: true,
    ___init: function(config) {
      // call super constructor
      Konva.Shape.call(this, config);
      this.className = 'Star';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var innerRadius = this.innerRadius(),
        outerRadius = this.outerRadius(),
        numPoints = this.numPoints();

      context.beginPath();
      context.moveTo(0, 0 - outerRadius);

      for (var n = 1; n < numPoints * 2; n++) {
        var radius = n % 2 === 0 ? outerRadius : innerRadius;
        var x = radius * Math.sin(n * Math.PI / numPoints);
        var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
        context.lineTo(x, y);
      }
      context.closePath();

      context.fillStrokeShape(this);
    },
    // implements Shape.prototype.getWidth()
    getWidth: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.getHeight()
    getHeight: function() {
      return this.getOuterRadius() * 2;
    },
    // implements Shape.prototype.setWidth()
    setWidth: function(width) {
      Konva.Node.prototype.setWidth.call(this, width);
      if (this.outerRadius() !== width / 2) {
        this.setOuterRadius(width / 2);
      }
    },
    // implements Shape.prototype.setHeight()
    setHeight: function(height) {
      Konva.Node.prototype.setHeight.call(this, height);
      if (this.outerRadius() !== height / 2) {
        this.setOuterRadius(height / 2);
      }
    }
  };
  Konva.Util.extend(Konva.Star, Konva.Shape);

  // add getters setters
  Konva.Factory.addGetterSetter(
    Konva.Star,
    'numPoints',
    5,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set number of points
   * @name setNumPoints
   * @method
   * @memberof Konva.Star.prototype
   * @param {Integer} points
   */

  /**
   * get number of points
   * @name getNumPoints
   * @method
   * @memberof Konva.Star.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.Star,
    'innerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set inner radius
   * @name setInnerRadius
   * @method
   * @memberof Konva.Star.prototype
   * @param {Number} radius
   */

  /**
   * get inner radius
   * @name getInnerRadius
   * @method
   * @memberof Konva.Star.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.Star,
    'outerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set outer radius
   * @name setOuterRadius
   * @method
   * @memberof Konva.Star.prototype
   * @param {Number} radius
   */

  /**
   * get outer radius
   * @name getOuterRadius
   * @method
   * @memberof Konva.Star.prototype
   */

  Konva.Collection.mapMethods(Konva.Star);
})();

(function() {
  'use strict';
  // constants
  var ATTR_CHANGE_LIST = [
      'fontFamily',
      'fontSize',
      'fontStyle',
      'padding',
      'lineHeight',
      'text',
      'width'
    ],
    CHANGE_KONVA = 'Change.konva',
    NONE = 'none',
    UP = 'up',
    RIGHT = 'right',
    DOWN = 'down',
    LEFT = 'left',
    LABEL = 'Label',
    // cached variables
    attrChangeListLen = ATTR_CHANGE_LIST.length;

  /**
   * Label constructor.&nbsp; Labels are groups that contain a Text and Tag shape
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // create label
   * var label = new Konva.Label({
   *   x: 100,
   *   y: 100,
   *   draggable: true
   * });
   *
   * // add a tag to the label
   * label.add(new Konva.Tag({
   *   fill: '#bbb',
   *   stroke: '#333',
   *   shadowColor: 'black',
   *   shadowBlur: 10,
   *   shadowOffset: [10, 10],
   *   shadowOpacity: 0.2,
   *   lineJoin: 'round',
   *   pointerDirection: 'up',
   *   pointerWidth: 20,
   *   pointerHeight: 20,
   *   cornerRadius: 5
   * }));
   *
   * // add text to the label
   * label.add(new Konva.Text({
   *   text: 'Hello World!',
   *   fontSize: 50,
   *   lineHeight: 1.2,
   *   padding: 10,
   *   fill: 'green'
   *  }));
   */
  Konva.Label = function(config) {
    this.____init(config);
  };

  Konva.Label.prototype = {
    ____init: function(config) {
      var that = this;

      Konva.Group.call(this, config);
      this.className = LABEL;

      this.on('add.konva', function(evt) {
        that._addListeners(evt.child);
        that._sync();
      });
    },
    /**
     * get Text shape for the label.  You need to access the Text shape in order to update
     * the text properties
     * @name getText
     * @method
     * @memberof Konva.Label.prototype
     */
    getText: function() {
      return this.find('Text')[0];
    },
    /**
     * get Tag shape for the label.  You need to access the Tag shape in order to update
     * the pointer properties and the corner radius
     * @name getTag
     * @method
     * @memberof Konva.Label.prototype
     */
    getTag: function() {
      return this.find('Tag')[0];
    },
    _addListeners: function(text) {
      var that = this,
        n;
      var func = function() {
        that._sync();
      };

      // update text data for certain attr changes
      for (n = 0; n < attrChangeListLen; n++) {
        text.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, func);
      }
    },
    getWidth: function() {
      return this.getText().getWidth();
    },
    getHeight: function() {
      return this.getText().getHeight();
    },
    _sync: function() {
      var text = this.getText(),
        tag = this.getTag(),
        width,
        height,
        pointerDirection,
        pointerWidth,
        x,
        y,
        pointerHeight;

      if (text && tag) {
        width = text.getWidth();
        height = text.getHeight();
        pointerDirection = tag.getPointerDirection();
        pointerWidth = tag.getPointerWidth();
        pointerHeight = tag.getPointerHeight();
        x = 0;
        y = 0;

        switch (pointerDirection) {
          case UP:
            x = width / 2;
            y = -1 * pointerHeight;
            break;
          case RIGHT:
            x = width + pointerWidth;
            y = height / 2;
            break;
          case DOWN:
            x = width / 2;
            y = height + pointerHeight;
            break;
          case LEFT:
            x = -1 * pointerWidth;
            y = height / 2;
            break;
        }

        tag.setAttrs({
          x: -1 * x,
          y: -1 * y,
          width: width,
          height: height
        });

        text.setAttrs({
          x: -1 * x,
          y: -1 * y
        });
      }
    }
  };

  Konva.Util.extend(Konva.Label, Konva.Group);

  Konva.Collection.mapMethods(Konva.Label);

  /**
   * Tag constructor.&nbsp; A Tag can be configured
   *  to have a pointer element that points up, right, down, or left
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {String} [config.pointerDirection] can be up, right, down, left, or none; the default
   *  is none.  When a pointer is present, the positioning of the label is relative to the tip of the pointer.
   * @param {Number} [config.pointerWidth]
   * @param {Number} [config.pointerHeight]
   * @param {Number} [config.cornerRadius]
   */
  Konva.Tag = function(config) {
    this.___init(config);
  };

  Konva.Tag.prototype = {
    ___init: function(config) {
      Konva.Shape.call(this, config);
      this.className = 'Tag';
      this.sceneFunc(this._sceneFunc);
    },
    _sceneFunc: function(context) {
      var width = this.getWidth(),
        height = this.getHeight(),
        pointerDirection = this.getPointerDirection(),
        pointerWidth = this.getPointerWidth(),
        pointerHeight = this.getPointerHeight(),
        cornerRadius = Math.min(this.getCornerRadius(), width / 2, height / 2);

      context.beginPath();
      if (!cornerRadius) {
        context.moveTo(0, 0);
      } else {
        context.moveTo(cornerRadius, 0);
      }

      if (pointerDirection === UP) {
        context.lineTo((width - pointerWidth) / 2, 0);
        context.lineTo(width / 2, -1 * pointerHeight);
        context.lineTo((width + pointerWidth) / 2, 0);
      }

      if (!cornerRadius) {
        context.lineTo(width, 0);
      } else {
        context.lineTo(width - cornerRadius, 0);
        context.arc(
          width - cornerRadius,
          cornerRadius,
          cornerRadius,
          Math.PI * 3 / 2,
          0,
          false
        );
      }

      if (pointerDirection === RIGHT) {
        context.lineTo(width, (height - pointerHeight) / 2);
        context.lineTo(width + pointerWidth, height / 2);
        context.lineTo(width, (height + pointerHeight) / 2);
      }

      if (!cornerRadius) {
        context.lineTo(width, height);
      } else {
        context.lineTo(width, height - cornerRadius);
        context.arc(
          width - cornerRadius,
          height - cornerRadius,
          cornerRadius,
          0,
          Math.PI / 2,
          false
        );
      }

      if (pointerDirection === DOWN) {
        context.lineTo((width + pointerWidth) / 2, height);
        context.lineTo(width / 2, height + pointerHeight);
        context.lineTo((width - pointerWidth) / 2, height);
      }

      if (!cornerRadius) {
        context.lineTo(0, height);
      } else {
        context.lineTo(cornerRadius, height);
        context.arc(
          cornerRadius,
          height - cornerRadius,
          cornerRadius,
          Math.PI / 2,
          Math.PI,
          false
        );
      }

      if (pointerDirection === LEFT) {
        context.lineTo(0, (height + pointerHeight) / 2);
        context.lineTo(-1 * pointerWidth, height / 2);
        context.lineTo(0, (height - pointerHeight) / 2);
      }

      if (cornerRadius) {
        context.lineTo(0, cornerRadius);
        context.arc(
          cornerRadius,
          cornerRadius,
          cornerRadius,
          Math.PI,
          Math.PI * 3 / 2,
          false
        );
      }

      context.closePath();
      context.fillStrokeShape(this);
    },
    getSelfRect: function() {
      var x = 0,
        y = 0,
        pointerWidth = this.getPointerWidth(),
        pointerHeight = this.getPointerHeight(),
        direction = this.pointerDirection(),
        width = this.getWidth(),
        height = this.getHeight();

      if (direction === UP) {
        y -= pointerHeight;
        height += pointerHeight;
      } else if (direction === DOWN) {
        height += pointerHeight;
      } else if (direction === LEFT) {
        // ARGH!!! I have no idea why should I used magic 1.5!!!!!!!!!
        x -= pointerWidth * 1.5;
        width += pointerWidth;
      } else if (direction === RIGHT) {
        width += pointerWidth * 1.5;
      }
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }
  };

  Konva.Util.extend(Konva.Tag, Konva.Shape);
  Konva.Factory.addGetterSetter(Konva.Tag, 'pointerDirection', NONE);

  /**
   * set pointer Direction
   * @name setPointerDirection
   * @method
   * @memberof Konva.Tag.prototype
   * @param {String} pointerDirection can be up, right, down, left, or none.  The
   *  default is none
   */

  /**
   * get pointer Direction
   * @name getPointerDirection
   * @method
   * @memberof Konva.Tag.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.Tag,
    'pointerWidth',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set pointer width
   * @name setPointerWidth
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} pointerWidth
   */

  /**
   * get pointer width
   * @name getPointerWidth
   * @method
   * @memberof Konva.Tag.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.Tag,
    'pointerHeight',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set pointer height
   * @name setPointerHeight
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} pointerHeight
   */

  /**
   * get pointer height
   * @name getPointerHeight
   * @method
   * @memberof Konva.Tag.prototype
   */

  Konva.Factory.addGetterSetter(
    Konva.Tag,
    'cornerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * set corner radius
   * @name setCornerRadius
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} corner radius
   */

  /**
   * get corner radius
   * @name getCornerRadius
   * @method
   * @memberof Konva.Tag.prototype
   */

  Konva.Collection.mapMethods(Konva.Tag);
})();

(function(Konva) {
  'use strict';
  /**
   * Arrow constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @param {Number} config.pointerLength Arrow pointer length. Default value is 10.
   * @param {Number} config.pointerWidth Arrow pointer width. Default value is 10.
   * @param {Boolean} config.pointerAtBeginning Do we need to draw pointer on both sides?. Default false.
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var line = new Konva.Line({
   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
   *   stroke: 'red',
   *   tension: 1,
   *   pointerLength : 10,
   *   pointerWidth : 12
   * });
   */
  Konva.Arrow = function(config) {
    this.____init(config);
  };

  Konva.Arrow.prototype = {
    ____init: function(config) {
      // call super constructor
      Konva.Line.call(this, config);
      this.className = 'Arrow';
    },
    _sceneFunc: function(ctx) {
      Konva.Line.prototype._sceneFunc.apply(this, arguments);
      var PI2 = Math.PI * 2;
      var points = this.points();

      var tp = points;
      var fromTension = this.getTension() !== 0 && points.length > 4;
      if (fromTension) {
        tp = this.getTensionPoints();
      }

      var n = points.length;

      var dx, dy;
      if (fromTension) {
        dx = points[n - 2] - tp[n - 2];
        dy = points[n - 1] - tp[n - 1];
      } else {
        dx = points[n - 2] - points[n - 4];
        dy = points[n - 1] - points[n - 3];
      }

      var radians = (Math.atan2(dy, dx) + PI2) % PI2;
      var length = this.pointerLength();
      var width = this.pointerWidth();

      ctx.save();
      ctx.beginPath();
      ctx.translate(points[n - 2], points[n - 1]);
      ctx.rotate(radians);
      ctx.moveTo(0, 0);
      ctx.lineTo(-length, width / 2);
      ctx.lineTo(-length, -width / 2);
      ctx.closePath();
      ctx.restore();

      if (this.pointerAtBeginning()) {
        ctx.save();
        ctx.translate(points[0], points[1]);
        if (fromTension) {
          dx = tp[0] - points[0];
          dy = tp[1] - points[1];
        } else {
          dx = points[2] - points[0];
          dy = points[3] - points[1];
        }

        ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
        ctx.moveTo(0, 0);
        ctx.lineTo(-length, width / 2);
        ctx.lineTo(-length, -width / 2);
        ctx.closePath();
        ctx.restore();
      }

      // here is a tricky part
      // we need to disable dash for arrow pointers
      var isDashEnabled = this.dashEnabled();
      if (isDashEnabled) {
        // manually disable dash for head
        // it is better not to use setter here,
        // because it will trigger attr change event
        this.attrs.dashEnabled = false;
        ctx.setLineDash([]);
      }

      ctx.fillStrokeShape(this);

      // restore old value
      if (isDashEnabled) {
        this.attrs.dashEnabled = true;
      }
    }
  };

  Konva.Util.extend(Konva.Arrow, Konva.Line);
  /**
   * get/set pointerLength
   * @name pointerLength
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Length of pointer of arrow.
   *   The default is 10.
   * @returns {Number}
   * @example
   * // get tension
   * var pointerLength = line.pointerLength();
   *
   * // set tension
   * line.pointerLength(15);
   */

  Konva.Factory.addGetterSetter(
    Konva.Arrow,
    'pointerLength',
    10,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set pointerWidth
   * @name pointerWidth
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Width of pointer of arrow.
   *   The default is 10.
   * @returns {Number}
   * @example
   * // get tension
   * var pointerWidth = line.pointerWidth();
   *
   * // set tension
   * line.pointerWidth(15);
   */

  Konva.Factory.addGetterSetter(
    Konva.Arrow,
    'pointerWidth',
    10,
    Konva.Validators.getNumberValidator()
  );
  /**
   * get/set pointerAtBeginning
   * @name pointerAtBeginning
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Should pointer displayed at beginning of arrow.
   *   The default is false.
   * @returns {Boolean}
   * @example
   * // get tension
   * var pointerAtBeginning = line.pointerAtBeginning();
   *
   * // set tension
   * line.pointerAtBeginning(true);
   */

  Konva.Factory.addGetterSetter(Konva.Arrow, 'pointerAtBeginning', false);
  Konva.Collection.mapMethods(Konva.Arrow);
})(Konva);

(function(Konva) {
  'use strict';

  var ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange'
  ].join(' ');

  var NODE_RECT = 'nodeRect';

  var TRANSFORM_CHANGE_STR = [
    'xChange.resizer',
    'yChange.resizer',
    'widthChange.resizer',
    'heightChange.resizer',
    'scaleXChange.resizer',
    'scaleYChange.resizer',
    'skewXChange.resizer',
    'skewYChange.resizer',
    'rotationChange.resizer',
    'offsetXChange.resizer',
    'offsetYChange.resizer',
    'transformsEnabledChange.resizer'
  ].join(' ');

  var REDRAW_CHANGE_STR = [
    'widthChange.resizer',
    'heightChange.resizer',
    'scaleXChange.resizer',
    'scaleYChange.resizer',
    'skewXChange.resizer',
    'skewYChange.resizer',
    'rotationChange.resizer',
    'offsetXChange.resizer',
    'offsetYChange.resizer'
  ].join(' ');

  var ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
  };

  function getCursor(anchorName, rad, isMirrored) {
    if (anchorName === 'rotater') {
      return 'crosshair';
    }

    rad += Konva.Util._degToRad(ANGLES[anchorName] || 0);
    // If we are mirrored, we need to mirror the angle (this is not the same as
    // rotate).
    if (isMirrored) {
      rad *= -1;
    }
    var angle = ((Konva.Util._radToDeg(rad) % 360) + 360) % 360;

    if (
      Konva.Util._inRange(angle, 315 + 22.5, 360) ||
      Konva.Util._inRange(angle, 0, 22.5)
    ) {
      // TOP
      return 'ns-resize';
    } else if (Konva.Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
      // TOP - RIGHT
      return 'nesw-resize';
    } else if (Konva.Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
      // RIGHT
      return 'ew-resize';
    } else if (Konva.Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
      // BOTTOM - RIGHT
      return 'nwse-resize';
    } else if (Konva.Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
      // BOTTOM
      return 'ns-resize';
    } else if (Konva.Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
      // BOTTOM - LEFT
      return 'nesw-resize';
    } else if (Konva.Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
      // RIGHT
      return 'ew-resize';
    } else if (Konva.Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
      // BOTTOM - RIGHT
      return 'nwse-resize';
    } else {
      // how can we can there?
      // TODO: throw error
      Konva.Util.error(
        'Transformer has unknown angle for cursor detection: ' + angle
      );
      return 'pointer';
    }
  }

  /**
   * Transformer constructor.  Transformer is a special type of group that allow you transform Konva
   * primitives and shapes. Transforming tool is not changing `width` and `height` properties of nodes
   * when you resize them. Instead it changes `scaleX` and `scaleY` properties.
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {Boolean} [config.resizeEnabled] Default is true
   * @param {Boolean} [config.rotateEnabled] Default is true
   * @param {Array} [config.rotationSnaps] Array of angles for rotation snaps. Default is []
   * @param {Number} [config.rotateAnchorOffset] Default is 50
   * @param {Number} [config.padding] Default is 0
   * @param {Boolean} [config.borderEnabled] Should we draw border? Default is true
   * @param {String} [config.borderStroke] Border stroke color
   * @param {Number} [config.borderStrokeWidth] Border stroke size
   * @param {Array} [config.borderDash] Array for border dash.
   * @param {String} [config.anchorFill] Anchor fill color
   * @param {String} [config.anchorStroke] Anchor stroke color
   * @param {String} [config.anchorCornerRadius] Anchor corner radius
   * @param {Number} [config.anchorStrokeWidth] Anchor stroke size
   * @param {Number} [config.anchorSize] Default is 10
   * @param {Boolean} [config.keepRatio] Should we keep ratio when we are moving edges? Default is true
   * @param {Boolean} [config.centeredScaling] Should we resize relative to node's center? Default is false
   * @param {Array} [config.enabledAnchors] Array of names of enabled handles
   * @param {Function} [config.boundBoxFunc] Bounding box function
   * @example
   * var transformer = new Konva.Transformer({
   *   node: rectangle,
   *   rotateAnchorOffset: 60,
   *   enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
   * });
   * layer.add(transformer);
   */

  Konva.Transformer = function(config) {
    this.____init(config);
  };

  var ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
  ];

  Konva.Transformer.prototype = {
    _centroid: false,
    ____init: function(config) {
      // call super constructor
      Konva.Group.call(this, config);
      this.className = 'Transformer';
      this._createElements();

      // bindings
      this._handleMouseMove = this._handleMouseMove.bind(this);
      this._handleMouseUp = this._handleMouseUp.bind(this);
      this.update = this.update.bind(this);

      // update transformer data for certain attr changes
      this.on(ATTR_CHANGE_LIST, this.update);

      if (this.getNode()) {
        this.update();
      }
    },

    /**
     * alias to `setNode`
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.attachTo(shape);
     */
    attachTo: function(node) {
      this.setNode(node);
    },

    /**
     * attach transformer to a Konva.Node. Transformer will adapt to its size and listen its events
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.setNode(shape);
     */
    setNode: function(node) {
      if (this._node) {
        this.detach();
      }
      this._node = node;
      this._resetTransformCache();

      node.on(TRANSFORM_CHANGE_STR, this._resetTransformCache.bind(this));
      node.on(
        REDRAW_CHANGE_STR,
        function() {
          if (!this._transforming) {
            this.update();
          }
        }.bind(this)
      );

      // TODO: why do we need this?
      var elementsCreated = !!this.findOne('.top-left');
      if (elementsCreated) {
        this.update();
      }
      return this;
    },

    getNode: function() {
      return this._node;
    },

    /**
     * detach transformer from a attached node
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.detach();
     */
    detach: function() {
      if (this.getNode()) {
        this.getNode().off('.resizer');
        this._node = undefined;
      }
      this._resetTransformCache();
    },

    _resetTransformCache: function() {
      this._clearCache(NODE_RECT);
      this._clearCache('transform');
      this._clearSelfAndDescendantCache('absoluteTransform');
    },

    _getNodeRect: function() {
      return this._getCache(NODE_RECT, this.__getNodeRect);
    },

    __getNodeRect: function() {
      var node = this.getNode();
      if (!node) {
        return {
          x: -Number.MAX_SAFE_INTEGER,
          y: -Number.MAX_SAFE_INTEGER,
          width: 0,
          height: 0,
          rotation: 0
        };
      }
      var rect = node.getClientRect({
        skipTransform: true,
        skipShadow: true,
        skipStroke: this.ignoreStroke()
      });
      var rotation = Konva.getAngle(node.rotation());

      var dx = rect.x * node.scaleX() - node.offsetX() * node.scaleX();
      var dy = rect.y * node.scaleY() - node.offsetY() * node.scaleY();

      return {
        x: node.x() + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
        y: node.y() + dy * Math.cos(rotation) + dx * Math.sin(rotation),
        width: rect.width * node.scaleX(),
        height: rect.height * node.scaleY(),
        rotation: node.rotation()
      };
    },

    getX: function() {
      return this._getNodeRect().x;
    },

    getY: function() {
      return this._getNodeRect().y;
    },

    getRotation: function() {
      return this._getNodeRect().rotation;
    },

    getWidth: function() {
      return this._getNodeRect().width;
    },

    getHeight: function() {
      return this._getNodeRect().height;
    },

    _createElements: function() {
      this._createBack();

      ANCHORS_NAMES.forEach(
        function(name) {
          this._createAnchor(name);
        }.bind(this)
      );

      this._createAnchor('rotater');
    },

    _createAnchor: function(name) {
      var anchor = new Konva.Rect({
        stroke: 'rgb(0, 161, 255)',
        fill: 'white',
        strokeWidth: 1,
        name: name + ' _anchor',
        dragDistance: 0,
        draggable: true
      });
      var self = this;
      anchor.on('mousedown touchstart', function(e) {
        self._handleMouseDown(e);
      });
      anchor.on('dragstart', function(e) {
        e.cancelBubble = true;
      });
      anchor.on('dragmove', function(e) {
        e.cancelBubble = true;
      });
      anchor.on('dragend', function(e) {
        e.cancelBubble = true;
      });

      // add hover styling
      anchor.on('mouseenter', function() {
        var tr = this.getParent();

        var rad = Konva.getAngle(tr.rotation());

        var scale = tr.getNode().getAbsoluteScale();
        // If scale.y < 0 xor scale.x < 0 we need to flip (not rotate).
        var isMirrored = scale.y * scale.x < 0;
        var cursor = getCursor(name, rad, isMirrored);
        anchor.getStage().content.style.cursor = cursor;
        tr._cursorChange = true;
      });
      anchor.on('mouseout', function() {
        if (!anchor.getStage() || !this.getParent()) {
          return;
        }
        anchor.getStage().content.style.cursor = '';
        this.getParent()._cursorChange = false;
      });
      this.add(anchor);
    },

    _createBack: function() {
      var back = new Konva.Shape({
        name: 'back',
        width: 0,
        height: 0,
        listening: false,
        sceneFunc: function(ctx) {
          var tr = this.getParent();
          var padding = tr.getPadding();
          ctx.beginPath();
          ctx.rect(
            -padding,
            -padding,
            this.width() + padding * 2,
            this.height() + padding * 2
          );
          ctx.moveTo(this.width() / 2, -padding);
          if (tr.rotateEnabled()) {
            ctx.lineTo(
              this.width() / 2,
              -tr.rotateAnchorOffset() * Konva.Util._sign(this.height())
            );
          }

          ctx.fillStrokeShape(this);
        }
      });
      this.add(back);
    },

    _handleMouseDown: function(e) {
      this.movingResizer = e.target.name().split(' ')[0];

      // var node = this.getNode();
      var attrs = this._getNodeRect();
      var width = attrs.width;
      var height = attrs.height;
      var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
      this.sin = height / hypotenuse;
      this.cos = width / hypotenuse;

      window.addEventListener('mousemove', this._handleMouseMove);
      window.addEventListener('touchmove', this._handleMouseMove);
      window.addEventListener('mouseup', this._handleMouseUp, true);
      window.addEventListener('touchend', this._handleMouseUp, true);

      this._transforming = true;

      this._fire('transformstart', { evt: e });
      this.getNode()._fire('transformstart', { evt: e });
    },

    _handleMouseMove: function(e) {
      var x, y, newHypotenuse;
      var resizerNode = this.findOne('.' + this.movingResizer);
      var stage = resizerNode.getStage();

      var box = stage.getContent().getBoundingClientRect();
      var zeroPoint = {
        x: box.left,
        y: box.top
      };
      var pointerPos = {
        left: e.clientX !== undefined ? e.clientX : e.touches[0].clientX,
        top: e.clientX !== undefined ? e.clientY : e.touches[0].clientY
      };
      var newAbsPos = {
        x: pointerPos.left - zeroPoint.x,
        y: pointerPos.top - zeroPoint.y
      };

      resizerNode.setAbsolutePosition(newAbsPos);

      var keepProportion = this.keepRatio() || e.shiftKey;

      // console.log(keepProportion);

      if (this.movingResizer === 'top-left') {
        if (keepProportion) {
          newHypotenuse = Math.sqrt(
            Math.pow(this.findOne('.bottom-right').x() - resizerNode.x(), 2) +
              Math.pow(this.findOne('.bottom-right').y() - resizerNode.y(), 2)
          );

          x = newHypotenuse * this.cos;
          y = newHypotenuse * this.sin;

          this.findOne('.top-left').x(this.findOne('.bottom-right').x() - x);
          this.findOne('.top-left').y(this.findOne('.bottom-right').y() - y);
        }
      } else if (this.movingResizer === 'top-center') {
        this.findOne('.top-left').y(resizerNode.y());
      } else if (this.movingResizer === 'top-right') {
        if (keepProportion) {
          newHypotenuse = Math.sqrt(
            Math.pow(this.findOne('.bottom-left').x() - resizerNode.x(), 2) +
              Math.pow(this.findOne('.bottom-left').y() - resizerNode.y(), 2)
          );

          x = newHypotenuse * this.cos;
          y = newHypotenuse * this.sin;

          this.findOne('.top-right').x(x);
          this.findOne('.top-right').y(this.findOne('.bottom-left').y() - y);
        }
        var pos = resizerNode.position();

        this.findOne('.top-left').y(pos.y);
        this.findOne('.bottom-right').x(pos.x);
      } else if (this.movingResizer === 'middle-left') {
        this.findOne('.top-left').x(resizerNode.x());
      } else if (this.movingResizer === 'middle-right') {
        this.findOne('.bottom-right').x(resizerNode.x());
      } else if (this.movingResizer === 'bottom-left') {
        if (keepProportion) {
          newHypotenuse = Math.sqrt(
            Math.pow(this.findOne('.top-right').x() - resizerNode.x(), 2) +
              Math.pow(this.findOne('.top-right').y() - resizerNode.y(), 2)
          );

          x = newHypotenuse * this.cos;
          y = newHypotenuse * this.sin;

          this.findOne('.bottom-left').x(this.findOne('.top-right').x() - x);
          this.findOne('.bottom-left').y(y);
        }

        pos = resizerNode.position();

        this.findOne('.top-left').x(pos.x);
        this.findOne('.bottom-right').y(pos.y);
      } else if (this.movingResizer === 'bottom-center') {
        this.findOne('.bottom-right').y(resizerNode.y());
      } else if (this.movingResizer === 'bottom-right') {
        if (keepProportion) {
          newHypotenuse = Math.sqrt(
            Math.pow(this.findOne('.bottom-right').x(), 2) +
              Math.pow(this.findOne('.bottom-right').y(), 2)
          );

          x = newHypotenuse * this.cos;
          y = newHypotenuse * this.sin;

          this.findOne('.bottom-right').x(x);
          this.findOne('.bottom-right').y(y);
        }
      } else if (this.movingResizer === 'rotater') {
        var padding = this.getPadding();
        var attrs = this._getNodeRect();
        x = resizerNode.x() - attrs.width / 2;
        y = -resizerNode.y() + attrs.height / 2;

        var dAlpha = Math.atan2(-y, x) + Math.PI / 2;

        if (attrs.height < 0) {
          dAlpha -= Math.PI;
        }

        var rot = Konva.getAngle(this.rotation());

        var newRotation =
          Konva.Util._radToDeg(rot) + Konva.Util._radToDeg(dAlpha);

        var alpha = Konva.getAngle(this.getNode().rotation());
        var newAlpha = Konva.Util._degToRad(newRotation);

        var snaps = this.rotationSnaps();
        var offset = 0.1;
        for (var i = 0; i < snaps.length; i++) {
          var angle = Konva.getAngle(snaps[i]);

          var dif =
            Math.abs(angle - Konva.Util._degToRad(newRotation)) % (Math.PI * 2);

          if (dif < offset) {
            newRotation = Konva.Util._radToDeg(angle);
            newAlpha = Konva.Util._degToRad(newRotation);
          }
        }

        var dx = padding;
        var dy = padding;

        this._fitNodeInto(
          {
            rotation: Konva.angleDeg
              ? newRotation
              : Konva.Util._degToRad(newRotation),
            x:
              attrs.x +
              (attrs.width / 2 + padding) *
                (Math.cos(alpha) - Math.cos(newAlpha)) +
              (attrs.height / 2 + padding) *
                (Math.sin(-alpha) - Math.sin(-newAlpha)) -
              (dx * Math.cos(rot) + dy * Math.sin(-rot)),
            y:
              attrs.y +
              (attrs.height / 2 + padding) *
                (Math.cos(alpha) - Math.cos(newAlpha)) +
              (attrs.width / 2 + padding) *
                (Math.sin(alpha) - Math.sin(newAlpha)) -
              (dy * Math.cos(rot) + dx * Math.sin(rot)),
            width: attrs.width + padding * 2,
            height: attrs.height + padding * 2
          },
          e
        );
      } else {
        console.error(
          new Error(
            'Wrong position argument of selection resizer: ',
            this.movingResizer
          )
        );
      }

      if (this.movingResizer === 'rotater') {
        return;
      }

      var absPos = this.findOne('.top-left').getAbsolutePosition(
        this.getParent()
      );

      var centeredScaling = this.getCenteredScaling() || e.altKey;
      if (centeredScaling) {
        var topLeft = this.findOne('.top-left');
        var bottomRight = this.findOne('.bottom-right');
        var topOffsetX = topLeft.x();
        var topOffsetY = topLeft.y();

        var bottomOffsetX = this.getWidth() - bottomRight.x();
        var bottomOffsetY = this.getHeight() - bottomRight.y();

        // console.log(topOffsetX, topOffsetY, bottomOffsetX, bottomOffsetY);

        bottomRight.move({
          x: -topOffsetX,
          y: -topOffsetY
        });

        topLeft.move({
          x: bottomOffsetX,
          y: bottomOffsetY
        });

        absPos = topLeft.getAbsolutePosition(this.getParent());
      }

      x = absPos.x;
      y = absPos.y;
      var width =
        this.findOne('.bottom-right').x() - this.findOne('.top-left').x();

      var height =
        this.findOne('.bottom-right').y() - this.findOne('.top-left').y();

      // console.log(x, y, width, height);

      this._fitNodeInto(
        {
          x: x + this.offsetX(),
          y: y + this.offsetY(),
          width: width,
          height: height
        },
        e
      );
    },

    _handleMouseUp: function(e) {
      this._removeEvents(e);
    },

    _removeEvents: function(e) {
      if (this._transforming) {
        this._transforming = false;
        window.removeEventListener('mousemove', this._handleMouseMove);
        window.removeEventListener('touchmove', this._handleMouseMove);
        window.removeEventListener('mouseup', this._handleMouseUp, true);
        window.removeEventListener('touchend', this._handleMouseUp, true);
        this._fire('transformend', { evt: e });
        var node = this.getNode();
        if (node) {
          node.fire('transformend', { evt: e });
        }
      }
    },

    _fitNodeInto: function(newAttrs, evt) {
      // waring! in this attrs padding may be included
      var boundBoxFunc = this.getBoundBoxFunc();
      if (boundBoxFunc) {
        var oldAttrs = this._getNodeRect();
        newAttrs = boundBoxFunc.call(this, oldAttrs, newAttrs);
      }
      this._settings = true;
      var node = this.getNode();
      if (newAttrs.rotation !== undefined) {
        this.getNode().rotation(newAttrs.rotation);
      }
      var pure = node.getClientRect({
        skipTransform: true,
        skipShadow: true,
        skipStroke: this.ignoreStroke()
      });

      var padding = this.getPadding();
      var scaleX = (newAttrs.width - padding * 2) / pure.width;
      var scaleY = (newAttrs.height - padding * 2) / pure.height;

      var rotation = Konva.getAngle(node.getRotation());
      var dx = pure.x * scaleX - padding - node.offsetX() * scaleX;
      var dy = pure.y * scaleY - padding - node.offsetY() * scaleY;

      this.getNode().setAttrs({
        scaleX: scaleX,
        scaleY: scaleY,
        x: newAttrs.x - (dx * Math.cos(rotation) + dy * Math.sin(-rotation)),
        y: newAttrs.y - (dy * Math.cos(rotation) + dx * Math.sin(rotation))
      });
      this._settings = false;

      this._fire('transform', { evt: evt });
      this.getNode()._fire('transform', { evt: evt });
      this.update();
      this.getLayer().batchDraw();
    },
    /**
     * force update of Konva.Transformer.
     * Use it when you updated attached Konva.Group and now you need to reset transformer size
     * @method
     * @memberof Konva.Transformer.prototype
     */
    forceUpdate: function() {
      this._resetTransformCache();
      this.update();
    },
    update: function() {
      var attrs = this._getNodeRect();
      var node = this.getNode();
      var scale = { x: 1, y: 1 };
      if (node && node.getParent()) {
        scale = node.getParent().getAbsoluteScale();
      }
      var invertedScale = {
        x: 1 / scale.x,
        y: 1 / scale.y
      };
      var width = attrs.width;
      var height = attrs.height;

      var enabledAnchors = this.enabledAnchors();
      var resizeEnabled = this.resizeEnabled();
      var padding = this.getPadding();

      var anchorSize = this.getAnchorSize();
      this.find('._anchor').setAttrs({
        width: anchorSize,
        height: anchorSize,
        offsetX: anchorSize / 2,
        offsetY: anchorSize / 2,
        stroke: this.getAnchorStroke(),
        strokeWidth: this.getAnchorStrokeWidth(),
        fill: this.getAnchorFill(),
        cornerRadius: this.getAnchorCornerRadius()
      });

      this.findOne('.top-left').setAttrs({
        x: -padding,
        y: -padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
      });
      this.findOne('.top-center').setAttrs({
        x: width / 2,
        y: -padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
      });
      this.findOne('.top-right').setAttrs({
        x: width + padding,
        y: -padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
      });
      this.findOne('.middle-left').setAttrs({
        x: -padding,
        y: height / 2,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
      });
      this.findOne('.middle-right').setAttrs({
        x: width + padding,
        y: height / 2,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
      });
      this.findOne('.bottom-left').setAttrs({
        x: -padding,
        y: height + padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
      });
      this.findOne('.bottom-center').setAttrs({
        x: width / 2,
        y: height + padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
      });
      this.findOne('.bottom-right').setAttrs({
        x: width + padding,
        y: height + padding,
        scale: invertedScale,
        visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
      });

      var scaledRotateAnchorOffset =
        -this.rotateAnchorOffset() * Math.abs(invertedScale.y);
      this.findOne('.rotater').setAttrs({
        x: width / 2,
        y: scaledRotateAnchorOffset * Konva.Util._sign(height),
        scale: invertedScale,
        visible: this.rotateEnabled()
      });

      this.findOne('.back').setAttrs({
        width: width * scale.x,
        height: height * scale.y,
        scale: invertedScale,
        visible: this.borderEnabled(),
        stroke: this.getBorderStroke(),
        strokeWidth: this.getBorderStrokeWidth(),
        dash: this.getBorderDash()
      });
    },
    /**
     * determine if transformer is in active transform
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Boolean}
     */
    isTransforming: function() {
      return this._transforming;
    },
    /**
     * Stop active transform action
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Boolean}
     */
    stopTransform: function() {
      if (this._transforming) {
        this._removeEvents();
        var resizerNode = this.findOne('.' + this.movingResizer);
        if (resizerNode) {
          resizerNode.stopDrag();
        }
      }
    },
    destroy: function() {
      // console.log(this.isTransforming() && this.getStage());
      if (this.getStage() && this._cursorChange) {
        this.getStage().content.style.cursor = '';
      }
      Konva.Group.prototype.destroy.call(this);
      this.detach();
      this._removeEvents();
    },
    // do not work as a container
    // we will recreate inner nodes manually
    toObject: function() {
      return Konva.Node.prototype.toObject.call(this);
    }
  };
  Konva.Util.extend(Konva.Transformer, Konva.Group);

  function validateResizers(val) {
    if (!(val instanceof Array)) {
      Konva.Util.warn('enabledAnchors value should be an array');
    }
    if (val instanceof Array) {
      val.forEach(function(name) {
        if (ANCHORS_NAMES.indexOf(name) === -1) {
          Konva.Util.warn(
            'Unknown anchor name: ' +
              name +
              '. Available names are: ' +
              ANCHORS_NAMES.join(', ')
          );
        }
      });
    }
    return val || [];
  }

  /**
   * get/set enabled handlers
   * @name enabledAnchors
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get list of handlers
   * var enabledAnchors = transformer.enabledAnchors();
   *
   * // set handlers
   * transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'enabledAnchors',
    ANCHORS_NAMES,
    validateResizers
  );

  /**
   * get/set resize ability. If false it will automatically hide resizing handlers
   * @name resizeEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get
   * var resizeEnabled = transformer.resizeEnabled();
   *
   * // set
   * transformer.resizeEnabled(false);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'resizeEnabled', true);
  /**
   * get/set anchor size. Default is 10
   * @name validateAnchors
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} 10
   * @returns {Number}
   * @example
   * // get
   * var anchorSize = transformer.anchorSize();
   *
   * // set
   * transformer.anchorSize(20)
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'anchorSize',
    10,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set ability to rotate.
   * @name rotateEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var rotateEnabled = transformer.rotateEnabled();
   *
   * // set
   * transformer.rotateEnabled(false);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'rotateEnabled', true);

  /**
   * get/set rotation snaps angles.
   * @name rotationSnaps
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get
   * var rotationSnaps = transformer.rotationSnaps();
   *
   * // set
   * transformer.rotationSnaps([0, 90, 180, 270]);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'rotationSnaps', []);

  /**
   * get/set distance for rotation handler
   * @name rotateAnchorOffset
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} offset
   * @returns {Number}
   * @example
   * // get
   * var rotateAnchorOffset = transformer.rotateAnchorOffset();
   *
   * // set
   * transformer.rotateAnchorOffset(100);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'rotateAnchorOffset',
    50,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set visibility of border
   * @name borderEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderEnabled = transformer.borderEnabled();
   *
   * // set
   * transformer.borderEnabled(false);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'borderEnabled', true);

  /**
   * get/set anchor stroke color
   * @name anchorStroke
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorStroke = transformer.anchorStroke();
   *
   * // set
   * transformer.anchorStroke('red');
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'anchorStroke',
    'rgb(0, 161, 255)'
  );

  /**
   * get/set anchor stroke width
   * @name anchorStrokeWidth
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorStrokeWidth = transformer.anchorStrokeWidth();
   *
   * // set
   * transformer.anchorStrokeWidth(3);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'anchorStrokeWidth',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set anchor fill color
   * @name anchorFill
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorFill = transformer.anchorFill();
   *
   * // set
   * transformer.anchorFill('red');
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'anchorFill', 'white');

  /**
   * get/set anchor corner radius
   * @name anchorCornerRadius
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} enabled
   * @returns {Number}
   * @example
   * // get
   * var anchorCornerRadius = transformer.anchorCornerRadius();
   *
   * // set
   * transformer.anchorCornerRadius(3);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'anchorCornerRadius',
    0,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set border stroke color
   * @name borderStroke
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderStroke = transformer.borderStroke();
   *
   * // set
   * transformer.borderStroke('red');
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'borderStroke',
    'rgb(0, 161, 255)'
  );

  /**
   * get/set border stroke width
   * @name borderStrokeWidth
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderStrokeWidth = transformer.borderStrokeWidth();
   *
   * // set
   * transformer.borderStrokeWidth(3);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'borderStrokeWidth',
    1,
    Konva.Validators.getNumberValidator()
  );

  /**
   * get/set border dash array
   * @name borderDash
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderDash = transformer.borderDash();
   *
   * // set
   * transformer.borderDash([2, 2]);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'borderDash');

  /**
   * get/set should we keep ratio while resize anchors at corners
   * @name keepRatio
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} keepRatio
   * @returns {Boolean}
   * @example
   * // get
   * var keepRatio = transformer.keepRatio();
   *
   * // set
   * transformer.keepRatio(false);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'keepRatio', true);

  /**
   * get/set should we resize relative to node's center?
   * @name centeredScaling
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} centeredScaling
   * @returns {Boolean}
   * @example
   * // get
   * var centeredScaling = transformer.centeredScaling();
   *
   * // set
   * transformer.centeredScaling(true);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'centeredScaling', false);

  /**
   * get/set should we think about stroke while resize? Good to use when a shape has strokeScaleEnabled = false
   * default is false
   * @name ignoreStroke
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} ignoreStroke
   * @returns {Boolean}
   * @example
   * // get
   * var ignoreStroke = transformer.ignoreStroke();
   *
   * // set
   * transformer.ignoreStroke(true);
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'ignoreStroke', false);

  /**
   * get/set padding
   * @name padding
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} padding
   * @returns {Number}
   * @example
   * // get
   * var padding = transformer.padding();
   *
   * // set
   * transformer.padding(10);
   */
  Konva.Factory.addGetterSetter(
    Konva.Transformer,
    'padding',
    0,
    Konva.Validators.getNumberValidator()
  );

  Konva.Factory.addOverloadedGetterSetter(Konva.Transformer, 'node');

  /**
   * get/set bounding box function
   * @name boundBoxFunc
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Function} func
   * @returns {Function}
   * @example
   * // get
   * var boundBoxFunc = transformer.boundBoxFunc();
   *
   * // set
   * transformer.boundBoxFunc(function(oldBox, newBox) {
   *   if (newBox.width > 200) {
   *     return oldBox;
   *   }
   *   return newBox;
   * });
   */
  Konva.Factory.addGetterSetter(Konva.Transformer, 'boundBoxFunc');

  Konva.Factory.backCompat(Konva.Transformer, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
  });

  Konva.Collection.mapMethods(Konva.Transformer);
})(Konva);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(50);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(60);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(61);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(63);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(65);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(67);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(20);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(69);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(71);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(73);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(74);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(21);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blendStyle=function blendStyle(){for(var _len=arguments.length,styles=Array(_len),_key=0;_key<_len;_key++){styles[_key]=arguments[_key];}return Object.assign.apply(Object,[{}].concat(styles));};/* harmony default export */ __webpack_exports__["a"] = (blendStyle);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
var colors={semiblack:"#231f20",black:"#111111",semiwhite:"#e1e1e7",white:"#f1f1f5"};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */


var validateFormat =  false ? function (format) {} : function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(44);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(51)(module)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(31);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(64)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_project1_png__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_project1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_project1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_project2_png__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_project2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_project2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_twitch_mp4__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_twitch_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_twitch_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_jiggle_wall_fallback_mp4__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_jiggle_wall_fallback_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_jiggle_wall_fallback_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Helper_media__ = __webpack_require__(5);
var _templateObject=_taggedTemplateLiteral(['transition: transform 0.5s;'],['transition: transform 0.5s;']),_templateObject2=_taggedTemplateLiteral(['\n\theight: 100%;\n\twidth: auto;\n\ttransition: transform 0.5s;\n'],['\n\theight: 100%;\n\twidth: auto;\n\ttransition: transform 0.5s;\n']),_templateObject3=_taggedTemplateLiteral(['\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: rgba(0, 0, 0, 0.3);\n\topacity: 0;\n\ttransition: opacity 0.5s;\n\tcolor: #fff;\n\tfont-family: \'Raleway\', sans-serif;\n\tfont-weight: 300;\n\tfont-size: 65.7px ',';\n\t',';\n'],['\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: rgba(0, 0, 0, 0.3);\n\topacity: 0;\n\ttransition: opacity 0.5s;\n\tcolor: #fff;\n\tfont-family: \'Raleway\', sans-serif;\n\tfont-weight: 300;\n\tfont-size: 65.7px ',';\n\t',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    font-size: 40px;\n  '],['\n    font-size: 40px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: 30px;\n  '],['\n    font-size: 30px;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n\tdisplay: ',';\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ',';\n\tbackground: #f6f6f9;\n\t&:hover {\n\t\t',', ',' {\n\t\t\ttransition: transform 0.5s;\n\t\t\ttransform: scale(1.1);\n\t\t}\n\t\t',' {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t',';\n'],['\n\tdisplay: ',';\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ',';\n\tbackground: #f6f6f9;\n\t&:hover {\n\t\t',', ',' {\n\t\t\ttransition: transform 0.5s;\n\t\t\ttransform: scale(1.1);\n\t\t}\n\t\t',' {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var WorkWall=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].img(_templateObject);var WorkWall_v=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */])(WorkWall)(_templateObject2).withComponent('video');var WorkDes=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].md(_templateObject4),__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].sm(_templateObject5));var WorkItem=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */])(_templateObject6,function(props){return props.comp?'none':'block';},function(props){return props.shrink?100/3*1+'%':100/1.618*1+'%';},WorkWall,WorkWall_v,WorkDes,function(props){return props.shrink?'\n    & '+WorkWall+', '+WorkWall_v+' {\n      width: 100%;\n      height: auto;\n      position: relative;\n      top: 50%;\n      transform: translate(0, -50%);\n      transition: transform 0.5s;\n    }\n    &:hover {\n      '+WorkWall+', '+WorkWall_v+' {\n        transition: transform 0.5s;\n        transform: scale(1.1) translate(0, -50%);\n      }\n\n    }\n  ':null;});var WorkLink=function WorkLink(_ref){var location=_ref.location,_ref$shrink=_ref.shrink,shrink=_ref$shrink===undefined?false:_ref$shrink;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkItem,{to:'/jiggle',comp:location.pathname=='/jiggle',shrink:shrink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkWall_v,{autoPlay:true,muted:true,playsInline:true,loop:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_6__img_jiggle_wall_fallback_mp4___default.a,type:'video/mp4'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkDes,{className:'ratio__inner'},'Jiggle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkItem,{to:'/twitch',comp:location.pathname=='/twitch',shrink:shrink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkWall_v,{autoPlay:true,muted:true,playsInline:true,loop:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_5__img_twitch_mp4___default.a,type:'video/mp4'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkDes,{className:'ratio__inner'},'Twitch Chat Visualization')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkItem,{to:'/NDF',comp:location.pathname=='/NDF',shrink:shrink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkWall,{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_project1_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkDes,{className:'ratio__inner'},'Naver Design Fellowship')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkItem,{to:'/CONVIoT',comp:location.pathname=='/CONVIoT',shrink:shrink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkWall,{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_4__img_project2_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkDes,{className:'ratio__inner'},'CONVIoT'))];};var Works=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* withRouter */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkLink,props);});/* harmony default export */ __webpack_exports__["a"] = (Works);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/touch_blur.da2543d1.png";

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProgramTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProgramDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SectionDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SectionTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArticleTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DemoLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Helper_media__ = __webpack_require__(5);
var _templateObject=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tline-height: 1;\n\t',';\n\t',';\n'],['\n\tfont-size: ','px;\n\tline-height: 1;\n\t',';\n\t',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 48px;\n    // margin-top: 1em;\n  '],['\n    font-size: 48px;\n    // margin-top: 1em;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 32px;\n    // margin-top: 1em;\n  '],['\n    font-size: 32px;\n    // margin-top: 1em;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: ','px;\n  margin-top: 1em;\n'],['\n  font-size: ','px;\n  margin-top: 1em;\n']),_templateObject6=_taggedTemplateLiteral(['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tfont-weight: 100;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\tbackground-image: linear-gradient(0deg, #fff 100%, #fff);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 58%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\t',' ',';\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n'],['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tfont-weight: 100;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\tbackground-image: linear-gradient(0deg, #fff 100%, #fff);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 58%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\t',' ',';\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: ','px;\n  '],['\n    font-size: ','px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 1em;\n\tfont-weight: 100;\n\t',';\n\t',';\n'],['\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-size: ','px;\n\tline-height: 1;\n\tmargin-bottom: 1em;\n\tfont-weight: 100;\n\t',';\n\t',';\n']),_templateObject9=_taggedTemplateLiteral(['\n    font-size: 40px\n  '],['\n    font-size: 40px\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    font-size: 30px\n  '],['\n    font-size: 30px\n  ']),_templateObject11=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\n\t',';\n\t',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\n\t',';\n\t',';\n']),_templateObject12=_taggedTemplateLiteral(['\n    font-size: 16px\n  '],['\n    font-size: 16px\n  ']),_templateObject13=_taggedTemplateLiteral(['\n\tdisplay: block;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tmargin-bottom: 0.8em;\n\t',';\n\t',';\n'],['\n\tdisplay: block;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\tmargin-bottom: 0.8em;\n\t',';\n\t',';\n']),_templateObject14=_taggedTemplateLiteral(['\n    font-size: 18px\n  '],['\n    font-size: 18px\n  ']),_templateObject15=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.4;\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.4;\n\t',' ',';\n']),_templateObject16=_taggedTemplateLiteral(['\n  font-size: ','px;\n'],['\n  font-size: ','px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProgramTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(64),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject2),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject3));var ProgramDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)));var DemoLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].a(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(14)));var SectionTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(50.65),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject9),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject10));var SectionDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject12),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject12));var ArticleTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(20),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject14),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject12));var ArticleParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16)));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Konva = __webpack_require__(16);
var ReactFiberReconciler = __webpack_require__(240);
var ReactDOMComponentTree = __webpack_require__(242);
var HostConfig = __webpack_require__(243);

var _require = __webpack_require__(39),
    applyNodeProps = _require.applyNodeProps,
    toggleStrictMode = _require.toggleStrictMode;

var REACT_VERSION = '16.6.3';

if (React.version !== REACT_VERSION) {
  console.error('Version mismatch detected for react-konva and react. react-konva expects to have react version ' + REACT_VERSION + ', but it has version ' + React.version + '. Make sure versions are matched, otherwise, react-konva work is not guaranteed.');
}

var Stage = function (_React$Component) {
  _inherits(Stage, _React$Component);

  function Stage() {
    _classCallCheck(this, Stage);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Stage.prototype.componentDidMount = function componentDidMount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._stage = new Konva.Stage({
      width: this.props.width,
      height: this.props.height,
      container: this._tagRef
    });

    this._setRef(this._stage);

    applyNodeProps(this._stage, this.props);

    this._mountNode = KonvaRenderer.createContainer(this._stage);
    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype._setRef = function _setRef(value) {
    var forwardedRef = this.props.forwardedRef;

    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(value);
    } else {
      forwardedRef.current = value;
    }
  };

  Stage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(this._stage);
    applyNodeProps(this._stage, this.props, prevProps);

    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(null);
    KonvaRenderer.updateContainer(null, this._mountNode, this);
    this._stage.destroy();
  };

  Stage.prototype.getStage = function getStage() {
    return this._stage;
  };

  Stage.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    return React.createElement('div', {
      ref: function ref(_ref) {
        return _this2._tagRef = _ref;
      },
      accessKey: props.accessKey,
      className: props.className,
      role: props.role,
      style: props.style,
      tabIndex: props.tabIndex,
      title: props.title
    });
  };

  return Stage;
}(React.Component);

var KONVA_NODES = ['Layer', 'FastLayer', 'Group', 'Label', 'Rect', 'Circle', 'Ellipse', 'Wedge', 'Line', 'Sprite', 'Image', 'Text', 'TextPath', 'Star', 'Ring', 'Arc', 'Tag', 'Path', 'RegularPolygon', 'Arrow', 'Shape', 'Transformer'];

var TYPES = {};

KONVA_NODES.forEach(function (nodeName) {
  TYPES[nodeName] = nodeName;
});

var KonvaRenderer = ReactFiberReconciler(HostConfig);

KonvaRenderer.injectIntoDevTools({
  findFiberByHostInstance: ReactDOMComponentTree.getClosestInstanceFromNode,
  bundleType:  false ? 1 : 0,
  version: React.version,
  rendererPackageName: 'react-konva',
  getInspectorDataForViewTag: function getInspectorDataForViewTag() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log(args);
  }
});

/** API */

var StageWrap = React.forwardRef(function (props, ref) {
  return React.createElement(Stage, _extends({}, props, { forwardedRef: ref }));
});

module.exports = _extends({}, TYPES, {
  Stage: StageWrap,
  useStrictMode: toggleStrictMode
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toggleStrictMode = toggleStrictMode;
exports.applyNodeProps = applyNodeProps;
exports.updatePicture = updatePicture;
var propsToSkip = {
  children: true,
  ref: true,
  key: true,
  style: true,
  forwardedRef: true
};

var idWarningShowed = false;
var zIndexWarningShowed = false;
var useStrictMode = false;

var EVENTS_NAMESPACE = exports.EVENTS_NAMESPACE = '.react-konva-event';

function toggleStrictMode(value) {
  useStrictMode = value;
}

function applyNodeProps(instance, props) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!idWarningShowed && 'id' in props) {
    var message = 'ReactKonva: You are using "id" attribute for a Konva node. In some very rare cases it may produce bugs. Currently we recommend not to use it and use "name" attribute instead.\nYou are using id = "' + props.id + '".\nFor me info see: https://github.com/konvajs/react-konva/issues/119';
    console.warn(message);
    idWarningShowed = true;
  }

  if (!zIndexWarningShowed && 'zIndex' in props) {
    var _message = 'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor me info see: https://github.com/konvajs/react-konva/issues/194\n';
    console.warn(_message);
    zIndexWarningShowed = true;
  }

  var updatedProps = {};
  var hasUpdates = false;
  for (var key in oldProps) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var propChanged = oldProps[key] !== props[key];
    if (isEvent && propChanged) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      instance.off(eventName, oldProps[key]);
    }
    var toRemove = !props.hasOwnProperty(key);
    if (toRemove) {
      instance.setAttr(key, undefined);
    }
  }

  var strictUpdate = useStrictMode || props._useStrictMode;

  for (var key in props) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var toAdd = oldProps[key] !== props[key];
    if (isEvent && toAdd) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      if (props[key]) {
        instance.on(eventName + EVENTS_NAMESPACE, props[key]);
      }
    }
    if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
      hasUpdates = true;
      updatedProps[key] = props[key];
    }
  }

  if (hasUpdates) {
    instance.setAttrs(updatedProps);
    updatePicture(instance);
  }
}

function updatePicture(node) {
  var drawingNode = node.getLayer() || node.getStage();
  drawingNode && drawingNode.batchDraw();
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_konva__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_konva__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_konva__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"],["\n  position: relative;\n  width: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding-top: ","%;\n  background: ",";\n"],["\n  position: relative;\n  width: 100%;\n  padding-top: ","%;\n  background: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  ","\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  ","\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ConceptWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var ConceptRep=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2,100/1.618,function(props){return props.color;});ConceptRep.Inner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Stage"])(_templateObject3,function(props){return props.filter?"\n  & canvas {\n    -webkit-filter: url(\"#goo\");\n    filter: url(\"#goo\");\n  }":null;});var Clip=function(_React$Component){_inherits(Clip,_React$Component);function Clip(){_classCallCheck(this,Clip);var _this=_possibleConstructorReturn(this,(Clip.__proto__||Object.getPrototypeOf(Clip)).call(this));_this.state={ratio:0};return _this;}_createClass(Clip,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var duration=2500;var anim=new __WEBPACK_IMPORTED_MODULE_4_konva___default.a.Animation(function(frame){var tick=frame.time%duration;var ratio=0;if(tick<duration-1000){ratio=tick/(duration-1000);}else{ratio=1;}_this2.setState({ratio:ratio});});anim.start();}},{key:"render",value:function render(){var _props=this.props,width=_props.width,height=_props.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptRep.Inner,{width:width,height:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Layer"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{x:0,y:height*0.98,width:width*this.state.ratio,height:height*0.02,fill:"#f94c1e"})));}}]);return Clip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Concept=function(_React$Component2){_inherits(Concept,_React$Component2);function Concept(){_classCallCheck(this,Concept);var _this3=_possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).call(this));_this3.refCallback=function(element){if(element){_this3.setState({size:element.getBoundingClientRect()});}};_this3.ref=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this3.state={size:{bottom:0,height:0,left:0,right:0,top:0,width:0,x:0,y:0}};return _this3;}_createClass(Concept,[{key:"componentDidMount",value:function componentDidMount(){var _this4=this;this.refCallback(this.ref.current);window.addEventListener("resize",function(){_this4.refCallback(_this4.ref.current);});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptRep,{color:this.props.color,ref:this.ref},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Clip,{width:this.state.size.width,height:this.state.size.height})));}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42);
module.exports = __webpack_require__(47);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(43).enable();
  window.Promise = __webpack_require__(45);
}

// fetch() polyfill for making API calls.
__webpack_require__(46);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(26);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(26);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_geometria_light_webfont_woff__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_geometria_light_webfont_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fonts_geometria_light_webfont_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_grid_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_layout_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_index_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_headers_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_headers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_headers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Home__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NDF__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Conviot__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Twitch__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Jiggle__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Works__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Helper_media__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__registerServiceWorker__ = __webpack_require__(300);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tfont-family: \'Raleway\', sans-serif;\n\tfont-size: ','px;\n\tmargin-bottom: 1em;\n\t',';\n'],['\n\tfont-family: \'Raleway\', sans-serif;\n\tfont-size: ','px;\n\tmargin-bottom: 1em;\n\t',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 32px;\n  '],['\n    font-size: 32px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SeeOhterHeader=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_17__Helper_pxToVw__["a" /* default */])(64),__WEBPACK_IMPORTED_MODULE_16__Helper_media__["a" /* default */].md(_templateObject2));window.mobilecheck=function(){var check=false;(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check=true;})(navigator.userAgent||navigator.vendor||window.opera);return check;};var Root=function(_React$Component){_inherits(Root,_React$Component);function Root(props){_classCallCheck(this,Root);var _this=_possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).call(this,props));_this.handleScroll=_this.handleScroll.bind(_this);_this.handleResize=_this.handleResize.bind(_this);_this.state={scrollTop:0,scrollDirection:'down',window_size:{w:window.innerWidth,h:window.innerHeight}};return _this;}_createClass(Root,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.addEventListener('scroll',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.throttle(function(e){return _this2.handleScroll(e);},30));window.addEventListener('resize',__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.throttle(function(e){return _this2.handleResize(e);},10));}},{key:'handleResize',value:function handleResize(e){this.setState({window_size:{w:window.innerWidth,h:window.innerHeight}});}},{key:'handleScroll',value:function handleScroll(e){var delta=15;this.setState(function(prevState){return Object.assign({},prevState,{scrollTop:document.documentElement&&document.documentElement.scrollTop||document.body.scrollTop,scrollDirection:function(){var differ=prevState.scrollTop-document.body.scrollTop;if(differ>delta)return'up';else if(differ<-delta)return'down';else return prevState.scrollDirection;}()});});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{exact:true,path:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Home__["a" /* default */],{scrolltop:_this3.state.scrollTop});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:'/jiggle',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Jiggle__["a" /* default */],{scrolltop:_this3.state.scrollTop,scrolldirection:_this3.state.scrollDirection,windowSize:_this3.state.window_size});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:'/twitch',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Twitch__["a" /* default */],{scrolltop:_this3.state.scrollTop,scrolldirection:_this3.state.scrollDirection});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:'/NDF',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NDF__["a" /* default */],{scrolltop:_this3.state.scrollTop,scrolldirection:_this3.state.scrollDirection});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:'/CONVIoT',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Conviot__["a" /* default */],{scrolltop:_this3.state.scrollTop,scrolldirection:_this3.state.scrollDirection});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:'/:work',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SeeOhterHeader,{className:'col-xs-24'},'See Other Works')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Works__["a" /* default */],{shrink:true}))));}})));}}]);return Root;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root,null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_18__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(13),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;
if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.6.3",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}};X.unstable_ConcurrentMode=x;X.unstable_Profiler=u;var Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(13),ba=__webpack_require__(17);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c=a._debugOwner,d=a._debugSource,e=mc(a.type);var f=null;c&&(f=mc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Yb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function xc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
xc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function yc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function zc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ac(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=zc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&yc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=zc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,zc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=A.getPooled(Gc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Hc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Gc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Wc=A.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=A}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function G(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function de(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=de(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+zc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:zc(c)}}
function ie(a,b){var c=zc(b.value),d=zc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ge(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var He=[],Ie=-1;function H(a){0>Ie||(a.current=He[Ie],He[Ie]=null,Ie--)}function I(a,b){Ie++;He[Ie]=a.current;a.current=b}var Je={},J={current:Je},K={current:!1},Ke=Je;
function Le(a,b){var c=a.type.contextTypes;if(!c)return Je;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Me(a){H(K,a);H(J,a)}function Ne(a){H(K,a);H(J,a)}
function Oe(a,b,c){J.current!==Je?t("168"):void 0;I(J,b,a);I(K,c,a)}function Pe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Qe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Je;Ke=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Re(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Pe(a,b,Ke),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}var Se=null,Te=null;function Ue(a){return function(b){try{return a(b)}catch(c){}}}
function Ve(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Se=Ue(function(a){return b.onCommitFiberRoot(c,a)});Te=Ue(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function We(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function M(a,b,c,d){return new We(a,b,c,d)}
function Xe(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ye(a){if("function"===typeof a)return Xe(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function Ze(a,b){var c=a.alternate;null===c?(c=M(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function $e(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Xe(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return af(c.children,e,f,b);case fc:return bf(c,e|3,f,b);case bc:return bf(c,e|2,f,b);case cc:return a=M(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=M(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=M(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function af(a,b,c,d){a=M(7,a,d,b);a.expirationTime=c;return a}function bf(a,b,c,d){a=M(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function cf(a,b,c){a=M(6,a,null,b);a.expirationTime=c;return a}
function df(a,b,c){b=M(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ef(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);ff(b,a)}
function gf(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c>=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);ff(b,a)}
function hf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function ff(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var jf=!1;
function kf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function lf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function nf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function of(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=kf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=kf(a.memoizedState),e=c.updateQueue=kf(c.memoizedState)):d=a.updateQueue=lf(e):null===e&&(e=c.updateQueue=lf(d));null===e||d===e?nf(d,b):null===d.lastUpdate||null===e.lastUpdate?(nf(d,b),nf(e,b)):(nf(d,b),e.lastUpdate=b)}
function pf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=kf(a.memoizedState):qf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function qf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=lf(b));return b}
function rf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:jf=!0}return d}
function sf(a,b,c,d,e){jf=!1;b=qf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var q=k.expirationTime;q<e?(null===m&&(m=k,null===g&&(f=l)),h<q&&(h=q)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function tf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);uf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;uf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function uf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function vf(a,b){return{value:a,source:b,stack:nc(b)}}var wf={current:null},xf=null,yf=null,zf=null;function Af(a,b){var c=a.type._context;I(wf,c._currentValue,a);c._currentValue=b}function Bf(a){var b=wf.current;H(wf,a);a.type._context._currentValue=b}function Cf(a){xf=a;zf=yf=null;a.firstContextDependency=null}
function Df(a,b){if(zf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)zf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===yf?(null===xf?t("293"):void 0,xf.firstContextDependency=yf=b):yf=yf.next=b}return a._currentValue}var Ef={},N={current:Ef},Ff={current:Ef},Gf={current:Ef};function Hf(a){a===Ef?t("174"):void 0;return a}
function If(a,b){I(Gf,b,a);I(Ff,a,a);I(N,Ef,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}H(N,a);I(N,b,a)}function Jf(a){H(N,a);H(Ff,a);H(Gf,a)}function Kf(a){Hf(Gf.current);var b=Hf(N.current);var c=me(b,a.type);b!==c&&(I(Ff,a,a),I(N,c,a))}function Lf(a){Ff.current===a&&(H(N,a),H(Ff,a))}
function O(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Nf=Xb.ReactCurrentOwner,Of=(new aa.Component).refs;
function Pf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Uf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Qf();c=Rf(c,a);var d=mf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Sf();of(a,d);Tf(a,c)}};function Vf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Wf(a,b,c){var d=!1,e=Je;var f=b.contextType;"object"===typeof f&&null!==f?f=Nf.currentDispatcher.readContext(f):(e=L(b)?Ke:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Le(a,e):Je);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Uf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Xf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Uf.enqueueReplaceState(b,b.state,null)}
function Yf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Of;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Nf.currentDispatcher.readContext(f):(f=L(b)?Ke:J.current,e.context=Le(a,f));f=a.updateQueue;null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Pf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Uf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Zf=Array.isArray;
function $f(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Of&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function ag(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function bg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=$f(a,b,c),d.return=a,d;d=$e(c.type,c.key,c.props,null,a.mode,d);d.ref=$f(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=af(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=$e(b.type,b.key,b.props,null,a.mode,c),c.ref=$f(a,null,b),c.return=a,c;case $b:return b=df(b,a.mode,c),b.return=a,b}if(Zf(b)||
lc(b))return b=af(b,a.mode,c,null),b.return=a,b;ag(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(Zf(c)||lc(c))return null!==e?null:m(a,b,c,d,null);ag(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Zf(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);ag(b,d)}return null}function B(e,g,h,k){for(var l=null,r=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=x(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===r?l=v:r.sibling=v;r=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=q(e,h[u],k))g=f(m,g,u),null===r?l=m:r.sibling=m,r=m;return l}for(m=d(e,m);u<h.length;u++)if(p=z(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===r?l=p:r.sibling=p,r=p;a&&m.forEach(function(a){return b(e,a)});return l}function Q(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,r=g,u=g=0,p=null,v=h.next();null!==r&&!v.done;u++,v=h.next()){r.index>u?(p=r,r=null):p=r.sibling;var y=x(e,r,v.value,k);if(null===y){r||(r=p);break}a&&r&&null===y.alternate&&b(e,r);g=f(y,g,u);null===m?l=y:m.sibling=y;m=y;r=p}if(v.done)return c(e,r),l;if(null===r){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(r=d(e,r);!v.done;u++,v=h.next())v=z(r,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&r.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=$f(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=af(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=$e(f.type,f.key,f.props,null,a.mode,h),h.ref=$f(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=cf(f,a.mode,h),d.return=a,a=d),g(a);if(Zf(f))return B(a,d,f,h);if(lc(f))return Q(a,d,f,h);l&&ag(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var cg=bg(!0),dg=bg(!1),eg=null,fg=null,gg=!1;
function hg(a,b){var c=M(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function ig(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function jg(a){if(gg){var b=fg;if(b){var c=b;if(!ig(a,b)){b=Fe(c);if(!b||!ig(a,b)){a.effectTag|=2;gg=!1;eg=a;return}hg(eg,c)}eg=a;fg=Ge(b)}else a.effectTag|=2,gg=!1,eg=a}}function kg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;eg=a}function lg(a){if(a!==eg)return!1;if(!gg)return kg(a),gg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=fg;b;)hg(a,b),b=Fe(b);kg(a);fg=eg?Fe(a.stateNode):null;return!0}function mg(){fg=eg=null;gg=!1}var ng=Xb.ReactCurrentOwner;
function P(a,b,c,d){b.child=null===a?dg(b,null,c,d):cg(b,a.child,c,d)}function og(a,b,c,d,e){c=c.render;var f=b.ref;Cf(b,e);d=c(d,f);b.effectTag|=1;P(a,b,d,e);return b.child}
function pg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Xe(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,qg(a,b,g,d,e,f);a=$e(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return rg(a,b,f);b.effectTag|=1;a=Ze(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function qg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?rg(a,b,f):sg(a,b,c,d,f)}function tg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function sg(a,b,c,d,e){var f=L(c)?Ke:J.current;f=Le(b,f);Cf(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function ug(a,b,c,d,e){if(L(c)){var f=!0;Qe(b)}else f=!1;Cf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Wf(b,c,d,e),Yf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l);jf=!1;var x=b.memoizedState;k=g.state=x;var z=b.updateQueue;null!==z&&(sf(b,z,d,g,e),k=b.memoizedState);h!==d||x!==k||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),k=b.memoizedState),(h=jf||Vf(b,c,h,d,x,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:O(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l)),m=c.getDerivedStateFromProps,
(q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l),jf=!1,k=b.memoizedState,x=g.state=k,z=b.updateQueue,null!==z&&(sf(b,z,d,g,e),x=b.memoizedState),h!==d||k!==x||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),x=b.memoizedState),(m=jf||Vf(b,c,h,d,k,x,l))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vg(a,b,c,d,f,e)}
function vg(a,b,c,d,e,f){tg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Re(b,c,!1),rg(a,b,f);d=b.stateNode;ng.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=cg(b,a.child,null,f),b.child=cg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&Re(b,c,!0);return b.child}function wg(a){var b=a.stateNode;b.pendingContext?Oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Oe(a,b.context,!1);If(a,b.containerInfo)}
function xg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;null===a?g?(g=e.fallback,e=af(null,d,0,null),0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=af(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=dg(b,null,e.children,c):null!==a.memoizedState?(d=a.child,a=d.sibling,g?(c=e.fallback,e=Ze(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==b.memoizedState?
b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Ze(a,c,a.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=cg(b,d.child,e.children,c)):(a=a.child,g?(g=e.fallback,e=af(null,d,0,null),e.child=a,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=af(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=cg(b,a,e.children,c));b.memoizedState=f;b.child=c;return d}
function rg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=Ze(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ze(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function yg(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!K.current&&d<c){switch(b.tag){case 3:wg(b);mg();break;case 5:Kf(b);break;case 1:L(b.type)&&Qe(b);break;case 4:If(b,b.stateNode.containerInfo);break;case 10:Af(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return xg(a,b,c);b=rg(a,b,c);return null!==b?b.sibling:null}}return rg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Le(b,J.current);Cf(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(L(d)){var f=!0;Qe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Pf(b,d,g,a);e.updater=Uf;b.stateNode=e;e._reactInternalFiber=b;Yf(b,d,a,c);b=vg(null,b,d,!0,f,c)}else b.tag=0,P(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Mf(e);b.type=a;e=b.tag=Ye(a);f=O(a,f);g=void 0;switch(e){case 0:g=sg(null,b,a,f,c);break;case 1:g=ug(null,b,a,f,c);break;case 11:g=og(null,b,a,f,c);break;case 14:g=pg(null,b,a,O(a.type,f),d,c);break;default:t("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),sg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),ug(a,b,d,
e,c);case 3:wg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;sf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)mg(),b=rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)fg=Ge(b.stateNode.containerInfo),eg=b,e=gg=!0;e?(b.effectTag|=2,b.child=dg(b,null,d,c)):(P(a,b,d,c),mg());b=b.child}return b;case 5:return Kf(b),null===a&&jg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),tg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&jg(b),null;case 13:return xg(a,b,c);case 4:return If(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=cg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),og(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,c),b.child;case 12:return P(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Af(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=rg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=mf(c);k.tag=2;of(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Cf(b,c),e=Df(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=O(e.type,b.pendingProps),pg(a,b,e,f,d,c);case 15:return qg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Qe(b)):
a=!1,Cf(b,c),Wf(b,d,e,c),Yf(b,d,e,c),vg(null,b,d,!0,a,c);default:t("156")}}function zg(a){a.effectTag|=4}var Ag=void 0,Bg=void 0,Fg=void 0,Gg=void 0;Ag=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Bg=function(){};
Fg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Hf(N.current);a=null;switch(c){case "input":f=Ac(g,f);d=Ac(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&zg(b)}};Gg=function(a,b,c,d){c!==d&&zg(b)};
function Hg(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Ig(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Jg(a,c)}else b.current=null}
function Kg(a){"function"===typeof Te&&Te(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Jg(e,f)}}c=c.next}while(c!==b)}break;case 1:Ig(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Jg(a,f)}break;case 5:Ig(a);break;case 4:Lg(a)}}
function Mg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Ng(a){a:{for(var b=a.return;null!==b;){if(Mg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Mg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Lg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Kg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Kg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Og(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ha]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);we(a,e);b=we(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?te(c,h):"dangerouslySetInnerHTML"===g?oe(c,h):"children"===g?pe(c,h):yc(c,g,h,b)}switch(a){case "input":Dc(c,d);break;case "textarea":ie(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?fe(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?fe(c,!!d.multiple,d.defaultValue,!0):fe(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Qf()));if(null!==a)a:for(b=c=a;;){if(5===
b.tag)a=b.stateNode,d?a.style.display="none":(a=b.stateNode,f=b.memoizedProps.style,f=void 0!==f&&null!==f&&f.hasOwnProperty("display")?f.display:null,a.style.display=se("display",f));else if(6===b.tag)b.stateNode.nodeValue=d?"":b.memoizedProps;else if(13===b.tag&&null!==b.memoizedState){a=b.child.sibling;a.return=b;b=a;continue}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===c)break a;for(;null===b.sibling;){if(null===b.return||b.return===c)break a;b=b.return}b.sibling.return=
b.return;b=b.sibling}break;case 17:break;default:t("163")}}function Pg(a,b,c){c=mf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qg(d);Hg(a,b)};return c}
function Rg(a,b,c){c=mf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Sg?Sg=new Set([this]):Sg.add(this));var c=b.value,e=b.stack;Hg(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Tg(a){switch(a.tag){case 1:L(a.type)&&Me(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Jf(a),Ne(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Lf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Jf(a),null;case 10:return Bf(a),null;default:return null}}
var Ug={readContext:Df},Vg=Xb.ReactCurrentOwner,Wg=1073741822,Xg=0,Yg=!1,R=null,S=null,T=0,Zg=-1,$g=!1,U=null,ah=!1,bh=null,ch=null,Sg=null;function dh(){if(null!==R)for(var a=R.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Me(b);break;case 3:Jf(b);Ne(b);break;case 5:Lf(b);break;case 4:Jf(b);break;case 10:Bf(b)}a=a.return}S=null;T=0;Zg=-1;$g=!1;R=null}function Sf(){null!==ch&&(ba.unstable_cancelCallback(bh),ch())}
function eh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){R=a;a:{var e=b;b=a;var f=T;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Me(b);break;case 3:Jf(b);Ne(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)lg(b),b.effectTag&=-3;Bg(b);break;case 5:Lf(b);var h=Hf(Gf.current);f=b.type;if(null!==e&&null!=b.stateNode)Fg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=Hf(N.current);if(lg(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,q=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":G("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)G(bb[l],e);break;case "source":G("error",e);break;case "img":case "image":case "link":G("error",e);G("load",e);break;case "form":G("reset",e);G("submit",e);break;case "details":G("toggle",e);break;case "input":Bc(e,m);G("invalid",e);xe(q,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};G("invalid",e);xe(q,"onChange");break;case "textarea":he(e,m),G("invalid",e),xe(q,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(q,f));switch(h){case "input":Vb(e);Fc(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&zg(b)}else{m=b;e=f;q=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof q.is?l=l.createElement(e,{is:q.is}):(l=l.createElement(e),"select"===e&&q.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Ag(e,b,!1,!1);q=e;l=f;m=g;var x=h,z=we(l,m);switch(l){case "iframe":case "object":G("load",
q);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)G(bb[h],q);h=m;break;case "source":G("error",q);h=m;break;case "img":case "image":case "link":G("error",q);G("load",q);h=m;break;case "form":G("reset",q);G("submit",q);h=m;break;case "details":G("toggle",q);h=m;break;case "input":Bc(q,m);h=Ac(q,m);G("invalid",q);xe(x,"onChange");break;case "option":h=ee(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});G("invalid",q);xe(x,"onChange");break;case "textarea":he(q,
m);h=ge(q,m);G("invalid",q);xe(x,"onChange");break;default:h=m}ve(l,h);k=void 0;var B=l,Q=q,v=h;for(k in v)if(v.hasOwnProperty(k)){var r=v[k];"style"===k?te(Q,r):"dangerouslySetInnerHTML"===k?(r=r?r.__html:void 0,null!=r&&oe(Q,r)):"children"===k?"string"===typeof r?("textarea"!==B||""!==r)&&pe(Q,r):"number"===typeof r&&pe(Q,""+r):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=r&&xe(x,k):null!=r&&yc(Q,k,r,z))}switch(l){case "input":Vb(q);
Fc(q,m,!1);break;case "textarea":Vb(q);je(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+zc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?fe(h,!!m.multiple,q,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=ye)}(g=Be(f,g))&&zg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Gg(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=Hf(Gf.current),Hf(N.current),lg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&zg(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;R=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g!==f||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Jf(b);Bg(b);break;case 10:Bf(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Me(b);break;default:t("156")}R=null}b=a;if(1===T||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==R)return R;null!==c&&0===(c.effectTag&1024)&&(null===
c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Tg(a,T);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function fh(a){var b=yg(a.alternate,a,T);a.memoizedProps=a.pendingProps;null===b&&(b=eh(a));Vg.current=null;return b}
function gh(a,b){Yg?t("243"):void 0;Sf();Yg=!0;Vg.currentDispatcher=Ug;var c=a.nextExpirationTimeToWorkOn;if(c!==T||a!==S||null===R)dh(),S=a,T=c,R=Ze(S.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==R&&!hh();)R=fh(R);else for(;null!==R;)R=fh(R)}catch(B){if(zf=yf=xf=null,null===R)d=!0,Qg(B);else{null===R?t("271"):void 0;var e=R,f=e.return;if(null===f)d=!0,Qg(B);else{a:{var g=a,h=f,k=e,l=B;f=T;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var q=-1,x=-1;do{if(13===l.tag){var z=l.alternate;if(null!==z&&(z=z.memoizedState,null!==z)){x=10*(1073741822-z.timedOutAt);break}z=l.pendingProps.maxDuration;if("number"===typeof z)if(0>=z)q=0;else if(-1===q||z<q)q=z}l=l.return}while(null!==l);l=h;do{if(z=13===l.tag)z=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(z){h=ih.bind(null,g,l,k,0===(l.mode&1)?1073741823:f);m.then(h,h);if(0===(l.mode&1)){l.effectTag|=64;k.effectTag&=-1957;
1===k.tag&&null===k.alternate&&(k.tag=17);k.expirationTime=f;break a}-1===q?g=1073741823:(-1===x&&(x=10*(1073741822-hf(g,f))-5E3),g=x+q);0<=g&&Zg<g&&(Zg=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}$g=!0;l=vf(l,k);g=h;do{switch(g.tag){case 3:k=
l;g.effectTag|=2048;g.expirationTime=f;f=Pg(g,k,f);pf(g,f);break a;case 1:if(k=l,h=g.type,m=g.stateNode,0===(g.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==m&&"function"===typeof m.componentDidCatch&&(null===Sg||!Sg.has(m)))){g.effectTag|=2048;g.expirationTime=f;f=Rg(g,k,f);pf(g,f);break a}}g=g.return}while(null!==g)}R=eh(e);continue}}}break}while(1);Yg=!1;zf=yf=xf=Vg.currentDispatcher=null;if(d)S=null,a.finishedWork=null;else if(null!==R)a.finishedWork=null;else{d=a.current.alternate;
null===d?t("281"):void 0;S=null;if($g){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){gf(a,c);jh(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;jh(a,d,c,b,-1);return}}b&&-1!==Zg?(gf(a,c),b=10*(1073741822-hf(a,c)),b<Zg&&(Zg=b),b=10*(1073741822-Qf()),b=Zg-b,jh(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=c,a.finishedWork=d)}}
function Jg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Sg||!Sg.has(d))){a=vf(b,a);a=Rg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}break;case 3:a=vf(b,a);a=Pg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}c=c.return}3===a.tag&&(c=vf(b,a),c=Pg(a,c,1073741823),of(a,c),Tf(a,1073741823))}
function Rf(a,b){0!==Xg?a=Xg:Yg?a=ah?1073741823:T:b.mode&1?(a=kh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==S&&a===T&&--a):a=1073741823;kh&&(0===lh||a<lh)&&(lh=a);return a}
function ih(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d<=e&&d>=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g>f)a.latestPingedTime=f;ff(f,a)}else e=Qf(),e=Rf(e,b),ef(a,e);0!==(b.mode&1)&&a===S&&T===d&&(S=null);mh(b,e);0===(b.mode&1)&&(mh(c,e),1===c.tag&&null!==c.stateNode&&(b=mf(e),b.tag=2,of(c,b)));c=a.expirationTime;0!==c&&nh(a,c)}
function mh(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Tf(a,b){a=mh(a,b);null!==a&&(!Yg&&0!==T&&b>T&&dh(),ef(a,b),Yg&&!ah&&S===a||nh(a,a.expirationTime),oh>ph&&(oh=0,t("185")))}function qh(a,b,c,d,e){var f=Xg;Xg=1073741823;try{return a(b,c,d,e)}finally{Xg=f}}var rh=null,V=null,sh=0,th=void 0,W=!1,uh=null,X=0,lh=0,vh=!1,wh=null,Z=!1,xh=!1,kh=!1,yh=null,zh=ba.unstable_now(),Ah=1073741822-(zh/10|0),Bh=Ah,ph=50,oh=0,Ch=null;function Dh(){Ah=1073741822-((ba.unstable_now()-zh)/10|0)}
function Eh(a,b){if(0!==sh){if(b<sh)return;null!==th&&ba.unstable_cancelCallback(th)}sh=b;a=ba.unstable_now()-zh;th=ba.unstable_scheduleCallback(Fh,{timeout:10*(1073741822-b)-a})}function jh(a,b,c,d,e){a.expirationTime=d;0!==e||hh()?0<e&&(a.timeoutHandle=De(Gh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Gh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Dh();Bh=Ah;Hh(a,c)}function Qf(){if(W)return Bh;Ih();if(0===X||1===X)Dh(),Bh=Ah;return Bh}
function nh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===V?(rh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=rh)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?xh&&(uh=a,X=1073741823,Jh(a,1073741823,!1)):1073741823===b?Kh(1073741823,!1):Eh(a,b))}
function Ih(){var a=0,b=null;if(null!==V)for(var c=V,d=rh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?t("244"):void 0;if(d===d.nextScheduledRoot){rh=V=d.nextScheduledRoot=null;break}else if(d===rh)rh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=rh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===V)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}uh=b;X=a}var Lh=!1;function hh(){return Lh?!0:ba.unstable_shouldYield()?Lh=!0:!1}function Fh(){try{if(!hh()&&null!==rh){Dh();var a=rh;do{var b=a.expirationTime;0!==b&&Ah<=b&&(a.nextExpirationTimeToWorkOn=Ah);a=a.nextScheduledRoot}while(a!==rh)}Kh(0,!0)}finally{Lh=!1}}
function Kh(a,b){Ih();if(b)for(Dh(),Bh=Ah;null!==uh&&0!==X&&a<=X&&!(Lh&&Ah>X);)Jh(uh,X,Ah>X),Ih(),Dh(),Bh=Ah;else for(;null!==uh&&0!==X&&a<=X;)Jh(uh,X,!1),Ih();b&&(sh=0,th=null);0!==X&&Eh(uh,X);oh=0;Ch=null;if(null!==yh)for(a=yh,yh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){vh||(vh=!0,wh=d)}}if(vh)throw a=wh,wh=null,vh=!1,a;}function Hh(a,b){W?t("253"):void 0;uh=a;X=b;Jh(a,b,!1);Kh(1073741823,!1)}
function Jh(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Mh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),gh(a,c),d=a.finishedWork,null!==d&&(hh()?a.finishedWork=d:Mh(a,d,b)))}else d=a.finishedWork,null!==d?Mh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),gh(a,c),d=a.finishedWork,null!==d&&Mh(a,d,b));W=!1}
function Mh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===yh?yh=[d]:yh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Ch?oh++:(Ch=a,oh=0);ah=Yg=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ef(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ef(a,d)):d>e&&ef(a,d));ff(0,a);Vg.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in e)var f={start:e.selectionStart,
end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,q=-1,x=0,z=0,B=e,Q=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(q=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;Q=B;B=v}for(;;){if(B===e)break b;Q===f&&
++x===h&&(m=l);Q===k&&++z===g&&(q=l);if(null!==(v=B.nextSibling))break;B=Q;Q=B.parentNode}B=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(U=d;null!==U;){e=!1;f=void 0;try{for(;null!==U;){if(U.effectTag&256)a:{var r=U.alternate;h=U;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==r){var u=r.memoizedProps,y=r.memoizedState,Y=h.stateNode,Th=Y.getSnapshotBeforeUpdate(h.elementType===h.type?
u:O(h.type,u),y);Y.__reactInternalSnapshotBeforeUpdate=Th}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}U=U.nextEffect}}catch(db){e=!0,f=db}e&&(null===U?t("178"):void 0,Jg(U,f),null!==U&&(U=U.nextEffect))}for(U=d;null!==U;){r=!1;u=void 0;try{for(;null!==U;){var w=U.effectTag;w&16&&pe(U.stateNode,"");if(w&128){var C=U.alternate;if(null!==C){var p=C.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(w&14){case 2:Ng(U);U.effectTag&=-3;break;case 6:Ng(U);U.effectTag&=
-3;Og(U.alternate,U);break;case 4:Og(U.alternate,U);break;case 8:y=U,Lg(y),y.return=null,y.child=null,y.alternate&&(y.alternate.child=null,y.alternate.return=null)}U=U.nextEffect}}catch(db){r=!0,u=db}r&&(null===U?t("178"):void 0,Jg(U,u),null!==U&&(U=U.nextEffect))}p=Ae;C=Td();w=p.focusedElem;u=p.selectionRange;if(C!==w&&w&&w.ownerDocument&&Sd(w.ownerDocument.documentElement,w)){null!==u&&Ud(w)&&(C=u.start,p=u.end,void 0===p&&(p=C),"selectionStart"in w?(w.selectionStart=C,w.selectionEnd=Math.min(p,
w.value.length)):(p=(C=w.ownerDocument||document)&&C.defaultView||window,p.getSelection&&(p=p.getSelection(),y=w.textContent.length,r=Math.min(u.start,y),u=void 0===u.end?r:Math.min(u.end,y),!p.extend&&r>u&&(y=u,u=r,r=y),y=Rd(w,r),Y=Rd(w,u),y&&Y&&(1!==p.rangeCount||p.anchorNode!==y.node||p.anchorOffset!==y.offset||p.focusNode!==Y.node||p.focusOffset!==Y.offset)&&(C=C.createRange(),C.setStart(y.node,y.offset),p.removeAllRanges(),r>u?(p.addRange(C),p.extend(Y.node,Y.offset)):(C.setEnd(Y.node,Y.offset),
p.addRange(C))))));C=[];for(p=w;p=p.parentNode;)1===p.nodeType&&C.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof w.focus&&w.focus();for(w=0;w<C.length;w++)p=C[w],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(U=d;null!==U;){d=!1;w=void 0;try{for(C=c;null!==U;){var Fb=U.effectTag;if(Fb&36){var Gb=U.alternate;p=U;r=C;switch(p.tag){case 0:case 11:case 15:break;case 1:var wc=p.stateNode;if(p.effectTag&4)if(null===Gb)wc.componentDidMount();
else{var ci=p.elementType===p.type?Gb.memoizedProps:O(p.type,Gb.memoizedProps);wc.componentDidUpdate(ci,Gb.memoizedState,wc.__reactInternalSnapshotBeforeUpdate)}var Cg=p.updateQueue;null!==Cg&&tf(p,Cg,wc,r);break;case 3:var Dg=p.updateQueue;if(null!==Dg){u=null;if(null!==p.child)switch(p.child.tag){case 5:u=p.child.stateNode;break;case 1:u=p.child.stateNode}tf(p,Dg,u,r)}break;case 5:var di=p.stateNode;null===Gb&&p.effectTag&4&&Be(p.type,p.memoizedProps)&&di.focus();break;case 6:break;case 4:break;
case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=U.ref;if(null!==Ic){var Eg=U.stateNode;switch(U.tag){case 5:var ce=Eg;break;default:ce=Eg}"function"===typeof Ic?Ic(ce):Ic.current=ce}}U=U.nextEffect}}catch(db){d=!0,w=db}d&&(null===U?t("178"):void 0,Jg(U,w),null!==U&&(U=U.nextEffect))}Yg=ah=!1;"function"===typeof Se&&Se(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Sg=null);a.expirationTime=b;a.finishedWork=null}
function Qg(a){null===uh?t("246"):void 0;uh.expirationTime=0;vh||(vh=!0,wh=a)}function Nh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Kh(1073741823,!1)}}function Oh(a,b){if(Z&&!xh){xh=!0;try{return a(b)}finally{xh=!1}}return a(b)}function Ph(a,b,c){if(kh)return a(b,c);Z||W||0===lh||(Kh(lh,!1),lh=0);var d=kh,e=Z;Z=kh=!0;try{return a(b,c)}finally{kh=d,(Z=e)||W||Kh(1073741823,!1)}}
function Qh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(L(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(L(h)){c=Pe(c,h,g);break a}}c=g}else c=Je;null===b.context?b.context=c:b.pendingContext=c;b=e;e=mf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Sf();of(f,e);Tf(f,d);return d}function Rh(a,b,c,d){var e=b.current,f=Qf();e=Rf(f,e);return Qh(a,b,c,e,d)}function Sh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Uh(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Dc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function Vh(a){var b=1073741822-25*(((1073741822-Qf()+500)/25|0)+1);b>=Wg&&(b=Wg-1);this._expirationTime=Wg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Vh.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Wh;Qh(a,b,null,c,d._onCommit);return d};
Vh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Vh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Hh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Vh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Wh(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Wh.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Wh.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function Xh(a,b,c){b=M(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Xh.prototype.render=function(a,b){var c=this._internalRoot,d=new Wh;b=void 0===b?null:b;null!==b&&d.then(b);Rh(a,c,null,d._onCommit);return d};Xh.prototype.unmount=function(a){var b=this._internalRoot,c=new Wh;a=void 0===a?null:a;null!==a&&c.then(a);Rh(null,b,null,c._onCommit);return c};Xh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Wh;c=void 0===c?null:c;null!==c&&e.then(c);Rh(b,d,a,e._onCommit);return e};
Xh.prototype.createBatch=function(){var a=new Vh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Yh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Nh;Lb=Ph;Mb=function(){W||0===lh||(Kh(lh,!1),lh=0)};
function Zh(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Xh(a,!1,b)}
function $h(a,b,c,d,e){Yh(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Sh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Zh(c,d);if("function"===typeof e){var h=e;e=function(){var a=Sh(f._internalRoot);h.call(a)}}Oh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Sh(f._internalRoot)}
function ai(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Yh(b)?void 0:t("200");return Uh(a,b,null,c)}
var bi={createPortal:ai,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return $h(null,a,b,!0,c)},render:function(a,b,c){return $h(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return $h(a,b,c,!1,d)},unmountComponentAtNode:function(a){Yh(a)?
void 0:t("40");return a._reactRootContainer?(Oh(function(){$h(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ai.apply(void 0,arguments)},unstable_batchedUpdates:Nh,unstable_interactiveUpdates:Ph,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return qh(a,b)}finally{Z=c,Kh(1073741823,!1)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{qh(a)}finally{(Z=b)||W||Kh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]},unstable_createRoot:function(a,b){Yh(a)?void 0:t("299","unstable_createRoot");return new Xh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Ve(n({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.6.3",rendererPackageName:"react-dom"});
var ei={default:bi},fi=ei&&bi||ei;module.exports=fi.default||fi;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.11.3
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=c()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=g.next=g.previous=g;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=g,p());b=c.previous;b.next=c.previous=g;g.next=c;g.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,f=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),e=!1;if(0>=P-c)if(-1!==b&&b<=c)e=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=c,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(h){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var e=d;do{if(e.expirationTime>b){c=e;break}e=e.next}while(e!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var c=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=c,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==d&&d.expirationTime<l||w())};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(54);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(28);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(19);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(62);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(66);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(68);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(70);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(72);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(22);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(33);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(22);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(76);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/geometria-light-webfont.d282bb5e.woff";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logo_svg__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_GitHub_Mark_png__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_GitHub_Mark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_GitHub_Mark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_google_scholar_icon_png__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_google_scholar_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_google_scholar_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_In_Black_0p5in_R_png__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_In_Black_0p5in_R_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_In_Black_0p5in_R_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_jiggle_mp4__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_jiggle_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_jiggle_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_profile2_png__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_profile2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_profile2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_logo_shadow_png__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_logo_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_logo_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__home_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__home_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Helper_scrollIt__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Helper_media__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Header__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Works__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tfont-size: 18px;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 900;\n\tletter-spacing: -1px;\n\t',';\n\t',';\n'],['\n\tfont-size: 18px;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 900;\n\tletter-spacing: -1px;\n\t',';\n\t',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 16px;\n  '],['\n    font-size: 16px;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n\tmargin-bottom: 16px;\n\tfont-weight: 500;\n\t',';\n\t',';\n'],['\n\tmargin-bottom: 16px;\n\tfont-weight: 500;\n\t',';\n\t',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    margin-bottom: 14px;\n  '],['\n    margin-bottom: 14px;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin-bottom: 12px;\n  '],['\n    margin-bottom: 12px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n\tfont-size: 16px;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 500;\n\t',';\n\t',';\n'],['\n\tfont-size: 16px;\n\tfont-family: \'Montserrat\', sans-serif;\n\tfont-weight: 500;\n\t',';\n\t',';\n']),_templateObject8=_taggedTemplateLiteral(['\n    font-size: 14px;\n  '],['\n    font-size: 14px;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n\tfont-size: 20px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n'],['\n\tfont-size: 20px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n']),_templateObject10=_taggedTemplateLiteral(['\n\tfont-size: 14px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n'],['\n\tfont-size: 14px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n']),_templateObject11=_taggedTemplateLiteral(['\n\tposition: absolute;\n\twidth: 20%;\n\ttop: 78%;\n\tleft: 44%;\n\ttransform: perspective(500px) rotateX(41deg) rotateY(1deg) rotateZ(29deg) translate(-50%, -50%);\n\tmix-blend-mode: hard-light;\n'],['\n\tposition: absolute;\n\twidth: 20%;\n\ttop: 78%;\n\tleft: 44%;\n\ttransform: perspective(500px) rotateX(41deg) rotateY(1deg) rotateZ(29deg) translate(-50%, -50%);\n\tmix-blend-mode: hard-light;\n']),_templateObject12=_taggedTemplateLiteral(['\n\theight: 100%;\n\tbackground: #f74c1e;\n\tmix-blend-mode: darken;\n'],['\n\theight: 100%;\n\tbackground: #f74c1e;\n\tmix-blend-mode: darken;\n']),_templateObject13=_taggedTemplateLiteral(['\n\twidth: 20%;\n\tposition: relative;\n\tleft: 42%;\n\ttop: 50%;\n\ttransform: perspective(500px) rotateX(10deg) rotateY(-10deg) rotateZ(20deg) translate(-50%, -50%);\n\tmix-blend-mode: multiply;\n'],['\n\twidth: 20%;\n\tposition: relative;\n\tleft: 42%;\n\ttop: 50%;\n\ttransform: perspective(500px) rotateX(10deg) rotateY(-10deg) rotateZ(20deg) translate(-50%, -50%);\n\tmix-blend-mode: multiply;\n']),_templateObject14=_taggedTemplateLiteral(['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tmargin: 1em;\n\tbackground-image: linear-gradient(0deg, #111 100%, #111);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 99%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\tfont-size: 16px;\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n'],['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tmargin: 1em;\n\tbackground-image: linear-gradient(0deg, #111 100%, #111);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 99%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\tfont-size: 16px;\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n']),_templateObject15=_taggedTemplateLiteral(['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tbackground-image: linear-gradient(0deg, #111 100%, #111);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 99%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n'],['\n\tdisplay: inline-block;\n\ttext-decoration: none;\n\tcolor: inherit;\n\tcursor: pointer;\n\tbackground-image: linear-gradient(0deg, #111 100%, #111);\n\tbackground-size: 0 1px;\n\tbackground-position: 0 99%;\n\tbackground-repeat: no-repeat;\n\t-webkit-transform-origin: left bottom;\n\ttransform-origin: left bottom;\n\ttransition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n\n\t&:hover {\n\t\tbackground-size: 100% 1px;\n\t}\n']),_templateObject16=_taggedTemplateLiteral(['\n\twidth: 24px;\n\theight: 24px;\n\tbackground-image: url(',');\n\tbackground-size: contain;\n\topacity: 0.5;\n\tmargin: 1em;\n\ttransition: opacity 0.25s;\n\tfilter: grayscale(100%);\n\t&:hover {\n\t\topacity: 1;\n\t}\n'],['\n\twidth: 24px;\n\theight: 24px;\n\tbackground-image: url(',');\n\tbackground-size: contain;\n\topacity: 0.5;\n\tmargin: 1em;\n\ttransition: opacity 0.25s;\n\tfilter: grayscale(100%);\n\t&:hover {\n\t\topacity: 1;\n\t}\n']),_templateObject17=_taggedTemplateLiteral(['\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tcursor: pointer;\n\ttext-decoration: none;\n'],['\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tcursor: pointer;\n\ttext-decoration: none;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import profile from './img/profile.jpg';
var Logo=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject2),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].sm(_templateObject3));var Name=Object(__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */])(Logo)(_templateObject4,__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject5),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].sm(_templateObject6));var JobTitle=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject8),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].sm(_templateObject8));var SectionLabel=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject9);var Desc=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject10);var LogoShadow=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].img(_templateObject11);var JiggleWallWrapper=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject12);var JiggleVideo=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].video(_templateObject13);var Resume=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].a(_templateObject14);var AwardItem=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].a(_templateObject15);var OutlinkStyle=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].div(_templateObject16,function(props){return props.src;});OutlinkStyle.Anchor=__WEBPACK_IMPORTED_MODULE_15_styled_components__["b" /* default */].a(_templateObject17);var Outlink=function Outlink(_ref){var src=_ref.src,name=_ref.name,path=_ref.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OutlinkStyle,{src:src},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OutlinkStyle.Anchor,{href:path,alt:name,target:'_blank',rel:'noopener noreferrer'}));};var JiggleWallFallback=function JiggleWallFallback(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JiggleWallWrapper,{className:'work_wall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LogoShadow,{src:__WEBPACK_IMPORTED_MODULE_9__img_logo_shadow_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JiggleVideo,{autoPlay:true,muted:true,playsInline:true,loop:true,className:'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_7__img_jiggle_mp4___default.a,type:'video/mp4'})));};var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var Exp=function Exp(_ref2){var maj=_ref2.maj,min=_ref2.min,dur=_ref2.dur;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["a" /* ExpMaj */],null,maj),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["b" /* ExpMin */],null,min),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["b" /* ExpMin */],null,dur));};var Awards=function Awards(_ref3){var maj=_ref3.maj,link=_ref3.link,min=_ref3.min,dur=_ref3.dur;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["a" /* ExpMaj */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AwardItem,{href:link,target:'_blank',rel:'noopener noreferrer'},maj)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["b" /* ExpMin */],null,min),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["b" /* ExpMin */],{dangerouslySetInnerHTML:{__html:dur}}));};var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this));_this.state={active:null};_this.handleScroll=_this.handleScroll.bind(_this);_this.handleActive=_this.handleActive.bind(_this);_this.getOffset=_this.getOffset.bind(_this);return _this;}_createClass(Home,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.handleActive();}},{key:'getOffset',value:function getOffset(elem){var offset={top:0,left:0};do{if(!isNaN(elem.offsetLeft)){offset.left+=elem.offsetLeft;}if(!isNaN(elem.offsetTop)){offset.top+=elem.offsetTop;}}while(elem=elem.offsetParent);return offset;}},{key:'handleScroll',value:function handleScroll(ref){ref=ref||document.getElementById('root');Object(__WEBPACK_IMPORTED_MODULE_11__Helper_scrollIt__["a" /* default */])(ref,1000,'easeOutQuad');}},{key:'handleActive',value:function handleActive(e){if(this.refs){var scrollTop=this.props.scrolltop;var isNull=true;var delta=10;for(var ref in this.refs){if(scrollTop>=this.getOffset(this.refs[ref]).top-delta){isNull=false;this.setState({active:this.refs[ref]});}}if(isNull){this.setState({active:null});}}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header',className:this.state.active!=null?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'global-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row middle-xs',style:{justifyContent:'space-between',background:'rgba(255, 255, 255, 0.8)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-6 col-xs-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo,{style:{cursor:'pointer'},onClick:function onClick(e){e.preventDefault();_this2.handleScroll();}},'Hyuntak Cha')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'homepage_feature__menu_lined homepage_feature__menu_lined--fixed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item homepage_feature__menu_item--fixed '+(this.state.active==this.refs.works?'homepage_feature__menu_item--active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#works',onClick:function onClick(e){e.preventDefault();_this2.handleScroll(_this2.refs.works);}},'works')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item homepage_feature__menu_item--fixed '+(this.state.active==this.refs.about?'homepage_feature__menu_item--active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#about',onClick:function onClick(e){e.preventDefault();_this2.handleScroll(_this2.refs.about);}},'about')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item homepage_feature__menu_item--fixed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailTo:chaht01@gmail.com'},'contact'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'home',className:'global-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12 col-md-10 col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottom-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-sm-4 col-xs-offset-2 col-sm-offset-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'origami'},[0,1,2,3].map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'origami__piece'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'origami__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'100%',height:'100%',viewBox:'0 0 100 100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'bg',points:'0,0 0,100 100,100'}))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-xs-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'homepage_paragraph'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'homepage_paragraph__title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Name,null,'Hyuntak Cha'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JobTitle,null,'Creative Developer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JobTitle,null,'Seoul, Korea')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'homepage_paragraph__dexcription'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc,null,'I create fun and inspirational works to make people touched.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row homepage_feature__menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-xs-offset-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{ref:'menu',className:'homepage_feature__menu_lined'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#works',onClick:function onClick(e){e.preventDefault();_this2.handleScroll(_this2.refs.works);}},'works')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#about',onClick:function onClick(e){e.preventDefault();_this2.handleScroll(_this2.refs.about);}},'about')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'homepage_feature__menu_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailTo:chaht01@gmail.com'},'contact'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'works',ref:'works',className:'global-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Works__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'about',ref:'about',className:'global-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8 col-sm-6 col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_8__img_profile2_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_minor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Desc,null,'Present Visual Insights by layering trivial things around us'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Outlink,{src:__WEBPACK_IMPORTED_MODULE_4__img_In_Black_0p5in_R_png___default.a,name:'linkedin',path:'https://www.linkedin.com/in/chaht01/'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Outlink,{src:__WEBPACK_IMPORTED_MODULE_2__img_GitHub_Mark_png___default.a,name:'github',path:'https://github.com/chaht01'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Outlink,{src:__WEBPACK_IMPORTED_MODULE_3__img_google_scholar_icon_png___default.a,name:'google_scholar',path:'https://scholar.google.com/citations?user=n1K703oAAAAJ&hl=ko'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Resume,{alt:'resume',href:'https://drive.google.com/file/d/1U2lxXnnfVFLfkuXr4xYZ-7JlOeh7kXOY/view?usp=sharing',target:'_blank',rel:'noopener noreferrer'},'Resume')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-md-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-sm-8 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row end-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Publication'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-7 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Awards,{maj:'Learning from Failure: De-biasing Classifier from Biased Classifier',link:'https://proceedings.neurips.cc/paper/2020/file/eddc3427c5d77843c2253f1e799fe933-Paper.pdf',min:'Advances in Neural Information Processing Systems 33',dur:'J Nam, <b>H Cha</b>, SS Ahn, J Lee, J Shin'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Awards,{maj:'Readersourcing an Accurate and Comprehensive Understanding of Health-related Information Represented by Media',link:'https://eunyoungko.com/resources/papers/CHI2019-Workshop-Readersourcing.pdf',min:'2019 CHI Conference on Human Factors in Computing Systems, CHI 2019',dur:'EY Ko, C Liu, <b>H Cha</b>, J Kim'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-sm-8 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row end-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Awards'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-7 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Awards,{maj:'Awwwards - Honorable Mention',link:'https://www.awwwards.com/sites/mimicus-inc',min:'MIMICUS INC.',dur:'June 2019'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-sm-8 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row end-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Experience'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-7 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'KIXLAB Summer Internship',min:'Research Intern',dur:'June 2018 - Aug 2018'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'Google Newslab Fellowship',min:'Developer & Presenter',dur:'Dec 2017 - Mar 2018'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'Naver Design Fellowship',min:'Design Fellow',dur:'April 2017 - June 2017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'Naver D2 - CONVIoT',min:'Frontend Engineer',dur:'Oct 2016 - Feb 2017'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'Military Service - ROKAF',min:'CERT',dur:'May 2015 - May 2017'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-sm-8 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row end-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Education'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-7 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about_row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'KAIST',min:'Graduate School of AI',dur:'2019.9 ~ '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Exp,{maj:'Seoul National University',min:'Computer Science and Engineering',dur:'2012.3 ~ 2019.2'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-sm-8 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row end-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Skills'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-3 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Javascript')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'FramerJS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'ReactJS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Illustrator'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-3 col-xs-offset-1 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'PyTorch')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Processing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionLabel,null,'Three.js'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.5d5d9eef.svg";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADNQTFRFDxAQw8PDaWpqpaWlHh8f4eHh0tLSLS4uS0xM8PDweHl5h4eHPD09WltblpaWtLS0////hzfTzQAAABF0Uk5T/////////////////////wAlrZliAAABNUlEQVR42pyU2ZKEIAxFL1tYRNv//9rBEGxBqOqavKh4ILlZwPmDofv6pGAB2JA+C8jpC2hmtXtDMWG0FAeIPN7mqYMM5mYe0IoRiiHC2kigyKr2Ttwlb+dHrJDmxaLYFCyHEHL5V/w4XtcM1Xf2G5WIVaweshvtIMzKIUfhjGgbRhMXiGjyfXxBURJs0LypiTsl/nBW3E97RP5BoktTqBVdoG0Kbf+AfnKXp1BukF3l8s5mUbevgxJvO84Dq2xKLnHgrpA1A3O0/nKl+KEA6cptMN/AnGlBI1ytonh6agltnQ96NqnizgxM+bqrWvgyobYvzwHx5LW4TDcJaEt78avcKKxuq12rx0TdkH5M8EV5vWkaIN3dBUefUYGO4Vah/IIyve8n4zvIm/lNR9/6KXqs/wkwAEw0LPOHPfN1AAAAAElFTkSuQmCC"

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google_scholar_icon.78e45921.png";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAC1QTFRFDxAQh4eHw8PDS0xMLS4uaWpq0tLS8PDwlpaW4eHhWltbHh8fPD09eHl5////Dw6pwAAAAA90Uk5T//////////////////8A1NyYoQAAAIhJREFUeNrslEsOgCAMBQuUv3L/41pCjAGFdqUbZ/UCk9DwCOAQGNBBBhaET9hjVJyjCsFZsUqekbxEEh0Hwfvw3jUZRRgKtgZqK2itFU4G1zWALQ27kFI5SXPpIq4kmqiFbS7VLXubqpfatbqxhWHwVsJaMs99/pJM6h8d9mvvkyWK5Ds8BBgAxcEOT7rHHNgAAAAASUVORK5CYII="

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiggle.916e2dcc.mp4";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/profile2.aad4ec5a.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo_shadow.ad7d56ce.png";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Code from https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
 */function scrollIt(destination){var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:200;var easing=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"linear";var callback=arguments[3];var easings={linear:function linear(t){return t;},easeInQuad:function easeInQuad(t){return t*t;},easeOutQuad:function easeOutQuad(t){return t*(2-t);},easeInOutQuad:function easeInOutQuad(t){return t<0.5?2*t*t:-1+(4-2*t)*t;},easeInCubic:function easeInCubic(t){return t*t*t;},easeOutCubic:function easeOutCubic(t){return--t*t*t+1;},easeInOutCubic:function easeInOutCubic(t){return t<0.5?4*t*t*t:(t-1)*(2*t-2)*(2*t-2)+1;},easeInQuart:function easeInQuart(t){return t*t*t*t;},easeOutQuart:function easeOutQuart(t){return 1- --t*t*t*t;},easeInOutQuart:function easeInOutQuart(t){return t<0.5?8*t*t*t*t:1-8*--t*t*t*t;},easeInQuint:function easeInQuint(t){return t*t*t*t*t;},easeOutQuint:function easeOutQuint(t){return 1+--t*t*t*t*t;},easeInOutQuint:function easeInOutQuint(t){return t<0.5?16*t*t*t*t*t:1+16*--t*t*t*t*t;}};var start=window.pageYOffset;var startTime="now"in window.performance?performance.now():new Date().getTime();var documentHeight=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight);var windowHeight=window.innerHeight||document.documentElement.clientHeight||document.getElementsByTagName("body")[0].clientHeight;var destinationOffset=typeof destination==="number"?destination:destination.offsetTop;var destinationOffsetToScroll=Math.round(documentHeight-destinationOffset<windowHeight?documentHeight-windowHeight:destinationOffset);if("requestAnimationFrame"in window===false){window.scroll(0,destinationOffsetToScroll);if(callback){callback();}return;}function scroll(){var now="now"in window.performance?performance.now():new Date().getTime();var time=Math.min(1,(now-startTime)/duration);var timeFunction=easings[easing](time);window.scroll(0,Math.ceil(timeFunction*(destinationOffsetToScroll-start)+start));if(window.pageYOffset===destinationOffsetToScroll){if(callback){callback();}return;}requestAnimationFrame(scroll);}scroll();}/* harmony default export */ __webpack_exports__["a"] = (scrollIt);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(99);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index], index);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(102);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpMaj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExpMin; });
/* unused harmony export ProgramTitle */
/* unused harmony export ProgramDescription */
/* unused harmony export SectionDescription */
/* unused harmony export SectionTitle */
/* unused harmony export ArticleParagraph */
/* unused harmony export ArticleTitle */
/* unused harmony export ArticleSubTitle */
/* unused harmony export DemoLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Helper_media__ = __webpack_require__(5);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 20px;\n  // font-size: ','px;\n  ','\n  ','\n  ','\n'],['\n  font-size: 20px;\n  // font-size: ','px;\n  ','\n  ','\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n  // font-size: 20px;\n  // font-size: ','px;\n  '],['\n  // font-size: 20px;\n  // font-size: ','px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  // font-size: 28px;\n  // font-size: ','px;\n  '],['\n  // font-size: 28px;\n  // font-size: ','px;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: 16px;\n  // font-size: 40px;\n  // font-size: ','px;\n  '],['\n  font-size: 16px;\n  // font-size: 40px;\n  // font-size: ','px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 14px;\n  // font-size: ','px;\n  ','\n  ','\n  ','\n'],['\n  font-size: 14px;\n  // font-size: ','px;\n  ','\n  ','\n  ','\n']),_templateObject6=_taggedTemplateLiteral(['\n  // font-size: 18px;\n  // font-size: ','px;\n  '],['\n  // font-size: 18px;\n  // font-size: ','px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n  // font-size: 25px;\n  // font-size: ','px;\n  '],['\n  // font-size: 25px;\n  // font-size: ','px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n  // font-size: 36px;\n  // font-size: ','px;\n  '],['\n  // font-size: 36px;\n  // font-size: ','px;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n\t',' font-family: "Source Sans Pro", sans-serif;\n\tmargin-bottom: 0.5em;\n'],['\n\t',' font-family: "Source Sans Pro", sans-serif;\n\tmargin-bottom: 0.5em;\n']),_templateObject10=_taggedTemplateLiteral(['\n\t',' font-family: "Source Sans Pro", sans-serif;\n\tfont-weight: 100;\n\tcolor: #aaa;\n\tmargin-bottom: 0.1em;\n\t& + & {\n\t\tmargin-bottom: 1em;\n\t}\n'],['\n\t',' font-family: "Source Sans Pro", sans-serif;\n\tfont-weight: 100;\n\tcolor: #aaa;\n\tmargin-bottom: 0.1em;\n\t& + & {\n\t\tmargin-bottom: 1em;\n\t}\n']),_templateObject11=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tline-height: 1;\n\t@media only screen and (min-width: 640px) {\n\t\tfont-size: ','px;\n\t\tmargin-top: 0;\n\t}\n'],['\n\tfont-size: ','px;\n\tline-height: 1;\n\t@media only screen and (min-width: 640px) {\n\t\tfont-size: ','px;\n\t\tmargin-top: 0;\n\t}\n']),_templateObject12=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tline-height: 1.6;\n\n\t',' ',';\n']),_templateObject13=_taggedTemplateLiteral(['\n  font-size: 36px;\n  // font-size: ','px;\n  margin-top: 8vw;\n'],['\n  font-size: 36px;\n  // font-size: ','px;\n  margin-top: 8vw;\n']),_templateObject14=_taggedTemplateLiteral(['\n  font-size: 40px;\n  // font-size: ','px;\n  margin-top: 8vw;\n'],['\n  font-size: 40px;\n  // font-size: ','px;\n  margin-top: 8vw;\n']),_templateObject15=_taggedTemplateLiteral(['\n  display: inline-block;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  font-weight: 100;\n  font-size: 30px;\n  // font-size: ','px;\n  margin-top: 1em;\n  background-image: linear-gradient(0deg, #fff 100%, #fff);\n  background-size: 0 1px;\n  background-position: 0 58%;\n  background-repeat: no-repeat;\n  -webkit-transform-origin: left bottom;\n  transform-origin: left bottom;\n  transition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  @media only screen and (min-width: 960px) {\n    font-size: 18px;\n    // font-size: ','px;\n  }\n\n  &:hover {\n    background-size: 100% 1px;\n  }\n'],['\n  display: inline-block;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  font-weight: 100;\n  font-size: 30px;\n  // font-size: ','px;\n  margin-top: 1em;\n  background-image: linear-gradient(0deg, #fff 100%, #fff);\n  background-size: 0 1px;\n  background-position: 0 58%;\n  background-repeat: no-repeat;\n  -webkit-transform-origin: left bottom;\n  transform-origin: left bottom;\n  transition: background-size 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  @media only screen and (min-width: 960px) {\n    font-size: 18px;\n    // font-size: ','px;\n  }\n\n  &:hover {\n    background-size: 100% 1px;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  font-family: "Montserrat", sans-serif;\n  font-size: 50.65px;\n  // font-size: ','px;\n  line-height: 1;\n  margin-bottom: 3vw;\n  font-weight: 100;\n  ','\n'],['\n  font-family: "Montserrat", sans-serif;\n  font-size: 50.65px;\n  // font-size: ','px;\n  line-height: 1;\n  margin-bottom: 3vw;\n  font-weight: 100;\n  ','\n']),_templateObject17=_taggedTemplateLiteral(['\n    font-size: 60px;\n    // font-size: ','px;\n  '],['\n    font-size: 60px;\n    // font-size: ','px;\n  ']),_templateObject18=_taggedTemplateLiteral(['\n  font-size: 18px;\n  // font-size: ','px;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 100;\n\n  ','\n  ','\n'],['\n  font-size: 18px;\n  // font-size: ','px;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 100;\n\n  ','\n  ','\n']),_templateObject19=_taggedTemplateLiteral(['\n  font-size: 30px;\n  // font-size: ','px;\n'],['\n  font-size: 30px;\n  // font-size: ','px;\n']),_templateObject20=_taggedTemplateLiteral(['\n  font-size: 36px;\n  // font-size: ','px;\n'],['\n  font-size: 36px;\n  // font-size: ','px;\n']),_templateObject21=_taggedTemplateLiteral(['\n  display: block;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  // font-size: ','px;\n  margin-bottom: 0.8em;\n  ','\n  ','\n'],['\n  display: block;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  // font-size: ','px;\n  margin-bottom: 0.8em;\n  ','\n  ','\n']),_templateObject22=_taggedTemplateLiteral(['\n  font-size: 24px;\n  // font-size: ','px;\n'],['\n  font-size: 24px;\n  // font-size: ','px;\n']),_templateObject23=_taggedTemplateLiteral(['\n  font-size: 28px;\n  // font-size: ','px;\n'],['\n  font-size: 28px;\n  // font-size: ','px;\n']),_templateObject24=_taggedTemplateLiteral(['\n  display: block;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 400;\n  font-size: 30px;\n  // font-size: ','px;\n  line-height: 1;\n  margin-bottom: 0.8em;\n\n  ','\n  ','\n'],['\n  display: block;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 400;\n  font-size: 30px;\n  // font-size: ','px;\n  line-height: 1;\n  margin-bottom: 0.8em;\n\n  ','\n  ','\n']),_templateObject25=_taggedTemplateLiteral(['\n  font-size: 50px;\n  // font-size: ','px;\n'],['\n  font-size: 50px;\n  // font-size: ','px;\n']),_templateObject26=_taggedTemplateLiteral(['\n  font-size: 60px;\n  // font-size: ','px;\n'],['\n  font-size: 60px;\n  // font-size: ','px;\n']),_templateObject27=_taggedTemplateLiteral(['\n  font-size: 14px;\n  // font-size: ','px;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 100;\n  line-height: 1.4;\n\n  ','\n  ','\n'],['\n  font-size: 14px;\n  // font-size: ','px;\n  font-family: "Source Sans Pro", sans-serif;\n  font-weight: 100;\n  line-height: 1.4;\n\n  ','\n  ','\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var mainText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* css */])(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(16),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].lg(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(20)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(28)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(40)));var subText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* css */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(14),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].lg(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(25)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(36)));// const Logo = styled.div`
// 	font-size: 20px;
//   font-family: 'Montserrat', sans-serif;
//   font-weight: 500;
//   margin-bottom: 16px;
// 	${media.sm`
//     font-size: 16px;
//   `};
// `;
// const Name = styled.div`${mainText} font-family: "Source Sans Pro", sans-serif;`;
// const Desc = styled.div`
// 	${subText} font-family: "Source Sans Pro", sans-serif;
// 	font-weight: 100;
// `;
var ExpMaj=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject9,mainText);var ExpMin=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject10,subText);var ProgramTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(64),Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(55.22));var ProgramDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(36)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(40)));var DemoLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].a(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30),Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18));var SectionTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(50.65),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(60)));var SectionDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(18),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(36)));var ArticleSubTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(15),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject22,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(24)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject23,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(28)));var ArticleTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject24,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject25,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(50)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject26,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(60)));var ArticleParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject27,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(14),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].md(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(30)),__WEBPACK_IMPORTED_MODULE_3__Helper_media__["a" /* default */].sm(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_2__Helper_pxToVw__["a" /* default */])(36)));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/project1.06e221c8.png";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/project2.16f62aa6.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/twitch.d84744d1.mp4";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiggle_wall_fallback.59c8f47d.mp4";

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blendStyle__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Intro__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inspiration__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Ideation__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Implementation__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ndf_css__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ndf_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ndf_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style={scrollDisable:{width:'100%',overflowX:'hidden'}};var NDF=function(_React$Component){_inherits(NDF,_React$Component);function NDF(props){_classCallCheck(this,NDF);var _this=_possibleConstructorReturn(this,(NDF.__proto__||Object.getPrototypeOf(NDF)).call(this,props));_this.blendStyle=__WEBPACK_IMPORTED_MODULE_1__blendStyle__["a" /* default */].bind(_this);return _this;}_createClass(NDF,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);var elem=__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this);// Set the opacity of the element to 0
elem.style.opacity=0;window.requestAnimationFrame(function(){// Now set a transition on the opacity
elem.style.transition="opacity 250ms";// and set the opacity to 1
elem.style.opacity=1;});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style.scrollDisable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Intro__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Inspiration__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Ideation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Implementation__["a" /* default */],null));}}]);return NDF;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NDF);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wallpaper__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_napp_png__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_napp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_napp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_studio_png__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_studio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_studio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_naveri_png__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_naveri_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_naveri_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_smarteditor_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_smarteditor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_smarteditor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_nkeyboard_png__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_nkeyboard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_nkeyboard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_nradio_png__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_nradio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_nradio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_ncafe_png__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_ncafe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_ncafe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_nlive_png__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_nlive_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_nlive_png__);
var Intro=function Intro(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs middle-xs full-height"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs start-md"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-6 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"program__title"},"Naver"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"program__title"},"Design"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"program__title"},"Fellowship")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-md-11 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"program__description"},"Naver had managed UXDP, design internship/educating program. Naver restarts their program as Naver Design Fellowship (NDF) by redefining the definition of \u2018design\u2019 as a constructing service system not as beautifying visual illustration. NDF is a program that nurtures talented students in design. For ten weeks, 8 participants challenge 8 actual design issues of Naver services that involve many different departments of the company and our own design outcomes are presented and feedbacks are shared and reflected. For these ten weeks of studying, I have identified problems, specified the ideas and implemented with prototypes. And now I would like to share three of the topmost self-valued project as \u2018The project of this week\u2019."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20 col-md-18 col-xs-offset-2 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Wallpaper__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--3-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_napp_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_3__img_studio_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_4__img_naveri_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_5__img_smarteditor_png___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_6__img_nkeyboard_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_7__img_nradio_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_8__img_ncafe_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"topics shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_9__img_nlive_png___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"})))));};/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var style={test:{}};var Wallpapaer=function Wallpapaer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow",style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/chaht01.github.io"+'/img/bg1.jpg'})));};/* harmony default export */ __webpack_exports__["a"] = (Wallpapaer);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/napp.75806bf2.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/studio.b6d64aef.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/naveri.8cd68a90.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smarteditor.379c5f71.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nkeyboard.13930abe.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nradio.c929770c.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ncafe.10ec51b1.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nlive.d6ec286b.png";

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_loading_bg_png__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_loading_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_loading_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_checklist_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_checklist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_checklist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_Trex_mp4__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_Trex_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_Trex_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_balloon_mp4__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_balloon_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_balloon_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_pwa_gif__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_pwa_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_pwa_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_pwa_member_gif__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_pwa_member_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_pwa_member_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_questions_gif__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_questions_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_questions_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_questions_bg_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_questions_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_questions_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_genre_bg_png__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_genre_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_genre_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_genres_png__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_genres_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_genres_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_toobar_png__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_toobar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_toobar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_jamm_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_jamm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_jamm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_congrat_png__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_congrat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_congrat_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_font_increasing_png__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_font_increasing_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_font_increasing_png__);
var Ideation=function Ideation(){var style={loading_bg:{background:"url("+__WEBPACK_IMPORTED_MODULE_1__img_loading_bg_png___default.a+")",backgroundSize:"contain",backgroundRepeat:"no-repeat",backgroundPosition:"0 50%"},pwa:{marginTop:"-13vw"},questionBg:{marginTop:"1vw"},postlist:{left:"-12vw",flexWrap:"nowrap"},post:{marginLeft:"1.25vw"},fbLike:{marginTop:"-2.5vw"},textInc:{opacity:0.3}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__title"},"Inspiration"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-sm-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__description"},"It is important to obtain inspirations from daily experiences and observe the obstacle from a different perspective in order to overcome weekly design problems effectively. For ten weeks, I strived to utilize my inspirations gained from design concept, gesture or context directly or indirectly."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.loading_bg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-sm-9 col-xs-offset-2 col-sm-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"TRex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner Trex__bg"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img",autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_3__img_Trex_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-6 col-xs-offset-3 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_checklist_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.pwa},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-6 col-xs-offset-14 col-md-offset-14"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pwa"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner ratio__inner--overflow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_6__img_pwa_member_gif___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_5__img_pwa_gif___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner pwa__guide"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-7 col-md-7 col-xs-offset-3 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"questions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner",style:style.questionBg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_8__img_questions_bg_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_7__img_questions_gif___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-sm-8 col-md-8 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph align--justify"},"What will be the role of the portal site (Naver) during an incident of an unstable network environment? From the result of the survey of 199 people and experience of playing T-rex game in Google Chrome and attending PWA roadshow as a staff member, I thought about how to improve users\u2019 experiences especially while internet service quality is unstable."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cos-xs-24 col-md-24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_9__img_genre_bg_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8 col-xs-offset-3 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_10__img_genres_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-sm-8 col-xs-offset-2 col-sm-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph align--justify"},"When can we be contented with music service quality? Why should we know our favorite category of genre, songs, and artists? There are too many sub-genre (1378) and songs (600k) to know ourselves\u2019 taste. Even in Korea, many people do not fully understand their musical taste as they only listen to music from \u201Cpopular music\u201D chart."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph align--justify"},"Although there have been great improvements in music service through the introduction and development of Artificial-Intelligence, AI does not effectively find the music that I like. It is disappointing that the service often provides unsuitable or not tailored playlists for a user. In my opinion, the process of making playlists is arbitrary and the range of their meaning can vary from too abstract to too specific. Additionally, the nested and hierarchical structure of music service confuses users by their ineffective navigation flow."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--3-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img shadow",src:__WEBPACK_IMPORTED_MODULE_12__img_jamm_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20 col-sm-10 col-md-10 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_11__img_toobar_png___default.a,alt:""})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs",style:style.postlist},[1,2,3,4,5].map(function(i){if(i!=2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-6",key:i,style:style.post},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"post--dummy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs center-xs post--dummy__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lines"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line"}))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11 col-md-11",key:i,style:style.post},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_13__img_congrat_png___default.a,alt:""}));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-4 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-increasing"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",style:style.textInc,src:__WEBPACK_IMPORTED_MODULE_14__img_font_increasing_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-md-22 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph"},"Many fans want to communicate with their celebrities by their comments/words to be seen and read through global live chatting service. If a user wants to express his/her message more \u201Cunique\u201D, how can the message be \u201Cunique\u201D in the same functions in the service for everyone? I found clues from \u2018special post\u2019 and \u2018like\u2019 button from Facebook.")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5",style:style.fbLike},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fb-like shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img",autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_4__img_balloon_mp4___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph"},"Many fans want to communicate with their celebrities by their comments/words to be seen and read through global live chatting service. If a user wants to express his/her message more \u201Cunique\u201D, how can the message be \u201Cunique\u201D in the same functions in the service for everyone? I found clues from \u2018special post\u2019 and \u2018like\u2019 button from Facebook.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}));};/* harmony default export */ __webpack_exports__["a"] = (Ideation);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading_bg.84196cea.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checklist.0766d88b.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Trex.2eb85d94.mp4";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/balloon.009ab43c.mp4";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pwa.0544a603.gif";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pwa_member.09d87012.gif";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/genre_bg.e6db44cd.png";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/genres.56a180ca.png";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jamm.0f2d85a5.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/congrat.441e0331.png";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_ux_table_png__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_ux_table_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_ux_table_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_dots_png__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_dots_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_dots_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_elavator_sketch_png__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_elavator_sketch_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_elavator_sketch_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_elevator_png__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_elevator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_elevator_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_wifi_png__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_wifi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_wifi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_songlikethis_png__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_songlikethis_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_songlikethis_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_wireframe_list_png__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_wireframe_list_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_wireframe_list_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_text_bg_png__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_text_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_text_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_long_png__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_long_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_long_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_short_png__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_short_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_short_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_live_png__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_live_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_live_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_context_blurred_mp4__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_context_blurred_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_context_blurred_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_box_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_box_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_box_png__);
var style={elevator:{marginTop:"-7.5vw",zIndex:1},wifiSketch:{marginLeft:"-1.25vw",marginTop:"-7.5vw"},idea1:{marginTop:"7.5vw"},contextImg:{marginTop:"-5%"},box:{marginTop:"-13vw",reverse:{marginTop:"13vw"}},wireframes:{marginTop:"-35vw"},idea2:{marginTop:"-5vw"},longSentence:{marginBottom:"-5vw"},shortSentence:{marginTop:"-5vw"},live:{marginTop:"5vw"}};var Ideation=function Ideation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__title"},"Ideation"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-sm-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__description"},"I realized that plotting and designing through the development process is very important in order for persuasiveness to be seen as a result of applying directly or indirectly to problems that need to be solved. Many of resources, existing applications, and research about other competent products are used and it is helpful to trim rough idea by diverging and converging itself repeatedly."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-14 col-sm-12 col-xs-offset-1 col-sm-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_1__img_ux_table_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-sm-6 col-xs-offset-1 col-sm-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dot-bg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_dots_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_3__img_elavator_sketch_png___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.elevator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-sm-6 col-xs-offset-16 col-sm-offset-13"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img shadow",src:__WEBPACK_IMPORTED_MODULE_4__img_elevator_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs start-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-14 col-sm-11 col-xs-offset-1 col-sm-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",style:style.wifiSketch,src:__WEBPACK_IMPORTED_MODULE_5__img_wifi_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20 col-sm-8 col-sm-offset-1",style:style.idea1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"idea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--orange"},"Keep from"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--orange"},"being bored"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph desc desc--below"},"Like psychological research about elevator mirror, I think the main role of the portal site is to keep people entertained or less bored in the situation the network is unstable. Especially for the teenage user group who are considered to be more sensitive to the network stability, I believe the game like T-Rex is needed in order to keep them entertained in an unstable or off-line network. To satisfy this, I have designed the ways to approach the game and manipulation to suit the current characteristics of the teenagers."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row top-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8 col-xs-offset-3 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"idea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--blue title--center"},"Move less"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--blue title--center"},"Do more"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--blue title--center"},"Keep simple"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"desc desc--below article__paragraph block-hide block-show-min-sm"},"People want to find the music that suits their taste perfectly, however, it is not possible. So I believe the music recommendation system needs to change entirely. Owing to developments and improvement of AI, such as Naver Clova, we do not necessarily choose the categories of genre and artist of the music. But instead, we can give users ranges of the choices based on the music that they listen to. This will prevent the users from getting options that are so unsuitable for their taste that will surprise users.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1 block-hide-max-sm"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_6__img_songlikethis_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-hide block-show-max-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"desc desc--below article__paragraph"},"People want to find the music that suits their taste perfectly, however, it is not possible. So I believe the music recommendation system needs to change entirely. Owing to developments and improvement of AI, such as Naver Clova, we do not necessarily choose the categories of genre and artist of the music. But instead, we can give users ranges of the choices based on the music that they listen to. This will prevent the users from getting options that are so unsuitable for their taste that will surprise users.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"chrome"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img",style:style.contextImg,autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_12__img_context_blurred_mp4___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs",style:style.box},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-md-8 col-xs-offset-2 col-md-offset-2",style:style.box.reverse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph"},"From Google Chrome\u2019s improved gesture of \u2018pull-to-refresh\u2019, I thought it can be applied to achieve the goal of navigating hierarchical structure (playlists \u2014 songs in the playlist). Thanks to this idea, we can structure our service independent from contents and make it simple.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_13__img_box_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1 block-hide-max-md"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--3-1 block-hide block-show-max-md"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs",style:style.wireframes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20 col-sm-16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_7__img_wireframe_list_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.longSentence},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_9__img_long_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_8__img_text_bg_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.shortSentence},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-13 col-md-offset-13"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_10__img_short_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.live},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-sm-8 col-xs-offset-2 col-sm-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"idea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--green"},"Make"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"title title--green"},"Prominent & Live"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"desc desc--below article__paragraph"},"Facebook demonstrated how fans can deliver their messages to their celebrities in a faster and more effective manner. And as many international fans are using global live services, we designed the service to deliver the message without translation. Lastly, since most of the live broadcast celebrities are singers we constructed the interactive system for the viewer as if they are listening to a live show."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-7 col-md-7 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_11__img_live_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}));};/* harmony default export */ __webpack_exports__["a"] = (Ideation);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ux_table.98027ef5.png";

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elavator_sketch.f3d3c7f2.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elevator.8db2c4e1.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wifi.23da77f2.png";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/songlikethis.5f3c329e.png";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wireframe_list.61f5db68.png";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/text_bg.61ff81e7.png";

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/short.70472d5c.png";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live.e4cf8775.png";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/context_blurred.2773c17c.mp4";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/box.51dd7f1b.png";

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Iphone__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Game__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Game_img_bird_png__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Game_img_bird_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__component_Game_img_bird_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_game_transition_png__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_game_transition_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_game_transition_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_cloud_png__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_cloud_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_cloud_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_trans_status1_png__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_trans_status1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_trans_status1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_trans_status2_png__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_trans_status2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_trans_status2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_trans_status3_png__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_trans_status3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_trans_status3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_trans_status4_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_trans_status4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_trans_status4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_trans_status5_png__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_trans_status5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_trans_status5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Game_img_touch_blur_png__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Game_img_touch_blur_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__component_Game_img_touch_blur_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_hand_mockkup_png__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_hand_mockkup_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_hand_mockkup_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_main_structure_png__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_main_structure_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_main_structure_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_branch_row_png__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_branch_row_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_branch_row_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_brand_row_png__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_brand_row_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__img_brand_row_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__video_mainVideo_mp4__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__video_mainVideo_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__video_mainVideo_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__video_changeChannel_mp4__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__video_changeChannel_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__video_changeChannel_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_depth_view_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_depth_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__img_depth_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_live_icons_png__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_live_icons_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__img_live_icons_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_live_icon1_png__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_live_icon1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__img_live_icon1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_live_icon4_png__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_live_icon4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__img_live_icon4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_live_icon2_png__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_live_icon2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__img_live_icon2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__img_live_icon3_png__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__img_live_icon3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__img_live_icon3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__video_live_1_mp4__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__video_live_1_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__video_live_1_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__video_live_2_mp4__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__video_live_2_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__video_live_2_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__video_live_4_mp4__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__video_live_4_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__video_live_4_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__img_before_translate_png__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__img_before_translate_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__img_before_translate_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__img_after_translate_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__img_after_translate_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__img_after_translate_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__img_selection_tiles_png__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__img_selection_tiles_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__img_selection_tiles_png__);
var style={brand_detail:{marginTop:'5vw'},new_channel:{marginTop:'-5vw',marginBottom:'-5vw'},hand_mockup:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_12__img_hand_mockkup_png___default.a+')',backgroundPositionX:'90%',backgroundSize:'contain',backgroundRepeat:'no-repeat'},channelMainPhone:{marginTop:'-50vw'},depth_view:{marginBottom:'-13vw'}};var Implementation=function Implementation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section__title'},'Implementation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-sm-12 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section__description'},'Although it is not easy to make ideas and construct prototypes weekly, implementation is the most obvious way to deliver more vividly. Because design results will speak for themselves than any resources and explanations for the design process. Followings are the results from inspiration and ideation mentioned above.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottom-xs project'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-10 col-xs-offset-1 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__title project__title--red'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'What if I'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'hang mirror on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'the Naver app?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-8 col-sm-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Department'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Naver App Lab')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Present Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Keynote')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Tools'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Photoshop, Keynote')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Hyuntak Cha')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs game_transition_status'},[__WEBPACK_IMPORTED_MODULE_6__img_trans_status1_png___default.a,__WEBPACK_IMPORTED_MODULE_7__img_trans_status2_png___default.a,__WEBPACK_IMPORTED_MODULE_8__img_trans_status3_png___default.a,__WEBPACK_IMPORTED_MODULE_9__img_trans_status4_png___default.a,__WEBPACK_IMPORTED_MODULE_10__img_trans_status5_png___default.a].map(function(img,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'col-xs-3 col-md-3 game_transition_status__item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:img,alt:''}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_4__img_game_transition_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{height:'100%',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('linearGradient',{id:'grad1',x1:'0%',y1:'0%',x2:'0%',y2:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('stop',{offset:'0%',style:{stopColor:'#f66241',stopOpacity:1}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('stop',{offset:'100%',style:{stopColor:'#f6a741',stopOpacity:1}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{width:'100%',height:'100%',fill:'url(#grad1)'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Game__["a" /* default */],null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottom-xs project'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-10 col-xs-offset-1 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__title project__title--blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'I am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'perfect'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'for you'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-8 col-sm-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Department'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Naver Music')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Present Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Keynote, Web, Video')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Tools'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Photoshop, Framer, Keynote')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Hyuntak Cha, Jiyoon Lee')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project2 col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project2__hand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner',style:style.hand_mockup})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row project2__navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner ratio__inner--overflow row middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-5 col-md-5 col-xs-offset-3 col-md-offset-3',style:style.channelMainPhone},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Iphone__["a" /* default */],{video:__WEBPACK_IMPORTED_MODULE_16__video_mainVideo_mp4___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article__paragraph'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-10 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_13__img_main_structure_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row project2__branching'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner row middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-17 col-md-17 col-xs-offset-4 col-md-offset-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_14__img_branch_row_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row project2__branching'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner row middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-17 col-md-17 col-xs-offset-4 col-md-offset-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_15__img_brand_row_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row project2__gesture'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-11 col-xs-offset-2 col-sm-4 col-md-offset-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_18__img_depth_view_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner row bottom-xs center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8 col-sm-8 col-md-4',style:style.depth_view},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Iphone__["a" /* default */],{video:__WEBPACK_IMPORTED_MODULE_17__video_changeChannel_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottom-xs project'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-10 col-xs-offset-1 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__title project__title--green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'I can'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'see your'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'voice'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-8 col-sm-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Department'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Naver VLive')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Present Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Keynote, Web, Video')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Tools'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Illustrator, AfterEffect, Framer, Keynote')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project__desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__name'},'Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'project__item'},'Hyuntak Cha, Soeun Bae')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-md-22 col-xs-offset-1 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-sm-16 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_19__img_live_icons_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-sm-16 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-landscape live_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img live_icon live_icon--left',src:__WEBPACK_IMPORTED_MODULE_20__img_live_icon1_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner live_phone__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'ratio__img',autoPlay:true,playsInline:'',muted:'',loop:true,poster:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'video/mp4',src:__WEBPACK_IMPORTED_MODULE_24__video_live_1_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-sm-16 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-landscape live_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img live_icon live_icon--right',src:__WEBPACK_IMPORTED_MODULE_21__img_live_icon4_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner live_phone__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'ratio__img',autoPlay:true,playsInline:'',muted:'',loop:true,poster:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'video/mp4',src:__WEBPACK_IMPORTED_MODULE_25__video_live_2_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-sm-16 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-landscape live_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img live_icon live_icon--left',src:__WEBPACK_IMPORTED_MODULE_23__img_live_icon3_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner live_phone__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_27__img_before_translate_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_28__img_after_translate_png___default.a,alt:''}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-sm-16 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-landscape live_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img live_icon live_icon--right',src:__WEBPACK_IMPORTED_MODULE_22__img_live_icon2_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner live_phone__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'ratio__img',autoPlay:true,playsInline:'',muted:'',loop:true,poster:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'video/mp4',src:__WEBPACK_IMPORTED_MODULE_26__video_live_4_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})));};/* harmony default export */ __webpack_exports__["a"] = (Implementation);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_iphone_mockup2_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_iphone_mockup2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_iphone_mockup2_png__);
var style={fade:{header:{},footer:{}}};var hexTorgb=function hexTorgb(hex){var result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);return result?{r:parseInt(result[1],16),g:parseInt(result[2],16),b:parseInt(result[3],16)}:null;};var fadeGenerator=function fadeGenerator(_ref){var color=_ref.color,direction=_ref.direction;switch(direction){case'top':return{top:0,background:'linear-gradient(to bottom, rgba('+hexTorgb(color).r+','+hexTorgb(color).g+','+hexTorgb(color).b+',1) 50%,\n                        rgba('+hexTorgb(color).r+','+hexTorgb(color).g+','+hexTorgb(color).b+',0) 100%)'};case'bottom':return{top:'40%',background:'linear-gradient(to bottom, rgba('+hexTorgb(color).r+','+hexTorgb(color).g+','+hexTorgb(color).b+',0) 0%,\n                        rgba('+hexTorgb(color).r+','+hexTorgb(color).g+','+hexTorgb(color).b+',1) 50%)'};default:return{display:'none'};}};var Iphone=function Iphone(_ref2){var fade=_ref2.fade,img=_ref2.img,video=_ref2.video,direction=_ref2.direction,color=_ref2.color,bazel=_ref2.bazel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-portrait'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner ratio__inner--overflow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img phone-portrait__frame',src:__WEBPACK_IMPORTED_MODULE_1__img_iphone_mockup2_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-portrait__screen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},img?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:img,alt:''}):video?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'ratio__img',autoPlay:true,playsInline:'',muted:'',loop:true,poster:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'video/mp4',src:video})):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner phone-portrait__fade',style:fade?fadeGenerator(fade):{display:'none'}}));};/* harmony default export */ __webpack_exports__["a"] = (Iphone);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_mountain_front_png__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_mountain_front_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_mountain_front_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_mountain_back_png__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_mountain_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_mountain_back_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_game_phone_frame_png__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_game_phone_frame_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_game_phone_frame_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_touch_blur_png__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_touch_blur_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_touch_blur_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_gameChar_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_gameChar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_gameChar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_bird_png__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_bird_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_bird_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style={game:{width:'100%',oveflow:'hidden'},game_phone_frame:{top:'50%',transform:'translateY(-50%)'},game_bg:{cursor:'url('+__WEBPACK_IMPORTED_MODULE_5__img_touch_blur_png___default.a+') 64 64, auto'}};var Game=function(_React$Component){_inherits(Game,_React$Component);function Game(props){_classCallCheck(this,Game);var _this=_possibleConstructorReturn(this,(Game.__proto__||Object.getPrototypeOf(Game)).call(this,props));_this.state={top:50,//center
velocity:0,acceleration:0,limit:10,status:0//0: up, 1: down
};_this.t=undefined;_this.changeStatus=_this.changeStatus.bind(_this);_this.repeat=_this.repeat.bind(_this);_this.onMouseUp=_this.onMouseUp.bind(_this);_this.onMouseDown=_this.onMouseDown.bind(_this);_this.onMouseOut=_this.onMouseOut.bind(_this);return _this;}_createClass(Game,[{key:'changeStatus',value:function changeStatus(status){this.setState({status:status});if(this.state.status==0){if(this.state.velocity>-10){this.setState({acceleration:-0.05});}else{this.setState({acceleration:0});}this.setState(function(prevState,props){return{velocity:prevState.velocity+prevState.acceleration};});this.setState(function(prevState,props){return{top:prevState.top+prevState.velocity};});}else{this.setState({acceleration:0.02});this.setState(function(prevState,props){return{velocity:prevState.velocity+prevState.acceleration};});this.setState(function(prevState,props){return{top:prevState.top+prevState.velocity};});}if(this.state.top<10){this.setState({top:10,velocity:0,acceleration:0});}if(this.state.top>90){this.setState({top:90,velocity:0,acceleration:0});}}},{key:'repeat',value:function repeat(status){this.changeStatus(status);this.t=setTimeout(this.repeat.bind(this,status),10);}},{key:'onMouseDown',value:function onMouseDown(){clearTimeout(this.t);this.repeat(0);}},{key:'onMouseUp',value:function onMouseUp(){clearTimeout(this.t);this.repeat(1);}},{key:'onMouseOut',value:function onMouseOut(){clearTimeout(this.t);this.t=undefined;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'game',style:style.game},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner game_bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ratio__inner middle-xs game_bg__back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-4 col-md-4 col-xs-offset-8 col-md-offset-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_2__img_mountain_back_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-4 col-md-4 col-xs-offset-8 col-md-offset-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_2__img_mountain_back_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ratio__inner middle-xs game_bg__cloud'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3 col-md-3 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3 col-md-3 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3 col-md-3 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3 col-md-3 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_mountain_cloud_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ratio__inner middle-xs game_bg__front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-6 col-xs-offset-6 col-md-offset-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_1__img_mountain_front_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-6 col-xs-offset-6 col-md-offset-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_1__img_mountain_front_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row birds_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-6 col-md-offset-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_bird_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-10 col-md-offset-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_bird_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row birds_2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-12 col-md-offset-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_bird_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row birds_3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_bird_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-14 col-md-offset-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_bird_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner ratio__inner--overflow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:style.game_phone_frame},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-md-10 col-xs-offset-1 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_4__img_game_phone_frame_png___default.a,alt:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner',style:style.game_bg,onMouseDown:function onMouseDown(e){return _this2.onMouseDown();},onMouseUp:function onMouseUp(e){return _this2.onMouseUp();},onMouseOver:function onMouseOver(e){return _this2.onMouseUp();},onMouseOut:function onMouseOut(e){return _this2.onMouseOut();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-md-2 col-xs-offset-4 col-md-offset-4',style:{position:'relative',transform:'translateY(-50%)',top:this.state.top+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_6__img_gameChar_png___default.a,alt:''}))));}}]);return Game;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Game);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mountain_front.cea1ad8a.png";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_phone_frame.d3be9d64.png";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_transition.ceab1d81.png";

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWUAAAFlCAYAAAAzhfm7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAFQ1JREFUeNrs3XuQnWd5GPDnO5L2JhnJ2MayVrItX/AV20ldoDhQKBgmGGhJQlqaNqGTJpC0ZVo6zDDTTtr+QTvJdEKToe00tE3TZtq4aUlpY5IapwzI1MWIix2DsI0sC2mlRZYtyUjas9Luefu85zsOwkFX70p7+f2Yx9/ZRbd9z/s95/m+771EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsOQ1moDFrpTSPHM8OtO9GMoOPRa9GM6ePZavh/P/XlUy8vWqfN0ZRDOI3guRv2YmjzP5zel8PR0loxNH83V3uBPdy1ZFr2maorWZbys1AUukuBjNWJ9xQ8aVg+N4xuUZF2dckjESNWm3Cbr+nmMZRzO6Gc9nHMzYlTExOH5zcHxq8OskZVTKcKLHSqmV7sp13fiRPP5wduA/n8ebMjZGWxnPh+mM3RnbMis/msc/OjgSD9bK+tam6XlXkJRZViZLGZrp9qvf12ePva0p/SRcq+I1GesG1e/w4NbEfOgNEnOtlo9kHOj/s5rYlrXzoxmPrByNx9Y3zTHvFpIyS9Kuo6Um2qs6TdyTxzvr64wrMtZmXJSx4gL/E2czvptxKOO5jCcytvZK3JfHnZvGmqPeRSRlFrX6wG5yKi4tEddmFfrn8ls311sUGZszXrYAEvFJ/+nR3o/ekfGVjG/0o8RXN4zGMx4QIimz2JJxTEzFZVkV10r41sxgNSHfM0jGi9HTGV/K+FSeYH+c1fPe8UzO/ROuccohKbMIKuRMyj+e+ep9+eWrMy5bIj9aTcQP52fOf8ik/N/rjyopIymzYO0+VuqDumub2fhXeXzdEv9x/2+ebf+idGLLxqFm0ruPpMyC8Wwpq7vH4i1ZQf5UU+LdsXzGy9eHgw9n/PLISDxwSdMc0RuQlLmgJrrllijx/nz52oyrMy5dRv2wPvCrIzYez/hi9OLe8dXNg3oFJzKjj3m3tZSadDsbpvvV8dvy9TszNmQMLcMiqI4iuT3jFdGJyyamysX53YdjOPaNG6WBpMx82zNVVva6sTbT8rX55c9GOwPvFcu8WeqH0VWDWJ3180WlGw/s6pYDm0aa43qNpAzzaU2Wh6/OGvCXSnvLgu/3jkzKN2e1XO8vb4l2IgrLmHvK9E1OlWtmSryy08QdmTw3DW4v1MV86kI+azJxjGRvWR11AkeJ5/N1XcSnJpI6o21//SOyMz3eK7F9ZRNfzq/3ztYZeE18JF+/N3/PGq18yjPxcP73v2T8xvhIs1WDSMosI3X0w3Q3birtBI06LrjOmls/p39JyYTd9GfgDetnZ6yusbEt41fHR5t/rzkkZZaoOmNuz7FYm1XsTfmG/2hT4lXRLmtZ7+1eNIi5fug2O+hfHe/AWXyUtYse7cpX/2R8rPkdTSIps4RsLaVzeTcuz6z4yvyyLnVZ15L4oWiXuVwtYS5on8n4aMYjWTUf1BySMou7Mm72dGN9ae8L3960CfmeMOphsfnNfpR4NKvmQ5pDUmaRmThS6j3c0aYTN2ZCfk++rmOC61A0D9kWr/8Z7QPA+7NiNjJjGTAkbmmpWyJdnwn543l8jeZYEupEm3qvuW5X9WnNoVJmEXiylFVj0/HWfDN/ppT4sVi46w5zbupD069mZn7/xtHmK5pjafOgZ5GbnCqXjHXjw1lL/f1MyG/0ni7Z8/S6psQHdnXLuOaQlFmgJqbLjbNN/PV8+RPRbpl0maufJXtFW9fMeEOnF++byCujiXY9EZbom80is+doqSfozXlafjDqZqLtKAsfsEtf3Zj1QIn4xTx+fuNos1+TqJS50NXxVFmXybiuMvbXMv5ytJNAvI/LQ53gU6e+/42mxI0TR/qbyyIpc4HVyR9/MxPz3xq8f652lt/l7Tvy8MaMK7WGpMyFrJKPljoJ5B9k/LTWWPaZ+UN59r5n16EyqjEkZS6A3d1yV56IfzXaxYOgrlfy+s5Q/wEvkjLntULultc1JT4c7Sy9i7UI0U78qutT37P7aLlac0jKnAeTU2XlZN0uqBc/F+0Sm5doFV5ULb+208SbiiFykjLz67E8yWYj1vUi7hpUyHUxISceL3ZLxt17pvpj1JGUmc/3Jmuf60rEP/6THT/gT7s0+8jtpd37kCVA5bVA7emWusLbz5bSr5LhVOq2XE9vGInb8liawa7YOw6Uet95zdBovCGPb4jSXzGwTjSqVXW9FTYy+P11a6+64FFdhe6pzArbM7b0ZuKRmWMxufnipquJJeVFJTv/mlXDcW3T6Xf+W7LzXxPtGNL6UO6iQZU7O+j8+zK+nS3/VB6/kfHIsan4cnb8wy/8eRNHyhV5DfNL+fLnXc1wxidziZ/odeKhTolbMyu/Odrq+c6XcJVVt6fanvE/MlE8cGQkPnd900xraUl5wXmylGb0WFza6fUvG++OdkePywdJuM6yqmNH6950KwdR27kMOnmdKls79lS0W//UZLw7Y1v+ovtLJx7NX1WT+z/MuM17xFn4P4P+9MJWX2sHRcG59qEyKCT2v1BM5JXb72SZ8GAZjslNTdPT5JLyBbWrlBV5IVe3Uqp73d01SMa3DS4JR19Ce9bkvLdWzfknPJmnwo35+k3RLkIDZ+rQoA/OxzOI2UE/fSjjS00Tv59/0RNXjFh4X1K+QPZ2y8uzLNicCfM1g4R596ASmet3ZCr/jnpCDWl1Fqj9TbsbygNZOX/12GhMbFY1S8rnw4527GczNBXXZWXw7ryWqwvI3zS4JITl7vGMz5RO/OdVx+PLl69pjmmSl852UKf/0KoV69/NhPwLmgO+zw0Z402J1+Xx7Rnf0SQq5XnzncNlzWwnXpu18j+LsL4AnMa3VkS8NY97148aQvdSGG71A9QtlmZXxE9mQv7IoBoATm18NuJjGXfuPlpWa45z5/bFi9QOlR3r3fnyx6Ndb8L9Yzi9Ovqojove3XSimSjlofGmmdEskvJLUvc+i+l4V5T4O/nlK+N7M56A01uX8d48f0aj2781+nlNcvbcvjjRdH9kxU9mXC8hwzl5ebT7Rr5rV7cYZy8pv0Ql/vZgHLLdHODc1aKmPvS7WVOcPaMvUn6i18VZXtMpcZ/WgDnRLRGfOj4S79vcGI2hUj4LO+rU6YirMiF/UHeAOTOU59UNq6biL2oKSfmsZKe5MUq8M6K/CBAwd7nlmqaJD2XhM5ThVqmkfHpPZpUcTdzatGtZuI8Mc6uOV755aDpuzRjTHJLyaY0ei5dnQn5VvrxDV4A5VxfWWtOUeGOGDX8l5TP44Xtxe7QLDK3VFWB+lIi3FruwS8pn2lnycLtuAPPqLaXEph0HirH/kvLJZQcZHVTJV+gGML95punEdUOjsV5TSMonlR2kTqOuu4h4AAHzq86HqDv0XKkpTm85r31Rd/ZdowvAeVBivGmnYKNSPmknuVKVDOfNCxu5IimfNCnX3aeHdQE4Ly4rNgKWlE+pcT8ZzqO1zjdJ+XTq/S07RsP5Mep8k5RPZySs/QFIygvqZ7d0KZwfxzNmNYOkfCq96E/qA86DuqbyMc0gKZ/KdzNs7Ajnx3MZhzWDpCwpwwLQROxv2nMOSfkkSuzO/x7VBeA8nG5N7Mx4RktIyqf66N4Xdf9q4HzYnufcdzSDpHyqpLxTpQzn6bq0xPbSk5Ql5VP1khKP5uFAGIEB818ll3hidjr2awpJ+aSOd2MiD/WTe0o3gHn1UF6ZPnPVusaDdUn55DZf3NRkvC1jr24A86eJuL9pr0o5AyuXe2cp7brK1+oKMOfqZJFnp0fiv4WJIyrlM1E6/fvK38x4XleAObevlLh3kJA9u5GUz+BjfCj2Z0/Zki//t64Ac3t65bn1aBY+H9/cNL0MSVlSPr3aWfLwjewtnw33vGAu1Ykin5kZ7g89RVI+c8dHYqI08XAm5od1B5gTdY2LbdHE/Vn4GHEhKZ91tVyXE3w6E/Ov6w4wJ76V8cDGkeYbmuLsWU/4BBNT5d/m4e0ZV2gNOKeMUhPyr8dwfGK8aboa5Oyt1AQnGIkPxnRePZR4T361RoPAWdmZ586HSonPbZSQz5ntkL5fXaDo32R8Oaz9CmesROzNy+4PNe25Y00ZSXlu5OXWbOnFY/nytzO+ENZ/hdOpY5BrQv6XmUw+m7Fv45iHey+F2xcvkh3qyORU+b3Z/ppFsSo726vDrQz4QWrRsjOa+OKqmfjXr1jTGFY6BzzoO4l9h8vozIq4pTTxgbw28/APvqfe5tuV8VAmkPumR+L3NjeNadSS8vzbUUq9vTO0qhu/lg3181oE+vbk+fDLTRN/cMVI86TmkJQviF3d8vZOiQ9Gezvj4vPwVx4oGU276/Z13gHOwG9l/NlBfxma4z+7v7hQKfHPoxOfKsOxY1M7IxZJ+YIl5UuybL46Srwmv3xTxlszXjYPf1VdHOlrmZDvzUrk8abERXki/Ha+UyP5/RXeCX6AOvxsMk/me3pNrM0+87pBcr4j4/o49wf6NenWpW0fzPhSaWJrfuep/NP2Z1LubrKexbzwoO8MbRppnt1VysGm29894ak8AR7P402Djr8+Y/QlfMjVIUSTNRlnbMueXkeAPNSsiO90ZmJ0NuJ38+u3Df4eH6S82LMZn75iJLbtyAQ80o19dTGg/N41UQuJiM21C2esGxQSqzPGMlYNfv/xaO8T1374XMbBaO8Z7x0c/zg73VNHh2Pn9aZNq5QXoidLaUaPxUWdXlydnf/2/NZVGeOD46WDzn/xIFEPDyqVWnXUDl3HPx8YdPya4OvuJ9szduab8UivE09PDcXh60+4NJzolhuyQv+FfPmjGa/0DnCCOgLiwbya+vDGsebrJ/4fOw/2n4kMr1yV/XJFXJl17dryvaS8+oSibGZQbR/NPvhcVsSHYja+3evFZG82DtsxRFJedLLzj61YGRuysr0tW7R2/vWlHa1x0aDz19sOdY2Nel/uuWz0vdnxJzPRfrteDs4cjyey459ywP3ubrkr/9yfypd/Jc7PPW0Wh1rF/teskj/auJ3g9gWtQUL91iDmxcaR5gt7pkqntJXym7U6A1/slfikhLx0mNG3iGwYbbZkVfRPM/6T1iDaZxD3bRyzGptKmQvpKxkzWRc9X5r4xXALarmq95K3lF58SVNIylzYavngnqOlVkj1/vQlGa+P9v61q57lZUuU+FyZiX2aYmlRZS1iE0fKjZmK35Evfzra4U+rtcqyuVr6aF4tfX7DWLNfc6iUWSDGVzffnJguB6LXXzDpL2TcmHGZllmy6gieOnSt7hC9VUJWKbNA7ShlaNVUf4bhzzRN/Fi4lbFUHSn5djcj/Vml0+PtVmZIyixUE0fL2jzckin541Hih7TIkjKT7+nne534wCaLAC1pKqolVkllfD0/ad9fmvhYtFNt7aCy+NUxyDuyhPpEHndrDpUyi+0MLqWZmI4r6qzCTulPA68jNOqa0K/QOosyIf+/PFPvzZP1NzeMNM9rkqXNg76l+Enbzu7as7WUyfXd/lY9T0U72/DmjB+Odp2O1a6UFoW6592n8g39w3EJWaXMkqmcY8+xWNsrcVNm4Xuy9rp1kJjrSI2LBjGkpRacp/O9+o08/q/xseYxzSEps0Q9W8rq6W7cVGqCbhftr9Xzei2z4PyjjP84Pto8rSkkZZaZyalyzUyJGzpN3FHatXc3RHsPus4WrKM66u2OVYM+U2cT1oeKh6Jdy/eZ+kfk73siK7vtTdNP8u/NuFLLntvFTf7vI1kd/4qmkJRhTkxMlfpg8ecy3hXuXZ+puob2toyPZXX87zTH8uRBH/Pli1HH1jb9PvbmrPxGNckpy6Op/O8fZTvd2z+iUoY5r5a7pS7G/5aow/FK3B3tw0X+tLoTze/n2XhfHreMjzR7NIlKGeZcJpcDk1PlD/KafFdp12yoiyfVER/DWudP7M0PrK2liU9kGz2yybA3lbImYL5tLaX2sxUbpuP9pcQ783Vdu6EOw1uuu3PXNSvqTMs6O++38iz8ZH5M7Rg/YV9GJGU4Lyamy13Ri4/myz+TsWaZNkNNyF9pSvzahrHmk3oFkjIX1PZSVg914+66EWzTxF+K5XMbrVbID5eIX5keic9c2zRH9AZezD1lLoR6f/nB/uV7iT/M0uDvRV3dbmn7ev6sv5vHL+TP+7VBG4BKmYVj9+FSp3a/vFnRn1n4tow7oh2hMbZEfsS6y/lEtBuc3p9J+aHSi50b1zRW7kNSZuHqr2o3FTc3TT8p13hVtFO/F+suKnWG4/bB1cDXSomvjY9G3XG6NI1TDkmZRZSc90zF1SXizsxddSZgXdWuTvOu452HF3B/ravyTUc73nhvtLPyHsrvfnrDaDw9WLUPJGUWr11Hy8vycFOn6U/VflPGxli4K9nVB3g7Mz7bK/2F6LdtGjPeGEmZJWqylJHZbtyc5ea7s8f+SNadd8aFH053uDSxNavhB+uu0itGY8v6pvHwDkmZZZGUO5mUx0q9x9zEuvzWukyE9d7zDRm3ZVwV7f3nVfP0Tzge7X3iWg3viOjPwKsP7w5mUj6Y/5aDmZQPrTf5A0mZ5eax0r8921nXjbVNWy2vGxxflhnx0ny9KX/F5fn1xqZN1Bfn1xfl63o7pN7+GIl2KGjt+zMZdSGgY/lrjuY3vluTb6kJuMQzTRPfztf7Ou0IiudLO+mj7ih94OBIf9nS3q0e3CEpw/erDwifOR6rpnuxJjv0pdGLtdmzL2naqdxrMomO5uvRQTKu1fQL07trZVvXhp4p7YO6bv66Q6Um5xLPRyf25+tDw504cNmqOO6BHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAi9r/F2AA9MxJ5lz5kUMAAAAASUVORK5CYII="

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAD+CAYAAACA/DjlAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEjhJREFUeNrs3etzJFd5x/Gnu2dGI2kv8tqGisEgQnCA2F7JZoMLApYwJJWEJKt3oaiUpZAbr2L9Bez+BZZfEW5ZbRIb3nmLKjCGF5bNpUgMeBbjisF2RWBIcYs9K+9qNLfunHOmtauVdZmemb6e72fdNfLWzq7U3fPr5zl9ulsEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIbgsAqwW/fpm6bVy3T4vzu/1t666/+HUVfLxV3/X9v+2jv12xpbAwSW3WE0pV5m1LL9ejx81eYy+m3XwjBbV8tPw1e91FSo1dmqBBaKUyXN7aiKtoOqaNZ2VGs63NapzggsZDecZsIwOhm+FjWYBgmyWliVrRFiBBbSa+l05XQv4TRwiD0ZtpTrrBICC6MNqO1wmpNr400YjfUwxJ4MqzACjMBCxJCaC8PprwioVALswo4AY1CfwMIeVdTpMKDmaPEyZTu8LlB9EVg2h9R0GFL3U0XlRi1sH88zgE9gEVLIY+tIeBFYhWz3/pmQKnR4nVfLKm0jgZXXoNqupE6zNqxrGx+S3pgXA/YEVuZbPl1JLQoD51AVV9gyrrEqCKwsBdViWE3NsTawT8v4UNgyUnURWKmElK6gHgiDapo1orhVkfIbr/+9jvp8di+xbnp0WOmB+rOMdRFYSQXVzI62zy7e8V4gqSXQX5tF5XbpeH/v97dE2r9Sr01xOuq1o4JMv+rfs89aGFy0iwRWLEGl271PWdX26XCqvEUCtehXU0HFpfVTcVo/E9l6wbYAWw+Da5VPGYE1iqBaFJumJJTfIMH4HSJjt/UqqDQEWya4nOZPegFmT3AxzkVgDRVUuqKatqHVC8ZvN0tqIbVvG6nax8az4mx+35axsHoYXCsEF4FFUO1UuVWCahhUedhZWy+Lc+Xbqn18meAisKwPKj3B80FrgmryfRKUb83pxrqkgus74mw9Z0twLTPGRWBtB9WcWDKYHpRuluDo/GiCynHUf544rlr0L7d08L/td3odnnoNgq76jWD4b6Hza3Eur5nKywLrwuC8vYEVzko/Z0NQiTMm/pE51f69e7i/xiuLq4JJh5MOq6HCU4WWDjETYN32cN9X++fivva42qgbNuy6tbDiWiOw7AiqqbCiesCGnzcYnxV/8h4TWoMVUp64pTEVUmVTVcXzTQbid1squJrqS3/gv8bd/K5qFb9ry66sA2vJtgmoVgWWCqsHwrAq/nV+3jHpHvmIav/ePNiH36uoZcy0fIkGrKq4up2tqy1k9DbxN+Je/oZ5tcRZsWhg3orACsep9IC6FXOp/PEZ8SfeO1BVtR1UKqnSrQx1u6iDS493DRK4V54St2HNbaqsGZgvdGCF7Z8OqkU76uUxVVV9WILK7w7Y+lUPHTxPPLhUq6grLvVV9J+p/QvxXvuKemvTpjZxucg3FCxsYFnV/umPs3dTL6xKN0XcARwzRmWqqqz+bOqX3940A/SRd/Duhgqtr6rX39o0+lHYNrFwgWXV2b/tFrDyNulO3he5BXRU2+eVJ1Jv//qvttqq2moM8MameJvfErf5vE2htS69Qfk1Aiu7YXVGetf9WXPzPL96p3Qn/ijy+8xYVamau5838Lum2goGaBG9xtPiqsUyK9Kbv1WIaqsQgRXe8kVXVVbdM70zOa+qq3dG/+CqoNKBldv2V/3q6tDyow/Iu63npXTlCdtCqzDVVu4Dy7axqqthNaHCauz3o4dVedK0goWoLjtb4vvRJ526zR9LadO60CpEtZXbwLJxrKq3xSoqrObEL09He5vjheNVxRq29NuNwUKr9RMVWmtiIV1tLeT1TGIu997wQuVztlVVOqzakx+VwLsx4qczDKuCnhT2O42BLu8xodV4UiylK60zBFa8QWXXvKpd2pN/Ln7pd6isRlhpea0XbA4tXWLm6vKe3OzFtg6sb+uMf1C65XdE27imshoXW67AMmNaA1RaXluH1lO2hlY9DK0LBNbowmoxrKysfNZfZ/wD0cNKz1y3KKx2hlYwUKX1nJS2/lMspieaLhNYtIDDhdXYrFqiFZWmDSyNF74N3He/0VMeBrgGsdz4pqq2XrQ5tPRA/HyWzyJmdo8OzwI+amsLaNZB+fekXf1A5PeVKpNi970Z9TytxkC3qqlsPiZu95c2h1Y9DK1MnkXM5F4d3l3hUbH4ce+Be0Kak38Z+X1uaUIc1xXrqbDSlVbkD0TQUqH1ZXH8y7avwaUs3v0hc4EVTgR90OrPmntEmuN/YaYxRAqrcnXoO4EWaj0G+jKeregfCv8VqTQeN+FlOf3IsSUCa/+w0mcBF23fS5oTHxVfVViRwsobM7cvxvX0VAd9N9OovPZLUml+mxWYsXGtTARWOLiur5WYsX3vaI29T7qlt0fbiCqo9C1isE9omTOH0QfhK83viNd5iRWYodnxqQeW7fOrrlsX3q3Sqt4bbQM6rgqrcT5SBzeHvdvSRHxSj24JxxpfUa9XWIW9wfiFtC+gTjWwwrDSldWU9R8pZ1K2qn8WcdzKEa9i31yrgdZv4JvZ8JE/IP6rUt36KivwmlQH41Pb022fDLrbVvVPxXdviPQec0tjBtn7D60Bx7PK7WfNgqtSuw4xlcAKw+oc272nXb5D2qVoj4vX97PSzwlENIOOZ1WbXxNXVVu4KpUziIkHVnhX0E+xvcMPkKqqtsb+JNpGCx8YgYHqLDOpNOpDLVy/bkIL14eW9B56kdgZxEQDi2kLe7SCKqyitoJemXGr4VrDrmoNoz9Jp9z5kWoNf8QKvF6i0x4S2+sJqz1aQdUGtkp/ELEVTP7hpoWsbPVTpiO2ho60Zbz5OGcNUwytRAKLsNrjKO9MSmPsj1Vj0v84lJlvleN7sWdrAwQDPe/Q838j1dYTrL+UQiv2wCKs9mkFK3PSdW+OsKHccHIoreDoMmuw1rDaWjPBheRDK9a9n7DaZ724t8hW+f3RWsHSWG6eH5ir0Oq2oreGqiWcaDE3K43Qivvis4ekN4N9hu0YfkBUC9gsnYzUivQeH+9EnqmN/tZtEPGJ0oEzIW3vHVLuvsAKvJ4OqbO5rbB2VFpnhKkMRst7t1re1f8GclyuE4z7IGLOGrYifnDaqsp6zLzC0LdYXsr9GNaO0LL+mkF9ZN4s3xdhoN3pTRClFYydOWsY8YZ/le5/m4WqKrl7wjNxNEHN0t3Sdt8aoV0pM4UhwWbd7zQjfnh0lfU1m6usRKqqVAPL1mpLV1dXSv3PaNdVlcMUhoRbw07k8ayK/7yNVVZqT9pJ+24N1lRbW95dqrp6S9+bxStVhCkMabSGrUitoa6uJttft6nKSryq2inVwZHwiu9Z6Z0KLayuc1OEsFIbxbSBhFUanIh3bdXjkW3v7Tasmu2qaiHNu49m5lMR3stdV1uFu93Mpvd+E1q0gnlpDduR5maZKqvzjSJXWWuSkSdEZ+2e7tPSG9uaK0yL4RyXK17/dxHN2Wz2+o7q+LDnvZ8MD0bT4ZLt7WYG4Puf9zbm/1gqailgVaXnVa1kpgLOZAtVoGpry5uVtnNr3+1Ihm/IVzdHWscEkw6p2rE7Pj1wa7Dx7CfnTHAFcm94gMpUiOnLdqIMwOvq6kjnMaoqGwOrKNWWL/rM4H19b4oMXtisd9YL6ns7f+zOT8c6zrjxw0/q7X1aRcX9kpGzx0G3rSc79P3nq92alIOXqapsDKwiVFsNd6bv6srVdw/NxgRRvcNeUDvGQ8fu/JdUToZs/PCfdHgtqobs/lQrryCINAPeCy7JpP8UVZXNgZXXakufPXrN62/elZ4c6jipP1NQ76Tn1bJy/ORn6llZj5cu/uNieMBKJbiCoBNpAF4HlhdsUFXZHFh5rLaa7m3SdG7rYwuoVtAtp76zHj/52UzvrJcu/kNqwRWlytIt4bh/kaqKwLoaWlNhtXU6y9/nZfdD4svhzwvstYKpbQYVUo4Oq3petr8KLnXQCpI9aJnWsP8pC0f9XEwkzU1VlevA2hFcp8Pgyly11XbeLA3nZJ+tYCpnBfVRdfn4zOdyOWH3Uu3vEz9omct2+pwBPx5cVJXWz6mqCKx8VFub7j3SkROHtoJOOq3g2amZz5+RAqjX/i7Rg1bQZ2voyYZM+t+iqiKwsl9t6TbwsjvfR3VVSroV1NXU0tTMFwp1GVS99gm9zR+VJE7IqAqr3wH4I/4T4kojS6sqt1VV4QIrS9XWlvMuaTrThxRXibeCq7oFnJr9Ql0Kqv7MJ3TVGPuF9OaynT5mwFeDF2UsyMQdSXNfVRUysLJSbW04Hz7wBn2OaQUTncKggupfV8QC9Wf+NoFtrwfgD58Br6uro8EaVdWIFe5WluE9et4WVhWJassb1e5ckt41aHsvvcoqSGLRR9YFW8JKUz+r3vaqHw9q8a1X3c67h/45X6rSlWNpVlX6iczzRQqrQlZYu6qtufCIO53Ev9dw7pCWvOmQVtBNaoedn7rrXE0sVP/Bkq6w9MMDY7vExzfXGR7cGlZFt4UvUlVRYfVdbemNp++3FXuVoSurltyy/1FXD7CrJYj/V00ts7aGlam07jpXV+tgXi0X4lrL/VRZbXkDVRUVVjarLV1ZNeT2/Uqr8N7ssa9u80y4G+5arQuMV3+wGN+zMc0dHQ6em3VUnkribGGhqyprKqwkq63OAUdT0waag24Q56LHbQirXdT6WFLrZjWWda4/PodMTYm5yrKiqrKywoqz2tLt4IZ8aP+win8KQ6+yuvs8YbVfpfX9+2OqtIID75tVll/LRDx3ALemqrKywoqz2tp3VrsZtzp8rGPIpVdZEVYHV1p3n19S62k1lrOGBxyQDr3igaqKCivpamtTblel/y2vX7luEpWVo8Lq3wirviutv4ml0jLXGQZ7nzWclO+pGvwVqioCa6TBdUYGnCl9SeZfN1m0N30h1tVbU3/9/Im7/52wiuiV78UVWntftlOVl8wyZFVVmNnqBNboQivyA167clRek3v2CKtYu219hJ098R7CaojQekZGPk8r2DO0SvKqHFFVFlXV8FxWwTVqp6ipRY9tne33Pa8/C+SES5wz2IMFwmrocIlhRry5M//r/qWO3DBoVWXtWBWBFS24dHvY1wNeO8ENO/ZZJ+6Z7GYG+4n3/EeNrTQctQ7NupRRP8TXCQ9Yu7JMV+KR2n21/9EC0hIO0ibq8Np3bKsefOTaynRjz3/VBj5MWI20Nfy4voznf2TEF0zvnlA64TwnFfnfft56NjxgggprtNVWr9TfvqjZjft65iXCKo5K6+G6Wrf6rEl9lNvL2TWdpRsc6beqIqwIrKFDa+fYVn332EQCFzQvnTj18CpbIqbQOmUOBPM7t+1ousNr+8UhLaGuqnRYcUAisGKpttbMThgc3bFTxlZarRBWSYVWsDz6SaXOdQc3qioCK+nQWtdnbtSXy13n5rj/udUTpx5ZZq0nFVqP6APD0mj/VudqaO16ihJVFYGVaHCt+OLOquNoLabaak19gJZY08mHllr3K6Pdlr1bC+mb+lFVEVipufHUI7VwPs9qDNcHLrCGU9uuy6PfprotvGWFqmrYehUj8X9Pf2xRvTwow58eNwPAN576IhND09+mo7qEZ10tC2qbElRUWFk5Kn9xVR1IZ9VSG+JArE+tLxBWGRHI8pDbUy8rer8grKiwsntk/q+P6UrrgYhvMzOvb/xDduyMbctB7w+vt+eS2p4XWIsEVh529NPq8NrvI6fq+jYxhFWWQyuIEloqpBwdVlTKBFaedvS/npbe3R/mDvmjKqy+tMYay/S2nAkrralDqqqzaltyDSCBleud/Yzsfz2iOhJ/aZW1lPvQ0tXxgtqW66wpAqsIO7uush7dtbMTVsUILV1VnWHtEFhF29mnwtCaI6wKEVrhwDrtPIq/wyPf23A6PAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABLy/wIMAA2gu7Klhjv9AAAAAElFTkSuQmCC"

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hand_mockkup.1eb70cd5.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/main_structure.d1fa1e3a.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/branch_row.044747c3.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brand_row.35524ab2.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mainVideo.d06d148d.mp4";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/changeChannel.11687ca6.mp4";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/depth_view.e0996ae5.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_icons.eeb4354c.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_icon1.837f805f.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_icon4.77aba8d8.png";

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_icon3.4371070f.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_1.b703ec32.mp4";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_2.d4ce96ae.mp4";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live_4.acf798af.mp4";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/before_translate.18d38a7b.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/after_translate.1bb8f3fc.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/selection_tiles.7ef18c43.png";

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Intro__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Role__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Develope__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__conviot_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__conviot_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__conviot_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Conviot=function(_React$Component){_inherits(Conviot,_React$Component);function Conviot(props){_classCallCheck(this,Conviot);return _possibleConstructorReturn(this,(Conviot.__proto__||Object.getPrototypeOf(Conviot)).call(this,props));}_createClass(Conviot,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);var elem=__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](this);// Set the opacity of the element to 0
elem.style.opacity=0;window.requestAnimationFrame(function(){// Now set a transition on the opacity
elem.style.transition="opacity 250ms";// and set the opacity to 1
elem.style.opacity=1;});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Intro__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Role__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Develope__["a" /* default */],null));}}]);return Conviot;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Conviot);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_intro_msg1_png__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_intro_msg1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_intro_msg1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_intro_msg2_png__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_intro_msg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_intro_msg2_png__);
var style={wall1:{background:'url('+__WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png___default.a+')'},wall2:{background:'url('+__WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png___default.a+')'},applet:{marginTop:'-30vw',marginBottom:'30vw'}};var Intro=function Intro(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs full-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs start-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-6 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'program__title'},'CONVIoT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-md-11 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'program__description'},'In October 2016, I joined CONVIoT team as a frontend developer. CONVIoT connects various IoT devices and app/web services. There are already many IoT services but because vendors force users to download their own service, it is difficult to maintain all those services for the user. CONVIoT helps people to manage all IoT device and service at once.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-14 col-xs-offset-3 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wall1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner cross--cyan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img wall1_img wall1_img--blur',src:__WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner cross--cyan wall1--shift'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img wall1_img',src:__WEBPACK_IMPORTED_MODULE_1__img_intro_wall1_png___default.a,alt:''}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs',style:style.applet},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applet shadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_intro_msg1_png___default.a,alt:''}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-md-20 col-xs-offset-2 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wall2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner cross--purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img wall2_img wall2_img--blur',src:__WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner cross--purple wall2--shift'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img wall2_img',src:__WEBPACK_IMPORTED_MODULE_2__img_intro_wall2_png___default.a,alt:''}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs',style:style.applet},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applet shadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_4__img_intro_msg2_png___default.a,alt:''}))))));};/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intro_wall1.8c9423ad.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intro_wall2.ea184d20.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intro_msg1.8f9bf125.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intro_msg2.70e542a8.png";

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_problem_png__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_problem_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_problem_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_structure_png__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_structure_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_structure_png__);
var Role=function Role(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--2-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__title"},"Role"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__description"},"When I joined Conviot team as a frontend developer, I thought draft service usability structure was unfriendly and does not explain to the user. Due to this, I started redesigning some flow and structure of service with our team designer. I considered both usability and possibility of development at once.")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_1__img_problem_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph"},"In many aspects, there were some problems in the draft. Among many problems, I thought it was derived from one reason - complicated structure. Because of that, the draft could make user confused and lose direction."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-md-16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_structure_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__paragraph"},"At last, we fixed up flow structure among component to redesign service. Thanks to this flow we could make user approach metadata when users hope to use."))));};/* harmony default export */ __webpack_exports__["a"] = (Role);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/problem.84a6ece1.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/structure.22ee1469.png";

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_1to2_png__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_1to2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_1to2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_2to3_png__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_2to3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_2to3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_card_action_png__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_card_action_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_card_action_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_card_condition_png__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_card_condition_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_card_condition_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_diagram_png__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_diagram_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_diagram_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_card_app_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_card_app_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_card_app_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_meta_png__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_meta_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_meta_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_number_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_number_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_number_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_string_png__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_string_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_string_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_transition1_png__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_transition1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_transition1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_transition2_png__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_transition2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_transition2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_transition3_png__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_transition3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_transition3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_wallpaper_png__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_wallpaper_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_wallpaper_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__video_condition_input_mp4__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__video_condition_input_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__video_condition_input_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__video_action_input_mp4__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__video_action_input_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__video_action_input_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__video_transition_mp4__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__video_transition_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__video_transition_mp4__);
var style={pageMain:{top:"-3.8vw"},condition_card:{marginTop:"-62vw"},action_card:{marginTop:"3vw"},applet_card:{marginTop:"3vw"},action_input:{marginLeft:"-6vw",zIndex:1},transition_row:{marginTop:"-20vw",marginBottom:"20vw"}};var Develope=function Develope(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--2-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__title"},"Develop"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section__description"},"For the user to access platform easily, many aspects of functions need to be hidden. It means convenient service makes the user think what they can do, not how to do. To achieve this goal, I developed with two principles - scalability and explainability.")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"pageMainBg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"100%",height:"100%",viewBox:"0 0 2400 1000"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{id:"pageMainGradient",gradientUnits:"userSpaceOnUse",x1:"2049.6487",y1:"-351.3515",x2:"352.3516",y2:"1345.9456"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"0",style:{stopColor:"#41B3CA"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"1",style:{stopColor:"#6451D0"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"url(#pageMainGradient)",d:"M2401,994.594c0,0-400-199.084-1200-199.084S1,994.594,1,994.594V0h2400V994.594z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner ratio__inner--overflow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs",style:style.pageMain},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-md-16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_13__img_wallpaper_png___default.a,alt:""}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title"},"Make procedure"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title"},"clear & simple")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-2 col-md-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_5__img_diagram_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11 col-md-11 col-xs-offset-9 col-md-offset-9"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--2-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_1__img_1to2_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-4 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_2to3_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.condition_card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-md-9 col-xs-offset-4 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img card shadow",src:__WEBPACK_IMPORTED_MODULE_4__img_card_condition_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.action_card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-md-9 col-xs-offset-11 col-md-offset-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img card shadow",src:__WEBPACK_IMPORTED_MODULE_3__img_card_action_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs",style:style.applet_card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img card shadow",src:__WEBPACK_IMPORTED_MODULE_6__img_card_app_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-24"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title"},"Design User Input Interaction")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"develope_bg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"100%",height:"100%",viewBox:"0 0 1000 692.5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#ececf0",points:"0,0 0,442.5 1000,692.5 1000,0"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row middle-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-md-9 col-xs-offset-4 col-md-offset-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title component_title"},"Condition"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"condition_input shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img",autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_14__video_condition_input_mp4___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5 col-xs-offset-2 col-md-offset-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_8__img_number_png___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_9__img_string_png___default.a,alt:""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row bottom-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-9 col-md-9 col-xs-offset-7 col-md-offset-7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title component_title"},"Action"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"action_input shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img",autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_15__video_action_input_mp4___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-5 col-md-5",style:style.action_input},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_7__img_meta_png___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-8 col-md-8 col-xs-offset-3 col-md-offset-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"transition_effect shadow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio__inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{className:"ratio__img shadow",autoPlay:true,playsInline:"",muted:"",loop:true,poster:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_16__video_transition_mp4___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs col-xs-offset-1 col-md-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"article__title"},"Oriented transition effect"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row",style:style.transition_row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-9 col-md-offset-9 transition_card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_10__img_transition1_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-9 col-md-offset-9 transition_card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_11__img_transition2_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-10 col-xs-offset-9 col-md-offset-9 transition_card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_12__img_transition3_png___default.a,alt:""}))));};/* harmony default export */ __webpack_exports__["a"] = (Develope);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1to2.b4c2ac14.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2to3.68bcd35f.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_action.88dc61ee.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_condition.12c5fa5e.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diagram.48788683.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_app.70e542a8.png";

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/transition1.1fcf18c1.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/transition2.37d151c8.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/transition3.359466f4.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wallpaper.1d7bad31.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/condition_input.9eb4d538.mp4";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/action_input.95d0f3ea.mp4";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/transition.fd194a76.mp4";

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blendStyle__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Intro__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__var__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ndf_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ndf_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ndf_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Preview__ = __webpack_require__(216);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  background: ",";\n  color: ",";\n  width: 100%;\n  overflow-x: hidden;\n"],["\n  background: ",";\n  color: ",";\n  width: 100%;\n  overflow-x: hidden;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BlackContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_3__var__["a" /* colors */].semiblack,__WEBPACK_IMPORTED_MODULE_3__var__["a" /* colors */].semiwhite);var Twitch=function(_React$Component){_inherits(Twitch,_React$Component);function Twitch(props){_classCallCheck(this,Twitch);var _this=_possibleConstructorReturn(this,(Twitch.__proto__||Object.getPrototypeOf(Twitch)).call(this,props));_this.blendStyle=__WEBPACK_IMPORTED_MODULE_1__blendStyle__["a" /* default */].bind(_this);return _this;}_createClass(Twitch,[{key:"componentDidMount",value:function componentDidMount(){window.scrollTo(0,0);var elem=__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);// Set the opacity of the element to 0
elem.style.opacity=0;window.requestAnimationFrame(function(){// Now set a transition on the opacity
elem.style.transition="opacity 250ms";// and set the opacity to 1
elem.style.opacity=1;});document.body.style.backgroundColor="#62449f";}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.body.style.backgroundColor="initial";}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlackContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Intro__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Preview__["a" /* default */],null));}}]);return Twitch;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Twitch);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_intro_bg_mobile_mp4__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_intro_bg_mobile_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_intro_bg_mobile_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__var__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(['\n\twidth: 100%;\n\tpadding-top: ','%;\n\tposition: relative;\n\t& > iframe {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n'],['\n\twidth: 100%;\n\tpadding-top: ','%;\n\tposition: relative;\n\t& > iframe {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n']),_templateObject2=_taggedTemplateLiteral(['\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100vh;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(17, 17, 17, 1);\n\tbackground: -moz-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -webkit-gradient(\n\t\tleft top,\n\t\tleft bottom,\n\t\tcolor-stop(0%, rgba(17, 17, 17, 1)),\n\t\tcolor-stop(100%, rgba(237, 237, 237, 0))\n\t);\n\tbackground: -webkit-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -o-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -ms-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: linear-gradient(to bottom, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#111111\', endColorstr=\'#ededed\', GradientType=0);\n'],['\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100vh;\n\tleft: 0;\n\ttop: 0;\n\tbackground: rgba(17, 17, 17, 1);\n\tbackground: -moz-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -webkit-gradient(\n\t\tleft top,\n\t\tleft bottom,\n\t\tcolor-stop(0%, rgba(17, 17, 17, 1)),\n\t\tcolor-stop(100%, rgba(237, 237, 237, 0))\n\t);\n\tbackground: -webkit-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -o-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: -ms-linear-gradient(top, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tbackground: linear-gradient(to bottom, rgba(17, 17, 17, 1) 0%, rgba(237, 237, 237, 0) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#111111\', endColorstr=\'#ededed\', GradientType=0);\n']),_templateObject3=_taggedTemplateLiteral(['\n\tbackground: ',';\n\tcolor: ',';\n'],['\n\tbackground: ',';\n\tcolor: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\tbackground: #231f20;\n\tcolor: #e1e1e7;\n'],['\n\tbackground: #231f20;\n\tcolor: #e1e1e7;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var VideoWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,100/1.618);var GradientDim=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2);var IntroContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_4__var__["a" /* colors */].semiblack,__WEBPACK_IMPORTED_MODULE_4__var__["a" /* colors */].semiwhite);var IntroUI=function IntroUI(){var isMobile=window.mobilecheck();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntroContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs full-height'},isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,id:'myVideo',style:{width:'100%',position:'absolute',left:0,top:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_2__img_intro_bg_mobile_mp4___default.a,type:'video/mp4'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bg__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GradientDim,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs',style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs start-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-6 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["e" /* ProgramTitle */],null,'Twitch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["e" /* ProgramTitle */],null,'Chat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["e" /* ProgramTitle */],null,'Visualization'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["c" /* DemoLink */],{href:'http://twitch.hyuntak.com/',target:'_blank',rel:'noopener noreferrer'},'Visit Demo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-10 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["d" /* ProgramDescription */],null,'This project deals with the visualization work that can visually express, search and analyze the main scene of the video from the video streaming of the game which is recently combined with the chat. Chat used as a window of user response can be effective not only in the number of simple feeds but also in presenting meaningful criteria for analyzing videos based on the words used. In this project, I devised and implemented a visualization that will accomplish the goals that will help the audience after collecting the most frequently mentioned words from video chats. The data used in this project was collected through twitch tv, parsed by Python, and implemented using a stacked bar chart, treemap, and Volume-Bias chart using d3.js and HTML canvas.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-18 shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'ytplayer',type:'text/html',width:'1000',height:'562.5',src:'https://www.youtube.com/embed/As5N7H4kWVU',frameborder:'0',allowfullscreen:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'block-hide block-show-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'})))));};var Intro=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])(IntroUI)(_templateObject4);/* harmony default export */ __webpack_exports__["a"] = (IntroUI);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intro_bg_mobile.e58453ba.mp4";

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bg_css_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bg_css_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bg_css_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 250%;\n  left: 75%;\n  font-size: ","px;\n  line-height: 2;\n  transform: translateX(-50%) rotate3D(1, 1, 1, -60deg);\n"],["\n  position: absolute;\n  width: 250%;\n  left: 75%;\n  font-size: ","px;\n  line-height: 2;\n  transform: translateX(-50%) rotate3D(1, 1, 1, -60deg);\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px;\n  color: rgba(255, 255, 255, 0.5);\n"],["\n  display: inline-block;\n  padding: 2px;\n  color: rgba(255, 255, 255, 0.5);\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SkewText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_1__Helper_pxToVw__["a" /* default */])(14));var ChatLog=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject2);var ChatTransition=function(_React$Component){_inherits(ChatTransition,_React$Component);function ChatTransition(){_classCallCheck(this,ChatTransition);var _this=_possibleConstructorReturn(this,(ChatTransition.__proto__||Object.getPrototypeOf(ChatTransition)).call(this));_this.state={curr:[],sid:-1,start:-1};_this.animation=_this.animation.bind(_this);_this.init=_this.init.bind(_this);return _this;}_createClass(ChatTransition,[{key:"componentDidMount",value:function componentDidMount(){this.init();}},{key:"animation",value:function animation(timestamp){if(this.state.start==-1){this.setState({start:timestamp});var count=Math.floor(Math.random()*5)+4;var this_ref={};while(Object.keys(this_ref).length<count){var cand=Math.floor(Math.random()*16);this_ref[cand]=1;}this.setState({curr:Object.keys(this_ref).map(function(k){return Number(k);})});}else{if(timestamp-this.state.start>1500){this.setState({start:-1});}}window.requestAnimationFrame(this.animation);}},{key:"init",value:function init(){var sid=window.requestAnimationFrame(this.animation);this.setState({sid:sid});}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.cancelAnimationFrame(this.sid);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SkewText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{id:"chat",className:"embed__chat"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB9C8\uC9C0\uB9C9 \uC7A5\uBA74\uC740"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"\uAC00 \uC798 \uD55C\uAC74 \uB9DE\uACE0, \uAC11\uC790\uAE30 \uC0AC\uB77C\uC838\uBC84\uB838\uC73C\uB2C8 \uBC45\uB3C4 \uBB50 \uADF8\uB807\uB2E4 \uCE58\uB294\uB370.....")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD06C\uC73C \uBC45\uC774 \uCF00\uB9AC\uD588\uB2E4!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uBC45\uBC45"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB871\uC8FC \uC7AC\uD3C9\uAC00 \u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"3\uC5F0\uB9D0\uC790\uD558!!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCF54\uC7A5\uC6B0\uB0D0 \u3160\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD2B8\uB808\uC774\uC2A4 \uCF54\uCE58\uB85C \uC6B0\uC2B9\uCEF5 \uB4E4\uC5C8\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uC9F8;;")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBC29\uCD9C\uD558\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC5E0\uBE44\uC158"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key12 "+(this.state.curr.indexOf(12)>-1?'show':'hidden'),style:{background:"#e7ba52"}},"\uB108\uBB34")," ","\uBA4B\uC788\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uBC45\uBC45\uD588\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD750;;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uB098\uAC00\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC544 \uB178\uC7BC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key1 "+(this.state.curr.indexOf(1)>-1?'show':'hidden'),style:{background:"#ad494a"}},"\uC5E0\uBE44\uC158")," ","1\uC138\uB300 \uC544\uB2D8?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2BC \uB300\uC9C4\uC6B4 \uC5D0\uD734"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD558\uB8E8 \uAC1C\uAFC0~~"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C \uBC45 \uC5CE\uB4DC\uB824"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC7A5\uB840\uC2DD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131"),"\uC774 \uC774\uAE40?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45 \uC740\uD1F4\uD574\uB77C"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uB05D\uC774\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544 \uADFC\uB370"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","\uB610 \uCC22\uC5B4\uC9C8\uAEBC \uAC19\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uCC28\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key4 "+(this.state.curr.indexOf(4)>-1?'show':'hidden'),style:{background:"#8c6d31"}},"\uBB34\uC5C7"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB1CC\uC2E0 \uC6B4\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uCD9C \u3145\u3131\u3147"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC695 \uC548\uD558\uACE0 \uC2F6\uC740\uB370 \uBC45 \uD55C\uB300\uCE58\uACE0\uC2F6\uB2E4\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6D0\uB51C\uCC28\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key12 "+(this.state.curr.indexOf(12)>-1?'show':'hidden'),style:{background:"#e7ba52"}},"\uB108\uBB34"),"\uC2EC\uD55C\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"S\u314BT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC120\uC218 \uADF8\uB9CC \uAE4C\uACE0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","\uC751\uC6D0\uD574\uC8FC\uC138\uC694 \uC0BC\uC131\uC774 \uC6B0\uC2B9\uD588\uB294\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uACC4\uC88C \uD655\uC778\uC880"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key1 "+(this.state.curr.indexOf(1)>-1?'show':'hidden'),style:{background:"#ad494a"}},"\uC5E0\uBE44\uC158")," ","\uD074\uB77C\uC2A4 \uC785\uC99D...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC624\uB298\uC740 \uD560\uB9D0\uC774\uC5C6\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB8F0\uB7EC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uAC1C \uBBF8\uCCE4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2A4\uD06C\uD2B8 \uC9C0\uAE08\uAE4C\uC9C0 \uC6B0\uC2B9 \uADF8\uB807\uAC8C \uD588\uC73C\uBA74 \uC904\uB584\uB428"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC695\uC124, \uC778\uC2E0\uACF5\uACA9, \uB3C4\uBC30, \uC74C\uB780\uC131 \uCC44\uD305\uC740 \uC81C\uC7AC \uB300\uC0C1\uC774 \uB418\uC624\uB2C8 \uC8FC\uC758 \uB2F9\uBD80 \uB4DC\uB9BD\uB2C8\uB2E4.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uCD9C\uAC01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC7AC\uD3C9\uAC00 \u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uD1F4\uCD9C\uD574\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB9D0\uC774 \uC5C6\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0AC\uB9DD \u3160"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B8\uC5B4?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB5BC\uC774\uADC0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC740\uD55C\uB3D9\uC548 \uACE0\uC0DD\uD558\uACA0\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB4DC\uB974\uB801"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC5B4\uC6B0\uC2BC\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"BibleThump BibleThump BibleThump"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB5BC\uC774\uADC0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uC900\uC2DD\uD588\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3161\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uD45C\uC815"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD5D0 \uD37C\uC5D0\uD0A4\u3153"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160 \uC6B8\uC9C0\uB9C8")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC810\uBA78 \uAD81 \uCC28\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key4 "+(this.state.curr.indexOf(4)>-1?'show':'hidden'),style:{background:"#8c6d31"}},"\uBB34\uC5C7"),"????")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3149\u3149 \u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8 \u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uB3C8 \uBC1B\uC740\uB4EF")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7EC\uB294\uAC70 \uCC98\uC74C\uBCF8\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uBD95")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB0D0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD601\uC544 \uC6B8\uC9C0\uB9C8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key13 "+(this.state.curr.indexOf(13)>-1?'show':'hidden'),style:{background:"#8ca252"}},"100"),"\uC810~")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC544..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8 \uD130\uC84C\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C \uC57C\uC57C \uC6B0\uB0D0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6CC\uD6C4\uB8E8\uD6C4\uB8E8\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCD95\uD558\uD55C\uB2E4 \uC5E0\uBE60\uB530!!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774 \uC6B4\uB2E4\u3160"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key13 "+(this.state.curr.indexOf(13)>-1?'show':'hidden'),style:{background:"#8ca252"}},"100"),"\uC7AC\uC724")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"apsxkfskrka"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ",".,...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCEAC\uD558\uD558 \uB85C\uC774\uC870 \uC601\uC785 \uAC01\uC774\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uBC29\uCD9C\uAC01\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD398\uC774\uCEE4 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC13\uC774\uCEE4;;;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"3 \uB300 \uB5A1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2F1\uD601\uC774"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B4\uB2E4..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45 \uAC1C\uC624\uC9C0\uB124 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315D\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC0C8@\uB07C\uADF8\uB0E5\uB098\uAC00\uB4A4\uC838\uB77C\uC774\uAC1C@\uC314@\uC528\uAC38\uC528@\uBE68"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4\uC13C\uC138.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD3D0\uC11D\uB300"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"FAKER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC570\uBE44\uC158 \uB9CC\uC138"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC1C\uBE61")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uC5B4?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB290\uADF8\uD601 \u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131"),"\uBC14\uB8E8\uC2A4 \uC0BC\uC131\uC794\uB098")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD751\uD751"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD3ED\uBC1C\uB2F9\uD588\uB124..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC6B0\uB294 \uAC70 \uCCA8\uBD10"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD398\uC774\uADC0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uADF9\uBCF5\uC2DC\uCF1C\uC90C \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7F0\uAC70 \uCC98\uC74C\uBD24\uC5B4..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC544\uD508\uAC70\uC544\uB2D8?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC219\uBA74\uC911\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC30\uACE0\uD504\uB370"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB85C\uC584\uC774\uACA8\uC8FC\uACE0 \uC6B0\uC2B9\uB3C4\uC8FC\uB0C9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uADF8\uC6D0\uB51C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD1F4\uC774\uCEE4....."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774 \uC815\uB3C4 \uACBD\uAE30\uB97C \uB4A4\uC9D1\uD788\uB2E4\uB2C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3148\u3134\uBE61\uCE58\uAC9F\uB2E4.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC900\uC2DD\uC774\uB97C \uC65C \uB370\uB824\uC624\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45 \uB300\uC2E0 \uD5EC\uD37C\uAE09 \uC6D0\uB51C \uCEAC\uD558\uD558 \uB4F1\uD310\uD574\uC57C. \uBC45 \uB300\uC2E0 \uD5EC\uD37C\uAE09 \uC6D0\uB51C \uCEAC\uD558\uD558 \uB4F1\uD310\uD574\uC57C.\uBC45 \uB300\uC2E0 \uD5EC\uD37C\uAE09 \uC6D0\uB51C \uCEAC\uD558\uD558 \uB4F1\uD310\uD574\uC57C.\uBC45 \uB300\uC2E0 \uD5EC\uD37C\uAE09 \uC6D0\uB51C \uCEAC\uD558\uD558 \uB4F1\uD310\uD574\uC57C.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC57C??;")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBE60\uCEE4 \uC13C\uC138"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uCCAB \uC88C\uC808 \uC544\uB2D8? \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uACE0\uC0DD\uD588\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBD84\uC2F8...\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B0\uB0D0? \u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD601\uC544 \uC6B8\uC9C0\uB9C8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4 \uBA58\uD0C8 \u3137"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD600\uAC15...",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"\uAC13")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"3\uB300 \uB5A1 \u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uAC00 \uC6B4\uB2E4 \u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC774\uC81C \uC911\uAD6D\uAC10 \u3145\u3131")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB9F4\uCC22...\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBD88\uC30D\uD558\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C \uC6B0\uB0D0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB77C\uC778\uC804 \uB2E4 \uC774\uACA8\uB3C4 \uB2E4\uB978 \uB77C\uC778\uC5D0\uC11C \uD130\uC9C0\uB294\uB370"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774\uAC74 \uBC14\uD140\uCC28\uC774\uAC00..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD654\uBCD1\uC73C\uB85C \uC0AC\uB9DD...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC9C0\uAC00 \uB2E4\uD588\uB294\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\uB290\uADF8\uD601 \u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160 \uC6D0\uB9E8\uD300 \uBD88\uC30D\uD558\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB0D0 ??? \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","\uD654\uC774\uD305!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC7AC\uD601\uC774\uD615"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC9C4\uC9DC \uBD88\uC30D\uD558\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2A4\uD0A8\uD0C0\uB839\uD558\uB354\uB2C8 \uC84C\uC8E0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uAC00 \uC6B8\uB2E4\uB2C8...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC798\uD588\uC5B4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774 \u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCF54\uB9AC\uC544 \uD0AC\uB7EC\uB124 10\uC0C9\uC774\uB4E4 \uC0BC\uC211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBB50\uD558\uB0D0 \uBC45"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6D0\uB51C\uCC28\uC774 \uC624\uC8F4\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB9E8\uD0C8")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","kt\uAC00\uC790 ;;")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"\uAC13 \u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD568\uC131",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD604\uC544",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC774\uC81C skt\uB098\uAC04\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC")," ","\uC6B0\uC2B9!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBE61\uCE68")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8\uB098\uAC13\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB204\uAD6C\uB97C \uC704\uD574 \uD5A5\uB85C\uBBF8\uB4DC\uD55C\uAC70\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC67C\uCABD \uCCD0\uB3C4 \uBB34\uC8C4 \uC778\uC815\uD55C\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBA87\uC778\uBD84\uC744 \uD574\uC57C \uC774\uAE30\uB0D0 \u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC29\uC0DD\uAD81 \uC2E4\uD654\uB140 \u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uBE61\uCE58\uACA0\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCE74\uB974\uB9C8\uD53D \uC624\uBC14\uC5FF\uC5B4 \u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0AC\uB78C\uBD10"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD601\uC544 \uC6B8\uC9C0\uB9C8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC778\uC0AC\uD558\uB7EC\uAC00\uC9C0\uB9C8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC6B8\uB9CC\uD558\uC9C0 \uC2ED\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE5B\uC0C1\uD601 : \uBC45 \uB54C\uBB38\uC5D0 \uC544 \uAC1C\uBE61\uCE5C\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD0D1\uC815\uAE00\uC774 \uC81C\uC815\uC2E0\uC544\uB2C8\uC57C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uAC1C\uB178\uB2F5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774\uAC78..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uB2E4 \uD574\uBA39\uC5C8\uB124 \u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC9C4\uC9DC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uBB54\uC8C4\uB0D0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC544.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2BC \uC694\uBC88 \uCEE4\uB9AC\uC5B4 \uC2A4\uD504\uB9C1 \uC6B0\uC2B9 \uB05D;;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBBF8\uAD6D\uAC00\uB77C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC6B8\uC5B4\uB3C4 \uB41C\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8\uD130\uC9D0;")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \u3131 \u3146 \u3132"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC1C \uAF2C\uC2DC\uB124 \u3139\u3147 \u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),".....")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD654\uBCD1\uC73C\uB85C \uC0BC\uC544")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC5BC\uB9C8\uB098 \uBE61\uCE60\uAE4C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC138\uCCB4\uC6D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC6B8\uC5B4\uB3C4 \u3147\u3148")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC10\uB3D9\uC758 \uACE8\uB9C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2E0\uB0AC\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC640 \uC778\uAD6C\uBD10"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C\uC57C \uC6B0\uB0D0? \u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7F0\uAC70 \uCC98\uC74C\uBD24\uB294\uB370?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3131"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6B0\uB9AC",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC13C\uBE60\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uB2E4\uD588\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAFC0\uC7A0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC606\uC5D0 \uB208\uCE58\uBCF4\uB294\uAC70\uBCF4\uC18C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uB2E4\uC74C\uBD80\uD130 \uBABB\uBCF4\uB294\uAC70\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC8FC\uBA39\uC73C\uB85C \uC878\uB77C\uCE58\uACE0\uC2F6\uACA0\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"3\uC5F0 \uC6B0\uC2B9 \uAC01\uC774\uC5C8\uB294\uB370 \uC544\uC27D\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7EC\uB294\uAC70 \uCCA8 \uBCF8\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB108 \uC6B0\uB0D0? \uC6B8\uC5B4?\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD398\uC816 \uCEE4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uB2E4\uD588\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC911\uAD6D\uD32C: \"RNG\uAC00"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","2\uBC88\uC774\uB098 \uC774\uACBC\uC73C\uB2C8 \uC0AC\uC2E4\uC0C1 RNG 1\uC704!\"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBB54 \uC8C4\uB0D0 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC1C\uBE61\uCE58\uACA0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB290\uC798\uD588\u3134\uB290\uB370..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB3C4 \uB9C8\uC9C0\uB9C9\uD310\uC5D0 \uAF64 \uB358\uC838\uC368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAD73"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3147\u3145\u3147\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB2E4\uB978\uD300 \uAC00\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC911\uAD6D \uD32C\uB4E4 \uD638\uC751\uC88B\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB0D0?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBED8\uC90C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC138\uCCB4\uC6D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6D0\uB51C\uC774 1\uC778\uBD84\uB9CC \uD574\uB3C4 \uC774\uAE30\uB294\uAC78"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBE61\uCE68")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8\uB098\uAC14\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC1C\uBE61")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE5B \uC0C1 \uD601 \uC790 \uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"3\uB300 \uB5A1.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uB178\uB2F5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544 \u3160\u3160\u3160\u3160"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key13 "+(this.state.curr.indexOf(13)>-1?'show':'hidden'),style:{background:"#8ca252"}},"100")," ","\uAC1C\uAC1D\uB07C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBC29\uCD9C \u3131]"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uB3C8\uBC1B\uC557\uB178"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6B0\uC2B9 '\uB2F9\uD588\uB2E4'"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uC911\uC2EC \uD53D\uBC34\uC778\uB370 \uBC45\uC774 \uB358\uC9C0\uBA74/ \uBC45\uC911\uC2EC \uD53D\uBC34\uC778\uB370 \uBC45\uC774\uB358\uC9C0\uBA74/ \uBC45\uC911\uC2EC \uD53D\uBC34\uC778\uB370 \uBC45\uC774 \uB358\uC9C0\uBA74/ \uBC45\uC911\uC2EC \uD53D\uBC34\uC778\uB370 \uBC45\uC774\uB358\uC9C0\uBA74/ \uBC45\uC911\uC2EC \uD53D\uBC34\uC778\uB370 \uBC45\uC774 \uB358\uC9C0\uBA74")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC548\uB3FC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD0B9\u3161\uBE44\u3161\uC158"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB2E4\uB54C\uB824 \uBD80\uC154\uB3C4 \uBB34\uC8C4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uD0A4\uBCF4\uB4DC\uB4E4\uC5B4\uC11C \uBC45 \uB370\uAC00\uB9AC \uAE68\uB77C \u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774\uB294 \uC695\uD558\uC9C0 \uB9C8\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640 \uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"),"..... \uBE0C\uC2E4\uACE8\uC778\uB370?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE5B\uBE60\uB530"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE5B \uC131"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uB2E4 \uB9DD\uCE68"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC")," ","\uC138 \uCD5C\uC6D0 \u3145\u3131")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC13C\uBE60\uC774 \uC800\uB7EC\uB294\uAC70"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uCC98\uC74C \uBCF8\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBB34\uC2A8 \uC8C4\uB0D0 \uC544\uC624")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB97C \uC6B8\uB9B0 \uB0A8\uC790 \uBC45!!!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6D0\uB51C\uCC28\uC774\uAC00 \uC774\uAC78...."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uB5A0\uB098\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3143\uBC14\uCEE4\uC13C\uBC14\uC774"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC0B4\uC778\uD574\uB3C4 \uC815\uB2F9\uBC29\uC704 \u3147\u3148")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uB2E4 \uB9D0\uC544\uBA39\uC5C8\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key13 "+(this.state.curr.indexOf(13)>-1?'show':'hidden'),style:{background:"#8ca252"}},"100"),"\uC5ED\uBC30\uCDA9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774 \uBA58\uD0C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC570\uBE44\uC158 \uAD6C\uB77D\uC2A4 \uB2E4 \uC7A1\uC74C \u3145\u3131"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\u3161\u3161")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695 \uD558\uB7EC\uAC04\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","\uAC13")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uAD50\uCCB4\uD574\uB77C \uB0B4\uB144\uC5D0.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","skt \uC815\uB5A8\uC5B4\uC838\uC11C \uB098\uAC00\uACA0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uAC00\uC9E4\uB824\uC11C \uB9E8\uD0C8\uB098\uAC14\uB098\uBCF8\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC30\uC900\uC2DD \uC0C8\u3161\uB07C\uC57C \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B0\uB294\uAC70 \uCC98\uC74C\uBCF4\uB294\uAC70 \uAC19\uC740\uB370"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB1CC\uC2E0\uB2C8\uBBA4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key8 "+(this.state.curr.indexOf(8)>-1?'show':'hidden'),style:{background:"#bd9e39"}},"\uD050\uBCA0")," ","\uADFC\uC5C4\uD55C\uAC83\uBCF4\uC18C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD558"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544 \uC6B8\uC9C0\uB9C8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uAC1C \uAF2C\uC2DC\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAFC0\uB4DC\uCEF5 \uC774\uC5B4\uB530"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8 \uB098\uAC10\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD398\uC774\uCEE4 \uC6B0\uB294\uAC70 \uCC98\uC74C\uC544\uB2C8\uB0D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBC45\uD55C\uD14C \uD398\uB4DC\uB9BD\uCCD0\uB3C4 \uC6A9\uB0A9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key7 "+(this.state.curr.indexOf(7)>-1?'show':'hidden'),style:{background:"#d6616b"}},"\uD53C\uB11B")," ","\uB355\uC5D0 \uC9C0\uB124\uC694")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC911\uAD6D\uAC00\uC790 \uADF8\uB0E5 BibleThump"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBC29\uCD9C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC0C1\uD601\uC774\uAC00 \uC5BC\uB9C8\uB098 \uC5F4\uC2EC\uD788\uD587\uB294\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\u3161,\u3161\u3161\u3161\u3161\u3161\u3161\u3161\uB7EC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uC26C\uD138\uB828\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC5B4\uCE7C\uAEBC\uC57C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2C8\uB124\uB3C4 3\uB300\uB5A1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC911\uAD6D\uAC00\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB108 \uC6B0\uB0D0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC774 \uD574\uB0C8\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"100 \uB108\uBB34\uD588\uB2E4 \uACB0\uC2B9\uC804\uC740"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0-\uB7EC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uB54C\uBB38\uC5D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uC796\uC544 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147"),"\uCC98\uC74C\uBCF8\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC2A4\uD06C"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB193\uC544\uC8FC\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC548 \uC6B8\uBA74 \uB9D0\uC774 \uC548\uB418\uC9C0 \uC560\uB4E4 \uB2E4\uB358\uC84C\uB294\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD300\uCE90\uB9AC\uC880 \uBC1B\uC558\uC73C\uBA74 \u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBE60\uCEE4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE5B \uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB9E8\uD0C8\u3139 \uD130\uC9C4\uAC70 \uCC98\uC74C\uBCF8\uB2E4;;;'")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAF2C\uC7A5 \uC6B4\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC6B8\uC5B4\uB3C4 \uB41C\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695\uD558\uB7EC \uAC04\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD6C4\uB2C8 \uB458\uC774 \uB2E4\uD568 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB0B4\uAC00"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uBA74 \uBC45 \uD55C\uB300 \uB54C\uB838\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC0B4\uC778 \uBA74\uD5C8 \uC8FC\uC790 \uC528\uBC14")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key0 "+(this.state.curr.indexOf(0)>-1?'show':'hidden'),style:{background:"#637939"}},"??"),"/ : \uBC45 \uB9AC\uD3FF\uC880")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD398\uC11D\uB300 \uC800\uB7EC\uB294\uAC70 \uCCA8\uBCF8\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB0B4\uB144\uC5D0 \uC911\uAD6D \uAC00\uACA0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC774\uAC74 \uB8F0\uB7EC \uD310\uB2E8\uB825\uC774 \uBBF8\uCE5C\uAC70\uC9C0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC798\uBABB\uC740 \uC544\uB2CC\uB4EF")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3134\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uBD95 \uB864\uC811\uB294\uAC70\uC544\uB2C8\uB0D0?? \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC194\uC9C1\uD788 \uD55C\uACBD\uAE30\uB3C4 \uBABB\uC774\uACBC\uB294\uB370 \uC800\uB7F4\uB9CC \uD558\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B0\uC2B9\uC870\uBB34\uC0AC \uD0B9\uB808\uC774"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774 \uC774\uC0C1 \uC5B4\uB5BB\uAC8C \uC798\uD574\uC8FC\uB0D0\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key7 "+(this.state.curr.indexOf(7)>-1?'show':'hidden'),style:{background:"#d6616b"}},"\uD53C\uB11B"),"\uC740 \uB610 \uC900\uACB0\uC2B9\uC5D0\uC11C...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBA58\uD0C8 \uB098\uAC14\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uADF8\uB0E5 \uB3C8\uC774\uB098\uBC8C\uC790 \uC911\uAD6D\uAC00\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC8C4\uAC00\uC5C6\uB2E4 \u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6D0\uB51C\uCC28\uC774\uC600\uB2E4\uC774\uAC74"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC774\uC81C skt\uBC84\uB9AC\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAE30\uBD84 \uAC1C\uC88B\uACA0\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147")," ","\uBC45 \uC2DC\uBC29 \uBA58\uD0C8 \uB2E4\uD130\uB974\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC778\uC0AC\uD558\uB7EC \uB4E4\uC5B4\uAC00\uB124 \u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uC744 \uB0B4\uBCF4\uB0B4\uC790"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"),"\u034F\u3160\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2E0\uC774 \uC8FD\uC5C8\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774\uB294 \uB098\uAC00\uC788\uC5B4..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC138\uCCB4\uC6D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"`")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uC695\uD558\uC9C0\uB9D0\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","2\uD68C \uC6B0\uC2B9 \u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB180\uB9AC\uB7EC\uC654\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"SK\uC6B0\uC2B9 \uB9CE\uC774 \uD588\uC796\uC544 \u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB9C8\uC9C0\uB9C9 \uB8F0\uB7EC \uC810\uBA78\uAD81\uB54C\uB9E4 \uC790\uCC45\uD558\uB294\uB4EF \u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBD84\uC704\uAE30 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57D\uC62C\uB9AC\uB7EC \uC624\uC8E0 \u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key13 "+(this.state.curr.indexOf(13)>-1?'show':'hidden'),style:{background:"#8ca252"}},"100"),"\uC778\uBD84\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"\uC810\uBA78\uAD81 \uC9C0\uB838\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695\uD558\uB7EC\uAC14\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3147"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7EC\uB294\uAC70 \uCC98\uC74C\uBD04")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B \uC6B0\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC640...."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC9C4\uC9DC \uBE61\uCE58\uACA0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC29\uC0DD\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key12 "+(this.state.curr.indexOf(12)>-1?'show':'hidden'),style:{background:"#e7ba52"}},"\uB108\uBB34")," ","\uCEF8\uC5B4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uC9C0\uB9C8\uB77C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC218\uACE0\uD588\uB2E4...."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544. \uB5A0\uB098\uC790"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131")," ","\uC9C4\u3149 \u314F\uB4DC\uB77C\uB9C8 \uC36F\uC0AC")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"... SKT \uB098\uC640\uB77C...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC70\uC758 \uCD08\uC0C1\uC9D1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD0B9\uB77C\uC6B4 \uAC13\uBE44\uC158"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uB10C \uC218\uC601\uCCD0\uC11C \uC640\uB77C \uADF8\uB0E5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"lck 3\uC2DC\uB4DC\uC784 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uAD70\uB300\uAC00\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBD88-\uD3B8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC560\uCD08\uC5D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC544\uB2C8\uC5C8\uC73C\uBA74 8\uAC15 \uAD11\uD0C8\uC774\uC5C8\uC5B4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCD08\uC0C1\uC9D1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC7A5\uB840\uC2DD\uC7A5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC9C4\uC9DC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7EC\uB294\uAC70 \uCC98\uC74C\u3148\uBCF4\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC194\uC9C1\uD788...\uC6D0\uB51C\uCC28\uC774\uAC00"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key12 "+(this.state.curr.indexOf(12)>-1?'show':'hidden'),style:{background:"#e7ba52"}},"\uB108\uBB34")," ","\uC2EC\uD558\uC796\uC544")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC")," ","\uC7A5\uC560\uAC19\uB2E4 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBD88\uC30D\uD558\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB10C\uC528\uB208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD328\uC790\uB18D\uB77D\uD558\uB7EC \uAC00\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBB34\uC2A8\uC8C4\uB0D0 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB125\uC11C\uC2A4\uAE68\uB7EC\uAC00\uB0B4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC5C4 \uC219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD06C \uC545\uC218 \u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCEAC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC778\uC0AC\uB97C \uD558\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695\uD0C0\uC784 \uC2DC\uC791"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB180\uB9AC\uB7EC \uC634"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC77C\uC5B4\uB098"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C ..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC0BC\uC131 \uC2E4\uD654\uB0D0 \uC774\uAC74")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC57C \uC57C \uC6B0\uB0D0?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key3 "+(this.state.curr.indexOf(3)>-1?'show':'hidden'),style:{background:"#843c39"}},"\uB8F0\uB7EC"),"\uAC00 \uC9C0\uB9AC\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4 \uAD70\uB300\uB098 \uAC00\uC790"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC04\uC808\uD568\uC758 \uCC28\uC774\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC1C\uB178\uC7BC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB290\uADF8\uB11B \uB290\uADF8\uD601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB294\uAC70 \uCCA8\uBCF8\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC2A4\uD3A0 \uC815\uD655\uD788 \uCCB4\uD06C\uD574\uC918\uC11C \uC55E\uC810\uBA78\uD55C\uAC70\uB2C8.. \uC11C\uD3FF\uB3C4 \uB300\uB2E8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD63C\uC790\uC11C\uB294 \uC548\uB428")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC9E0\uD558\uB2E4...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBD80\uAD00\uCC38\uC2DC..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774\uAC83\uB3C4 \uC778\uC0AC\uD558\uB0D0 \u3148\uAC19\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key5 "+(this.state.curr.indexOf(5)>-1?'show':'hidden'),style:{background:"#de9ed6"}},"\uC774\uAC70")," ","\uB9AC\uC5BC \uC870\uC0AC\uD574\uC57C\uB41C\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uC5B4\uB728\uCE84"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB791 \uC0AC\uAE30\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD30C\uCEE4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uC911\uAD6D\uAC00\uB294\uAC70 \uC544\uB2C8\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC77C\uC5B4\uB098\uC9C8\uC54A\uB294\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBC25\uBA39\uC73C\uB7EC\uAC00\uC57C\uC9C0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCD08\uC0C1\uC9D1 \uBC29\uBB38 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC6B8\uC8E0 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uACB0\uC2B9\uC778\uB370 \uB4E4\uC5B4\uC624\uB0D0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"?"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC1C\uBE61\uCE58\uB098\uBD10..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCD08\uC0C1\uC9D1 \u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"vpdlzj bbb"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC744\uB838\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC548\uC77C\u3147\uB108\u314F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB290\uADF8\uC877 \uB4DC\uB974\uB801 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBE61 .\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC6B8\uC5B4 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC5B4\uC0C9 ;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key2 "+(this.state.curr.indexOf(2)>-1?'show':'hidden'),style:{background:"#7b4173"}},"\u3139\u3147"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC138\uACC4\uCD5C\uACE0\uC784\uC744 \uC99D\uBA85\uD588\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD300\uC6B4 \u3148\uB9DD\uAC9C\uC740 \uC99D\uBA85\uB410\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB2A5\uC695\uD0C0\uC784 \uC2A4\uD0C0\uD2B8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uCD08\uC0C1\uC9D1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC4D \uC911\uAD6D\uAC00\uC790 \uC774 \uB178\uB2F5\uD300 \u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD5A5\uB85C\uAC00"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB97C \uC774\uACBC\uB124 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB0D0?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u3160\u3160"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBED8-\uCB58"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC0BC\uC288\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u314D")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBD80\uAD00\uCC38\uC2DC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","....")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC11\uBD84\uC2F8 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC090\uC9D0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC11\uBD84\uC2F8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uADF8\uB0E5 \uC9C0\uB098\uAC00"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB290 \uADF8 \uD601 \uB3C4 \uB9C9\uD310\uC5D0 \uBABB\uD55C\uAC70 \uD329\uD2B8\uC8E0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBABB\uC77C\uC5B4\uB098\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC778\uB098\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC4F0\uB7EC\uC84C\uB124"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC11\uBD84\uC2F8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4\uAC00 \uC6B0\uB294\uAC70 \uCCA8\uBCF8\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC4D\uC9C0\uB098\uAC00\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC545\uC218\uB294 \uD574\uC57C\uC9C0 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6B0\uB9AC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAD00\uC9DD\uC5D0 \uC2DC\uBA58\uD2B8 \uBD80\uC5B4\uBC84\uB9AC\uAE30"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uBA58\uD0C8..",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B0\uB098\uBD10"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uAC11\uBD84\uC2F8"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uACBD\uAE30\uB825 \uCD5C\uC545\uC774\uC9C0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uBC45\uC774 \uB450\uBC88\uB358\uC838\uC5B4 \uC9C4\uAC74\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC624\uB77D\uC9C0\uACE0 \uC9C8\uC9C8\uC9EC \u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC545\uC218 \uD558\uB77E \uBED8\uCB58 \u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB204\uAC00"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uB838\uB0D0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB5F4\uC774\uADC0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544\uC774\uACE0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB525\uBE61")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC911\uAD6D \uC774\uC801\uAC01\uC774\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4 \u315C\u3161"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B4\uB2E4 \uC6B8\uC5B4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC545\uC218 \uAC70\uBD80 \u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6B0\uB9AC\uD601"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB9E4\uB108\uBCF4\uC18C \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB294\uAC70 \uB9C8\uC74C\uC544\uD504\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B4\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAC13\uC774\uCEE4 \u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD604\uD53C\uAC01"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC090\uCE74 \u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBE5B\uC0C1\uD601"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC774\uBC88\uC5D4 \uC2A4\uD0A8 \uAC04\uC9C0\uC880 \uB098\uACA0\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),":\uBE60\uB530\uD615 \uBE7C\uB530\uC880\uBE4C\uB824\uC918")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314D\u314D\u314D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"BibleThump BibleThump BibleThump"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC774\uC801\uD558\uC790")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uADF8\uB0E5 \uAC00\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B4\uB2E4,"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC6C3\uB294\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B4\uB2E4...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD398\uC774\uCEE4 \uD398\uC774\uCEE4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBF5D\uCE68")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC5BC\uB9C8\uB098 \uC5B5\uC6B8\uD558\uACE0 \uD654\uB0A0\uAE4C"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC0C1\uD601\uC774")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC5B4\uB5A1\uD574.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B0\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uB525\uBE61")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6C3\uACE0\uC788\uC5CC\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC640 \uC0C1\uD601\uC544 \u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),".....")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544..\uBE60\uCEE4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC778\uC131\uC774?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC6B4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u3160 \uBE5B\uC0C1\uD601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uD398\uC774\uCEE4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC6B4\uB2E4 \u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","! \uD398\uC774\uCEE4 ! \uD398\uC774\uCEE4 !")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"? \uC65C \uC545\uC218 \uD558\uB294\uB370 ?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC6B0\uC11C?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uB204\uAC00 \uC6B8\uB838\uB0D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBE61\uCCE4\uC5B4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC84\uB987\uC5C6\uC774 \uC790\uB294\uAC70\uBCF4\uC18C \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC544\uC774\uACE0.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774.."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC5B4\uB5BB\uD558\uB0D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C \uBE60\uCEE4 \uC6B8\uC5B4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C \uC6B0\uB0D0?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBEEC\uC774\uAE4C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 r\uD0A4 \uBE90\uC73C\uBA74........."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB0B4 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD398\uC774\uCEE4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC528\uB208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC9C4\uC9DC"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uAC1C\uC5F4\uBC1B\uC9C0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uC9C4\uC9DC \uC798\uD588\uB294\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBE60\uB530 \uCCD0\uB9DE\uC544\uC57C\uB400\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC6B4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBB34\uC8C4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uCF5C\uBD10 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE7C\uC774\uCEE4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBAB0\uB77D \u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uADF8\uB0E5 \uC8FD\uC790 \uADF8 \uAE38 \uBC16\uC5D0 \uC5C6\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB124 \u314B\u314B\u314B\u314B\u314B\u314B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uC790\uB098 \uBC45\uCE5C\uAD6C\uC57C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\u314B\u314B\u314B\u314B\u314B\u314B\u314B \uB208\uCE58\uBCF4\uB294\uAC70\uBD10 \u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544\uC774\uACE0..."," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB294 \uBB34\uC2A8\uC8C4\uB0D0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBE5B \uC0C1\uD601"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160"),".\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uCF5C\uD574\uC8FC\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key1 "+(this.state.curr.indexOf(1)>-1?'show':'hidden'),style:{background:"#ad494a"}},"\uC5E0\uBE44\uC158")," ","\uBA4B\uC9C0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC911\uAD6D\uD55C\uAC00\uC6B4\uB370\uC11C"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key15 "+(this.state.curr.indexOf(15)>-1?'show':'hidden'),style:{background:"#9c9ede"}},"\uC0BC\uC131"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"..")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uD3AD\uD0A4\u3153")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC9DC\uC774\uC694"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC528\u3147\uBC1C\uB144\uB54C\uB9E4 \uC0C1\uD601\uC774 \uC6B8\uC796\uC544"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544...."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uD53C\uC774\uCEE4\uAC00 \uBB34\uB108\uC84B\uB124"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC751\uC6D0\uD574\uC8FC\uB124 \u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B0\uB124 \u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uB09C\uAC10 ..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B8\uB9CC\uD588\uB2E4 \uBE60\uCEE4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC57C \uC6B0\uB0D0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uB3C4 \uC6B0\uB294\uAD6C\uB098...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC6C3\uC5B4? \uC6C3\uC5B4?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC544\uC774\uACE0....\uC0C1\uD601\uC544..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544... \uC6B8\uC9C0\uB9C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B8\uC9C0\uB9C8 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uD608\uC555 \uC62C\uB77C\uC11C \uCE60\uACF5\uBD84\uD608 \uAC01\uC778\uB370")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC6B0\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u3160\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \u315C\u315C\u315C\u315C\u315C\u315C\u3160\u315C\u315C\u3160\u315C\u3160\u315C\u3160\u315C\u3160\u315C\u3160\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uAE30\uBD84\uC774...\uC548 \uC88B\uC544\uC694..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"BibleThump BibleThump BibleThump"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uB54C\uC774\uADC0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uC6B4\uB2E4...."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC624\uC5F4\uD558\uB124;;;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC544 \uC6B8\uC9C0\uB9C8\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uAD00\uC911\uB4E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBD80\uB974\uB124")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160 \u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC11C\uB7FD\uACA0\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uC815\uB9D0 \u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC640"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\uAC00...........")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBC45 \uBA38\uB9AC\uC548\uB9C9\uACE0 \uBB50\uD558\uB0D0"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC900\uC2DD\uC544..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uCC21\uD558\uB2E4 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"),"\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC740 \uC6C3\uB294\uB2E4 \u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B\u314B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45\uC81C\uBC1C \uB098\uAC00\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0C1\uD601\uC774 \uC5BC\uB9C8\uB098 \uBE61\uCE58\uBA74 \u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC6B8\uC9C0\uB9C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key9 "+(this.state.curr.indexOf(9)>-1?'show':'hidden'),style:{background:"#6b6ecf"}},"\uC9C4\uC9DC")," ","\uC6B0\uB124 \u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC0BC \uB300 \uB5A1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC6B4\uB2E4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uD398\uC774\uCEE4 \uC800\uB7F0\uBAA8\uC2B5 \uCC98\uC74C\uBCF8\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key6 "+(this.state.curr.indexOf(6)>-1?'show':'hidden'),style:{background:"#393b79"}},"\u3137\u3137"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC0C1\uD601\uC774 \uBB34\uC8C4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uC800\uB7EC\uB294\uAC70 \uCC98\uC74C\uBD10")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uBE60\uCEE4 \uC6B4\uB2E4"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C\u315C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBE60\uCEE4 \uC6B4\uB2E4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\uBB34\uC8C4 \uD310\uC815 \u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC5BC\uB9C8\uB098 \uBD84\uD558\uBA74"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC798\uD558\uACE0\uB3C4 \uC9C0\uB2C8 \uC5F4\uBC1B\uC9C0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uBC45 \uBC29\uCD9C\uD574\uB77C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key11 "+(this.state.curr.indexOf(11)>-1?'show':'hidden'),style:{background:"#5254a3"}},"\uD398\uC774\uCEE4")," ","\u315C\u315C\u315C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,"\uC13C\uBE60\uC774 \uC6B8\uC9C0\uB9C8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatLog,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"\uC544"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"keyword key14 "+(this.state.curr.indexOf(14)>-1?'show':'hidden'),style:{background:"#b5cf6b"}},"\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160\u3160")))));}}]);return ChatTransition;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ChatTransition);

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_tendency_mp4__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_tendency_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_tendency_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_brushing_mp4__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_brushing_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_brushing_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_drilldown_mp4__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_drilldown_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_drilldown_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_chatlog_mp4__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_chatlog_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_chatlog_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_scalable_ruler_mp4__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_scalable_ruler_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_scalable_ruler_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_tendency_gif__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_tendency_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_tendency_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_brushing_gif__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_brushing_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_brushing_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_drilldown_gif__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_drilldown_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_drilldown_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_chatlog_low_gif__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_chatlog_low_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_chatlog_low_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_stacked_bar_png__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_stacked_bar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_stacked_bar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_scalable_ruler_gif__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_scalable_ruler_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_scalable_ruler_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_scalable_ruler_mobile_gif__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_scalable_ruler_mobile_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_scalable_ruler_mobile_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_before_labeling_png__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_before_labeling_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_before_labeling_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_after_labeling_png__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_after_labeling_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_after_labeling_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_transition_png__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_transition_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__img_transition_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_performance_png__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_performance_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__img_performance_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_feed_inspector_intro_png__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_feed_inspector_intro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__img_feed_inspector_intro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_bias_diagram_png__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_bias_diagram_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__img_bias_diagram_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_tendency_mobile_gif__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_tendency_mobile_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__img_tendency_mobile_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_brushing_mobile_gif__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_brushing_mobile_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__img_brushing_mobile_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_drilldown_mobile_gif__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_drilldown_mobile_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__img_drilldown_mobile_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_chatlog_low_mobile_gif__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_chatlog_low_mobile_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__img_chatlog_low_mobile_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Concepts__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Header__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_styled_components__ = __webpack_require__(1);
var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var Preview=function Preview(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["g" /* SectionTitle */],null,'Motivation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["f" /* SectionDescription */],null,'With the advent of the Independent(personal)-media era and the ability to watch broadcasts via the Internet, the types, lengths, and timing of video content have become diverse. In addition to this, it is able to add a real-time response to the video through chat. In recent years, there have been more and more real-time responses to real-time sports events, e-sports, and presidential campaigns. It can be seen that the reaction of the viewer is projected on the image while the existing image has unilaterally deviated from the limitation that was transmitted to the viewer.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'So I thought it would be a good idea to know where the important parts of the video were and what the audience was so enthusiastic about. The goal of this project is knowing three things like below.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs',style:{overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Concepts__["a" /* HotConcept */],{className:'shadow-5',label:'Reactive'},'Which scene or part of the video was the most reactive?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-md-6 col-xs-offset-1 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Concepts__["b" /* ReferConcept */],{className:'shadow-5',label:'Mentioned'},'What words people mostly mentioned about?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-7 col-md-6 col-xs-offset-1 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Concepts__["c" /* TendencyConcept */],{className:'shadow-5',label:'Bias'},'Among mentioned words, how could we measure the intensity of the specific word?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["g" /* SectionTitle */],null,'Implementation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row top-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-11 col-sm-10 col-xs-offset-1 col-sm-offset-2 shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__img_tendency_mp4___default.a,type:'video/mp4'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-sm-8 col-xs-offset-1 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'idea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title title--orange'},'Volume-Bias Chart'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],{className:'desc desc--below'},'Although there are words as "mostly mentioned" throughout the video content (Volume), the highest ranking of the word does not guarantee that the maximum feed amount (Bias) of this word is highest at a specific time. This information is worth visualizing in that it helps to distinguish between "event indicator" and "universal attention" that should be of interest to the video. I designed this new-type idiom and named it a "Volume-Bias" chart.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-xs-offset-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_18__img_bias_diagram_png___default.a,style:{opacity:0.3,marginTop:'-14vw'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs start-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'idea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title title--orange'},'Feed Inspector')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'idea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'ratio__img',src:__WEBPACK_IMPORTED_MODULE_17__img_feed_inspector_intro_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'idea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],{className:'desc'},'There are differences in the attributes of ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'video'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'chat'),'. A video is generated by only one event at a time, the result of which is a series of successive events. Chat, the response to a video can have multiple simultaneous responses at any one time. In addition, all of these reactions may not be classified into any of the data preprocessing performed previously, Also in the opposite way, multiple classification criteria may be applied at the same time.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Therefore, it seems possible to express the trend of the continuous variable by words in the stream graph, but the chats belonging to the classification standard of the actual chat feed could not be used because they could not be represented continuously. I could use it to \'look like a sequential\', but I thought I could make a misconception about the goal of showing some of the attention to the visual content. So, this \' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Feed Inspector'),'\' can be used to help handle these concerns separately in an interactive way.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["b" /* ArticleTitle */],null,'Keyword Stream Graph'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_10__img_stacked_bar_png___default.a,style:{position:'absolute',opacity:0.3}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,'As a result, I\'ve visualized the change in the chat keyword over time with the stacked bar graph. At this time, there can be one of the cases: [1] Include only one keyword. [2] Include more than one keyword. or [3] Does not include any keywords. Although visualization classifies chat texts into words and selects keywords, essentially, the units accumulated at one point are text (sentences). Therefore, in the case of [2], the feed was classified by keyword with the highest ranking(The mostly mentioned keyword). In the case of [3], it was excluded from the visualization because it could create a misunderstanding in the purpose of helping the viewer through the \'sentence containing meaningful contents\u2019.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-sm-4 col-xs-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img shadow-5',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_5__img_scalable_ruler_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-8 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,'However, Simply replacing 1 second with 1px and displaying results as a stacked bar graph has the following problems.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'1. The stream traverse length of the visualization result depends on the length of the video.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'2. Because the limitation of the screen size, data cannot be shown at a glance.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This project provides a range slider to control the stacked bar graph and provide the interface from \'1px per second\' to \'Full-screen height as a whole video segment length\'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["b" /* ArticleTitle */],null,'Render Performance'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-18',style:{marginTop:'-4vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_16__img_performance_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,'It is possible to render a variety of video lengths and feeds with a range slider, which takes a lot of time with the existing d3 stacke bar chart. This is because the size of the final and quarter-round chat data used for implementation is 18000 seconds in terms of time, and it is not so small as 20 keywords, and it is because a lot of memory is used to make it a document object (DOM) binding with data in d3. In this project, without making each element of the stacked bar chart using svg, used the HTML5 <canvas> element.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-8 col-sm-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,"The HTML5 <canvas> element requires only one <canvas> element in an html document, which can dramatically reduce the DOM to be managed. Instead, d3 was used to determine the position, size, and color to draw the stacked bar chart on the canvas. In order to support user interaction with the chart data (eg brush) I've implemented the svg element in the <canvas> element (fake d3 element)."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["b" /* ArticleTitle */],null,'Brushing & Drilldown: Back and Forth'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-14 col-xs-offset-2 col-sm-offset-2 shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_2__img_brushing_mp4___default.a,type:'video/mp4'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-5 col-xs-offset-2 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,'Stacked bar graph selection by brushing: only the type and weight of the keyword in the selection are represented in the treemap.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottom-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-5 col-xs-offset-2 col-sm-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],null,'Click word (duplicate selectable): Only the feeds corresponding to the selected word are displayed in the stacked bar graph.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-14 col-xs-offset-2 col-sm-offset-1 shadow-5',style:{marginTop:'-10vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_3__img_drilldown_mp4___default.a,type:'video/mp4'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row middle-sm center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-11 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'idea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title title--orange'},'Meem parser'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* ArticleParagraph */],{className:'desc desc--below'},'The problem was in the form of uncommon chat(Meem). Unlike sentences, which are usually written in complete form and spelling, chats were deliberately mislabeled or distorted in character. By implementing meme parser specifically in Korean(right figure), this system can extract feasible words more properly.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-9 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-sm-20',style:{marginBottom:'-4vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_13__img_before_labeling_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-3 col-sm-4 col-xs-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_15__img_transition_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-xs-offset-4 shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img',style:{position:'relative',zIndex:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__img_chatlog_mp4___default.a,type:'video/mp4'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-sm-20',style:{marginTop:'-4vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_14__img_after_labeling_png___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs start-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})));};/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tendency.c2357a04.mp4";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brushing.fa1774e4.mp4";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/drilldown.5d68dfc0.mp4";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chatlog.0c69cffc.mp4";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/scalable_ruler.18ee395f.mp4";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tendency.52e7db4b.gif";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brushing.269d8b45.gif";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/drilldown.580d24a2.gif";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chatlog_low.76e56d84.gif";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stacked_bar.e8a424f8.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/scalable_ruler.b607fc8b.gif";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/scalable_ruler_mobile.d519175d.gif";

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAAG/CAYAAABFW8kPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABQBJREFUeNrs3cFtE0EYhuENSgF7zcmmg6UDuwKcCjAVxFRgOghUEFIBdJB0EHcQ+5SrOwj/KJMLQpGQkP3v+PmkVYTEAetlZh8CEl1nZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmyXfW6gfb7Z76+PIYz/1kcnE5xs/wruHfeEM8fX06cXJtM/YP0GycuMr28eV9PJfi5Nx1PKux/uLPGwbBLL4svHNMHHFoTZwDae1DPJ/Fybl1PEtay6e1gdbyrh/7B6A1cY6yrbzJ3zvxTJ2cnLuqKBAnodYKoz+KQ2vi0BqtGa3RGq3Rmji0ZuLQGq3RGq2JQ2u0Jo7RmtGak0NrtCYOrdGaOLRmtEZr4tAarQGBiUNrtObk0Bqt0RqtiUNrtGa05lqjNVoTh9ZMHFozWsu9T/HMxMmptVUNJA6tiUNrtGa0duJaG8TJq7UrcWhNHFqjNaO1077WFrSWV2trWqM1cWiN1ozWXGu0Rmvi0JqJQ2u0Rmu0Jg6t0Zo4RmuW+r0zo7W8G2gtr9auaY3WxKE1WjNac63RGq2JQ2smDq3RGq3Rmji0RmviGK1Z6vfOor57nJyEm9ZHHFoTh9ZMHFqjNSeH1sShNVoTx2jNaM3JoTVaE4fWaE0cWrN/fO8sy79dc3Lyvnd6cWhNHFozcWiN1miN1sShNVoTx2jNaM3JoTVaE4fWaE0cWjNaozVxaI3WgMDEoTVac3JojdZojdbEoTVaM1pzrdEarYlDayYOrdEardGaOLRGa+IYrclLa04OrdGaOLQmDq3RmtEarYlDa04OrZk4tEZrTg6t0Rqt0Zo4tEZrRmtODq3Rmji0ZuLQmtEarYlDa7QmjolDa7Tm5NAarYlDa+LQGq0ZrdGaOLQmDq2ZOKestWbjTCYXJc6XeL6LY+LQGq2JY7QmDq2J41qjNXFozbUmDq2JQ2smDq3RmpNj4tAarYljtEZrtCaOa43WxKE115qTQ2vi0JqJQ2u0RmsmDq3RmjhGa+LQmjiuNVoTh9Zca+LQmji0ZuLQmpNDayYOrdGaOEZrtEZr4rjWaE0cWnNyXGu0Jg6tmTiH216cvFrb0JqJQ2u0Jo6JQ2u0Jo5rrTGtTWkt76ZOjolDa7QmjtEardGaOK41WhOH1pwc1xqtiUNrJg6t0RqtmTi0RmvimDi0RmviuNZoTRxaE8e1Rmvi0JqJQ2vi0JqJQ2u0Jo6JQ2u0Jo5rjdbEoTVx/jg9e3Fyau0mnrU4tCYOrdGaOLRGa7RGa+LQmolDa7RGa7QmDq3RmjhGa+LQmji0Rmvi0BqtiUNr4tAarYlDa7TmnWPi0BqtiUNrtEZrtCYOrdGaOLTmWqM1WhOH1kwcWqM1WqM1cWiN1sQxcWiN1sShNVoTh9bEoTVaE4fWWty2PuIk1NrP7uX/MxCH1sShNVoTh9be2HnjN8OG1vJq7a57+f6aOLQmDq3Rmji0dsJau+/8TWharT3QGq2JQ2u0Js6BtPYtnltxDv/CX8TzGM/yjZ92W8UmzhFe+OW5iUADreW6tsqV9aP+8O4vgWjtyCvfASjvlj6eGa3lOj1FZPP6/IrT8zWevhWttfQdgRLmOZ6H10DxtbyPVmP9TGcNxXkFQF+vunl97+zjhG1da8e94rY1SLnOCg7WtJbvD57z+mebHRAkDBTPvPPtm9SjteRIGCoUzMzMzMzMzMzMzMzMzP77fgswAK24rLKU98LKAAAAAElFTkSuQmCC"

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/performance.b542b14a.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/feed_inspector_intro.287adbc8.png";

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA0wAAAFPCAYAAAB+lk4wAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAE/RJREFUeNrs3T9WG8naB+DmHuefbngjyysYfLwAi9iBcTKpIZwIswJgBeBoQkM6iXHgGM0CfKxZwcjRDYe7An9d9lumaLf+gCSE0POc08dYNFJ3qatUv67qVlUBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAiw1FALA8Hz/t9+p/LtZw149ePDs+dATAdL7+9mtvrTqov//R965zXzxSBAAA9966nVhxUh+BCYBr+i+eHW899J38+Gn/sP7nwNsNwKr4lyIAAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAQGACAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAQGACAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAQGACAABAYAIAABCYAAAABCYAAACBCQAAQGACAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAIEJAABAYAIAABCYAAAABCYAAACBCQAAQGACAABAYAIAABCYAAAABCYAAACBCQAAQGACAAAQmAAAAAQmAAAAgQkAAEBgAgAAEJgAAAAEJgAAAL55pAgAuM8+fto/rP85WMNd33rx7LjvCICp2olO/c+mkliqy7rNGghMAABw/6SwdKEYlqpfL1sCEwAsz9GLZ8eHD30nP37aT52+nrcb4H5wDRMAAIDABNy1L1/+262XzTk9V6deekoVABCYgIcQllJQ+pyW+uedWcNS9X1u+kX98zulCwAITMCqh6UUcM7r5Wm9HN82NBVhKXlSL5tCEwAgMAGr7FtYevz4P7v1km4xunWb0NQIS1v1cw3juVJoOlbMAIDABKyiYYSaFHiq24SmlrB0GT93Y/lLMQMAi+a24sAibFVX1xx9CzspNKWf47EUok5vGpaKqX774/4euD/iJEl3iZtwGqPTALdihAmYuwg4+cvrLm4y0iQswYPzOlX/Jb5211sAzMIIE7Cw0JRHlKopR5qEJXiwzuq627/rF63bjueKHpiVESZgoaGpmnKkSVgCAO4jI0zAwkPTFCNNKSy9FpbgwXq9pC+e7ip6YFZGmIA7CU3V+JGmA2EJHqy3qUov6bXP6mXgLQBmYYQJuLPQNGak6Wl5FythCR5U3U9fYH2uJIBVZYQJuNPQVLWPNAlLAIDABBCh6VW9pGD0pmWV43o5F5YAAIEJWDsxqvS++n5dwUnLKvv1sj3qe5oAAAQm4CGHpZ9uHV6a5sttAQDuips+AEsNS8U1S8P8+LgvtwVWru5vV9+n4C7LSdvJGYBpGWEC7kNYOorfjf1yW2Al7aUqvaTXfr3ksAY8AEaYgGWHpW93w6v/f1qN/3JbI02wus7q+ttfQvvzXNEDszLCBCw9LKXHpvhyWyNNAMCdM8IELD0sZRO+3NZIE6yu13Xd7S3hdbuKHpiVESbgXoSlMjRVRprgITlL1X+Jrz30FgCzMMIELMKtwlIZmow0wcOgngKrzggTsAjdehncJiyVoalqGWmqvp8tTssvihkAEJiAVZSCznYdct7dJiyNCU3deK4UxvYVMwAgMAErp7jeKH1h5efbhKURoenvCEu7ShkAEJiAVQ9NT+vl1azXMBShaVdYAgDu0oO/6cPX3349rP85WMP3dmvj9z/6U5ZRmuLUUx2Wr37PNh5YaBpWc7pDVYSmU0cJAHCXjDABAACMsE63FT/a+P2Pw4e+kzOOFk09KsXc37evSgEA4P4xwgQAACAwAQAACEwAAAACEwAAgMAEAAAgMAEAAAhMAAAAAhMAAIDABAAAIDABAAAITAAAAAITAAAAAhMAAIDABAAAIDABAAAITAAAAAITAACAwAQAACAwAQAACEwAAAACEwAAgMAEAAAgMAEAACAwAQAACEwAAAACEwAAgMAEAAAgMAEAAAhMAAAAAhMAAIDABAAAIDABAAAITAAAAAITAAAAAhMAAIDABAAAIDABAAAITAAAAAITAACAwAQAACAwAQAACEwAAAACEwAAgMAEAAAgMAEAACAwAQAACEwAAAACEwAAgMAEAAAgMAEAAAhMAAAAAhMAAIDABAAAIDABAAAITAAAAAITAACAwAQAAIDABAAAIDABAADMwaM12teDr7/9euAtH+uiLiOlAMvR+/hp/6tiGN+O12WkHQdAYAIA4MrG739sKIXRXjw77qdiUhIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDNxrru+Jcv/92p/3lZL7166cTDg3r5UC8njx//53IF9+m4/mcz/Vxv/9aox8b8fVrvoF6246FUDvtL2peL/J4saxtgyfU51ce9aKO68fCwXvr1clTXi6FSWsrnRmpT0+fDlvcA7nVdfT3i16mv97asv9Hevo/+4G79u3OlSOnRGlaiTlSKXsuvN2PZq9fbryvM6Yrt3mbLfm2O2NdmuaQO2UURHpP/LXFfeg/4GMz7NtThYsQxkjrlb1p+lepp6gjs1Ouk0HS4RmVyJ/UmOk6pHbysX2fQ+PXr+F0n3odDRyvcS90x/Yj0+Ju6ru8W/bzt6urEVDpRJTBxzb/WMCxdFJUonSVMleWoXk7irEMVH4bv4gzFujgowtJ5lIkGYzEuYtlRFLS0U+8aYSnXx7T0i8f34kSHejNfx/E6xy2/G4z4Gbi/BtF29hv19rhoQ9Vtxlq3EabUEdksOiG7zal3xZSLHJr6azIKkBuNdFb1laoBSwlLb4pAMIg2atBYpxdt2SsjlHcrTQ+uy/9D1T76BNxPacZQv2hDD6urk8SpPT1NU/Dqx5+mx8p1Ye0CU0yzyNfm9EeFgjQ8W6+bw1UVlWq3mKZRtVWmYrpI1aiY3Xjdb1M8UlBrzJvtFCEufwDvxPr9/Fzx+r3qahSoP49KHdvXLZ53WOzLoAyU9ePb5baOm+PbKO9h7PflFOue36YjMu22RXmXQ+/nLR3SbvH7Zhn8NF2nOVWo2JZr73d5DOVDJf+tBpqivani2GkNRHGsPLltXSiP7/RcjTZqprozY7uXn/taezGp3syrDW1pCzvNtrA4G51+12k54baQsgfmql+0tWWb1Mn1tOX6pqn6X402YGzfB4Hpvtoufn47bsUITXtx0Ke/262+z2ndiQpRznvNlemiqIj5A7rtOoQ0BFzeTKH82/3q+tS41DEYRHjbbnas4ndbM1bGnUbDUW5PuklEv7gYsttoGIbRqRs0Gp22a8SOm9eFjVg37ddpNDTdKYJSL8pnmm170yjf/Hr9OAM1aCmTrer6NKjj2N5+/K4qyusktmezsd/5eDlu7OtOdTWasKE5Wm9x7ORj8/Smo0cT6sJ+0Rn/cXynY7M4OZTX/6ldmVB3XjXWnbXdy+tvRZ2cVG/m1YZObAtHtQ2LLHtgru1sJ/pz+cRUv6W+p+nPh7HuVP2vOPnxvvH539r3YTWt0zVMz4tANM1ZvFyJOhEYjorfNe+8stcMY43rEIbxfPlD8E0MCTcdNzoNH6Ki/hh9ie04LSr4+wU3LrkR6RblkoNFeuwiGpW2a8QGZTlW36c4lh2fUTff2JkyLDW3rZS3rVt0+Jrlm/XK/ZjBm5bGMjeYHc0NE/QadX+WetqsC+8bdS971/LYZhl4pqk7xbrzaPdye3F8izK88zZ0kWUPzEX6fP+alvrnf6I9uIyTGeNOTN2k7ch3JE7PexLLZW7L9AEEpoesvENcJypV7vz3io54p6hQw5gH26uuzoCmM8VP4pbeT6qrGynsjXjdVIHTWdN/V9+HfVPlTPNq01nctBzWy24R4HqzXPgdz7dR7Ft6zY1Y+kUHJFX8p2k/6iVtz1bRsdlpCQxpVOVpsd/Dcr+jjMpgtRXb8aSa/oLLskO1H2X272io8tmjbrxH5VSn3eK1Tov9mEdH5bTYjvPiuXtRduVI0lEua9WNGZV14ag4Bstb8h+0/N1lUffKrx14WbRvzWmCue7kNuPbVLU5tXtlW9GLaW83rTe3akOnaAvvtOyBhbosTuaM6h/dpP9VTsM7itH09Ldp/SdGjVffozWrHFXuBExx8D4ufs4f4G+LTv5efCDm+ef5980PvMvGWdX8up2Ws47pA/okKmq5falCpiHg98X2DBu/H867wKKz1Cteczvm55bl0o39PSn2OweVw5Z1t1vK6MeF7XEN0FacBZp2205zueUOU/37s+Iao/I9+jE0HiF4N96HtG1p5PBwxmNsvxiif1vs72blroNM2UZV7aM509aF8hhO00R/iSDTdnLlbQ4DcU1NP54rf/j3GnXnvKinr4qTSVVMY5613UvPe1YEjM3q+pTYSe60DV1w2QPzkfpq5YnYvfhsTqO/rybMOpq27ehHXU/19++YsvdntAvCksC0Uv4sOq/p39MJ6/8ICrlDEKNHZcd/v7qanndZXR+qzd7ccBubH8jfKnVLBe7eQZltNn7enHL98qz0xOduXjgeF1f3q/HfxVRuy5eWM0ODEeu2dYqGcyrTgYaRGZTB4OUNAvbYutB4rDvmNSc997BZTxshb27t3ozt/F22oYsse2A+Bo1R4nSC4u8chka1tTdsO/KI8k51dfe9XoSt8vpNVtQ6TckrK8TBuPmkcdFyrhBnjV/nUaRuzO3PnfryLELZsdgas0wz9aycDrNVTDU5uoMyK/fjdMx+7DfWH0zY72vPPeK92LzBtv1fy3vYGbFu22t1ijKepKvZYBEi5OdjdWfEdS8/PsiLY3xsXWg8djlDG9C5QT2btd2bp0W2oYsse2BxLqfoa0zddqT+X0zXS9OK0+j7SXX9+k0jxwLTynRGhsVBnjq9n5sdkvTh37hoOV+8VzWCQ64Exy1BKinPcm6mMxt5qa6mfg2nHI3YbJ4hib97fEdlljsEvbwNsR2p05OGtbvFaE6/2ObLxn6/zM/RUkbvyo5XvAedG2zbTtkYxfv6T3qe+LnfCMvdYt2d6vp3czU7Nr1i3TdzDky/aIJo2C1+fh/HXDOkpMfSWc+L4va3rUEr6sVO7tzf4pb9zbpT1tPD6vvUk/zlj/Ns9+ZZb27bhk7s4Cy47IEFiDa0+VUEM7UdqS9RL+nmL9tpNlKMKJVfX7Ot5FfbWn1xbZpfXh/Qj6uru7BdxBS7YXTQNxtnH366vWtMFzuvrn/b/LXvGGncljx1JtId+v6KSrZTdMSfTLHZ51HRelHJB9Hx2LmjYtuvrm4p/jn2/X+xDemxdKY7Xxx5VF1d03UR66YpKc+L4JHKYDfK6KC6mt7Yizm/3RuEkrxtndi2QaORS2V0FtdFnFRXN6X4O6b8NV/rqCjz46KT+HLaDtSUhkXZfY7OlC8LJl/Lkm83ne+udFB8qJffSZS/G+S0URcuWupCeXzf6KRJo+7801J3Uj07mnO7N896c9M2NLflnZi20/pZMKIdmlvZA3NzEd+v2eZo1rYjTiTlG2T14trFL9X1Oyq7hnnFrd1d8hp3OKniA7jX+HDrxwfkYMoK1va9TrvV9S9kPCgq2bBx5mGco+r6iNZFPM/5HZXXeXV9ZC5/H0vuLJ00b6JQXd1KcyfW7RXlWs7jfVXsW57z241yG9xw23IHpXwfd4t5y0eNMusV+5DvnDcs9uO05Xkv51TuzW3enuVOhzy4Nuo06sawUTd61fXpo6+KujepLpzM8D0gk+pOGSbm1e7Ns97ctA19W6zfra6+j++27dCJ72CBe2l/wg0fpmo7ov0r+zM7jX7SqRHm1fdoHXc6RppO4qB+XnRC0gH9YcItZPNZ1/38d23rR+V4GlO+XlZXt+Zu3jVlWHzYtj5P/Rzp1pR7Raf9LLb1r+I5qni8edFz22Nt8nrDEeV1WmzDyLKKG2P0o2xfFtv3Z7PTEPv2pLFu2oaT6KB0qwl3rhqzbW8bo37fGrSYMvO6aMg+VC13sUnBul73z+IM0SA6Ut0o92FLR665ra3vbZyJv4zn7lQLuMMhK99GpQ/k82g/nhfH6zDqyHnLMTtVXWi0M8NJ7cVN6s6c2r3W7RtTb+bZhub1t2L9bqw/nLBtCyl74NbG9eOGLW3oT+3ITdqOmB3wNPouZd/nbFKfEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFbB/wswAO/U3bFuAe6jAAAAAElFTkSuQmCC"

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tendency_mobile.3cb72c04.gif";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brushing_mobile.4f0d68a3.gif";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/drilldown_mobile.7eff304b.gif";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chatlog_low_mobile.50c72ef5.gif";

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HotConcept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReferConcept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TendencyConcept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_konva__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_concept1_mp4__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_concept1_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_concept1_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_concept2_mp4__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_concept2_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_concept2_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_concept3_mp4__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_concept3_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_concept3_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Helper_media__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_konva__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_chroma_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_chroma_js__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tposition: relative;\n\twidth: 100%;\n'],['\n\tposition: relative;\n\twidth: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\ttext-align: center;\n\tfont-family: \'Montserrat\', sans-serif;\n\tmargin-bottom: 1em;\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\ttext-align: center;\n\tfont-family: \'Montserrat\', sans-serif;\n\tmargin-bottom: 1em;\n\t',' ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: ','px;\n  margin-top: 1em;\n'],['\n  font-size: ','px;\n  margin-top: 1em;\n']),_templateObject4=_taggedTemplateLiteral(['\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ','%;\n\tbackground: ',';\n'],['\n\tposition: relative;\n\twidth: 100%;\n\tpadding-top: ','%;\n\tbackground: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n\tfont-size: ','px;\n\tmargin-top: 0.5em;\n\tfont-weight: lighter;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\ttext-align: justify;\n\tpadding: 0 0.5em;\n\toverflow: hidden;\n\tword-break: break-word;\n\n\t',' ',';\n'],['\n\tfont-size: ','px;\n\tmargin-top: 0.5em;\n\tfont-weight: lighter;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\ttext-align: justify;\n\tpadding: 0 0.5em;\n\toverflow: hidden;\n\tword-break: break-word;\n\n\t',' ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: ','px;\n    margin-top: 1em;\n  '],['\n    font-size: ','px;\n    margin-top: 1em;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\toverflow: hidden;\n\t',';\n'],['\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\toverflow: hidden;\n\t',';\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ConceptWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var ConceptLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(20),__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].md(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(16)),__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].sm(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(16)));var ConceptRep=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject4,100/1.618,__WEBPACK_IMPORTED_MODULE_2__var__["a" /* colors */].black);var ConceptDetail=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(16),__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].md(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(14)),__WEBPACK_IMPORTED_MODULE_8__Helper_media__["a" /* default */].sm(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_7__Helper_pxToVw__["a" /* default */])(14)));ConceptRep.Inner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Stage"])(_templateObject7,function(props){return props.filter?'\n  & canvas {\n    -webkit-filter: url("#goo");\n    filter: url("#goo");\n  }':null;});function easeInOutExpo(t,b,c,d){if(t==0)return b;if(t==d)return b+c;if((t/=d/2)<1)return c/2*Math.pow(2,10*(t-1))+b;return c/2*(-Math.pow(2,-10*--t)+2)+b;}var TendencyClip=function(_React$Component){_inherits(TendencyClip,_React$Component);function TendencyClip(){_classCallCheck(this,TendencyClip);var _this=_possibleConstructorReturn(this,(TendencyClip.__proto__||Object.getPrototypeOf(TendencyClip)).call(this));_this.pos_and_size=[[0.3,0.6,__WEBPACK_IMPORTED_MODULE_10_chroma_js___default.a.scale(['#ff6956',__WEBPACK_IMPORTED_MODULE_10_chroma_js___default()('#ff6956').saturate(3)])],[0.7,0.6,__WEBPACK_IMPORTED_MODULE_10_chroma_js___default.a.scale(['#62449f',__WEBPACK_IMPORTED_MODULE_10_chroma_js___default()('#62449f').saturate(3)])]];_this.state={attrib:_this.pos_and_size.slice().map(function(_ref){var _ref2=_slicedToArray(_ref,3),p=_ref2[0],s=_ref2[1],c=_ref2[2];return[p,s,c(0).hex()];})};return _this;}_createClass(TendencyClip,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var duration=2000;var delay=duration/5;var anim=new __WEBPACK_IMPORTED_MODULE_9_konva___default.a.Animation(function(frame){var tick=frame.time;var updated=_this2.pos_and_size.map(function(_ref3,i){var _ref4=_slicedToArray(_ref3,3),pos=_ref4[0],size=_ref4[1],color=_ref4[2];return[pos,size/2+size/2*(Math.cos(tick/500+Math.PI*i)+1)*0.5,color((Math.cos(tick/500+Math.PI*i)+1.0)*0.5).hex()];});_this2.setState({attrib:updated});});anim.start();}},{key:'render',value:function render(){var _props=this.props,width=_props.width,height=_props.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptRep.Inner,{width:width,height:height,filter:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Layer"],null,this.state.attrib.map(function(_ref5,i){var _ref6=_slicedToArray(_ref5,3),pos=_ref6[0],size=_ref6[1],color=_ref6[2];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Circle"],{x:width*pos,y:height*0.5,width:width*size,height:width*size,fill:color});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',version:'1.1',style:{position:'absolute'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('filter',{id:'goo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feGaussianBlur',{'in':'SourceGraphic',stdDeviation:'10',result:'blur'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('feColorMatrix',{'in':'blur',mode:'matrix',values:'1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 60 -9'})))));}}]);return TendencyClip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var HotClip=function(_React$Component2){_inherits(HotClip,_React$Component2);function HotClip(){_classCallCheck(this,HotClip);var _this3=_possibleConstructorReturn(this,(HotClip.__proto__||Object.getPrototypeOf(HotClip)).call(this));_this3.pos_and_size=[[0.1,0.05,0.25],[0.125,0.08333,0.25],[0.4,0.25,0.4],[0.55,0.066,0.3],[0.6,0.08333,0.5],[0.8,0.055,0.3],[0.9,1,0.25]];_this3.state={attrib:[[0.1,0.05,0.25],[0.125,0.08333,0.25],[0.4,0.25,0.4],[0.55,0.066,0.3],[0.6,0.08333,0.5],[0.8,0.055,0.3],[0.9,1,0.25]]};return _this3;}_createClass(HotClip,[{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var duration=2000;var delay=duration/5;var anim=new __WEBPACK_IMPORTED_MODULE_9_konva___default.a.Animation(function(frame){var tick=frame.time%duration;var updated=_this4.pos_and_size.map(function(_ref7,i){var _ref8=_slicedToArray(_ref7,3),pos=_ref8[0],size=_ref8[1],opacity=_ref8[2];if(tick<i*delay/7){return[pos,0,0];}else{var ratio=(tick-i*delay/7)/(duration-i*delay/7);return[pos,size*1.5*ratio,(1-ratio)*opacity];}});_this4.setState({attrib:updated});});anim.start();}},{key:'render',value:function render(){var _props2=this.props,width=_props2.width,height=_props2.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptRep.Inner,{width:width,height:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Layer"],null,this.state.attrib.map(function(_ref9,i){var _ref10=_slicedToArray(_ref9,3),pos=_ref10[0],size=_ref10[1],opacity=_ref10[2];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Circle"],{x:width*pos,y:height*0.5,width:width*size,height:width*size,fill:'#913dbf',opacity:opacity});})));}}]);return HotClip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var ReferClip=function(_React$Component3){_inherits(ReferClip,_React$Component3);function ReferClip(){_classCallCheck(this,ReferClip);var _this5=_possibleConstructorReturn(this,(ReferClip.__proto__||Object.getPrototypeOf(ReferClip)).call(this));_this5.pos=[0.6,0.4,1.0,0.5,0.3,0.8,0.6];_this5.blocks=[[[0.3,0.45]],[[0.0,0.3],[0.55,0.7]],[[0.35,0.5]],[[0.85,1.0]],[[0.6,0.8]],[[0.2,0.5]],[[0.3,0.45]]];_this5.colors=[['#913dbf'],['#62449f','#913dbf'],['#ccb6bc'],['#913dbf'],['#ccb6bc'],['#62449f'],['#913dbf']];_this5.state={pos:_this5.pos,blocks:_this5.blocks,colors:_this5.colors,start:0,offset:0};return _this5;}_createClass(ReferClip,[{key:'componentDidMount',value:function componentDidMount(){var _this6=this;var duration=1000;var anim=new __WEBPACK_IMPORTED_MODULE_9_konva___default.a.Animation(function(frame){var tick=frame.time%duration;if(duration-500<tick){var ratio=(tick-(duration-500))/500;_this6.setState({offset:easeInOutExpo(ratio,0,1,1)});}else{if(_this6.state.offset!=0){_this6.setState(function(prevState){return{start:prevState.start+1,offset:0};});}}});anim.start();}},{key:'render',value:function render(){var _this7=this;var _props3=this.props,width=_props3.width,height=_props3.height;var offsetCalculator=function offsetCalculator(i){if(i==0){return _this7.state.offset*0.8+0.2;}if(i==1){return 1-_this7.state.offset*0.8;}if(i==5){return _this7.state.offset*0.8+0.2;}if(i==6){return 0.2;}return 1;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptRep.Inner,{width:width,height:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Layer"],null,this.state.pos.map(function(pos,k){var i=((k-_this7.state.start)%7+7)%7;if(pos!=1.0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{cornerRadius:width*0.01,x:0.05*width,y:height*0.85*i/7+height*0.15-height*0.85*_this7.state.offset/7,width:width*pos*0.9,height:height*0.1,fill:'#e1e1e7',opacity:offsetCalculator(i)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{cornerRadius:width*0.01,x:0.05*width+width*pos*0.9+width*0.05,y:height*0.85*i/7+height*0.15-height*0.85*_this7.state.offset/7,width:width*(1-pos)*0.9-width*0.05,height:height*0.1,fill:'#e1e1e7',opacity:offsetCalculator(i)}),_this7.state.blocks[(i+_this7.state.start)%7].map(function(b,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{cornerRadius:width*0.01,x:0.05*width+width*b[0]*0.9+width*0.05,y:height*0.85*i/7+height*0.15-height*0.85*_this7.state.offset/7,width:width*(b[1]-b[0])*0.9-width*0.05,height:height*0.1,fill:_this7.state.colors[(i+_this7.state.start)%7][j],opacity:offsetCalculator(i)});}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{cornerRadius:width*0.01,x:0.05*width,y:height*0.85*i/7+height*0.15-height*0.85*_this7.state.offset/7,width:width*pos*0.9,height:height*0.1,fill:'#e1e1e7',opacity:offsetCalculator(i)}),_this7.state.blocks[(i+_this7.state.start)%7].map(function(b,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{cornerRadius:width*0.01,x:0.05*width+width*b[0]*0.9+width*0.05,y:height*0.85*i/7+height*0.15-height*0.85*_this7.state.offset/7,width:width*(b[1]-b[0])*0.9-width*0.05,height:height*0.1,fill:_this7.state.colors[(i+_this7.state.start)%7][j],opacity:offsetCalculator(i)});}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{x:0,y:0,width:width,height:height*0.15,fill:__WEBPACK_IMPORTED_MODULE_2__var__["a" /* colors */].black}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_konva__["Rect"],{x:0,y:height*0.85,width:width,height:height*0.15,fill:__WEBPACK_IMPORTED_MODULE_2__var__["a" /* colors */].black})));}}]);return ReferClip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var TendencyConcept=function(_React$Component4){_inherits(TendencyConcept,_React$Component4);function TendencyConcept(){_classCallCheck(this,TendencyConcept);var _this8=_possibleConstructorReturn(this,(TendencyConcept.__proto__||Object.getPrototypeOf(TendencyConcept)).call(this));_this8.refCallback=function(element){if(element){_this8.setState({size:element.getBoundingClientRect()});}};_this8.ref=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this8.state={size:{bottom:0,height:0,left:0,right:0,top:0,width:0,x:0,y:0}};return _this8;}_createClass(TendencyConcept,[{key:'componentDidMount',value:function componentDidMount(){var _this9=this;this.refCallback(this.ref.current);window.addEventListener('resize',function(){_this9.refCallback(_this9.ref.current);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptLabel,null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_6__img_concept3_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptDetail,null,this.props.children));}}]);return TendencyConcept;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var HotConcept=function(_React$Component5){_inherits(HotConcept,_React$Component5);function HotConcept(){_classCallCheck(this,HotConcept);var _this10=_possibleConstructorReturn(this,(HotConcept.__proto__||Object.getPrototypeOf(HotConcept)).call(this));_this10.refCallback=function(element){if(element){_this10.setState({size:element.getBoundingClientRect()});}};_this10.ref=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this10.state={size:{bottom:0,height:0,left:0,right:0,top:0,width:0,x:0,y:0}};return _this10;}_createClass(HotConcept,[{key:'componentDidMount',value:function componentDidMount(){var _this11=this;this.refCallback(this.ref.current);window.addEventListener('resize',function(){_this11.refCallback(_this11.ref.current);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptLabel,null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__img_concept1_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptDetail,null,this.props.children));}}]);return HotConcept;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var ReferConcept=function(_React$Component6){_inherits(ReferConcept,_React$Component6);function ReferConcept(){_classCallCheck(this,ReferConcept);var _this12=_possibleConstructorReturn(this,(ReferConcept.__proto__||Object.getPrototypeOf(ReferConcept)).call(this));_this12.refCallback=function(element){if(element){_this12.setState({size:element.getBoundingClientRect()});}};_this12.ref=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this12.state={size:{bottom:0,height:0,left:0,right:0,top:0,width:0,x:0,y:0}};return _this12;}_createClass(ReferConcept,[{key:'componentDidMount',value:function componentDidMount(){var _this13=this;this.refCallback(this.ref.current);window.addEventListener('resize',function(){_this13.refCallback(_this13.ref.current);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptLabel,null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,'class':'ratio__img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_5__img_concept2_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConceptDetail,null,this.props.children));}}]);return ReferConcept;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(241);
} else {
  module.exports = require('./cjs/react-reconciler.development.js');
}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/** @license React v16.6.1
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
module.exports = function $$$reconciler($$$hostConfig) {
'use strict';var aa=__webpack_require__(13),ba=__webpack_require__(0);var ca=__webpack_require__(17);function da(a,b,c,d,e,g,f,l){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var h=[c,d,e,g,f,l],k=0;a=Error(b.replace(/%s/g,function(){return h[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function m(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);da(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}
var ea=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,n="function"===typeof Symbol&&Symbol.for,fa=n?Symbol.for("react.element"):60103,ha=n?Symbol.for("react.portal"):60106,ia=n?Symbol.for("react.fragment"):60107,ja=n?Symbol.for("react.strict_mode"):60108,ka=n?Symbol.for("react.profiler"):60114,la=n?Symbol.for("react.provider"):60109,ma=n?Symbol.for("react.context"):60110,na=n?Symbol.for("react.concurrent_mode"):60111,oa=n?Symbol.for("react.forward_ref"):60112,pa=n?Symbol.for("react.suspense"):
60113,qa=n?Symbol.for("react.memo"):60115,ra=n?Symbol.for("react.lazy"):60116,sa="function"===typeof Symbol&&Symbol.iterator;function ua(a){if(null===a||"object"!==typeof a)return null;a=sa&&a[sa]||a["@@iterator"];return"function"===typeof a?a:null}
function va(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case na:return"ConcurrentMode";case ia:return"Fragment";case ha:return"Portal";case ka:return"Profiler";case ja:return"StrictMode";case pa:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ma:return"Context.Consumer";case la:return"Context.Provider";case oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case qa:return va(a.type);case ra:if(a=1===a._status?a._result:null)return va(a)}return null}function wa(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function xa(a){2!==wa(a)?m("188"):void 0}
function ya(a){var b=a.alternate;if(!b)return b=wa(a),3===b?m("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,g=e?e.alternate:null;if(!e||!g)break;if(e.child===g.child){for(var f=e.child;f;){if(f===c)return xa(e),a;if(f===d)return xa(e),b;f=f.sibling}m("188")}if(c.return!==d.return)c=e,d=g;else{f=!1;for(var l=e.child;l;){if(l===c){f=!0;c=e;d=g;break}if(l===d){f=!0;d=e;c=g;break}l=l.sibling}if(!f){for(l=g.child;l;){if(l===c){f=!0;c=g;d=e;break}if(l===d){f=!0;d=g;c=e;break}l=l.sibling}f?
void 0:m("189")}}c.alternate!==d?m("190"):void 0}3!==c.tag?m("188"):void 0;return c.stateNode.current===c?a:b}function za(a){a=ya(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function Aa(a){a=ya(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var Ba=$$$hostConfig.getPublicInstance,Ca=$$$hostConfig.getRootHostContext,Da=$$$hostConfig.getChildHostContext,Ea=$$$hostConfig.prepareForCommit,Fa=$$$hostConfig.resetAfterCommit,Ga=$$$hostConfig.createInstance,Ha=$$$hostConfig.appendInitialChild,Ia=$$$hostConfig.finalizeInitialChildren,Ja=$$$hostConfig.prepareUpdate,Ka=$$$hostConfig.shouldSetTextContent,La=$$$hostConfig.shouldDeprioritizeSubtree,Ma=$$$hostConfig.createTextInstance,Na=$$$hostConfig.scheduleDeferredCallback,Oa=$$$hostConfig.cancelDeferredCallback,
Pa=$$$hostConfig.shouldYield,Qa=$$$hostConfig.setTimeout,Ra=$$$hostConfig.clearTimeout,Sa=$$$hostConfig.noTimeout,Ta=$$$hostConfig.now,Ua=$$$hostConfig.isPrimaryRenderer,Va=$$$hostConfig.supportsMutation,Wa=$$$hostConfig.supportsPersistence,Xa=$$$hostConfig.supportsHydration,Ya=$$$hostConfig.appendChild,Za=$$$hostConfig.appendChildToContainer,$a=$$$hostConfig.commitTextUpdate,ab=$$$hostConfig.commitMount,bb=$$$hostConfig.commitUpdate,cb=$$$hostConfig.insertBefore,db=$$$hostConfig.insertInContainerBefore,
eb=$$$hostConfig.removeChild,fb=$$$hostConfig.removeChildFromContainer,gb=$$$hostConfig.resetTextContent,hb=$$$hostConfig.hideInstance,ib=$$$hostConfig.hideTextInstance,jb=$$$hostConfig.unhideInstance,kb=$$$hostConfig.unhideTextInstance,lb=$$$hostConfig.cloneInstance,mb=$$$hostConfig.createContainerChildSet,nb=$$$hostConfig.appendChildToContainerChildSet,ob=$$$hostConfig.finalizeContainerChildren,pb=$$$hostConfig.replaceContainerChildren,qb=$$$hostConfig.cloneHiddenInstance,rb=$$$hostConfig.cloneUnhiddenInstance,
tb=$$$hostConfig.createHiddenTextInstance,ub=$$$hostConfig.canHydrateInstance,vb=$$$hostConfig.canHydrateTextInstance,wb=$$$hostConfig.getNextHydratableSibling,xb=$$$hostConfig.getFirstHydratableChild,yb=$$$hostConfig.hydrateInstance,zb=$$$hostConfig.hydrateTextInstance,Ab=/^(.*)[\\\/]/;
function Bb(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c=a._debugOwner,d=a._debugSource,e=va(a.type);var g=null;c&&(g=va(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Ab,"")+":"+d.lineNumber+")":g&&(e=" (created by "+g+")");g="\n    in "+(c||"Unknown")+e;break a;default:g=""}b+=g;a=a.return}while(a);return b}new Set;var Cb=[],Db=-1;function x(a){0>Db||(a.current=Cb[Db],Cb[Db]=null,Db--)}function z(a,b){Db++;Cb[Db]=a.current;a.current=b}
var Eb={},A={current:Eb},B={current:!1},Fb=Eb;function Gb(a,b){var c=a.type.contextTypes;if(!c)return Eb;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},g;for(g in c)e[g]=b[g];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function C(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Hb(a){x(B,a);x(A,a)}
function Ib(a){x(B,a);x(A,a)}function Jb(a,b,c){A.current!==Eb?m("168"):void 0;z(A,b,a);z(B,c,a)}function Kb(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:m("108",va(b)||"Unknown",e);return aa({},c,d)}function Lb(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Eb;Fb=A.current;z(A,b,a);z(B,B.current,a);return!0}
function Mb(a,b,c){var d=a.stateNode;d?void 0:m("169");c?(b=Kb(a,b,Fb),d.__reactInternalMemoizedMergedChildContext=b,x(B,a),x(A,a),z(A,b,a)):x(B,a);z(B,c,a)}var Nb=null,Ob=null;function Pb(a){return function(b){try{return a(b)}catch(c){}}}
function Qb(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Nb=Pb(function(a){return b.onCommitFiberRoot(c,a)});Ob=Pb(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Rb(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function D(a,b,c,d){return new Rb(a,b,c,d)}
function Sb(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Tb(a){if("function"===typeof a)return Sb(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===oa)return 11;if(a===qa)return 14}return 2}
function Ub(a,b){var c=a.alternate;null===c?(c=D(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Vb(a,b,c,d,e,g){var f=2;d=a;if("function"===typeof a)Sb(a)&&(f=1);else if("string"===typeof a)f=5;else a:switch(a){case ia:return Wb(c.children,e,g,b);case na:return Xb(c,e|3,g,b);case ja:return Xb(c,e|2,g,b);case ka:return a=D(12,c,b,e|4),a.elementType=ka,a.type=ka,a.expirationTime=g,a;case pa:return a=D(13,c,b,e),a.elementType=pa,a.type=pa,a.expirationTime=g,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case la:f=10;break a;case ma:f=9;break a;case oa:f=11;break a;case qa:f=
14;break a;case ra:f=16;d=null;break a}m("130",null==a?a:typeof a,"")}b=D(f,c,b,e);b.elementType=a;b.type=d;b.expirationTime=g;return b}function Wb(a,b,c,d){a=D(7,a,d,b);a.expirationTime=c;return a}function Xb(a,b,c,d){a=D(8,a,d,b);b=0===(b&1)?ja:na;a.elementType=b;a.type=b;a.expirationTime=c;return a}function Yb(a,b,c){a=D(6,a,null,b);a.expirationTime=c;return a}
function Zb(a,b,c){b=D(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function $b(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);ac(b,a)}
function bc(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c>=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);ac(b,a)}
function cc(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function ac(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,g=b.latestPingedTime;e=0!==e?e:g;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var ec=!1;
function fc(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function gc(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function hc(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function ic(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function E(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=fc(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=fc(a.memoizedState),e=c.updateQueue=fc(c.memoizedState)):d=a.updateQueue=gc(e):null===e&&(e=c.updateQueue=gc(d));null===e||d===e?ic(d,b):null===d.lastUpdate||null===e.lastUpdate?(ic(d,b),ic(e,b)):(ic(d,b),e.lastUpdate=b)}
function jc(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=fc(a.memoizedState):kc(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function kc(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=gc(b));return b}
function lc(a,b,c,d,e,g){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(g,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(g,d,e):a;if(null===e||void 0===e)break;return aa({},d,e);case 2:ec=!0}return d}
function mc(a,b,c,d,e){ec=!1;b=kc(a,b);for(var g=b.baseState,f=null,l=0,h=b.firstUpdate,k=g;null!==h;){var p=h.expirationTime;p<e?(null===f&&(f=h,g=k),l<p&&(l=p)):(k=lc(a,b,h,k,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=h:(b.lastEffect.nextEffect=h,b.lastEffect=h)));h=h.next}p=null;for(h=b.firstCapturedUpdate;null!==h;){var y=h.expirationTime;y<e?(null===p&&(p=h,null===f&&(g=k)),l<y&&(l=y)):(k=lc(a,b,h,k,c,d),null!==h.callback&&(a.effectTag|=
32,h.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=h:(b.lastCapturedEffect.nextEffect=h,b.lastCapturedEffect=h)));h=h.next}null===f&&(b.lastUpdate=null);null===p?b.lastCapturedUpdate=null:a.effectTag|=32;null===f&&null===p&&(g=k);b.baseState=g;b.firstUpdate=f;b.firstCapturedUpdate=p;a.expirationTime=l;a.memoizedState=k}
function nc(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);oc(b.firstEffect,c);b.firstEffect=b.lastEffect=null;oc(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function oc(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?m("191",c):void 0;c.call(d)}a=a.nextEffect}}
function pc(a,b){return{value:a,source:b,stack:Bb(b)}}var qc={current:null},rc=null,sc=null,tc=null;function uc(a,b){var c=a.type._context;Ua?(z(qc,c._currentValue,a),c._currentValue=b):(z(qc,c._currentValue2,a),c._currentValue2=b)}function vc(a){var b=qc.current;x(qc,a);a=a.type._context;Ua?a._currentValue=b:a._currentValue2=b}function wc(a){rc=a;tc=sc=null;a.firstContextDependency=null}
function xc(a,b){if(tc!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)tc=a,b=1073741823;b={context:a,observedBits:b,next:null};null===sc?(null===rc?m("293"):void 0,rc.firstContextDependency=sc=b):sc=sc.next=b}return Ua?a._currentValue:a._currentValue2}var yc={},zc={current:yc},Ac={current:yc},Bc={current:yc};function Cc(a){a===yc?m("174"):void 0;return a}function Dc(a,b){z(Bc,b,a);z(Ac,a,a);z(zc,yc,a);b=Ca(b);x(zc,a);z(zc,b,a)}function Ec(a){x(zc,a);x(Ac,a);x(Bc,a)}
function Fc(){return Cc(zc.current)}function Gc(a){var b=Cc(Bc.current),c=Cc(zc.current);b=Da(c,a.type,b);c!==b&&(z(Ac,a,a),z(zc,b,a))}function Hc(a){Ac.current===a&&(x(zc,a),x(Ac,a))}var Ic=Object.prototype.hasOwnProperty;function Jc(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function Kc(a,b){if(Jc(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ic.call(b,c[d])||!Jc(a[c[d]],b[c[d]]))return!1;return!0}function F(a,b){if(a&&a.defaultProps){b=aa({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function Lc(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Mc=ea.ReactCurrentOwner,Nc=(new ba.Component).refs;
function Oc(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:aa({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sc={isMounted:function(a){return(a=a._reactInternalFiber)?2===wa(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=G();d=Pc(d,a);var e=hc(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qc();E(a,e);Rc(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=G();d=Pc(d,a);var e=hc(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qc();E(a,e);Rc(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=G();c=Pc(c,a);var d=hc(c);d.tag=2;
void 0!==b&&null!==b&&(d.callback=b);Qc();E(a,d);Rc(a,c)}};function Tc(a,b,c,d,e,g,f){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,g,f):b.prototype&&b.prototype.isPureReactComponent?!Kc(c,d)||!Kc(e,g):!0}
function Uc(a,b,c){var d=!1,e=Eb;var g=b.contextType;"object"===typeof g&&null!==g?g=Mc.currentDispatcher.readContext(g):(e=C(b)?Fb:A.current,d=b.contextTypes,g=(d=null!==d&&void 0!==d)?Gb(a,e):Eb);b=new b(c,g);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sc;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=g);return b}
function Vc(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sc.enqueueReplaceState(b,b.state,null)}
function Wc(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Nc;var g=b.contextType;"object"===typeof g&&null!==g?e.context=Mc.currentDispatcher.readContext(g):(g=C(b)?Fb:A.current,e.context=Gb(a,g));g=a.updateQueue;null!==g&&(mc(a,g,c,e,d),e.state=a.memoizedState);g=b.getDerivedStateFromProps;"function"===typeof g&&(Oc(a,b,g,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sc.enqueueReplaceState(e,e.state,null),g=a.updateQueue,null!==g&&(mc(a,g,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xc=Array.isArray;
function Yc(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?m("289"):void 0,d=c.stateNode);d?void 0:m("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(b){var a=d.refs;a===Nc&&(a=d.refs={});null===b?delete a[e]:a[e]=b};b._stringRef=e;return b}"string"!==typeof a?m("284"):void 0;c._owner?void 0:m("290",a)}return a}
function Zc(a,b){"textarea"!==a.type&&m("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function $c(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(b,a){for(b=new Map;null!==a;)null!==a.key?b.set(a.key,a):b.set(a.index,a),a=a.sibling;return b}function e(b,a,c){b=Ub(b,a,c);b.index=0;b.sibling=null;return b}function g(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function f(b){a&&null===b.alternate&&(b.effectTag=2);return b}function l(b,a,c,d){if(null===a||6!==a.tag)return a=Yb(c,b.mode,d),a.return=b,a;a=e(a,c,d);a.return=b;return a}function h(b,a,c,d){if(null!==a&&a.elementType===c.type)return d=e(a,c.props,d),d.ref=Yc(b,a,c),d.return=b,d;d=Vb(c.type,c.key,c.props,null,b.mode,d);d.ref=Yc(b,a,c);d.return=b;return d}function k(b,a,c,d){if(null===a||4!==a.tag||a.stateNode.containerInfo!==c.containerInfo||a.stateNode.implementation!==
c.implementation)return a=Zb(c,b.mode,d),a.return=b,a;a=e(a,c.children||[],d);a.return=b;return a}function p(b,a,c,d,f){if(null===a||7!==a.tag)return a=Wb(c,b.mode,d,f),a.return=b,a;a=e(a,c,d);a.return=b;return a}function y(b,a,c){if("string"===typeof a||"number"===typeof a)return a=Yb(""+a,b.mode,c),a.return=b,a;if("object"===typeof a&&null!==a){switch(a.$$typeof){case fa:return c=Vb(a.type,a.key,a.props,null,b.mode,c),c.ref=Yc(b,null,a),c.return=b,c;case ha:return a=Zb(a,b.mode,c),a.return=b,a}if(Xc(a)||
ua(a))return a=Wb(a,b.mode,c,null),a.return=b,a;Zc(b,a)}return null}function v(b,a,c,d){var e=null!==a?a.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:l(b,a,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fa:return c.key===e?c.type===ia?p(b,a,c.props.children,d,e):h(b,a,c,d):null;case ha:return c.key===e?k(b,a,c,d):null}if(Xc(c)||ua(c))return null!==e?null:p(b,a,c,d,null);Zc(b,c)}return null}function u(b,a,c,d,e){if("string"===typeof d||"number"===typeof d)return b=
b.get(c)||null,l(a,b,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case fa:return b=b.get(null===d.key?c:d.key)||null,d.type===ia?p(a,b,d.props.children,e,d.key):h(a,b,d,e);case ha:return b=b.get(null===d.key?c:d.key)||null,k(a,b,d,e)}if(Xc(d)||ua(d))return b=b.get(c)||null,p(a,b,d,e,null);Zc(a,d)}return null}function J(e,f,h,l){for(var k=null,w=null,q=f,t=f=0,p=null;null!==q&&t<h.length;t++){q.index>t?(p=q,q=null):p=q.sibling;var r=v(e,q,h[t],l);if(null===r){null===q&&(q=p);break}a&&
q&&null===r.alternate&&b(e,q);f=g(r,f,t);null===w?k=r:w.sibling=r;w=r;q=p}if(t===h.length)return c(e,q),k;if(null===q){for(;t<h.length;t++)if(q=y(e,h[t],l))f=g(q,f,t),null===w?k=q:w.sibling=q,w=q;return k}for(q=d(e,q);t<h.length;t++)if(p=u(q,e,t,h[t],l))a&&null!==p.alternate&&q.delete(null===p.key?t:p.key),f=g(p,f,t),null===w?k=p:w.sibling=p,w=p;a&&q.forEach(function(a){return b(e,a)});return k}function ta(e,f,h,l){var k=ua(h);"function"!==typeof k?m("150"):void 0;h=k.call(h);null==h?m("151"):void 0;
for(var q=k=null,t=f,w=f=0,p=null,r=h.next();null!==t&&!r.done;w++,r=h.next()){t.index>w?(p=t,t=null):p=t.sibling;var U=v(e,t,r.value,l);if(null===U){t||(t=p);break}a&&t&&null===U.alternate&&b(e,t);f=g(U,f,w);null===q?k=U:q.sibling=U;q=U;t=p}if(r.done)return c(e,t),k;if(null===t){for(;!r.done;w++,r=h.next())r=y(e,r.value,l),null!==r&&(f=g(r,f,w),null===q?k=r:q.sibling=r,q=r);return k}for(t=d(e,t);!r.done;w++,r=h.next())r=u(t,e,w,r.value,l),null!==r&&(a&&null!==r.alternate&&t.delete(null===r.key?w:
r.key),f=g(r,f,w),null===q?k=r:q.sibling=r,q=r);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,g,h){var k="object"===typeof g&&null!==g&&g.type===ia&&null===g.key;k&&(g=g.props.children);var l="object"===typeof g&&null!==g;if(l)switch(g.$$typeof){case fa:a:{l=g.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?g.type===ia:k.elementType===g.type){c(a,k.sibling);d=e(k,g.type===ia?g.props.children:g.props,h);d.ref=Yc(a,k,g);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}g.type===ia?(d=Wb(g.props.children,a.mode,h,g.key),d.return=a,a=d):(h=Vb(g.type,g.key,g.props,null,a.mode,h),h.ref=Yc(a,d,g),h.return=a,a=h)}return f(a);case ha:a:{for(k=g.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===g.containerInfo&&d.stateNode.implementation===g.implementation){c(a,d.sibling);d=e(d,g.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Zb(g,a.mode,h);d.return=a;a=d}return f(a)}if("string"===typeof g||"number"===typeof g)return g=
""+g,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,g,h),d.return=a,a=d):(c(a,d),d=Yb(g,a.mode,h),d.return=a,a=d),f(a);if(Xc(g))return J(a,d,g,h);if(ua(g))return ta(a,d,g,h);l&&Zc(a,g);if("undefined"===typeof g&&!k)switch(a.tag){case 1:case 0:h=a.type,m("152",h.displayName||h.name||"Component")}return c(a,d)}}var ad=$c(!0),bd=$c(!1),H=null,cd=null,dd=!1;
function ed(a,b){var c=D(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function fd(a,b){switch(a.tag){case 5:return b=ub(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=vb(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function id(a){if(dd){var b=cd;if(b){var c=b;if(!fd(a,b)){b=wb(c);if(!b||!fd(a,b)){a.effectTag|=2;dd=!1;H=a;return}ed(H,c)}H=a;cd=xb(b)}else a.effectTag|=2,dd=!1,H=a}}function jd(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;H=a}function kd(a){if(!Xa||a!==H)return!1;if(!dd)return jd(a),dd=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ka(b,a.memoizedProps))for(b=cd;b;)ed(a,b),b=wb(b);jd(a);cd=H?wb(a.stateNode):null;return!0}function ld(){Xa&&(cd=H=null,dd=!1)}var md=ea.ReactCurrentOwner;
function I(a,b,c,d){b.child=null===a?bd(b,null,c,d):ad(b,a.child,c,d)}function nd(a,b,c,d,e){c=c.render;var g=b.ref;wc(b,e);d=c(d,g);b.effectTag|=1;I(a,b,d,e);return b.child}
function od(a,b,c,d,e,g){if(null===a){var f=c.type;if("function"===typeof f&&!Sb(f)&&void 0===f.defaultProps&&null===c.compare)return b.tag=15,b.type=f,pd(a,b,f,d,e,g);a=Vb(c.type,null,d,null,b.mode,g);a.ref=b.ref;a.return=b;return b.child=a}f=a.child;if(e<g&&(e=f.memoizedProps,c=c.compare,c=null!==c?c:Kc,c(e,d)&&a.ref===b.ref))return qd(a,b,g);b.effectTag|=1;a=Ub(f,d,g);a.ref=b.ref;a.return=b;return b.child=a}
function pd(a,b,c,d,e,g){return null!==a&&e<g&&Kc(a.memoizedProps,d)&&a.ref===b.ref?qd(a,b,g):rd(a,b,c,d,g)}function sd(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function rd(a,b,c,d,e){var g=C(c)?Fb:A.current;g=Gb(b,g);wc(b,e);c=c(d,g);b.effectTag|=1;I(a,b,c,e);return b.child}
function td(a,b,c,d,e){if(C(c)){var g=!0;Lb(b)}else g=!1;wc(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Uc(b,c,d,e),Wc(b,c,d,e),d=!0;else if(null===a){var f=b.stateNode,l=b.memoizedProps;f.props=l;var h=f.context,k=c.contextType;"object"===typeof k&&null!==k?k=Mc.currentDispatcher.readContext(k):(k=C(c)?Fb:A.current,k=Gb(b,k));var p=c.getDerivedStateFromProps,y="function"===typeof p||"function"===typeof f.getSnapshotBeforeUpdate;y||"function"!==typeof f.UNSAFE_componentWillReceiveProps&&
"function"!==typeof f.componentWillReceiveProps||(l!==d||h!==k)&&Vc(b,f,d,k);ec=!1;var v=b.memoizedState;h=f.state=v;var u=b.updateQueue;null!==u&&(mc(b,u,d,f,e),h=b.memoizedState);l!==d||v!==h||B.current||ec?("function"===typeof p&&(Oc(b,c,p,d),h=b.memoizedState),(l=ec||Tc(b,c,l,d,v,h,k))?(y||"function"!==typeof f.UNSAFE_componentWillMount&&"function"!==typeof f.componentWillMount||("function"===typeof f.componentWillMount&&f.componentWillMount(),"function"===typeof f.UNSAFE_componentWillMount&&
f.UNSAFE_componentWillMount()),"function"===typeof f.componentDidMount&&(b.effectTag|=4)):("function"===typeof f.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=h),f.props=d,f.state=h,f.context=k,d=l):("function"===typeof f.componentDidMount&&(b.effectTag|=4),d=!1)}else f=b.stateNode,l=b.memoizedProps,f.props=b.type===b.elementType?l:F(b.type,l),h=f.context,k=c.contextType,"object"===typeof k&&null!==k?k=Mc.currentDispatcher.readContext(k):(k=C(c)?Fb:A.current,k=Gb(b,k)),p=c.getDerivedStateFromProps,
(y="function"===typeof p||"function"===typeof f.getSnapshotBeforeUpdate)||"function"!==typeof f.UNSAFE_componentWillReceiveProps&&"function"!==typeof f.componentWillReceiveProps||(l!==d||h!==k)&&Vc(b,f,d,k),ec=!1,h=b.memoizedState,v=f.state=h,u=b.updateQueue,null!==u&&(mc(b,u,d,f,e),v=b.memoizedState),l!==d||h!==v||B.current||ec?("function"===typeof p&&(Oc(b,c,p,d),v=b.memoizedState),(p=ec||Tc(b,c,l,d,h,v,k))?(y||"function"!==typeof f.UNSAFE_componentWillUpdate&&"function"!==typeof f.componentWillUpdate||
("function"===typeof f.componentWillUpdate&&f.componentWillUpdate(d,v,k),"function"===typeof f.UNSAFE_componentWillUpdate&&f.UNSAFE_componentWillUpdate(d,v,k)),"function"===typeof f.componentDidUpdate&&(b.effectTag|=4),"function"===typeof f.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof f.componentDidUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=4),"function"!==typeof f.getSnapshotBeforeUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=v),f.props=d,f.state=v,f.context=k,d=p):("function"!==typeof f.componentDidUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=4),"function"!==typeof f.getSnapshotBeforeUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=256),d=!1);return ud(a,b,c,d,g,e)}
function ud(a,b,c,d,e,g){sd(a,b);var f=0!==(b.effectTag&64);if(!d&&!f)return e&&Mb(b,c,!1),qd(a,b,g);d=b.stateNode;md.current=b;var l=f&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&f?(b.child=ad(b,a.child,null,g),b.child=ad(b,null,l,g)):I(a,b,l,g);b.memoizedState=d.state;e&&Mb(b,c,!0);return b.child}function vd(a){var b=a.stateNode;b.pendingContext?Jb(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Jb(a,b.context,!1);Dc(a,b.containerInfo)}
function wd(a,b,c){var d=b.mode,e=b.pendingProps,g=b.memoizedState;if(0===(b.effectTag&64)){g=null;var f=!1}else g={timedOutAt:null!==g?g.timedOutAt:0},f=!0,b.effectTag&=-65;null===a?f?(f=e.fallback,e=Wb(null,d,0,null),0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=Wb(f,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=bd(b,null,e.children,c):null!==a.memoizedState?(d=a.child,a=d.sibling,f?(c=e.fallback,e=Ub(d,d.pendingProps,0),0===(b.mode&1)&&(f=null!==b.memoizedState?
b.child.child:b.child,f!==d.child&&(e.child=f)),d=e.sibling=Ub(a,c,a.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=ad(b,d.child,e.children,c)):(a=a.child,f?(f=e.fallback,e=Wb(null,d,0,null),e.child=a,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Wb(f,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=ad(b,a,e.children,c));b.memoizedState=g;b.child=c;return d}
function qd(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?m("153"):void 0;if(null!==b.child){a=b.child;c=Ub(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ub(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function xd(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!B.current&&d<c){switch(b.tag){case 3:vd(b);ld();break;case 5:Gc(b);break;case 1:C(b.type)&&Lb(b);break;case 4:Dc(b,b.stateNode.containerInfo);break;case 10:uc(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return wd(a,b,c);b=qd(a,b,c);return null!==b?b.sibling:null}}return qd(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Gb(b,A.current);wc(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(C(d)){var g=!0;Lb(b)}else g=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var f=d.getDerivedStateFromProps;"function"===typeof f&&Oc(b,d,f,a);e.updater=Sc;b.stateNode=e;e._reactInternalFiber=b;Wc(b,d,a,c);b=ud(null,b,d,!0,g,c)}else b.tag=0,I(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);g=b.pendingProps;a=Lc(e);b.type=a;e=b.tag=Tb(a);g=F(a,g);f=void 0;switch(e){case 0:f=rd(null,b,a,g,c);break;case 1:f=td(null,b,a,g,c);break;case 11:f=nd(null,b,a,g,c);break;case 14:f=od(null,b,a,F(a.type,g),d,c);break;default:m("283",a)}return f;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:F(d,e),rd(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:F(d,e),td(a,b,d,
e,c);case 3:vd(b);d=b.updateQueue;null===d?m("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;mc(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)ld(),b=qd(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Xa?(cd=xb(b.stateNode.containerInfo),H=b,e=dd=!0):e=!1;e?(b.effectTag|=2,b.child=bd(b,null,d,c)):(I(a,b,d,c),ld());b=b.child}return b;case 5:return Gc(b),null===a&&id(b),d=b.type,e=b.pendingProps,g=null!==a?a.memoizedProps:null,f=e.children,Ka(d,e)?f=null:
null!==g&&Ka(d,g)&&(b.effectTag|=16),sd(a,b),1!==c&&b.mode&1&&La(d,e)?(b.expirationTime=1,b=null):(I(a,b,f,c),b=b.child),b;case 6:return null===a&&id(b),null;case 13:return wd(a,b,c);case 4:return Dc(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=ad(b,null,d,c):I(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:F(d,e),nd(a,b,d,e,c);case 7:return I(a,b,b.pendingProps,c),b.child;case 8:return I(a,b,b.pendingProps.children,c),b.child;case 12:return I(a,
b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;f=b.memoizedProps;g=e.value;uc(b,g);if(null!==f){var l=f.value;g=l===g&&(0!==l||1/l===1/g)||l!==l&&g!==g?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(l,g):1073741823)|0;if(0===g){if(f.children===e.children&&!B.current){b=qd(a,b,c);break a}}else for(f=b.child,null!==f&&(f.return=b);null!==f;){l=f.firstContextDependency;if(null!==l){do{if(l.context===d&&0!==(l.observedBits&g)){if(1===f.tag){var h=
hc(c);h.tag=2;E(f,h)}f.expirationTime<c&&(f.expirationTime=c);h=f.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);for(var k=f.return;null!==k;){h=k.alternate;if(k.childExpirationTime<c)k.childExpirationTime=c,null!==h&&h.childExpirationTime<c&&(h.childExpirationTime=c);else if(null!==h&&h.childExpirationTime<c)h.childExpirationTime=c;else break;k=k.return}}h=f.child;l=l.next}while(null!==l)}else h=10===f.tag?f.type===b.type?null:f.child:f.child;if(null!==h)h.return=f;else for(h=f;null!==
h;){if(h===b){h=null;break}f=h.sibling;if(null!==f){f.return=h.return;h=f;break}h=h.return}f=h}}I(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,g=b.pendingProps,d=g.children,wc(b,c),e=xc(e,g.unstable_observedBits),d=d(e),b.effectTag|=1,I(a,b,d,c),b.child;case 14:return e=b.type,g=F(e.type,b.pendingProps),od(a,b,e,g,d,c);case 15:return pd(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:F(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=
2),b.tag=1,C(d)?(a=!0,Lb(b)):a=!1,wc(b,c),Uc(b,d,e,c),Wc(b,d,e,c),ud(null,b,d,!0,a,c);default:m("156")}}function K(a){a.effectTag|=4}var yd=void 0,zd=void 0,Ad=void 0,Bd=void 0;
if(Va)yd=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)Ha(a,c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}},zd=function(){},Ad=function(a,b,c,d,e){a=a.memoizedProps;if(a!==d){var g=b.stateNode,f=Fc();c=Ja(g,c,a,d,e,f);(b.updateQueue=c)&&K(b)}},Bd=function(a,b,c,d){c!==d&&K(b)};else if(Wa){yd=function(a,b,c,d){for(var e=
b.child;null!==e;){a:if(5===e.tag){var g=e.stateNode;if(c){var f=e.memoizedProps,l=e.type;g=d?qb(g,l,f,e):rb(g,l,f,e);e.stateNode=g}Ha(a,g)}else if(6===e.tag)g=e.stateNode,c&&(g=e.memoizedProps,f=Cc(Bc.current),l=Fc(),g=d?tb(g,f,l,b):Ma(g,f,l,b),e.stateNode=g),Ha(a,g);else if(4!==e.tag){if(13===e.tag&&(f=e.alternate,null!==f&&(g=null!==e.memoizedState,null!==f.memoizedState!==g))){f=g?e.child:e;null!==f&&yd(a,f,!0,g);break a}if(null!==e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===
e.sibling;){if(null===e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};var Cd=function(a,b,c,d){for(var e=b.child;null!==e;){a:if(5===e.tag){var g=e.stateNode;if(c){var f=e.memoizedProps,l=e.type;g=d?qb(g,l,f,e):rb(g,l,f,e);e.stateNode=g}nb(a,g)}else if(6===e.tag)g=e.stateNode,c&&(g=e.memoizedProps,f=Cc(Bc.current),l=Fc(),g=d?tb(g,f,l,b):Ma(g,f,l,b),e.stateNode=g),nb(a,g);else if(4!==e.tag){if(13===e.tag&&(f=e.alternate,null!==f&&(g=null!==e.memoizedState,null!==f.memoizedState!==
g))){f=g?e.child:e;null!==f&&Cd(a,f,!0,g);break a}if(null!==e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===e.sibling;){if(null===e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};zd=function(a){var b=a.stateNode;if(null!==a.firstEffect){var c=b.containerInfo,d=mb(c);Cd(d,a,!1,!1);b.pendingChildren=d;K(a);ob(c,d)}};Ad=function(a,b,c,d,e){var g=a.stateNode,f=a.memoizedProps;if((a=null===b.firstEffect)&&f===d)b.stateNode=g;else{var l=b.stateNode,
h=Fc(),k=null;f!==d&&(k=Ja(l,c,f,d,e,h));a&&null===k?b.stateNode=g:(g=lb(g,k,c,f,d,b,a,l),Ia(g,c,d,e,h)&&K(b),b.stateNode=g,a?K(b):yd(g,b,!1,!1))}};Bd=function(a,b,c,d){c!==d&&(a=Cc(Bc.current),c=Fc(),b.stateNode=Ma(d,a,c,b),K(b))}}else zd=function(){},Ad=function(){},Bd=function(){};function Dd(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Bb(c));null!==c&&va(c.type);b=b.value;null!==a&&1===a.tag&&va(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}
function Ed(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Fd(a,c)}else b.current=null}
function Gd(a){"function"===typeof Ob&&Ob(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(g){Fd(e,g)}}c=c.next}while(c!==b)}break;case 1:Ed(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(g){Fd(a,g)}break;case 5:Ed(a);break;case 4:Va?Hd(a):Wa&&Wa&&(a=a.stateNode.containerInfo,
b=mb(a),pb(a,b))}}function Id(a){for(var b=a;;)if(Gd(b),null===b.child||Va&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return}b.sibling.return=b.return;b=b.sibling}else b.child.return=b,b=b.child}function Jd(a){return 5===a.tag||3===a.tag||4===a.tag}
function Kd(a){if(Va){a:{for(var b=a.return;null!==b;){if(Jd(b)){var c=b;break a}b=b.return}m("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:m("161")}c.effectTag&16&&(gb(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Jd(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?db(b,e.stateNode,c):cb(b,e.stateNode,c):d?Za(b,e.stateNode):Ya(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}}
function Hd(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?m("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag)Id(b),e?fb(d,b.stateNode):eb(d,b.stateNode);else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Gd(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||
b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Ld(a,b){if(Va)switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,g=b.updateQueue;b.updateQueue=null;null!==g&&bb(c,g,e,a,d,b)}break;case 6:null===b.stateNode?m("162"):void 0;c=b.memoizedProps;$a(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;case 12:break;case 13:d=b.memoizedState;a=b;null===d?c=!1:(c=!0,a=b.child,0===d.timedOutAt&&(d.timedOutAt=G()));if(null!==
a)a:if(b=a,Va)for(d=b;;){if(5===d.tag)a=d.stateNode,c?hb(a):jb(d.stateNode,d.memoizedProps);else if(6===d.tag)a=d.stateNode,c?ib(a):kb(a,d.memoizedProps);else if(13===d.tag&&null!==d.memoizedState){a=d.child.sibling;a.return=d;d=a;continue}else if(null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break a;for(;null===d.sibling;){if(null===d.return||d.return===b)break a;d=d.return}d.sibling.return=d.return;d=d.sibling}break;case 17:break;default:m("163")}else{switch(b.tag){case 0:case 11:case 14:case 15:return}if(Wa)switch(b.tag){case 1:break;
case 5:break;case 6:break;case 3:case 4:b=b.stateNode;pb(b.containerInfo,b.pendingChildren);break;default:m("163")}}}function Md(a,b,c){c=hc(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Nd(d);Dd(a,b)};return c}
function Od(a,b,c){c=hc(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var g=a.stateNode;null!==g&&"function"===typeof g.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Pd?Pd=new Set([this]):Pd.add(this));var c=b.value,e=b.stack;Dd(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Qd(a){switch(a.tag){case 1:C(a.type)&&Hb(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Ec(a),Ib(a),b=a.effectTag,0!==(b&64)?m("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Hc(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Ec(a),null;case 10:return vc(a),null;default:return null}}
var Rd={readContext:xc},Sd=ea.ReactCurrentOwner,Td=1073741822,Ud=0,Vd=!1,L=null,M=null,N=0,Wd=-1,Xd=!1,O=null,Yd=!1,Zd=null,$d=null,Pd=null;function ae(){if(null!==L)for(var a=L.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Hb(b);break;case 3:Ec(b);Ib(b);break;case 5:Hc(b);break;case 4:Ec(b);break;case 10:vc(b)}a=a.return}M=null;N=0;Wd=-1;Xd=!1;L=null}function Qc(){null!==$d&&(ca.unstable_cancelCallback(Zd),$d())}
function be(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){L=a;a:{var e=b;b=a;var g=N,f=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:C(b.type)&&Hb(b);break;case 3:Ec(b);Ib(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)kd(b),b.effectTag&=-3;zd(b);break;case 5:Hc(b);g=Cc(Bc.current);var l=b.type;if(null!==e&&null!=b.stateNode)Ad(e,b,l,f,g),e.ref!==b.ref&&(b.effectTag|=
128);else if(f){e=Fc();if(kd(b))f=b,Xa||m("175"),e=yb(f.stateNode,f.type,f.memoizedProps,g,e,f),f.updateQueue=e,e=null!==e?!0:!1,e&&K(b);else{var h=Ga(l,f,g,e,b);yd(h,b,!1,!1);Ia(h,l,f,g,e)&&K(b);b.stateNode=h}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?m("166"):void 0;break;case 6:e&&null!=b.stateNode?Bd(e,b,e.memoizedProps,f):("string"!==typeof f&&(null===b.stateNode?m("166"):void 0),e=Cc(Bc.current),g=Fc(),kd(b)?(e=b,Xa||m("176"),(e=zb(e.stateNode,e.memoizedProps,e))&&K(b)):b.stateNode=
Ma(f,e,g,b));break;case 11:break;case 13:f=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=g;L=b;break a}f=null!==f;g=null!==e&&null!==e.memoizedState;null!==e&&!f&&g&&(e=e.child.sibling,null!==e&&(l=b.firstEffect,null!==l?(b.firstEffect=e,e.nextEffect=l):(b.firstEffect=b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(f!==g||0===(b.effectTag&1)&&f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Ec(b);zd(b);break;case 10:vc(b);break;case 9:break;case 14:break;case 17:C(b.type)&&
Hb(b);break;default:m("156")}L=null}b=a;if(1===N||1!==b.childExpirationTime){e=0;for(f=b.child;null!==f;)g=f.expirationTime,l=f.childExpirationTime,g>e&&(e=g),l>e&&(e=l),f=f.sibling;b.childExpirationTime=e}if(null!==L)return L;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,
c.lastEffect=a))}else{a=Qd(a,N);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function ce(a){var b=xd(a.alternate,a,N);a.memoizedProps=a.pendingProps;null===b&&(b=be(a));Sd.current=null;return b}
function de(a,b){Vd?m("243"):void 0;Qc();Vd=!0;Sd.currentDispatcher=Rd;var c=a.nextExpirationTimeToWorkOn;if(c!==N||a!==M||null===L)ae(),M=a,N=c,L=Ub(M.current,null,N),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==L&&!ee();)L=ce(L);else for(;null!==L;)L=ce(L)}catch(J){if(tc=sc=rc=null,null===L)d=!0,Nd(J);else{null===L?m("271"):void 0;var e=L,g=e.return;if(null===g)d=!0,Nd(J);else{a:{var f=a,l=g,h=e,k=J;g=N;h.effectTag|=1024;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===
typeof k&&"function"===typeof k.then){var p=k;k=l;var y=-1,v=-1;do{if(13===k.tag){var u=k.alternate;if(null!==u&&(u=u.memoizedState,null!==u)){v=10*(1073741822-u.timedOutAt);break}u=k.pendingProps.maxDuration;if("number"===typeof u)if(0>=u)y=0;else if(-1===y||u<y)y=u}k=k.return}while(null!==k);k=l;do{if(u=13===k.tag)u=void 0===k.memoizedProps.fallback?!1:null===k.memoizedState;if(u){l=fe.bind(null,f,k,h,0===(k.mode&1)?1073741823:g);p.then(l,l);if(0===(k.mode&1)){k.effectTag|=64;h.effectTag&=-1957;
1===h.tag&&null===h.alternate&&(h.tag=17);h.expirationTime=g;break a}-1===y?f=1073741823:(-1===v&&(v=10*(1073741822-cc(f,g))-5E3),f=v+y);0<=f&&Wd<f&&(Wd=f);k.effectTag|=2048;k.expirationTime=g;break a}k=k.return}while(null!==k);k=Error((va(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Bb(h))}Xd=!0;k=pc(k,h);f=l;do{switch(f.tag){case 3:h=
k;f.effectTag|=2048;f.expirationTime=g;g=Md(f,h,g);jc(f,g);break a;case 1:if(h=k,l=f.type,p=f.stateNode,0===(f.effectTag&64)&&("function"===typeof l.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&(null===Pd||!Pd.has(p)))){f.effectTag|=2048;f.expirationTime=g;g=Od(f,h,g);jc(f,g);break a}}f=f.return}while(null!==f)}L=be(e);continue}}}break}while(1);Vd=!1;tc=sc=rc=Sd.currentDispatcher=null;if(d)M=null,a.finishedWork=null;else if(null!==L)a.finishedWork=null;else{d=a.current.alternate;
null===d?m("281"):void 0;M=null;if(Xd){e=a.latestPendingTime;g=a.latestSuspendedTime;f=a.latestPingedTime;if(0!==e&&e<c||0!==g&&g<c||0!==f&&f<c){bc(a,c);ge(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;ge(a,d,c,b,-1);return}}b&&-1!==Wd?(bc(a,c),b=10*(1073741822-cc(a,c)),b<Wd&&(Wd=b),b=10*(1073741822-G()),b=Wd-b,ge(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=c,a.finishedWork=d)}}
function Fd(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Pd||!Pd.has(d))){a=pc(b,a);a=Od(c,a,1073741823);E(c,a);Rc(c,1073741823);return}break;case 3:a=pc(b,a);a=Md(c,a,1073741823);E(c,a);Rc(c,1073741823);return}c=c.return}3===a.tag&&(c=pc(b,a),c=Md(a,c,1073741823),E(a,c),Rc(a,1073741823))}
function Pc(a,b){0!==Ud?a=Ud:Vd?a=Yd?1073741823:N:b.mode&1?(a=P?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==M&&a===N&&--a):a=1073741823;P&&(0===Q||a<Q)&&(Q=a);return a}
function fe(a,b,c,d){var e=a.earliestSuspendedTime;var g=a.latestSuspendedTime;if(0!==e&&d<=e&&d>=g){g=e=d;a.didError=!1;var f=a.latestPingedTime;if(0===f||f>g)a.latestPingedTime=g;ac(g,a)}else e=G(),e=Pc(e,b),$b(a,e);0!==(b.mode&1)&&a===M&&N===d&&(M=null);he(b,e);0===(b.mode&1)&&(he(c,e),1===c.tag&&null!==c.stateNode&&(b=hc(e),b.tag=2,E(c,b)));c=a.expirationTime;0!==c&&ie(a,c)}
function he(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Rc(a,b){a=he(a,b);null!==a&&(!Vd&&0!==N&&b>N&&ae(),$b(a,b),Vd&&!Yd&&M===a||ie(a,a.expirationTime),je>ke&&(je=0,m("185")))}function le(a,b,c,d,e){var g=Ud;Ud=1073741823;try{return a(b,c,d,e)}finally{Ud=g}}var R=null,S=null,me=0,ne=void 0,T=!1,V=null,W=0,Q=0,oe=!1,pe=null,X=!1,qe=!1,P=!1,re=null,se=Ta(),Y=1073741822-(se/10|0),te=Y,ke=50,je=0,ue=null;function ve(){Y=1073741822-((Ta()-se)/10|0)}
function we(a,b){if(0!==me){if(b<me)return;null!==ne&&Oa(ne)}me=b;a=Ta()-se;ne=Na(xe,{timeout:10*(1073741822-b)-a})}function ge(a,b,c,d,e){a.expirationTime=d;0!==e||ee()?0<e&&(a.timeoutHandle=Qa(ze.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function ze(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;ve();te=Y;Ae(a,c)}function G(){if(T)return te;Be();if(0===W||1===W)ve(),te=Y;return te}
function ie(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===S?(R=S=a,a.nextScheduledRoot=a):(S=S.nextScheduledRoot=a,S.nextScheduledRoot=R)):b>a.expirationTime&&(a.expirationTime=b);T||(X?qe&&(V=a,W=1073741823,Ce(a,1073741823,!1)):1073741823===b?Z(1073741823,!1):we(a,b))}
function Be(){var a=0,b=null;if(null!==S)for(var c=S,d=R;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===S?m("244"):void 0;if(d===d.nextScheduledRoot){R=S=d.nextScheduledRoot=null;break}else if(d===R)R=e=d.nextScheduledRoot,S.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===S){S=c;S.nextScheduledRoot=R;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===S)break;if(1073741823===a)break;
c=d;d=d.nextScheduledRoot}}V=b;W=a}var De=!1;function ee(){return De?!0:Pa()?De=!0:!1}function xe(){try{if(!ee()&&null!==R){ve();var a=R;do{var b=a.expirationTime;0!==b&&Y<=b&&(a.nextExpirationTimeToWorkOn=Y);a=a.nextScheduledRoot}while(a!==R)}Z(0,!0)}finally{De=!1}}
function Z(a,b){Be();if(b)for(ve(),te=Y;null!==V&&0!==W&&a<=W&&!(De&&Y>W);)Ce(V,W,Y>W),Be(),ve(),te=Y;else for(;null!==V&&0!==W&&a<=W;)Ce(V,W,!1),Be();b&&(me=0,ne=null);0!==W&&we(V,W);je=0;ue=null;if(null!==re)for(a=re,re=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){oe||(oe=!0,pe=d)}}if(oe)throw a=pe,pe=null,oe=!1,a;}function Ae(a,b){T?m("253"):void 0;V=a;W=b;Ce(a,b,!1);Z(1073741823,!1)}
function Ce(a,b,c){T?m("245"):void 0;T=!0;if(c){var d=a.finishedWork;null!==d?Ee(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,d!==Sa&&(a.timeoutHandle=Sa,Ra(d)),de(a,c),d=a.finishedWork,null!==d&&(ee()?a.finishedWork=d:Ee(a,d,b)))}else d=a.finishedWork,null!==d?Ee(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,d!==Sa&&(a.timeoutHandle=Sa,Ra(d)),de(a,c),d=a.finishedWork,null!==d&&Ee(a,d,b));T=!1}
function Ee(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===re?re=[d]:re.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===ue?je++:(ue=a,je=0);Yd=Vd=!0;a.current===b?m("177"):void 0;c=a.pendingCommitExpirationTime;0===c?m("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?$b(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,$b(a,d)):d>e&&$b(a,d));ac(0,a);Sd.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;Ea(a.containerInfo);for(O=d;null!==O;){e=!1;var g=void 0;try{for(;null!==
O;){if(O.effectTag&256)a:{var f=O.alternate,l=O;switch(l.tag){case 0:case 11:case 15:break a;case 1:if(l.effectTag&256&&null!==f){var h=f.memoizedProps,k=f.memoizedState,p=l.stateNode,y=p.getSnapshotBeforeUpdate(l.elementType===l.type?h:F(l.type,h),k);p.__reactInternalSnapshotBeforeUpdate=y}break a;case 3:case 5:case 6:case 4:case 17:break a;default:m("163")}}O=O.nextEffect}}catch(r){e=!0,g=r}e&&(null===O?m("178"):void 0,Fd(O,g),null!==O&&(O=O.nextEffect))}for(O=d;null!==O;){f=!1;h=void 0;try{for(;null!==
O;){var v=O.effectTag;v&16&&Va&&gb(O.stateNode);if(v&128){var u=O.alternate;if(null!==u){var J=u.ref;null!==J&&("function"===typeof J?J(null):J.current=null)}}switch(v&14){case 2:Kd(O);O.effectTag&=-3;break;case 6:Kd(O);O.effectTag&=-3;Ld(O.alternate,O);break;case 4:Ld(O.alternate,O);break;case 8:k=O,Va?Hd(k):Id(k),k.return=null,k.child=null,k.alternate&&(k.alternate.child=null,k.alternate.return=null)}O=O.nextEffect}}catch(r){f=!0,h=r}f&&(null===O?m("178"):void 0,Fd(O,h),null!==O&&(O=O.nextEffect))}Fa(a.containerInfo);
a.current=b;for(O=d;null!==O;){v=!1;u=void 0;try{for(J=c;null!==O;){var ta=O.effectTag;if(ta&36){var q=O.alternate;f=O;h=J;switch(f.tag){case 0:case 11:case 15:break;case 1:var w=f.stateNode;if(f.effectTag&4)if(null===q)w.componentDidMount();else{var t=f.elementType===f.type?q.memoizedProps:F(f.type,q.memoizedProps);w.componentDidUpdate(t,q.memoizedState,w.__reactInternalSnapshotBeforeUpdate)}var U=f.updateQueue;null!==U&&nc(f,U,w,h);break;case 3:var gd=f.updateQueue;if(null!==gd){k=null;if(null!==
f.child)switch(f.child.tag){case 5:k=Ba(f.child.stateNode);break;case 1:k=f.child.stateNode}nc(f,gd,k,h)}break;case 5:var ye=f.stateNode;null===q&&f.effectTag&4&&ab(ye,f.type,f.memoizedProps,f);break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:m("163")}}if(ta&128){var sb=O.ref;if(null!==sb){var hd=O.stateNode;switch(O.tag){case 5:var dc=Ba(hd);break;default:dc=hd}"function"===typeof sb?sb(dc):sb.current=dc}}O=O.nextEffect}}catch(r){v=!0,u=r}v&&(null===O?m("178"):void 0,
Fd(O,u),null!==O&&(O=O.nextEffect))}Vd=Yd=!1;"function"===typeof Nb&&Nb(b.stateNode);ta=b.expirationTime;b=b.childExpirationTime;b=b>ta?b:ta;0===b&&(Pd=null);a.expirationTime=b;a.finishedWork=null}function Nd(a){null===V?m("246"):void 0;V.expirationTime=0;oe||(oe=!0,pe=a)}
function Fe(a,b,c,d,e){var g=b.current;a:if(c){c=c._reactInternalFiber;b:{2===wa(c)&&1===c.tag?void 0:m("170");var f=c;do{switch(f.tag){case 3:f=f.stateNode.context;break b;case 1:if(C(f.type)){f=f.stateNode.__reactInternalMemoizedMergedChildContext;break b}}f=f.return}while(null!==f);m("171");f=void 0}if(1===c.tag){var l=c.type;if(C(l)){c=Kb(c,l,f);break a}}c=f}else c=Eb;null===b.context?b.context=c:b.pendingContext=c;b=e;e=hc(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Qc();E(g,e);Rc(g,d);return d}function Ge(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?m("188"):m("268",Object.keys(a)));a=za(b);return null===a?null:a.stateNode}
var He={updateContainerAtExpirationTime:Fe,createContainer:function(a,b,c){b=D(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:Sa,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,
b,c,d){var e=b.current,g=G();e=Pc(g,e);return Fe(a,b,c,e,d)},flushRoot:Ae,requestWork:ie,computeUniqueAsyncExpiration:function(){var a=1073741822-25*(((1073741822-G()+500)/25|0)+1);a>=Td&&(a=Td-1);return Td=a},batchedUpdates:function(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||T||Z(1073741823,!1)}},unbatchedUpdates:function(a,b){if(X&&!qe){qe=!0;try{return a(b)}finally{qe=!1}}return a(b)},deferredUpdates:function(a){var b=G(),c=Ud,d=P;Ud=1073741822-25*(((1073741822-b+500)/25|0)+1);P=!1;try{return a()}finally{Ud=
c,P=d}},syncUpdates:le,interactiveUpdates:function(a,b,c){if(P)return a(b,c);X||T||0===Q||(Z(Q,!1),Q=0);var d=P,e=X;X=P=!0;try{return a(b,c)}finally{P=d,(X=e)||T||Z(1073741823,!1)}},flushInteractiveUpdates:function(){T||0===Q||(Z(Q,!1),Q=0)},flushControlled:function(a){var b=X;X=!0;try{le(a)}finally{(X=b)||T||Z(1073741823,!1)}},flushSync:function(a,b){T?m("187"):void 0;var c=X;X=!0;try{return le(a,b)}finally{X=c,Z(1073741823,!1)}},getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;
switch(a.child.tag){case 5:return Ba(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:Ge,findHostInstanceWithWarning:function(a){return Ge(a)},findHostInstanceWithNoPortals:function(a){a=Aa(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return Qb(aa({},a,{findHostInstanceByFiber:function(a){a=za(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}};module.exports=He.default||He;

    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getClosestInstanceFromNode = getClosestInstanceFromNode;
// from https://github.com/facebook/react/blob/87ae211ccd8d61796cfdef138d1e12fb7a74f85d/packages/shared/ReactTypeOfWork.js
var HostComponent = 5;
var HostText = 6;

// adapted FROM: https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMComponentTree.js

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactInternalInstance$' + randomKey;

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  while (!node[internalInstanceKey]) {
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var inst = node[internalInstanceKey];
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber, this will always be the deepest root.
    return inst;
  }

  return null;
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.supportsMutation = exports.isPrimaryRenderer = exports.noTimeout = exports.cancelTimeout = exports.scheduleTimeout = exports.cancelDeferredCallback = exports.shouldYield = exports.scheduleDeferredCallback = exports.now = undefined;

var _HostConfigWithNoPersistence = __webpack_require__(244);

Object.keys(_HostConfigWithNoPersistence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoPersistence[key];
    }
  });
});

var _HostConfigWithNoHydration = __webpack_require__(245);

Object.keys(_HostConfigWithNoHydration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoHydration[key];
    }
  });
});

var _scheduler = __webpack_require__(17);

Object.defineProperty(exports, 'now', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_now;
  }
});
Object.defineProperty(exports, 'scheduleDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_scheduleCallback;
  }
});
Object.defineProperty(exports, 'shouldYield', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_shouldYield;
  }
});
Object.defineProperty(exports, 'cancelDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_cancelCallback;
  }
});
exports.appendInitialChild = appendInitialChild;
exports.createInstance = createInstance;
exports.createTextInstance = createTextInstance;
exports.finalizeInitialChildren = finalizeInitialChildren;
exports.getPublicInstance = getPublicInstance;
exports.prepareForCommit = prepareForCommit;
exports.prepareUpdate = prepareUpdate;
exports.resetAfterCommit = resetAfterCommit;
exports.resetTextContent = resetTextContent;
exports.shouldDeprioritizeSubtree = shouldDeprioritizeSubtree;
exports.getRootHostContext = getRootHostContext;
exports.getChildHostContext = getChildHostContext;
exports.shouldSetTextContent = shouldSetTextContent;
exports.appendChild = appendChild;
exports.appendChildToContainer = appendChildToContainer;
exports.insertBefore = insertBefore;
exports.insertInContainerBefore = insertInContainerBefore;
exports.removeChild = removeChild;
exports.removeChildFromContainer = removeChildFromContainer;
exports.commitTextUpdate = commitTextUpdate;
exports.commitMount = commitMount;
exports.commitUpdate = commitUpdate;
exports.hideInstance = hideInstance;
exports.hideTextInstance = hideTextInstance;
exports.unhideInstance = unhideInstance;
exports.unhideTextInstance = unhideTextInstance;

var _konva = __webpack_require__(16);

var _konva2 = _interopRequireDefault(_konva);

var _makeUpdates = __webpack_require__(39);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_CONTEXT = {};
var UPDATE_SIGNAL = {};

function appendInitialChild(parentInstance, child) {
  if (typeof child === 'string') {
    // Noop for string children of Text (eg <Text>foo</Text>)
    (0, _invariant2.default)(false, 'Don not use plain text as child of Konva.Node. You are using text: "%s"', child);
    return;
  }

  parentInstance.add(child);

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function createInstance(type, props, internalInstanceHandle) {
  var NodeClass = _konva2.default[type];
  if (!NodeClass) {
    (0, _invariant2.default)(instance, 'ReactKonva does not support the type "%s". If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html', type);
    return;
  }

  var instance = new NodeClass();
  instance._applyProps = _makeUpdates.applyNodeProps;
  instance._applyProps(instance, props);

  return instance;
}

function createTextInstance(text, rootContainerInstance, internalInstanceHandle) {
  (0, _invariant2.default)(false, 'Text components are not supported for now in ReactKonva. You text is: "' + text + '"');
}

function finalizeInitialChildren(domElement, type, props) {
  return false;
}

function getPublicInstance(instance) {
  return instance;
}

function prepareForCommit() {
  // Noop
}

function prepareUpdate(domElement, type, oldProps, newProps) {
  return UPDATE_SIGNAL;
}

function resetAfterCommit() {
  // Noop
}

function resetTextContent(domElement) {
  // Noop
}

function shouldDeprioritizeSubtree(type, props) {
  return false;
}

function getRootHostContext() {
  return NO_CONTEXT;
}

function getChildHostContext() {
  return NO_CONTEXT;
}

var scheduleTimeout = exports.scheduleTimeout = setTimeout;
var cancelTimeout = exports.cancelTimeout = clearTimeout;
var noTimeout = exports.noTimeout = -1;

function shouldSetTextContent(type, props) {
  return false;
}

// The Konva renderer is secondary to the React DOM renderer.
var isPrimaryRenderer = exports.isPrimaryRenderer = false;

var supportsMutation = exports.supportsMutation = true;

function appendChild(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function appendChildToContainer(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertBefore(parentInstance, child, beforeChild) {
  (0, _invariant2.default)(child !== beforeChild, 'ReactKonva: Can not insert node before itself');
  // remove and add back to reset zIndex
  child.remove();
  parentInstance.add(child);
  child.setZIndex(beforeChild.getZIndex());
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertInContainerBefore(parentInstance, child, beforeChild) {
  (0, _invariant2.default)(child !== beforeChild, 'ReactKonva: Can not insert node before itself');
  // remove and add back to reset zIndex
  child.remove();
  parentInstance.add(child);
  child.setZIndex(beforeChild.getZIndex());
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function removeChild(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function removeChildFromContainer(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function commitTextUpdate(textInstance, oldText, newText) {
  (0, _invariant2.default)(false, 'Text components are not yet supported in ReactKonva. You text is: "' + newText + '"');
}

function commitMount(instance, type, newProps) {
  // Noop
}

function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
  instance._applyProps(instance, newProps, oldProps);
}

function hideInstance(instance) {
  instance.hide();
  (0, _makeUpdates.updatePicture)(instance);
}

function hideTextInstance(textInstance) {
  // Noop
}

function unhideInstance(instance, props) {
  if (props.visible == null || props.visible) {
    instance.show();
  }
}

function unhideTextInstance(textInstance, text) {
  // Noop
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createHiddenTextInstance = exports.cloneUnhiddenInstance = exports.cloneHiddenInstance = exports.replaceContainerChildren = exports.finalizeContainerChildren = exports.appendChildToContainerChildSet = exports.createContainerChildSet = exports.cloneInstance = exports.supportsPersistence = undefined;

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Renderers that don't support persistence
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support persistence. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Persistence (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsPersistence = exports.supportsPersistence = false;
var cloneInstance = exports.cloneInstance = shim;
var createContainerChildSet = exports.createContainerChildSet = shim;
var appendChildToContainerChildSet = exports.appendChildToContainerChildSet = shim;
var finalizeContainerChildren = exports.finalizeContainerChildren = shim;
var replaceContainerChildren = exports.replaceContainerChildren = shim;
var cloneHiddenInstance = exports.cloneHiddenInstance = shim;
var cloneUnhiddenInstance = exports.cloneUnhiddenInstance = shim;
var createHiddenTextInstance = exports.createHiddenTextInstance = shim;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.didNotFindHydratableTextInstance = exports.didNotFindHydratableInstance = exports.didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerInstance = exports.didNotHydrateInstance = exports.didNotHydrateContainerInstance = exports.didNotMatchHydratedTextInstance = exports.didNotMatchHydratedContainerTextInstance = exports.hydrateTextInstance = exports.hydrateInstance = exports.getFirstHydratableChild = exports.getNextHydratableSibling = exports.canHydrateTextInstance = exports.canHydrateInstance = exports.supportsHydration = undefined;

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Renderers that don't support hydration
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support hyration. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Hydration (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsHydration = exports.supportsHydration = false;
var canHydrateInstance = exports.canHydrateInstance = shim;
var canHydrateTextInstance = exports.canHydrateTextInstance = shim;
var getNextHydratableSibling = exports.getNextHydratableSibling = shim;
var getFirstHydratableChild = exports.getFirstHydratableChild = shim;
var hydrateInstance = exports.hydrateInstance = shim;
var hydrateTextInstance = exports.hydrateTextInstance = shim;
var didNotMatchHydratedContainerTextInstance = exports.didNotMatchHydratedContainerTextInstance = shim;
var didNotMatchHydratedTextInstance = exports.didNotMatchHydratedTextInstance = shim;
var didNotHydrateContainerInstance = exports.didNotHydrateContainerInstance = shim;
var didNotHydrateInstance = exports.didNotHydrateInstance = shim;
var didNotFindHydratableContainerInstance = exports.didNotFindHydratableContainerInstance = shim;
var didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerTextInstance = shim;
var didNotFindHydratableInstance = exports.didNotFindHydratableInstance = shim;
var didNotFindHydratableTextInstance = exports.didNotFindHydratableTextInstance = shim;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/concept1.9b7a04fa.mp4";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/concept2.6d9af71c.mp4";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/concept3.d57c5809.mp4";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2018, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.chroma = factory());
}(this, (function () { 'use strict';

    var limit = function (x, min, max) {
        if ( min === void 0 ) min=0;
        if ( max === void 0 ) max=1;

        return x < min ? min : x > max ? max : x;
    };

    var clip_rgb = function (rgb) {
        rgb._clipped = false;
        rgb._unclipped = rgb.slice(0);
        for (var i=0; i<=3; i++) {
            if (i < 3) {
                if (rgb[i] < 0 || rgb[i] > 255) { rgb._clipped = true; }
                rgb[i] = limit(rgb[i], 0, 255);
            } else if (i === 3) {
                rgb[i] = limit(rgb[i], 0, 1);
            }
        }
        return rgb;
    };

    // ported from jQuery's $.type
    var classToType = {};
    for (var i = 0, list = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; i < list.length; i += 1) {
        var name = list[i];

        classToType[("[object " + name + "]")] = name.toLowerCase();
    }
    var type = function(obj) {
        return classToType[Object.prototype.toString.call(obj)] || "object";
    };

    var unpack = function (args, keyOrder) {
        if ( keyOrder === void 0 ) keyOrder=null;

    	// if called with more than 3 arguments, we return the arguments
        if (args.length >= 3) { return Array.prototype.slice.call(args); }
        // with less than 3 args we check if first arg is object
        // and use the keyOrder string to extract and sort properties
    	if (type(args[0]) == 'object' && keyOrder) {
    		return keyOrder.split('')
    			.filter(function (k) { return args[0][k] !== undefined; })
    			.map(function (k) { return args[0][k]; });
    	}
    	// otherwise we just return the first argument
    	// (which we suppose is an array of args)
        return args[0];
    };

    var last = function (args) {
        if (args.length < 2) { return null; }
        var l = args.length-1;
        if (type(args[l]) == 'string') { return args[l].toLowerCase(); }
        return null;
    };

    var PI = Math.PI;

    var utils = {
    	clip_rgb: clip_rgb,
    	limit: limit,
    	type: type,
    	unpack: unpack,
    	last: last,
    	PI: PI,
    	TWOPI: PI*2,
    	PITHIRD: PI/3,
    	DEG2RAD: PI / 180,
    	RAD2DEG: 180 / PI
    };

    var input = {
    	format: {},
    	autodetect: []
    };

    var last$1 = utils.last;
    var clip_rgb$1 = utils.clip_rgb;
    var type$1 = utils.type;


    var Color = function Color() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var me = this;
        if (type$1(args[0]) === 'object' &&
            args[0].constructor &&
            args[0].constructor === this.constructor) {
            // the argument is already a Color instance
            return args[0];
        }

        // last argument could be the mode
        var mode = last$1(args);
        var autodetect = false;

        if (!mode) {
            autodetect = true;
            if (!input.sorted) {
                input.autodetect = input.autodetect.sort(function (a,b) { return b.p - a.p; });
                input.sorted = true;
            }
            // auto-detect format
            for (var i = 0, list = input.autodetect; i < list.length; i += 1) {
                var chk = list[i];

                mode = chk.test.apply(chk, args);
                if (mode) { break; }
            }
        }

        if (input.format[mode]) {
            var rgb = input.format[mode].apply(null, autodetect ? args : args.slice(0,-1));
            me._rgb = clip_rgb$1(rgb);
        } else {
            throw new Error('unknown format: '+args);
        }

        // add alpha channel
        if (me._rgb.length === 3) { me._rgb.push(1); }
    };

    Color.prototype.toString = function toString () {
        if (type$1(this.hex) == 'function') { return this.hex(); }
        return ("[" + (this._rgb.join(',')) + "]");
    };

    var Color_1 = Color;

    var chroma = function () {
    	var args = [], len = arguments.length;
    	while ( len-- ) args[ len ] = arguments[ len ];

    	return new (Function.prototype.bind.apply( chroma.Color, [ null ].concat( args) ));
    };

    chroma.Color = Color_1;
    chroma.version = '2.0.2';

    var chroma_1 = chroma;

    var unpack$1 = utils.unpack;
    var max = Math.max;

    var rgb2cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$1(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var k = 1 - max(r,max(g,b));
        var f = k < 1 ? 1 / (1-k) : 0;
        var c = (1-r-k) * f;
        var m = (1-g-k) * f;
        var y = (1-b-k) * f;
        return [c,m,y,k];
    };

    var rgb2cmyk_1 = rgb2cmyk;

    var unpack$2 = utils.unpack;

    var cmyk2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$2(args, 'cmyk');
        var c = args[0];
        var m = args[1];
        var y = args[2];
        var k = args[3];
        var alpha = args.length > 4 ? args[4] : 1;
        if (k === 1) { return [0,0,0,alpha]; }
        return [
            c >= 1 ? 0 : 255 * (1-c) * (1-k), // r
            m >= 1 ? 0 : 255 * (1-m) * (1-k), // g
            y >= 1 ? 0 : 255 * (1-y) * (1-k), // b
            alpha
        ];
    };

    var cmyk2rgb_1 = cmyk2rgb;

    var unpack$3 = utils.unpack;
    var type$2 = utils.type;



    Color_1.prototype.cmyk = function() {
        return rgb2cmyk_1(this._rgb);
    };

    chroma_1.cmyk = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['cmyk']) ));
    };

    input.format.cmyk = cmyk2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$3(args, 'cmyk');
            if (type$2(args) === 'array' && args.length === 4) {
                return 'cmyk';
            }
        }
    });

    var unpack$4 = utils.unpack;
    var last$2 = utils.last;
    var rnd = function (a) { return Math.round(a*100)/100; };

    /*
     * supported arguments:
     * - hsl2css(h,s,l)
     * - hsl2css(h,s,l,a)
     * - hsl2css([h,s,l], mode)
     * - hsl2css([h,s,l,a], mode)
     * - hsl2css({h,s,l,a}, mode)
     */
    var hsl2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hsla = unpack$4(args, 'hsla');
        var mode = last$2(args) || 'lsa';
        hsla[0] = rnd(hsla[0] || 0);
        hsla[1] = rnd(hsla[1]*100) + '%';
        hsla[2] = rnd(hsla[2]*100) + '%';
        if (mode === 'hsla' || (hsla.length > 3 && hsla[3]<1)) {
            hsla[3] = hsla.length > 3 ? hsla[3] : 1;
            mode = 'hsla';
        } else {
            hsla.length = 3;
        }
        return (mode + "(" + (hsla.join(',')) + ")");
    };

    var hsl2css_1 = hsl2css;

    var unpack$5 = utils.unpack;

    /*
     * supported arguments:
     * - rgb2hsl(r,g,b)
     * - rgb2hsl(r,g,b,a)
     * - rgb2hsl([r,g,b])
     * - rgb2hsl([r,g,b,a])
     * - rgb2hsl({r,g,b,a})
     */
    var rgb2hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$5(args, 'rgba');
        var r = args[0];
        var g = args[1];
        var b = args[2];

        r /= 255;
        g /= 255;
        b /= 255;

        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);

        var l = (max + min) / 2;
        var s, h;

        if (max === min){
            s = 0;
            h = Number.NaN;
        } else {
            s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
        }

        if (r == max) { h = (g - b) / (max - min); }
        else if (g == max) { h = 2 + (b - r) / (max - min); }
        else if (b == max) { h = 4 + (r - g) / (max - min); }

        h *= 60;
        if (h < 0) { h += 360; }
        if (args.length>3 && args[3]!==undefined) { return [h,s,l,args[3]]; }
        return [h,s,l];
    };

    var rgb2hsl_1 = rgb2hsl;

    var unpack$6 = utils.unpack;
    var last$3 = utils.last;


    var round = Math.round;

    /*
     * supported arguments:
     * - rgb2css(r,g,b)
     * - rgb2css(r,g,b,a)
     * - rgb2css([r,g,b], mode)
     * - rgb2css([r,g,b,a], mode)
     * - rgb2css({r,g,b,a}, mode)
     */
    var rgb2css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$6(args, 'rgba');
        var mode = last$3(args) || 'rgb';
        if (mode.substr(0,3) == 'hsl') {
            return hsl2css_1(rgb2hsl_1(rgba), mode);
        }
        rgba[0] = round(rgba[0]);
        rgba[1] = round(rgba[1]);
        rgba[2] = round(rgba[2]);
        if (mode === 'rgba' || (rgba.length > 3 && rgba[3]<1)) {
            rgba[3] = rgba.length > 3 ? rgba[3] : 1;
            mode = 'rgba';
        }
        return (mode + "(" + (rgba.slice(0,mode==='rgb'?3:4).join(',')) + ")");
    };

    var rgb2css_1 = rgb2css;

    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8})$/;

    var hex2rgb = function (hex) {
        if (hex.match(RE_HEX)) {
            // remove optional leading #
            if (hex.length === 4 || hex.length === 7) {
                hex = hex.substr(1);
            }
            // expand short-notation to full six-digit
            if (hex.length === 3) {
                hex = hex.split('');
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            var u = parseInt(hex, 16);
            var r = u >> 16;
            var g = u >> 8 & 0xFF;
            var b = u & 0xFF;
            return [r,g,b,1];
        }

        // match rgba hex format, eg #FF000077
        if (hex.match(RE_HEXA)) {
            if (hex.length === 9) {
                // remove optional leading #
                hex = hex.substr(1);
            }
            var u$1 = parseInt(hex, 16);
            var r$1 = u$1 >> 24 & 0xFF;
            var g$1 = u$1 >> 16 & 0xFF;
            var b$1 = u$1 >> 8 & 0xFF;
            var a = Math.round((u$1 & 0xFF) / 0xFF * 100) / 100;
            return [r$1,g$1,b$1,a];
        }

        // we used to check for css colors here
        // if _input.css? and rgb = _input.css hex
        //     return rgb

        throw new Error(("unknown hex color: " + hex));
    };

    var hex2rgb_1 = hex2rgb;

    var unpack$7 = utils.unpack;
    var round$1 = Math.round;

    var hsl2rgb = function () {
        var assign;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$7(args, 'hsl');
        var h = args[0];
        var s = args[1];
        var l = args[2];
        var r,g,b;
        if (s === 0) {
            r = g = b = l*255;
        } else {
            var t3 = [0,0,0];
            var c = [0,0,0];
            var t2 = l < 0.5 ? l * (1+s) : l+s-l*s;
            var t1 = 2 * l - t2;
            var h_ = h / 360;
            t3[0] = h_ + 1/3;
            t3[1] = h_;
            t3[2] = h_ - 1/3;
            for (var i=0; i<3; i++) {
                if (t3[i] < 0) { t3[i] += 1; }
                if (t3[i] > 1) { t3[i] -= 1; }
                if (6 * t3[i] < 1)
                    { c[i] = t1 + (t2 - t1) * 6 * t3[i]; }
                else if (2 * t3[i] < 1)
                    { c[i] = t2; }
                else if (3 * t3[i] < 2)
                    { c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6; }
                else
                    { c[i] = t1; }
            }
            (assign = [round$1(c[0]*255),round$1(c[1]*255),round$1(c[2]*255)], r = assign[0], g = assign[1], b = assign[2]);
        }
        if (args.length > 3) {
            // keep alpha channel
            return [r,g,b,args[3]];
        }
        return [r,g,b];
    };

    var hsl2rgb_1 = hsl2rgb;

    /**
    	X11 color names

    	http://www.w3.org/TR/css3-color/#svg-color
    */

    var w3cx11 = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflower: '#6495ed',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkgrey: '#a9a9a9',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkslategrey: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        grey: '#808080',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        indianred: '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        laserlemon: '#ffff54',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrod: '#fafad2',
        lightgoldenrodyellow: '#fafad2',
        lightgray: '#d3d3d3',
        lightgreen: '#90ee90',
        lightgrey: '#d3d3d3',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        maroon2: '#7f0000',
        maroon3: '#b03060',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370db',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#db7093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        purple2: '#7f007f',
        purple3: '#a020f0',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32'
    };

    var w3cx11_1 = w3cx11;

    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;

    var round$2 = Math.round;

    var css2rgb = function (css) {
        css = css.toLowerCase().trim();
        // named X11 colors
        if (w3cx11_1[css]) {
            return hex2rgb_1(w3cx11_1[css]);
        }
        var m;

        // rgb(250,20,0)
        if ((m = css.match(RE_RGB))) {
            var rgb = m.slice(1,4);
            for (var i=0; i<3; i++) {
                rgb[i] = +rgb[i];
            }
            rgb[3] = 1;  // default alpha
            return rgb;
        }

        // rgba(250,20,0,0.4)
        if ((m = css.match(RE_RGBA))) {
            var rgb$1 = m.slice(1,5);
            for (var i$1=0; i$1<4; i$1++) {
                rgb$1[i$1] = +rgb$1[i$1];
            }
            return rgb$1;
        }

        // rgb(100%,0%,0%)
        if ((m = css.match(RE_RGB_PCT))) {
            var rgb$2 = m.slice(1,4);
            for (var i$2=0; i$2<3; i$2++) {
                rgb$2[i$2] = round$2(rgb$2[i$2] * 2.55);
            }
            rgb$2[3] = 1;  // default alpha
            return rgb$2;
        }

        // rgba(100%,0%,0%,0.4)
        if ((m = css.match(RE_RGBA_PCT))) {
            var rgb$3 = m.slice(1,5);
            for (var i$3=0; i$3<3; i$3++) {
                rgb$3[i$3] = round$2(rgb$3[i$3] * 2.55);
            }
            rgb$3[3] = +rgb$3[3];
            return rgb$3;
        }

        // hsl(0,100%,50%)
        if ((m = css.match(RE_HSL))) {
            var hsl = m.slice(1,4);
            hsl[1] *= 0.01;
            hsl[2] *= 0.01;
            var rgb$4 = hsl2rgb_1(hsl);
            rgb$4[3] = 1;
            return rgb$4;
        }

        // hsla(0,100%,50%,0.5)
        if ((m = css.match(RE_HSLA))) {
            var hsl$1 = m.slice(1,4);
            hsl$1[1] *= 0.01;
            hsl$1[2] *= 0.01;
            var rgb$5 = hsl2rgb_1(hsl$1);
            rgb$5[3] = +m[4];  // default alpha = 1
            return rgb$5;
        }
    };

    css2rgb.test = function (s) {
        return RE_RGB.test(s) ||
            RE_RGBA.test(s) ||
            RE_RGB_PCT.test(s) ||
            RE_RGBA_PCT.test(s) ||
            RE_HSL.test(s) ||
            RE_HSLA.test(s);
    };

    var css2rgb_1 = css2rgb;

    var type$3 = utils.type;




    Color_1.prototype.css = function(mode) {
        return rgb2css_1(this._rgb, mode);
    };

    chroma_1.css = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['css']) ));
    };

    input.format.css = css2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$3(h) === 'string' && css2rgb_1.test(h)) {
                return 'css';
            }
        }
    });

    var unpack$8 = utils.unpack;

    input.format.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$8(args, 'rgba');
        rgb[0] *= 255;
        rgb[1] *= 255;
        rgb[2] *= 255;
        return rgb;
    };

    chroma_1.gl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['gl']) ));
    };

    Color_1.prototype.gl = function() {
        var rgb = this._rgb;
        return [rgb[0]/255, rgb[1]/255, rgb[2]/255, rgb[3]];
    };

    var unpack$9 = utils.unpack;

    var rgb2hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$9(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var c = delta * 100 / 255;
        var _g = min / (255 - delta) * 100;
        var h;
        if (delta === 0) {
            h = Number.NaN;
        } else {
            if (r === max) { h = (g - b) / delta; }
            if (g === max) { h = 2+(b - r) / delta; }
            if (b === max) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, c, _g];
    };

    var rgb2hcg_1 = rgb2hcg;

    var unpack$a = utils.unpack;
    var floor = Math.floor;

    /*
     * this is basically just HSV with some minor tweaks
     *
     * hue.. [0..360]
     * chroma .. [0..1]
     * grayness .. [0..1]
     */

    var hcg2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$a(args, 'hcg');
        var h = args[0];
        var c = args[1];
        var _g = args[2];
        var r,g,b;
        _g = _g * 255;
        var _c = c * 255;
        if (c === 0) {
            r = g = b = _g;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;
            var i = floor(h);
            var f = h - i;
            var p = _g * (1 - c);
            var q = p + _c * (1 - f);
            var t = p + _c * f;
            var v = p + _c;
            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var hcg2rgb_1 = hcg2rgb;

    var unpack$b = utils.unpack;
    var type$4 = utils.type;






    Color_1.prototype.hcg = function() {
        return rgb2hcg_1(this._rgb);
    };

    chroma_1.hcg = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcg']) ));
    };

    input.format.hcg = hcg2rgb_1;

    input.autodetect.push({
        p: 1,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$b(args, 'hcg');
            if (type$4(args) === 'array' && args.length === 3) {
                return 'hcg';
            }
        }
    });

    var unpack$c = utils.unpack;
    var last$4 = utils.last;
    var round$3 = Math.round;

    var rgb2hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$c(args, 'rgba');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var a = ref[3];
        var mode = last$4(args) || 'auto';
        if (a === undefined) { a = 1; }
        if (mode === 'auto') {
            mode = a < 1 ? 'rgba' : 'rgb';
        }
        r = round$3(r);
        g = round$3(g);
        b = round$3(b);
        var u = r << 16 | g << 8 | b;
        var str = "000000" + u.toString(16); //#.toUpperCase();
        str = str.substr(str.length - 6);
        var hxa = '0' + round$3(a * 255).toString(16);
        hxa = hxa.substr(hxa.length - 2);
        switch (mode.toLowerCase()) {
            case 'rgba': return ("#" + str + hxa);
            case 'argb': return ("#" + hxa + str);
            default: return ("#" + str);
        }
    };

    var rgb2hex_1 = rgb2hex;

    var type$5 = utils.type;




    Color_1.prototype.hex = function(mode) {
        return rgb2hex_1(this._rgb, mode);
    };

    chroma_1.hex = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hex']) ));
    };

    input.format.hex = hex2rgb_1;
    input.autodetect.push({
        p: 4,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$5(h) === 'string' && [3,4,6,7,8,9].includes(h.length)) {
                return 'hex';
            }
        }
    });

    var unpack$d = utils.unpack;
    var TWOPI = utils.TWOPI;
    var min = Math.min;
    var sqrt = Math.sqrt;
    var acos = Math.acos;

    var rgb2hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
        */
        var ref = unpack$d(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        r /= 255;
        g /= 255;
        b /= 255;
        var h;
        var min_ = min(r,g,b);
        var i = (r+g+b) / 3;
        var s = i > 0 ? 1 - min_/i : 0;
        if (s === 0) {
            h = NaN;
        } else {
            h = ((r-g)+(r-b)) / 2;
            h /= sqrt((r-g)*(r-g) + (r-b)*(g-b));
            h = acos(h);
            if (b > g) {
                h = TWOPI - h;
            }
            h /= TWOPI;
        }
        return [h*360,s,i];
    };

    var rgb2hsi_1 = rgb2hsi;

    var unpack$e = utils.unpack;
    var limit$1 = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos = Math.cos;

    /*
     * hue [0..360]
     * saturation [0..1]
     * intensity [0..1]
     */
    var hsi2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        borrowed from here:
        http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
        */
        args = unpack$e(args, 'hsi');
        var h = args[0];
        var s = args[1];
        var i = args[2];
        var r,g,b;

        if (isNaN(h)) { h = 0; }
        if (isNaN(s)) { s = 0; }
        // normalize hue
        if (h > 360) { h -= 360; }
        if (h < 0) { h += 360; }
        h /= 360;
        if (h < 1/3) {
            b = (1-s)/3;
            r = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            g = 1 - (b+r);
        } else if (h < 2/3) {
            h -= 1/3;
            r = (1-s)/3;
            g = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            b = 1 - (r+g);
        } else {
            h -= 2/3;
            g = (1-s)/3;
            b = (1+s*cos(TWOPI$1*h)/cos(PITHIRD-TWOPI$1*h))/3;
            r = 1 - (g+b);
        }
        r = limit$1(i*r*3);
        g = limit$1(i*g*3);
        b = limit$1(i*b*3);
        return [r*255, g*255, b*255, args.length > 3 ? args[3] : 1];
    };

    var hsi2rgb_1 = hsi2rgb;

    var unpack$f = utils.unpack;
    var type$6 = utils.type;






    Color_1.prototype.hsi = function() {
        return rgb2hsi_1(this._rgb);
    };

    chroma_1.hsi = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsi']) ));
    };

    input.format.hsi = hsi2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$f(args, 'hsi');
            if (type$6(args) === 'array' && args.length === 3) {
                return 'hsi';
            }
        }
    });

    var unpack$g = utils.unpack;
    var type$7 = utils.type;






    Color_1.prototype.hsl = function() {
        return rgb2hsl_1(this._rgb);
    };

    chroma_1.hsl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsl']) ));
    };

    input.format.hsl = hsl2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$g(args, 'hsl');
            if (type$7(args) === 'array' && args.length === 3) {
                return 'hsl';
            }
        }
    });

    var unpack$h = utils.unpack;
    var min$1 = Math.min;
    var max$1 = Math.max;

    /*
     * supported arguments:
     * - rgb2hsv(r,g,b)
     * - rgb2hsv([r,g,b])
     * - rgb2hsv({r,g,b})
     */
    var rgb2hsl$1 = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$h(args, 'rgb');
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var min_ = min$1(r, g, b);
        var max_ = max$1(r, g, b);
        var delta = max_ - min_;
        var h,s,v;
        v = max_ / 255.0;
        if (max_ === 0) {
            h = Number.NaN;
            s = 0;
        } else {
            s = delta / max_;
            if (r === max_) { h = (g - b) / delta; }
            if (g === max_) { h = 2+(b - r) / delta; }
            if (b === max_) { h = 4+(r - g) / delta; }
            h *= 60;
            if (h < 0) { h += 360; }
        }
        return [h, s, v]
    };

    var rgb2hsv = rgb2hsl$1;

    var unpack$i = utils.unpack;
    var floor$1 = Math.floor;

    var hsv2rgb = function () {
        var assign, assign$1, assign$2, assign$3, assign$4, assign$5;

        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        args = unpack$i(args, 'hsv');
        var h = args[0];
        var s = args[1];
        var v = args[2];
        var r,g,b;
        v *= 255;
        if (s === 0) {
            r = g = b = v;
        } else {
            if (h === 360) { h = 0; }
            if (h > 360) { h -= 360; }
            if (h < 0) { h += 360; }
            h /= 60;

            var i = floor$1(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));

            switch (i) {
                case 0: (assign = [v, t, p], r = assign[0], g = assign[1], b = assign[2]); break
                case 1: (assign$1 = [q, v, p], r = assign$1[0], g = assign$1[1], b = assign$1[2]); break
                case 2: (assign$2 = [p, v, t], r = assign$2[0], g = assign$2[1], b = assign$2[2]); break
                case 3: (assign$3 = [p, q, v], r = assign$3[0], g = assign$3[1], b = assign$3[2]); break
                case 4: (assign$4 = [t, p, v], r = assign$4[0], g = assign$4[1], b = assign$4[2]); break
                case 5: (assign$5 = [v, p, q], r = assign$5[0], g = assign$5[1], b = assign$5[2]); break
            }
        }
        return [r,g,b,args.length > 3?args[3]:1];
    };

    var hsv2rgb_1 = hsv2rgb;

    var unpack$j = utils.unpack;
    var type$8 = utils.type;






    Color_1.prototype.hsv = function() {
        return rgb2hsv(this._rgb);
    };

    chroma_1.hsv = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hsv']) ));
    };

    input.format.hsv = hsv2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$j(args, 'hsv');
            if (type$8(args) === 'array' && args.length === 3) {
                return 'hsv';
            }
        }
    });

    var labConstants = {
        // Corresponds roughly to RGB brighter/darker
        Kn: 18,

        // D65 standard referent
        Xn: 0.950470,
        Yn: 1,
        Zn: 1.088830,

        t0: 0.137931034,  // 4 / 29
        t1: 0.206896552,  // 6 / 29
        t2: 0.12841855,   // 3 * t1 * t1
        t3: 0.008856452,  // t1 * t1 * t1
    };

    var unpack$k = utils.unpack;
    var pow = Math.pow;

    var rgb2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$k(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2xyz(r,g,b);
        var x = ref$1[0];
        var y = ref$1[1];
        var z = ref$1[2];
        var l = 116 * y - 16;
        return [l < 0 ? 0 : l, 500 * (x - y), 200 * (y - z)];
    };

    var rgb_xyz = function (r) {
        if ((r /= 255) <= 0.04045) { return r / 12.92; }
        return pow((r + 0.055) / 1.055, 2.4);
    };

    var xyz_lab = function (t) {
        if (t > labConstants.t3) { return pow(t, 1 / 3); }
        return t / labConstants.t2 + labConstants.t0;
    };

    var rgb2xyz = function (r,g,b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / labConstants.Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / labConstants.Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / labConstants.Zn);
        return [x,y,z];
    };

    var rgb2lab_1 = rgb2lab;

    var unpack$l = utils.unpack;
    var pow$1 = Math.pow;

    /*
     * L* [0..100]
     * a [-100..100]
     * b [-100..100]
     */
    var lab2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$l(args, 'lab');
        var l = args[0];
        var a = args[1];
        var b = args[2];
        var x,y,z, r,g,b_;

        y = (l + 16) / 116;
        x = isNaN(a) ? y : y + a / 500;
        z = isNaN(b) ? y : y - b / 200;

        y = labConstants.Yn * lab_xyz(y);
        x = labConstants.Xn * lab_xyz(x);
        z = labConstants.Zn * lab_xyz(z);

        r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);  // D65 -> sRGB
        g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
        b_ = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);

        return [r,g,b_,args.length > 3 ? args[3] : 1];
    };

    var xyz_rgb = function (r) {
        return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow$1(r, 1 / 2.4) - 0.055)
    };

    var lab_xyz = function (t) {
        return t > labConstants.t1 ? t * t * t : labConstants.t2 * (t - labConstants.t0)
    };

    var lab2rgb_1 = lab2rgb;

    var unpack$m = utils.unpack;
    var type$9 = utils.type;






    Color_1.prototype.lab = function() {
        return rgb2lab_1(this._rgb);
    };

    chroma_1.lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lab']) ));
    };

    input.format.lab = lab2rgb_1;

    input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$m(args, 'lab');
            if (type$9(args) === 'array' && args.length === 3) {
                return 'lab';
            }
        }
    });

    var unpack$n = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$1 = Math.sqrt;
    var atan2 = Math.atan2;
    var round$4 = Math.round;

    var lab2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$n(args, 'lab');
        var l = ref[0];
        var a = ref[1];
        var b = ref[2];
        var c = sqrt$1(a * a + b * b);
        var h = (atan2(b, a) * RAD2DEG + 360) % 360;
        if (round$4(c*10000) === 0) { h = Number.NaN; }
        return [l, c, h];
    };

    var lab2lch_1 = lab2lch;

    var unpack$o = utils.unpack;



    var rgb2lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$o(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        var ref$1 = rgb2lab_1(r,g,b);
        var l = ref$1[0];
        var a = ref$1[1];
        var b_ = ref$1[2];
        return lab2lch_1(l,a,b_);
    };

    var rgb2lch_1 = rgb2lch;

    var unpack$p = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin = Math.sin;
    var cos$1 = Math.cos;

    var lch2lab = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        /*
        Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
        These formulas were invented by David Dalrymple to obtain maximum contrast without going
        out of gamut if the parameters are in the range 0-1.

        A saturation multiplier was added by Gregor Aisch
        */
        var ref = unpack$p(args, 'lch');
        var l = ref[0];
        var c = ref[1];
        var h = ref[2];
        if (isNaN(h)) { h = 0; }
        h = h * DEG2RAD;
        return [l, cos$1(h) * c, sin(h) * c]
    };

    var lch2lab_1 = lch2lab;

    var unpack$q = utils.unpack;



    var lch2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        args = unpack$q(args, 'lch');
        var l = args[0];
        var c = args[1];
        var h = args[2];
        var ref = lch2lab_1 (l,c,h);
        var L = ref[0];
        var a = ref[1];
        var b_ = ref[2];
        var ref$1 = lab2rgb_1 (L,a,b_);
        var r = ref$1[0];
        var g = ref$1[1];
        var b = ref$1[2];
        return [r, g, b, args.length > 3 ? args[3] : 1];
    };

    var lch2rgb_1 = lch2rgb;

    var unpack$r = utils.unpack;


    var hcl2rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var hcl = unpack$r(args, 'hcl').reverse();
        return lch2rgb_1.apply(void 0, hcl);
    };

    var hcl2rgb_1 = hcl2rgb;

    var unpack$s = utils.unpack;
    var type$a = utils.type;






    Color_1.prototype.lch = function() { return rgb2lch_1(this._rgb); };
    Color_1.prototype.hcl = function() { return rgb2lch_1(this._rgb).reverse(); };

    chroma_1.lch = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['lch']) ));
    };
    chroma_1.hcl = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['hcl']) ));
    };

    input.format.lch = lch2rgb_1;
    input.format.hcl = hcl2rgb_1;

    ['lch','hcl'].forEach(function (m) { return input.autodetect.push({
        p: 2,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$s(args, m);
            if (type$a(args) === 'array' && args.length === 3) {
                return m;
            }
        }
    }); });

    var type$b = utils.type;





    Color_1.prototype.name = function() {
        var hex = rgb2hex_1(this._rgb, 'rgb');
        for (var i = 0, list = Object.keys(w3cx11_1); i < list.length; i += 1) {
            var n = list[i];

            if (w3cx11_1[n] === hex) { return n.toLowerCase(); }
        }
        return hex;
    };

    input.format.named = function (name) {
        name = name.toLowerCase();
        if (w3cx11_1[name]) { return hex2rgb_1(w3cx11_1[name]); }
        throw new Error('unknown color name: '+name);
    };

    input.autodetect.push({
        p: 5,
        test: function (h) {
            var rest = [], len = arguments.length - 1;
            while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

            if (!rest.length && type$b(h) === 'string' && w3cx11_1[h.toLowerCase()]) {
                return 'named';
            }
        }
    });

    var unpack$t = utils.unpack;

    var rgb2num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var ref = unpack$t(args, 'rgb');
        var r = ref[0];
        var g = ref[1];
        var b = ref[2];
        return (r << 16) + (g << 8) + b;
    };

    var rgb2num_1 = rgb2num;

    var type$c = utils.type;

    var num2rgb = function (num) {
        if (type$c(num) == "number" && num >= 0 && num <= 0xFFFFFF) {
            var r = num >> 16;
            var g = (num >> 8) & 0xFF;
            var b = num & 0xFF;
            return [r,g,b,1];
        }
        throw new Error("unknown num color: "+num);
    };

    var num2rgb_1 = num2rgb;

    var type$d = utils.type;



    Color_1.prototype.num = function() {
        return rgb2num_1(this._rgb);
    };

    chroma_1.num = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['num']) ));
    };

    input.format.num = num2rgb_1;

    input.autodetect.push({
        p: 5,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            if (args.length === 1 && type$d(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xFFFFFF) {
                return 'num';
            }
        }
    });

    var unpack$u = utils.unpack;
    var type$e = utils.type;
    var round$5 = Math.round;

    Color_1.prototype.rgb = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        if (rnd === false) { return this._rgb.slice(0,3); }
        return this._rgb.slice(0,3).map(round$5);
    };

    Color_1.prototype.rgba = function(rnd) {
        if ( rnd === void 0 ) rnd=true;

        return this._rgb.slice(0,4).map(function (v,i) {
            return i<3 ? (rnd === false ? v : round$5(v)) : v;
        });
    };

    chroma_1.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['rgb']) ));
    };

    input.format.rgb = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgba = unpack$u(args, 'rgba');
        if (rgba[3] === undefined) { rgba[3] = 1; }
        return rgba;
    };

    input.autodetect.push({
        p: 3,
        test: function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

            args = unpack$u(args, 'rgba');
            if (type$e(args) === 'array' && (args.length === 3 ||
                args.length === 4 && type$e(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) {
                return 'rgb';
            }
        }
    });

    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     */

    var log = Math.log;

    var temperature2rgb = function (kelvin) {
        var temp = kelvin / 100;
        var r,g,b;
        if (temp < 66) {
            r = 255;
            g = -155.25485562709179 - 0.44596950469579133 * (g = temp-2) + 104.49216199393888 * log(g);
            b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp-10) + 115.67994401066147 * log(b);
        } else {
            r = 351.97690566805693 + 0.114206453784165 * (r = temp-55) - 40.25366309332127 * log(r);
            g = 325.4494125711974 + 0.07943456536662342 * (g = temp-50) - 28.0852963507957 * log(g);
            b = 255;
        }
        return [r,g,b,1];
    };

    var temperature2rgb_1 = temperature2rgb;

    /*
     * Based on implementation by Neil Bartlett
     * https://github.com/neilbartlett/color-temperature
     **/


    var unpack$v = utils.unpack;
    var round$6 = Math.round;

    var rgb2temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var rgb = unpack$v(args, 'rgb');
        var r = rgb[0], b = rgb[2];
        var minTemp = 1000;
        var maxTemp = 40000;
        var eps = 0.4;
        var temp;
        while (maxTemp - minTemp > eps) {
            temp = (maxTemp + minTemp) * 0.5;
            var rgb$1 = temperature2rgb_1(temp);
            if ((rgb$1[2] / rgb$1[0]) >= (b / r)) {
                maxTemp = temp;
            } else {
                minTemp = temp;
            }
        }
        return round$6(temp);
    };

    var rgb2temperature_1 = rgb2temperature;

    Color_1.prototype.temp =
    Color_1.prototype.kelvin =
    Color_1.prototype.temperature = function() {
        return rgb2temperature_1(this._rgb);
    };

    chroma_1.temp =
    chroma_1.kelvin =
    chroma_1.temperature = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return new (Function.prototype.bind.apply( Color_1, [ null ].concat( args, ['temp']) ));
    };

    input.format.temp =
    input.format.kelvin =
    input.format.temperature = temperature2rgb_1;

    var type$f = utils.type;

    Color_1.prototype.alpha = function(a, mutate) {
        if ( mutate === void 0 ) mutate=false;

        if (a !== undefined && type$f(a) === 'number') {
            if (mutate) {
                this._rgb[3] = a;
                return this;
            }
            return new Color_1([this._rgb[0], this._rgb[1], this._rgb[2], a], 'rgb');
        }
        return this._rgb[3];
    };

    Color_1.prototype.clipped = function() {
        return this._rgb._clipped || false;
    };

    Color_1.prototype.darken = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lab = me.lab();
    	lab[0] -= labConstants.Kn * amount;
    	return new Color_1(lab, 'lab').alpha(me.alpha(), true);
    };

    Color_1.prototype.brighten = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.darken(-amount);
    };

    Color_1.prototype.darker = Color_1.prototype.darken;
    Color_1.prototype.brighter = Color_1.prototype.brighten;

    Color_1.prototype.get = function(mc) {
        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) { return src[i]; }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var type$g = utils.type;
    var pow$2 = Math.pow;

    var EPS = 1e-7;
    var MAX_ITER = 20;

    Color_1.prototype.luminance = function(lum) {
        if (lum !== undefined && type$g(lum) === 'number') {
            if (lum === 0) {
                // return pure black
                return new Color_1([0,0,0,this._rgb[3]], 'rgb');
            }
            if (lum === 1) {
                // return pure white
                return new Color_1([255,255,255,this._rgb[3]], 'rgb');
            }
            // compute new color using...
            var cur_lum = this.luminance();
            var mode = 'rgb';
            var max_iter = MAX_ITER;

            var test = function (low, high) {
                var mid = low.interpolate(high, 0.5, mode);
                var lm = mid.luminance();
                if (Math.abs(lum - lm) < EPS || !max_iter--) {
                    // close enough
                    return mid;
                }
                return lm > lum ? test(low, mid) : test(mid, high);
            };

            var rgb = (cur_lum > lum ? test(new Color_1([0,0,0]), this) : test(this, new Color_1([255,255,255]))).rgb();
            return new Color_1(rgb.concat( [this._rgb[3]]));
        }
        return rgb2luminance.apply(void 0, (this._rgb).slice(0,3));
    };


    var rgb2luminance = function (r,g,b) {
        // relative luminance
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        r = luminance_x(r);
        g = luminance_x(g);
        b = luminance_x(b);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    var luminance_x = function (x) {
        x /= 255;
        return x <= 0.03928 ? x/12.92 : pow$2((x+0.055)/1.055, 2.4);
    };

    var interpolator = {};

    var type$h = utils.type;


    var mix = function (col1, col2, f) {
        if ( f === void 0 ) f=0.5;
        var rest = [], len = arguments.length - 3;
        while ( len-- > 0 ) rest[ len ] = arguments[ len + 3 ];

        var mode = rest[0] || 'lrgb';
        if (!interpolator[mode] && !rest.length) {
            // fall back to the first supported mode
            mode = Object.keys(interpolator)[0];
        }
        if (!interpolator[mode]) {
            throw new Error(("interpolation mode " + mode + " is not defined"));
        }
        if (type$h(col1) !== 'object') { col1 = new Color_1(col1); }
        if (type$h(col2) !== 'object') { col2 = new Color_1(col2); }
        return interpolator[mode](col1, col2, f)
            .alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
    };

    Color_1.prototype.mix =
    Color_1.prototype.interpolate = function(col2, f) {
    	if ( f === void 0 ) f=0.5;
    	var rest = [], len = arguments.length - 2;
    	while ( len-- > 0 ) rest[ len ] = arguments[ len + 2 ];

    	return mix.apply(void 0, [ this, col2, f ].concat( rest ));
    };

    Color_1.prototype.premultiply = function(mutate) {
    	if ( mutate === void 0 ) mutate=false;

    	var rgb = this._rgb;
    	var a = rgb[3];
    	if (mutate) {
    		this._rgb = [rgb[0]*a, rgb[1]*a, rgb[2]*a, a];
    		return this;
    	} else {
    		return new Color_1([rgb[0]*a, rgb[1]*a, rgb[2]*a, a], 'rgb');
    	}
    };

    Color_1.prototype.saturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	var me = this;
    	var lch = me.lch();
    	lch[1] += labConstants.Kn * amount;
    	if (lch[1] < 0) { lch[1] = 0; }
    	return new Color_1(lch, 'lch').alpha(me.alpha(), true);
    };

    Color_1.prototype.desaturate = function(amount) {
    	if ( amount === void 0 ) amount=1;

    	return this.saturate(-amount);
    };

    var type$i = utils.type;

    Color_1.prototype.set = function(mc, value, mutate) {
        if ( mutate === void 0 ) mutate=false;

        var ref = mc.split('.');
        var mode = ref[0];
        var channel = ref[1];
        var src = this[mode]();
        if (channel) {
            var i = mode.indexOf(channel);
            if (i > -1) {
                if (type$i(value) == 'string') {
                    switch(value.charAt(0)) {
                        case '+': src[i] += +value; break;
                        case '-': src[i] += +value; break;
                        case '*': src[i] *= +(value.substr(1)); break;
                        case '/': src[i] /= +(value.substr(1)); break;
                        default: src[i] = +value;
                    }
                } else if (type$i(value) === 'number') {
                    src[i] = value;
                } else {
                    throw new Error("unsupported value for Color.set");
                }
                var out = new Color_1(src, mode);
                if (mutate) {
                    this._rgb = out._rgb;
                    return this;
                }
                return out;
            }
            throw new Error(("unknown channel " + channel + " in mode " + mode));
        } else {
            return src;
        }
    };

    var rgb$1 = function (col1, col2, f) {
        var xyz0 = col1._rgb;
        var xyz1 = col2._rgb;
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'rgb'
        )
    };

    // register interpolator
    interpolator.rgb = rgb$1;

    var sqrt$2 = Math.sqrt;
    var pow$3 = Math.pow;

    var lrgb = function (col1, col2, f) {
        var ref = col1._rgb;
        var x1 = ref[0];
        var y1 = ref[1];
        var z1 = ref[2];
        var ref$1 = col2._rgb;
        var x2 = ref$1[0];
        var y2 = ref$1[1];
        var z2 = ref$1[2];
        return new Color_1(
            sqrt$2(pow$3(x1,2) * (1-f) + pow$3(x2,2) * f),
            sqrt$2(pow$3(y1,2) * (1-f) + pow$3(y2,2) * f),
            sqrt$2(pow$3(z1,2) * (1-f) + pow$3(z2,2) * f),
            'rgb'
        )
    };

    // register interpolator
    interpolator.lrgb = lrgb;

    var lab$1 = function (col1, col2, f) {
        var xyz0 = col1.lab();
        var xyz1 = col2.lab();
        return new Color_1(
            xyz0[0] + f * (xyz1[0]-xyz0[0]),
            xyz0[1] + f * (xyz1[1]-xyz0[1]),
            xyz0[2] + f * (xyz1[2]-xyz0[2]),
            'lab'
        )
    };

    // register interpolator
    interpolator.lab = lab$1;

    var _hsx = function (col1, col2, f, m) {
        var assign, assign$1;

        var xyz0, xyz1;
        if (m === 'hsl') {
            xyz0 = col1.hsl();
            xyz1 = col2.hsl();
        } else if (m === 'hsv') {
            xyz0 = col1.hsv();
            xyz1 = col2.hsv();
        } else if (m === 'hcg') {
            xyz0 = col1.hcg();
            xyz1 = col2.hcg();
        } else if (m === 'hsi') {
            xyz0 = col1.hsi();
            xyz1 = col2.hsi();
        } else if (m === 'lch' || m === 'hcl') {
            m = 'hcl';
            xyz0 = col1.hcl();
            xyz1 = col2.hcl();
        }

        var hue0, hue1, sat0, sat1, lbv0, lbv1;
        if (m.substr(0, 1) === 'h') {
            (assign = xyz0, hue0 = assign[0], sat0 = assign[1], lbv0 = assign[2]);
            (assign$1 = xyz1, hue1 = assign$1[0], sat1 = assign$1[1], lbv1 = assign$1[2]);
        }

        var sat, hue, lbv, dh;

        if (!isNaN(hue0) && !isNaN(hue1)) {
            // both colors have hue
            if (hue1 > hue0 && hue1 - hue0 > 180) {
                dh = hue1-(hue0+360);
            } else if (hue1 < hue0 && hue0 - hue1 > 180) {
                dh = hue1+360-hue0;
            } else{
                dh = hue1 - hue0;
            }
            hue = hue0 + f * dh;
        } else if (!isNaN(hue0)) {
            hue = hue0;
            if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') { sat = sat0; }
        } else if (!isNaN(hue1)) {
            hue = hue1;
            if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') { sat = sat1; }
        } else {
            hue = Number.NaN;
        }

        if (sat === undefined) { sat = sat0 + f * (sat1 - sat0); }
        lbv = lbv0 + f * (lbv1-lbv0);
        return new Color_1([hue, sat, lbv], m);
    };

    var lch$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'lch');
    };

    // register interpolator
    interpolator.lch = lch$1;
    interpolator.hcl = lch$1;

    var num$1 = function (col1, col2, f) {
        var c1 = col1.num();
        var c2 = col2.num();
        return new Color_1(c1 + f * (c2-c1), 'num')
    };

    // register interpolator
    interpolator.num = num$1;

    var hcg$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hcg');
    };

    // register interpolator
    interpolator.hcg = hcg$1;

    var hsi$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsi');
    };

    // register interpolator
    interpolator.hsi = hsi$1;

    var hsl$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsl');
    };

    // register interpolator
    interpolator.hsl = hsl$1;

    var hsv$1 = function (col1, col2, f) {
    	return _hsx(col1, col2, f, 'hsv');
    };

    // register interpolator
    interpolator.hsv = hsv$1;

    var clip_rgb$2 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$3 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$1 = Math.sin;
    var atan2$1 = Math.atan2;

    var average = function (colors, mode) {
        if ( mode === void 0 ) mode='lrgb';

        var l = colors.length;
        // convert colors to Color objects
        colors = colors.map(function (c) { return new Color_1(c); });
        if (mode === 'lrgb') {
            return _average_lrgb(colors)
        }
        var first = colors.shift();
        var xyz = first.get(mode);
        var cnt = [];
        var dx = 0;
        var dy = 0;
        // initial color
        for (var i=0; i<xyz.length; i++) {
            xyz[i] = xyz[i] || 0;
            cnt.push(isNaN(xyz[i]) ? 0 : 1);
            if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
                var A = xyz[i] / 180 * PI$1;
                dx += cos$2(A);
                dy += sin$1(A);
            }
        }

        var alpha = first.alpha();
        colors.forEach(function (c) {
            var xyz2 = c.get(mode);
            alpha += c.alpha();
            for (var i=0; i<xyz.length; i++) {
                if (!isNaN(xyz2[i])) {
                    cnt[i]++;
                    if (mode.charAt(i) === 'h') {
                        var A = xyz2[i] / 180 * PI$1;
                        dx += cos$2(A);
                        dy += sin$1(A);
                    } else {
                        xyz[i] += xyz2[i];
                    }
                }
            }
        });

        for (var i$1=0; i$1<xyz.length; i$1++) {
            if (mode.charAt(i$1) === 'h') {
                var A$1 = atan2$1(dy / cnt[i$1], dx / cnt[i$1]) / PI$1 * 180;
                while (A$1 < 0) { A$1 += 360; }
                while (A$1 >= 360) { A$1 -= 360; }
                xyz[i$1] = A$1;
            } else {
                xyz[i$1] = xyz[i$1]/cnt[i$1];
            }
        }
        alpha /= l;
        return (new Color_1(xyz, mode)).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };


    var _average_lrgb = function (colors) {
        var l = colors.length;
        var f = 1/l;
        var xyz = [0,0,0,0];
        for (var i = 0, list = colors; i < list.length; i += 1) {
            var col = list[i];

            var rgb = col._rgb;
            xyz[0] += pow$4(rgb[0],2) * f;
            xyz[1] += pow$4(rgb[1],2) * f;
            xyz[2] += pow$4(rgb[2],2) * f;
            xyz[3] += rgb[3] * f;
        }
        xyz[0] = sqrt$3(xyz[0]);
        xyz[1] = sqrt$3(xyz[1]);
        xyz[2] = sqrt$3(xyz[2]);
        if (xyz[3] > 0.9999999) { xyz[3] = 1; }
        return new Color_1(clip_rgb$2(xyz));
    };

    // minimal multi-purpose interface

    // @requires utils color analyze


    var type$j = utils.type;

    var pow$5 = Math.pow;

    var scale = function(colors) {

        // constructor
        var _mode = 'rgb';
        var _nacol = chroma_1('#ccc');
        var _spread = 0;
        // const _fixed = false;
        var _domain = [0, 1];
        var _pos = [];
        var _padding = [0,0];
        var _classes = false;
        var _colors = [];
        var _out = false;
        var _min = 0;
        var _max = 1;
        var _correctLightness = false;
        var _colorCache = {};
        var _useCache = true;
        var _gamma = 1;

        // private methods

        var setColors = function(colors) {
            colors = colors || ['#fff', '#000'];
            if (colors && type$j(colors) === 'string' && chroma_1.brewer &&
                chroma_1.brewer[colors.toLowerCase()]) {
                colors = chroma_1.brewer[colors.toLowerCase()];
            }
            if (type$j(colors) === 'array') {
                // handle single color
                if (colors.length === 1) {
                    colors = [colors[0], colors[0]];
                }
                // make a copy of the colors
                colors = colors.slice(0);
                // convert to chroma classes
                for (var c=0; c<colors.length; c++) {
                    colors[c] = chroma_1(colors[c]);
                }
                // auto-fill color position
                _pos.length = 0;
                for (var c$1=0; c$1<colors.length; c$1++) {
                    _pos.push(c$1/(colors.length-1));
                }
            }
            resetCache();
            return _colors = colors;
        };

        var getClass = function(value) {
            if (_classes != null) {
                var n = _classes.length-1;
                var i = 0;
                while (i < n && value >= _classes[i]) {
                    i++;
                }
                return i-1;
            }
            return 0;
        };

        var tmap = function (t) { return t; };

        // const classifyValue = function(value) {
        //     let val = value;
        //     if (_classes.length > 2) {
        //         const n = _classes.length-1;
        //         const i = getClass(value);
        //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
        //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
        //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
        //     }
        //     return val;
        // };

        var getColor = function(val, bypassMap) {
            var col, t;
            if (bypassMap == null) { bypassMap = false; }
            if (isNaN(val) || (val === null)) { return _nacol; }
            if (!bypassMap) {
                if (_classes && (_classes.length > 2)) {
                    // find the class
                    var c = getClass(val);
                    t = c / (_classes.length-2);
                } else if (_max !== _min) {
                    // just interpolate between min/max
                    t = (val - _min) / (_max - _min);
                } else {
                    t = 1;
                }
            } else {
                t = val;
            }

            if (!bypassMap) {
                t = tmap(t);  // lightness correction
            }

            if (_gamma !== 1) { t = pow$5(t, _gamma); }

            t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));

            t = Math.min(1, Math.max(0, t));

            var k = Math.floor(t * 10000);

            if (_useCache && _colorCache[k]) {
                col = _colorCache[k];
            } else {
                if (type$j(_colors) === 'array') {
                    //for i in [0.._pos.length-1]
                    for (var i=0; i<_pos.length; i++) {
                        var p = _pos[i];
                        if (t <= p) {
                            col = _colors[i];
                            break;
                        }
                        if ((t >= p) && (i === (_pos.length-1))) {
                            col = _colors[i];
                            break;
                        }
                        if (t > p && t < _pos[i+1]) {
                            t = (t-p)/(_pos[i+1]-p);
                            col = chroma_1.interpolate(_colors[i], _colors[i+1], t, _mode);
                            break;
                        }
                    }
                } else if (type$j(_colors) === 'function') {
                    col = _colors(t);
                }
                if (_useCache) { _colorCache[k] = col; }
            }
            return col;
        };

        var resetCache = function () { return _colorCache = {}; };

        setColors(colors);

        // public interface

        var f = function(v) {
            var c = chroma_1(getColor(v));
            if (_out && c[_out]) { return c[_out](); } else { return c; }
        };

        f.classes = function(classes) {
            if (classes != null) {
                if (type$j(classes) === 'array') {
                    _classes = classes;
                    _domain = [classes[0], classes[classes.length-1]];
                } else {
                    var d = chroma_1.analyze(_domain);
                    if (classes === 0) {
                        _classes = [d.min, d.max];
                    } else {
                        _classes = chroma_1.limits(d, 'e', classes);
                    }
                }
                return f;
            }
            return _classes;
        };


        f.domain = function(domain) {
            if (!arguments.length) {
                return _domain;
            }
            _min = domain[0];
            _max = domain[domain.length-1];
            _pos = [];
            var k = _colors.length;
            if ((domain.length === k) && (_min !== _max)) {
                // update positions
                for (var i = 0, list = Array.from(domain); i < list.length; i += 1) {
                    var d = list[i];

                  _pos.push((d-_min) / (_max-_min));
                }
            } else {
                for (var c=0; c<k; c++) {
                    _pos.push(c/(k-1));
                }
            }
            _domain = [_min, _max];
            return f;
        };

        f.mode = function(_m) {
            if (!arguments.length) {
                return _mode;
            }
            _mode = _m;
            resetCache();
            return f;
        };

        f.range = function(colors, _pos) {
            setColors(colors, _pos);
            return f;
        };

        f.out = function(_o) {
            _out = _o;
            return f;
        };

        f.spread = function(val) {
            if (!arguments.length) {
                return _spread;
            }
            _spread = val;
            return f;
        };

        f.correctLightness = function(v) {
            if (v == null) { v = true; }
            _correctLightness = v;
            resetCache();
            if (_correctLightness) {
                tmap = function(t) {
                    var L0 = getColor(0, true).lab()[0];
                    var L1 = getColor(1, true).lab()[0];
                    var pol = L0 > L1;
                    var L_actual = getColor(t, true).lab()[0];
                    var L_ideal = L0 + ((L1 - L0) * t);
                    var L_diff = L_actual - L_ideal;
                    var t0 = 0;
                    var t1 = 1;
                    var max_iter = 20;
                    while ((Math.abs(L_diff) > 1e-2) && (max_iter-- > 0)) {
                        (function() {
                            if (pol) { L_diff *= -1; }
                            if (L_diff < 0) {
                                t0 = t;
                                t += (t1 - t) * 0.5;
                            } else {
                                t1 = t;
                                t += (t0 - t) * 0.5;
                            }
                            L_actual = getColor(t, true).lab()[0];
                            return L_diff = L_actual - L_ideal;
                        })();
                    }
                    return t;
                };
            } else {
                tmap = function (t) { return t; };
            }
            return f;
        };

        f.padding = function(p) {
            if (p != null) {
                if (type$j(p) === 'number') {
                    p = [p,p];
                }
                _padding = p;
                return f;
            } else {
                return _padding;
            }
        };

        f.colors = function(numColors, out) {
            // If no arguments are given, return the original colors that were provided
            if (arguments.length < 2) { out = 'hex'; }
            var result = [];

            if (arguments.length === 0) {
                result = _colors.slice(0);

            } else if (numColors === 1) {
                result = [f(0.5)];

            } else if (numColors > 1) {
                var dm = _domain[0];
                var dd = _domain[1] - dm;
                result = __range__(0, numColors, false).map(function (i) { return f( dm + ((i/(numColors-1)) * dd) ); });

            } else { // returns all colors based on the defined classes
                colors = [];
                var samples = [];
                if (_classes && (_classes.length > 2)) {
                    for (var i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                        samples.push((_classes[i-1]+_classes[i])*0.5);
                    }
                } else {
                    samples = _domain;
                }
                result = samples.map(function (v) { return f(v); });
            }

            if (chroma_1[out]) {
                result = result.map(function (c) { return c[out](); });
            }
            return result;
        };

        f.cache = function(c) {
            if (c != null) {
                _useCache = c;
                return f;
            } else {
                return _useCache;
            }
        };

        f.gamma = function(g) {
            if (g != null) {
                _gamma = g;
                return f;
            } else {
                return _gamma;
            }
        };

        f.nodata = function(d) {
            if (d != null) {
                _nacol = chroma_1(d);
                return f;
            } else {
                return _nacol;
            }
        };

        return f;
    };

    function __range__(left, right, inclusive) {
      var range = [];
      var ascending = left < right;
      var end = !inclusive ? right : ascending ? right + 1 : right - 1;
      for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
      }
      return range;
    }

    //
    // interpolates between a set of colors uzing a bezier spline
    //

    // @requires utils lab




    var bezier = function(colors) {
        var assign, assign$1, assign$2;

        var I, lab0, lab1, lab2;
        colors = colors.map(function (c) { return new Color_1(c); });
        if (colors.length === 2) {
            // linear interpolation
            (assign = colors.map(function (c) { return c.lab(); }), lab0 = assign[0], lab1 = assign[1]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return lab0[i] + (t * (lab1[i] - lab0[i])); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 3) {
            // quadratic bezier interpolation
            (assign$1 = colors.map(function (c) { return c.lab(); }), lab0 = assign$1[0], lab1 = assign$1[1], lab2 = assign$1[2]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t) * lab0[i]) + (2 * (1-t) * t * lab1[i]) + (t * t * lab2[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 4) {
            // cubic bezier interpolation
            var lab3;
            (assign$2 = colors.map(function (c) { return c.lab(); }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3]);
            I = function(t) {
                var lab = ([0, 1, 2].map(function (i) { return ((1-t)*(1-t)*(1-t) * lab0[i]) + (3 * (1-t) * (1-t) * t * lab1[i]) + (3 * (1-t) * t * t * lab2[i]) + (t*t*t * lab3[i]); }));
                return new Color_1(lab, 'lab');
            };
        } else if (colors.length === 5) {
            var I0 = bezier(colors.slice(0, 3));
            var I1 = bezier(colors.slice(2, 5));
            I = function(t) {
                if (t < 0.5) {
                    return I0(t*2);
                } else {
                    return I1((t-0.5)*2);
                }
            };
        }
        return I;
    };

    var bezier_1 = function (colors) {
        var f = bezier(colors);
        f.scale = function () { return scale(f); };
        return f;
    };

    /*
     * interpolates between a set of colors uzing a bezier spline
     * blend mode formulas taken from http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
     */




    var blend = function (bottom, top, mode) {
        if (!blend[mode]) {
            throw new Error('unknown blend mode ' + mode);
        }
        return blend[mode](bottom, top);
    };

    var blend_f = function (f) { return function (bottom,top) {
            var c0 = chroma_1(top).rgb();
            var c1 = chroma_1(bottom).rgb();
            return chroma_1.rgb(f(c0, c1));
        }; };

    var each = function (f) { return function (c0, c1) {
            var out = [];
            out[0] = f(c0[0], c1[0]);
            out[1] = f(c0[1], c1[1]);
            out[2] = f(c0[2], c1[2]);
            return out;
        }; };

    var normal = function (a) { return a; };
    var multiply = function (a,b) { return a * b / 255; };
    var darken$1 = function (a,b) { return a > b ? b : a; };
    var lighten = function (a,b) { return a > b ? a : b; };
    var screen = function (a,b) { return 255 * (1 - (1-a/255) * (1-b/255)); };
    var overlay = function (a,b) { return b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255 ) * ( 1 - b / 255 )); };
    var burn = function (a,b) { return 255 * (1 - (1 - b / 255) / (a/255)); };
    var dodge = function (a,b) {
        if (a === 255) { return 255; }
        a = 255 * (b / 255) / (1 - a / 255);
        return a > 255 ? 255 : a
    };

    // # add = (a,b) ->
    // #     if (a + b > 255) then 255 else a + b

    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken$1));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    // blend.add = blend_f(each(add));

    var blend_1 = blend;

    // cubehelix interpolation
    // based on D.A. Green "A colour scheme for the display of astronomical intensity images"
    // http://astron-soc.in/bulletin/11June/289392011.pdf

    var type$k = utils.type;
    var clip_rgb$3 = utils.clip_rgb;
    var TWOPI$2 = utils.TWOPI;
    var pow$6 = Math.pow;
    var sin$2 = Math.sin;
    var cos$3 = Math.cos;


    var cubehelix = function(start, rotations, hue, gamma, lightness) {
        if ( start === void 0 ) start=300;
        if ( rotations === void 0 ) rotations=-1.5;
        if ( hue === void 0 ) hue=1;
        if ( gamma === void 0 ) gamma=1;
        if ( lightness === void 0 ) lightness=[0,1];

        var dh = 0, dl;
        if (type$k(lightness) === 'array') {
            dl = lightness[1] - lightness[0];
        } else {
            dl = 0;
            lightness = [lightness, lightness];
        }

        var f = function(fract) {
            var a = TWOPI$2 * (((start+120)/360) + (rotations * fract));
            var l = pow$6(lightness[0] + (dl * fract), gamma);
            var h = dh !== 0 ? hue[0] + (fract * dh) : hue;
            var amp = (h * l * (1-l)) / 2;
            var cos_a = cos$3(a);
            var sin_a = sin$2(a);
            var r = l + (amp * ((-0.14861 * cos_a) + (1.78277* sin_a)));
            var g = l + (amp * ((-0.29227 * cos_a) - (0.90649* sin_a)));
            var b = l + (amp * (+1.97294 * cos_a));
            return chroma_1(clip_rgb$3([r*255,g*255,b*255,1]));
        };

        f.start = function(s) {
            if ((s == null)) { return start; }
            start = s;
            return f;
        };

        f.rotations = function(r) {
            if ((r == null)) { return rotations; }
            rotations = r;
            return f;
        };

        f.gamma = function(g) {
            if ((g == null)) { return gamma; }
            gamma = g;
            return f;
        };

        f.hue = function(h) {
            if ((h == null)) { return hue; }
            hue = h;
            if (type$k(hue) === 'array') {
                dh = hue[1] - hue[0];
                if (dh === 0) { hue = hue[1]; }
            } else {
                dh = 0;
            }
            return f;
        };

        f.lightness = function(h) {
            if ((h == null)) { return lightness; }
            if (type$k(h) === 'array') {
                lightness = h;
                dl = h[1] - h[0];
            } else {
                lightness = [h,h];
                dl = 0;
            }
            return f;
        };

        f.scale = function () { return chroma_1.scale(f); };

        f.hue(hue);

        return f;
    };

    var digits = '0123456789abcdef';

    var floor$2 = Math.floor;
    var random = Math.random;

    var random_1 = function () {
        var code = '#';
        for (var i=0; i<6; i++) {
            code += digits.charAt(floor$2(random() * 16));
        }
        return new Color_1(code, 'hex');
    };

    var log$1 = Math.log;
    var pow$7 = Math.pow;
    var floor$3 = Math.floor;
    var abs = Math.abs;


    var analyze = function (data, key) {
        if ( key === void 0 ) key=null;

        var r = {
            min: Number.MAX_VALUE,
            max: Number.MAX_VALUE*-1,
            sum: 0,
            values: [],
            count: 0
        };
        if (type(data) === 'object') {
            data = Object.values(data);
        }
        data.forEach(function (val) {
            if (key && type(val) === 'object') { val = val[key]; }
            if (val !== undefined && val !== null && !isNaN(val)) {
                r.values.push(val);
                r.sum += val;
                if (val < r.min) { r.min = val; }
                if (val > r.max) { r.max = val; }
                r.count += 1;
            }
        });

        r.domain = [r.min, r.max];

        r.limits = function (mode, num) { return limits(r, mode, num); };

        return r;
    };


    var limits = function (data, mode, num) {
        if ( mode === void 0 ) mode='equal';
        if ( num === void 0 ) num=7;

        if (type(data) == 'array') {
            data = analyze(data);
        }
        var min = data.min;
        var max = data.max;
        var values = data.values.sort(function (a,b) { return a-b; });

        if (num === 1) { return [min,max]; }

        var limits = [];

        if (mode.substr(0,1) === 'c') { // continuous
            limits.push(min);
            limits.push(max);
        }

        if (mode.substr(0,1) === 'e') { // equal interval
            limits.push(min);
            for (var i=1; i<num; i++) {
                limits.push(min+((i/num)*(max-min)));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'l') { // log scale
            if (min <= 0) {
                throw new Error('Logarithmic scales are only possible for values > 0');
            }
            var min_log = Math.LOG10E * log$1(min);
            var max_log = Math.LOG10E * log$1(max);
            limits.push(min);
            for (var i$1=1; i$1<num; i$1++) {
                limits.push(pow$7(10, min_log + ((i$1/num) * (max_log - min_log))));
            }
            limits.push(max);
        }

        else if (mode.substr(0,1) === 'q') { // quantile scale
            limits.push(min);
            for (var i$2=1; i$2<num; i$2++) {
                var p = ((values.length-1) * i$2)/num;
                var pb = floor$3(p);
                if (pb === p) {
                    limits.push(values[pb]);
                } else { // p > pb
                    var pr = p - pb;
                    limits.push((values[pb]*(1-pr)) + (values[pb+1]*pr));
                }
            }
            limits.push(max);

        }

        else if (mode.substr(0,1) === 'k') { // k-means clustering
            /*
            implementation based on
            http://code.google.com/p/figue/source/browse/trunk/figue.js#336
            simplified for 1-d input values
            */
            var cluster;
            var n = values.length;
            var assignments = new Array(n);
            var clusterSizes = new Array(num);
            var repeat = true;
            var nb_iters = 0;
            var centroids = null;

            // get seed values
            centroids = [];
            centroids.push(min);
            for (var i$3=1; i$3<num; i$3++) {
                centroids.push(min + ((i$3/num) * (max-min)));
            }
            centroids.push(max);

            while (repeat) {
                // assignment step
                for (var j=0; j<num; j++) {
                    clusterSizes[j] = 0;
                }
                for (var i$4=0; i$4<n; i$4++) {
                    var value = values[i$4];
                    var mindist = Number.MAX_VALUE;
                    var best = (void 0);
                    for (var j$1=0; j$1<num; j$1++) {
                        var dist = abs(centroids[j$1]-value);
                        if (dist < mindist) {
                            mindist = dist;
                            best = j$1;
                        }
                        clusterSizes[best]++;
                        assignments[i$4] = best;
                    }
                }

                // update centroids step
                var newCentroids = new Array(num);
                for (var j$2=0; j$2<num; j$2++) {
                    newCentroids[j$2] = null;
                }
                for (var i$5=0; i$5<n; i$5++) {
                    cluster = assignments[i$5];
                    if (newCentroids[cluster] === null) {
                        newCentroids[cluster] = values[i$5];
                    } else {
                        newCentroids[cluster] += values[i$5];
                    }
                }
                for (var j$3=0; j$3<num; j$3++) {
                    newCentroids[j$3] *= 1/clusterSizes[j$3];
                }

                // check convergence
                repeat = false;
                for (var j$4=0; j$4<num; j$4++) {
                    if (newCentroids[j$4] !== centroids[j$4]) {
                        repeat = true;
                        break;
                    }
                }

                centroids = newCentroids;
                nb_iters++;

                if (nb_iters > 200) {
                    repeat = false;
                }
            }

            // finished k-means clustering
            // the next part is borrowed from gabrielflor.it
            var kClusters = {};
            for (var j$5=0; j$5<num; j$5++) {
                kClusters[j$5] = [];
            }
            for (var i$6=0; i$6<n; i$6++) {
                cluster = assignments[i$6];
                kClusters[cluster].push(values[i$6]);
            }
            var tmpKMeansBreaks = [];
            for (var j$6=0; j$6<num; j$6++) {
                tmpKMeansBreaks.push(kClusters[j$6][0]);
                tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length-1]);
            }
            tmpKMeansBreaks = tmpKMeansBreaks.sort(function (a,b){ return a-b; });
            limits.push(tmpKMeansBreaks[0]);
            for (var i$7=1; i$7 < tmpKMeansBreaks.length; i$7+= 2) {
                var v = tmpKMeansBreaks[i$7];
                if (!isNaN(v) && (limits.indexOf(v) === -1)) {
                    limits.push(v);
                }
            }
        }
        return limits;
    };

    var analyze_1 = {analyze: analyze, limits: limits};

    var contrast = function (a, b) {
        // WCAG contrast ratio
        // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.luminance();
        var l2 = b.luminance();
        return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };

    var sqrt$4 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var abs$1 = Math.abs;
    var cos$4 = Math.cos;
    var PI$2 = Math.PI;

    var deltaE = function(a, b, L, C) {
        if ( L === void 0 ) L=1;
        if ( C === void 0 ) C=1;

        // Delta E (CMC)
        // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CMC.html
        a = new Color_1(a);
        b = new Color_1(b);
        var ref = Array.from(a.lab());
        var L1 = ref[0];
        var a1 = ref[1];
        var b1 = ref[2];
        var ref$1 = Array.from(b.lab());
        var L2 = ref$1[0];
        var a2 = ref$1[1];
        var b2 = ref$1[2];
        var c1 = sqrt$4((a1 * a1) + (b1 * b1));
        var c2 = sqrt$4((a2 * a2) + (b2 * b2));
        var sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + (0.01765 * L1));
        var sc = ((0.0638 * c1) / (1.0 + (0.0131 * c1))) + 0.638;
        var h1 = c1 < 0.000001 ? 0.0 : (atan2$2(b1, a1) * 180.0) / PI$2;
        while (h1 < 0) { h1 += 360; }
        while (h1 >= 360) { h1 -= 360; }
        var t = (h1 >= 164.0) && (h1 <= 345.0) ? (0.56 + abs$1(0.2 * cos$4((PI$2 * (h1 + 168.0)) / 180.0))) : (0.36 + abs$1(0.4 * cos$4((PI$2 * (h1 + 35.0)) / 180.0)));
        var c4 = c1 * c1 * c1 * c1;
        var f = sqrt$4(c4 / (c4 + 1900.0));
        var sh = sc * (((f * t) + 1.0) - f);
        var delL = L1 - L2;
        var delC = c1 - c2;
        var delA = a1 - a2;
        var delB = b1 - b2;
        var dH2 = ((delA * delA) + (delB * delB)) - (delC * delC);
        var v1 = delL / (L * sl);
        var v2 = delC / (C * sc);
        var v3 = sh;
        return sqrt$4((v1 * v1) + (v2 * v2) + (dH2 / (v3 * v3)));
    };

    // simple Euclidean distance
    var distance = function(a, b, mode) {
        if ( mode === void 0 ) mode='lab';

        // Delta E (CIE 1976)
        // see http://www.brucelindbloom.com/index.html?Equations.html
        a = new Color_1(a);
        b = new Color_1(b);
        var l1 = a.get(mode);
        var l2 = b.get(mode);
        var sum_sq = 0;
        for (var i in l1) {
            var d = (l1[i] || 0) - (l2[i] || 0);
            sum_sq += d*d;
        }
        return Math.sqrt(sum_sq);
    };

    var valid = function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        try {
            new (Function.prototype.bind.apply( Color_1, [ null ].concat( args) ));
            return true;
        } catch (e) {
            return false;
        }
    };

    // some pre-defined color scales:




    var scales = {
    	cool: function cool() { return scale([chroma_1.hsl(180,1,.9), chroma_1.hsl(250,.7,.4)]) },
    	hot: function hot() { return scale(['#000','#f00','#ff0','#fff'], [0,.25,.75,1]).mode('rgb') }
    };

    /**
        ColorBrewer colors for chroma.js

        Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
        Pennsylvania State University.

        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0

        Unless required by applicable law or agreed to in writing, software distributed
        under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for the
        specific language governing permissions and limitations under the License.
    */

    var colorbrewer = {
        // sequential
        OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
        PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
        BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
        Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
        BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
        YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
        YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
        Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
        RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
        Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
        YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
        Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
        GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
        Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
        YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
        PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
        Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
        PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
        Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],

        // diverging

        Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
        RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
        RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
        PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
        PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
        RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
        BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
        RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
        PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],

        // qualitative

        Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
        Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
        Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
        Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
        Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
        Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
        Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
        Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2'],
    };

    // add lowercase aliases for case-insensitive matches
    for (var i$1 = 0, list$1 = Object.keys(colorbrewer); i$1 < list$1.length; i$1 += 1) {
        var key = list$1[i$1];

        colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }

    var colorbrewer_1 = colorbrewer;

    // feel free to comment out anything to rollup
    // a smaller chroma.js built

    // io --> convert colors















    // operators --> modify existing Colors










    // interpolators










    // generators -- > create new colors
    chroma_1.average = average;
    chroma_1.bezier = bezier_1;
    chroma_1.blend = blend_1;
    chroma_1.cubehelix = cubehelix;
    chroma_1.mix = chroma_1.interpolate = mix;
    chroma_1.random = random_1;
    chroma_1.scale = scale;

    // other utility methods
    chroma_1.analyze = analyze_1.analyze;
    chroma_1.contrast = contrast;
    chroma_1.deltaE = deltaE;
    chroma_1.distance = distance;
    chroma_1.limits = analyze_1.limits;
    chroma_1.valid = valid;

    // scale
    chroma_1.scales = scales;

    // colors
    chroma_1.colors = w3cx11_1;
    chroma_1.brewer = colorbrewer_1;

    var chroma_js = chroma_1;

    return chroma_js;

})));


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blendStyle__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Intro__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__var__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ndf_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ndf_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ndf_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Motivation__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Problems__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Goals__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Design__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Implementation__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Impact__ = __webpack_require__(294);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  overflow-x: hidden;\n"],["\n  width: 100%;\n  overflow-x: hidden;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["b" /* default */].div(_templateObject);var Jiggle=function(_React$Component){_inherits(Jiggle,_React$Component);function Jiggle(props){_classCallCheck(this,Jiggle);var _this=_possibleConstructorReturn(this,(Jiggle.__proto__||Object.getPrototypeOf(Jiggle)).call(this,props));_this.blendStyle=__WEBPACK_IMPORTED_MODULE_1__blendStyle__["a" /* default */].bind(_this);return _this;}_createClass(Jiggle,[{key:"componentDidMount",value:function componentDidMount(){window.scrollTo(0,0);var elem=__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);// Set the opacity of the element to 0
elem.style.opacity=0;window.requestAnimationFrame(function(){// Now set a transition on the opacity
elem.style.transition="opacity 250ms";// and set the opacity to 1
elem.style.opacity=1;});document.body.style.backgroundColor=__WEBPACK_IMPORTED_MODULE_3__var__["a" /* colors */].lightGreeny;}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.body.style.backgroundColor="initial";}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Intro__["a" /* default */],{scrolltop:this.props.scrolltop,windowSize:this.props.windowSize}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Motivation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Problems__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Goals__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Design__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Implementation__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Impact__["a" /* default */],null));}}]);return Jiggle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Jiggle);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_jiggle_wall_fallback_mp4__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_jiggle_wall_fallback_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_jiggle_wall_fallback_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_logo_gnf_png__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_logo_gnf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_logo_gnf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_logo_mediati_png__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_logo_mediati_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_logo_mediati_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_logo_mt_png__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_logo_mt_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_logo_mt_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(['\n\twidth: 100%;\n\tpadding-top: ','%;\n\tposition: relative;\n\t& > iframe {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n'],['\n\twidth: 100%;\n\tpadding-top: ','%;\n\tposition: relative;\n\t& > iframe {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n']),_templateObject2=_taggedTemplateLiteral(['\n\tbackground: #df422b;\n\tcolor: ',';\n'],['\n\tbackground: #df422b;\n\tcolor: ',';\n']),_templateObject3=_taggedTemplateLiteral(['background: #fff;'],['background: #fff;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var VideoWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,100/1.618);var IntroContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2__var__["a" /* colors */].white);var SupportContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject3);var Intro=function Intro(_ref){var scrolltop=_ref.scrolltop,windowSize=_ref.windowSize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntroContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs full-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs full-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'ratio__img',autoPlay:true,muted:true,playsInline:true,loop:true,style:{position:'absolute',height:'100%',width:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_3__img_jiggle_wall_fallback_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs',style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs start-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-6 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["f" /* ProgramTitle */],null,'Jiggle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["d" /* DemoLink */],{href:'http://jiggle.newslabfellows.com/',target:'_blank',rel:'noopener noreferrer'},'Visit Demo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-10 col-md-offset-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["e" /* ProgramDescription */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Jiggle is a web-based data visualization tool for a journalist. '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'With the advent of a new format of media such as interactive news, dynamic chart and so on, online web-based news has found many feasible ways to deliver their message to readers. In reality, because of this type of new media should be produced with many technical resources, most of the journalist suffer from being a lack of creating their own content like this. So with the mission of "Benefit media with technology" in this Google news lab fellowship program, we researched, designed and finally made a web-based data visualization tool for a journalist. In this process, different from our assumption and expectation, there were a lot of problems specific to Korea media environment so we necessarily had to figure out special solutions for our nation and below is our takeaway from this project.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-20 col-md-18 shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{width:'560',height:'315',src:'https://www.youtube.com/embed/LOwPcxVyog4',frameborder:'0',allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio__inner'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SupportContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_4__img_logo_gnf_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_5__img_logo_mediati_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-8 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_6__img_logo_mt_png___default.a})))));};/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiggle_wall_fallback.59c8f47d.mp4";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gnf.91e55e2d.png";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mt.b0d4867a.png";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_korea_chart_png__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_korea_chart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_korea_chart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_clip_mp4__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_clip_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_clip_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__var__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n\tposition: relative;\n\ttransform: rotate3D(-2, 1, -2, -60deg);\n'],['\n\tposition: relative;\n\ttransform: rotate3D(-2, 1, -2, -60deg);\n']),_templateObject2=_taggedTemplateLiteral(['\n\tposition: relative;\n\theight: 50vh;\n\tdisplay: flex;\n'],['\n\tposition: relative;\n\theight: 50vh;\n\tdisplay: flex;\n']),_templateObject3=_taggedTemplateLiteral(['\n\tposition: absolute;\n\tdisplay: block;\n\theight: 100%;\n\twidth: auto;\n\topacity: 0.4;\n\ttransition: opacity 0.2s;\n\t&:hover {\n\t\topacity: 1;\n\t}\n\t&:after {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: rgba(0, 1, 17, 0.4);\n\t}\n'],['\n\tposition: absolute;\n\tdisplay: block;\n\theight: 100%;\n\twidth: auto;\n\topacity: 0.4;\n\ttransition: opacity 0.2s;\n\t&:hover {\n\t\topacity: 1;\n\t}\n\t&:after {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: rgba(0, 1, 17, 0.4);\n\t}\n']),_templateObject4=_taggedTemplateLiteral(['',' right: 100%;'],['',' right: 100%;']),_templateObject5=_taggedTemplateLiteral(['',' left: 100%;'],['',' left: 100%;']),_templateObject6=_taggedTemplateLiteral(['\n\tbackground: ',';\n\tcolor: ',';\n\twidth: 100%;\n\toverflow-x: hidden;\n'],['\n\tbackground: ',';\n\tcolor: ',';\n\twidth: 100%;\n\toverflow-x: hidden;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SkewContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].div(_templateObject);var FixedHeightRow=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].div(_templateObject2);var Shaded=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* css */])(_templateObject3);var ShadedLeft=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].video(_templateObject4,Shaded);var ShadedRight=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].img(_templateObject5,Shaded);var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_5__var__["a" /* colors */].black,__WEBPACK_IMPORTED_MODULE_5__var__["a" /* colors */].semiwhite);var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var Motivation=function Motivation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,'Motivation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-16 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,'There have been already many data visualization tools on web. In industries, universities, and even media, these tools are widely used. Observing charts on online news in Korea, we only could find static chart images.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In contrast to our situation, many major press companies such as the NYT or the WP have led a new media movement on the web. For example, the NYT shocked other companies with "The Snowfall" which is interactive web based news article and even these days, they continuously make their own contents with many feasible features of the web. Of course, it would not be of any consequence if charts in Korea online new remain as static images because people are able to easily know what the charts convey. However, because our team thought the public has right to receive benefits from technology, we started to find solutions for this problem.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs',style:{height:'100vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-2 col-lg-2 col-xs-offset-reverse-4 col-lg-offset-reverse-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SkewContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FixedHeightRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShadedRight,{src:__WEBPACK_IMPORTED_MODULE_2__img_korea_chart_png___default.a,className:'shadow-5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShadedLeft,{autoPlay:true,muted:true,playsInline:true,loop:true,className:'shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_3__img_clip_mp4___default.a,type:'video/mp4'})))))));};/* harmony default export */ __webpack_exports__["a"] = (Motivation);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/korea_chart.3b899f95.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clip.17d245b0.mp4";

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_interview_o0_png__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_interview_o0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_interview_o0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_interview_o1_png__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_interview_o1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_interview_o1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_interview_o2_png__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_interview_o2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_interview_o2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_chart_2_gif__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_chart_2_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_chart_2_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_chart_1_gif__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_chart_1_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_chart_1_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_black_chart_png__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_black_chart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_black_chart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_problem_graph_png__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_problem_graph_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_problem_graph_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__var__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Helper_media__ = __webpack_require__(5);
var _templateObject=_taggedTemplateLiteral(['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n'],['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n']),_templateObject2=_taggedTemplateLiteral(['\n\t',' font-style: italic;\n\tposition: relative;\n\tpadding: 1em 2em;\n\tfont-size: ','px;\n\tcolor: #abaefb;\n\t',';\n\n\t&:before,\n\t&:after {\n\t\tposition: absolute;\n\t\tcontent: \'"\';\n\t\tdisplay: inline-block;\n\n\t\topacity: 0.3;\n\t\tfont-size: ','px;\n\t\t',';\n\t}\n\t&:before {\n\t\tleft: 0.2em;\n\t\ttop: 0;\n\t\t@media only screen and (min-width: 960px) {\n\t\t\tleft: 0;\n\t\t}\n\t}\n\t&:after {\n\t\tright: 0.5em;\n\t\ttop: 0;\n\t\t@media only screen and (min-width: 960px) {\n\t\t\tright: 0;\n\t\t}\n\t}\n'],['\n\t',' font-style: italic;\n\tposition: relative;\n\tpadding: 1em 2em;\n\tfont-size: ','px;\n\tcolor: #abaefb;\n\t',';\n\n\t&:before,\n\t&:after {\n\t\tposition: absolute;\n\t\tcontent: \'"\';\n\t\tdisplay: inline-block;\n\n\t\topacity: 0.3;\n\t\tfont-size: ','px;\n\t\t',';\n\t}\n\t&:before {\n\t\tleft: 0.2em;\n\t\ttop: 0;\n\t\t@media only screen and (min-width: 960px) {\n\t\t\tleft: 0;\n\t\t}\n\t}\n\t&:after {\n\t\tright: 0.5em;\n\t\ttop: 0;\n\t\t@media only screen and (min-width: 960px) {\n\t\t\tright: 0;\n\t\t}\n\t}\n']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 16px;\n    padding: 1em;\n  '],['\n    font-size: 16px;\n    padding: 1em;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      font-size: 30px;\n    '],['\n      font-size: 30px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n\t',' opacity: 0.8;\n\tmargin-top: 0.5em;\n'],['\n\t',' opacity: 0.8;\n\tmargin-top: 0.5em;\n']),_templateObject6=_taggedTemplateLiteral(['\n  ','\n  text-align: left;\n  font-size: ','px;\n  ',';\n  &:before{\n    content: "Insight 0','";\n    font-weight: bold;\n    display:block;\n    margin-bottom: 1em;\n  }\n'],['\n  ','\n  text-align: left;\n  font-size: ','px;\n  ',';\n  &:before{\n    content: "Insight 0','";\n    font-weight: bold;\n    display:block;\n    margin-bottom: 1em;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: 14px;\n  '],['\n    font-size: 14px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n\tbackground: ',';\n\tcolor: ',';\n\twidth: 100%;\n\toverflow-x: hidden;\n'],['\n\tbackground: ',';\n\tcolor: ',';\n\twidth: 100%;\n\toverflow-x: hidden;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var interviewFont=Object(__WEBPACK_IMPORTED_MODULE_9_styled_components__["a" /* css */])(_templateObject);var Mention=__WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].div(_templateObject2,interviewFont,Object(__WEBPACK_IMPORTED_MODULE_11__Helper_pxToVw__["a" /* default */])(28),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject3),Object(__WEBPACK_IMPORTED_MODULE_11__Helper_pxToVw__["a" /* default */])(70),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject4));var Interviewee=__WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].div(_templateObject5,interviewFont);var Insight=__WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].div(_templateObject6,interviewFont,Object(__WEBPACK_IMPORTED_MODULE_11__Helper_pxToVw__["a" /* default */])(24),__WEBPACK_IMPORTED_MODULE_12__Helper_media__["a" /* default */].md(_templateObject7),function(props){return props.index;});var Container=__WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_10__var__["a" /* colors */].black,__WEBPACK_IMPORTED_MODULE_10__var__["a" /* colors */].semiwhite);var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var Interview=function Interview(_ref){var img=_ref.img,mention=_ref.mention,_interviewee=_ref.interviewee,index=_ref.index,_insight=_ref.insight;var parse=function parse(str){return str?str.split('<br/>').map(function(line){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,line,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}):'';};var interviewee=parse(_interviewee);var insight=parse(_insight);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Mention,null,mention))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs middle-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-6 col-md-3 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Interviewee,null,interviewee)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-14 col-md-6 col-xs-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Insight,{index:index},insight))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))));};var Problems=function Problems(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,'Current Status Analysis'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-16 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,'At a first glance, it seems right to make an assumption like "There must be some troubles or obstacles to make the new type of media for the journalist". Figuring out the cause of this problem from journalist can be effective to find the solution because eventually, every chart on the press must be reviewed by them.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'So we started interviewing 7 journalists, 3 designers and one developer in many media companies. From this interviewing, we knew this problem should be analyzed both microscopic and macroscopic perspectives.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'ratio--2-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Microscopic Analysis'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Interview,{img:__WEBPACK_IMPORTED_MODULE_2__img_interview_o0_png___default.a,index:1,mention:'It takes 30 to 90 minutes to pass the data and receive the\n            visualized data again. It is quite harsh to demand faster worker,\n            but I have to wait for the designer to work on the order.',interviewee:'Journalist Sunmi Kang <br/> from Money Today',insight:'All charts in online news are created through designers. But they\n            have a desire to make the charts by themselves.<br/><br/>However, this process was taking too much time. Reporters need to\n            organize their data and deliver it to designers, and designers are\n            overloaded with too much work and requirements. And if the visual\n            materials created by designers are not completely in mind, they may\n            have difficulty communicating with each other.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Interview,{img:__WEBPACK_IMPORTED_MODULE_3__img_interview_o1_png___default.a,index:2,mention:'When the chart received from the designer\n      is not what I had in mind, we have to wait\n      again for the order. So it would be very nice\n      if I could create visual materials myself.',interviewee:'Journalist Hyukjin Oh<br/>\n      from Korea Securities Press',insight:'Journalists who are interested in new media\n      feel the need for dynamic charts. They think\n      static charts are no longer helpful for story-\n      telling and information delivery.<br/><br/>Journalists in Korea also want to create dynamic\n      charts and articles in a variety of formats, such as\n      those provided by The New York Times or Bloom-\n      berg. However, most Koreans get their news\n      through portals, and portals have put a lot of\n      limitations on media companies, so reporters\n      cannot attempt to provide new and forward-\n      thinking designs. The formats that can be uploaded\n      to portal sites are all text, images, and YouTube links.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Interview,{img:__WEBPACK_IMPORTED_MODULE_4__img_interview_o2_png___default.a,index:3,mention:'Static charts do not help storytelling. But\n        I was afraid of the tool and did not think\n        about trying it.',interviewee:'Journalist Heegun Lee<br/>\n        from Mun-Hwa Daily Press',insight:'Most journalists have little experience with tools\n        and are afraid to learn new tools. Also, they have\n        to complete articles by deadlines every day, so\n        they always lack time.<br/><br/>In fact, there are many services that reporters can\n        create dynamic tools. But most reporters who have\n        difficulty learning new things feel that the services are\n        also difficult. They need a data tool that can provide\n        some needed functionality and produce efficient\n        results in a short amount of time.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Macroscopic Analysis'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-xs-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img shadow-1',src:__WEBPACK_IMPORTED_MODULE_5__img_chart_2_gif___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Digital news consumption rate through portal site by country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-18 col-md-8 col-md-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img shadow-1',src:__WEBPACK_IMPORTED_MODULE_6__img_chart_1_gif___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Digital news consumption rate through media homepage by country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'From these two charts, 77% of reader visit portal sites to read the news and only 4% of reader visit the press\' websites to read. Compare to other nations, the dependency is too concentrated only on portal sites in Korea. In reality, many people in Korea read news through portal sites like "Naver" or "Daum" and even worse, some of them regard portal sites as the press.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_8__img_problem_graph_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'This can be a serious cause of our problem. Because of high traffic of portal sites, the press has no choice but to publish their news to portal services. In this process, the press must adjust the format of their content to be received and as a result, they cannot use any dynamic scripting on their contents. It makes contents less flexible and experimental. This is the main reason why we still see static and old type contents.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null));};/* harmony default export */ __webpack_exports__["a"] = (Problems);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/interview_o0.346826c3.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/interview_o1.f66bc15d.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/interview_o2.12e01f02.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chart_2.94b44f60.gif";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chart_1.c4e2fc26.gif";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/black chart.1924311a.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/problem_graph.429a30f1.png";

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Helper_media__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__var__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\nposition: relative;\n  width: 30%;\n  padding-top: 30%;\n  margin: 0 auto;\n  border-radius: 100%;\n  color: #fff;\n  background: ',';\n  font-family: "Montserrat", sans-serif;\n  ',';\n  &:after{\n    content: "','";\n    font-size: 14px;\n    position: absolute;\n    left: 50%;\n    display: block;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n'],['\nposition: relative;\n  width: 30%;\n  padding-top: 30%;\n  margin: 0 auto;\n  border-radius: 100%;\n  color: #fff;\n  background: ',';\n  font-family: "Montserrat", sans-serif;\n  ',';\n  &:after{\n    content: "','";\n    font-size: 14px;\n    position: absolute;\n    left: 50%;\n    display: block;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 10%;\n    padding-top: 10%;\n    margin-top: 10%;\n  '],['\n    width: 10%;\n    padding-top: 10%;\n    margin-top: 10%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\t',';\n'],['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-size: ','px;\n\tmargin-top: 1em;\n\t',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    margin-top: 0;\n  '],['\n    margin-top: 0;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tmargin-top: 2em;\n\tfont-size: ','px;\n\t',';\n\t',';\n'],['\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 100;\n\tmargin-top: 2em;\n\tfont-size: ','px;\n\t',';\n\t',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: 15px;\n    padding: 1em;\n  '],['\n    font-size: 15px;\n    padding: 1em;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: 15px;\n    margin-top: 0;\n  '],['\n    font-size: 15px;\n    margin-top: 0;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: ',';\n\tcolor: ',';\n\tpadding: 1em 0;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\t',';\n'],['\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: ',';\n\tcolor: ',';\n\tpadding: 1em 0;\n\tfont-family: \'Source Sans Pro\', sans-serif;\n\tfont-weight: 400;\n\tfont-size: ','px;\n\t',';\n']),_templateObject9=_taggedTemplateLiteral(['\n    font-size: 20px;\n    padding: 1em;\n  '],['\n    font-size: 20px;\n    padding: 1em;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GoalFigure=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_5__var__["a" /* colors */].black,__WEBPACK_IMPORTED_MODULE_4__Helper_media__["a" /* default */].sm(_templateObject2),function(props){return props.index;});var GoalLabel=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__Helper_pxToVw__["a" /* default */])(30),__WEBPACK_IMPORTED_MODULE_4__Helper_media__["a" /* default */].sm(_templateObject4));var GoalDes=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_3__Helper_pxToVw__["a" /* default */])(24),__WEBPACK_IMPORTED_MODULE_4__Helper_media__["a" /* default */].md(_templateObject6),__WEBPACK_IMPORTED_MODULE_4__Helper_media__["a" /* default */].sm(_templateObject7));var HMW=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_5__var__["a" /* colors */].black,__WEBPACK_IMPORTED_MODULE_5__var__["a" /* colors */].semiwhite,Object(__WEBPACK_IMPORTED_MODULE_3__Helper_pxToVw__["a" /* default */])(45),__WEBPACK_IMPORTED_MODULE_4__Helper_media__["a" /* default */].md(_templateObject9));var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var Goals=function Goals(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,'Goals'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-16 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,'From those lessons above, it\'s possible to set up goals to step into the design phase. The microscopic analysis could give us a direct approach to help them make the new type of media contents. In contrast, Macroscopic analysis means our problem should be approached as a platform/system problem. These 3 goals below inclusively regard both microscopic and macroscopic analysis.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-sm-7 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalFigure,{index:'01'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalLabel,null,'Without Designer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalDes,null,'A journalist wants to make their own contents without a designer. Main obstacles are (1)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'it must take less time than the case when designer do the same thing'),' and (2)',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'has to be easy to learn'),'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-sm-7 col-md-6 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalFigure,{index:'02'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalLabel,null,'Familiar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalDes,null,'To use easily and in a friendly way, every detail work process should be familiar with what they\'ve done before. For this reason, there need to observe every step to publish news within chart from scratch.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-sm-7 col-md-6 col-sm-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalFigure,{index:'03'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalLabel,null,'Cross Platform'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalDes,null,'The other but possible main reason about why this problem exists especially in Korea is the dependency on portal sites. Changing public reading source from portal to the press\' site must be costly. Rather than this, our design should suggest available everywhere.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HMW,null,'How might we help journalist making',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' a narrative chart with minimum learning cost?'))));};/* harmony default export */ __webpack_exports__["a"] = (Goals);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_crop_persona_png__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_crop_persona_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_crop_persona_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_persona_diagram_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_persona_diagram_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_persona_diagram_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_persona_interview_png__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_persona_interview_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_persona_interview_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_proto_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_proto_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_proto_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_tool_proficiency_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_tool_proficiency_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_tool_proficiency_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_templates_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_templates_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_templates_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_1_1_jpeg__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_1_1_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_1_1_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_1_2_jpeg__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_1_2_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_1_2_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_1_3_v1_jpeg__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_1_3_v1_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_1_3_v1_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_input_diagram_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_input_diagram_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_input_diagram_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_input_diagram2_png__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_input_diagram2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_input_diagram2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_input_cells_png__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_input_cells_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_input_cells_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_input2_emp_png__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_input2_emp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_input2_emp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_styling_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_styling_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__img_styling_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_navigation_flow_png__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_navigation_flow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__img_navigation_flow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_nav_paper_png__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_nav_paper_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__img_nav_paper_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_SectionScroll_mp4__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_SectionScroll_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__img_SectionScroll_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__var__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n'],['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n\tposition: relative;\n\tdisplay: block;\n\t&:after {\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tcontent: \'\';\n\t\tbackground: #002f52;\n\t\topacity: 0.3;\n\t}\n'],['\n\tposition: relative;\n\tdisplay: block;\n\t&:after {\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tcontent: \'\';\n\t\tbackground: #002f52;\n\t\topacity: 0.3;\n\t}\n']),_templateObject3=_taggedTemplateLiteral(['position: relative;'],['position: relative;']),_templateObject4=_taggedTemplateLiteral(['background: ',';'],['background: ',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PicGrid=__WEBPACK_IMPORTED_MODULE_19_styled_components__["b" /* default */].div(_templateObject);var ProtoImgWrapper=__WEBPACK_IMPORTED_MODULE_19_styled_components__["b" /* default */].div(_templateObject2);var ProtoImg=__WEBPACK_IMPORTED_MODULE_19_styled_components__["b" /* default */].img(_templateObject3);var ColorParagraph=__WEBPACK_IMPORTED_MODULE_19_styled_components__["b" /* default */].div(_templateObject4,function(props){return props.color;});var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--2-1'})));};var SmallGap=function SmallGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'})));};var Design=function Design(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,'Design'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,'Lack of experience about domain could lead solution unreasonable and wasteful. To avoid this situation, conducted iterative investigation, prototyping and interviewing to get feedback. Also to achieve our goals, we\'ve made 4 important design decisions from iterations.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratio--4-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Persona'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Defining persona is classic but the most obvious way to make the problem clear. It is because persona rarely be changed as long as the definition of problem isn\'t changed. After arranging field research material, it was able to see our problem more in detail and finally start to make our persona. Based on interviewing and research from journalist, it was possible to find many traits of (1)who they might be, (2)what they need and (3)why they want it. Combining each type of traits and considering the fitness to our main problem, eventually got persona.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_2__img_crop_persona_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_3__img_persona_diagram_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img shadow-2',src:__WEBPACK_IMPORTED_MODULE_4__img_persona_interview_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Prototyping'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Without making in-app prototypes, conducting paper prototyping can be effective to grasp basic concept of the service. First our team start to drawing own solution individually. Comparing each drawing can show the differences and make each solution\'s benefit and flaw more clear. It is also possible to show detail interaction using paper. Doing these prevents making a rough consensus in decision making which would led changing from beginning.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-16 col-md-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImgWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImg,{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_5__img_proto_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-10 col-xs-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PicGrid,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImgWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImg,{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_8__img_1_1_jpeg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImgWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtoImg,{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_9__img_1_2_jpeg___default.a}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Iterative A/B Testing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Although most of conflicting opinions could be resolved during the decision-making process, some of them were worth testing and receiving feedback from real users. Some A/B testing results shocked us as they were in opposition to our expectations. For example, we struggled with designing navigation flow and some other features as well. After some discussion and meetings, we asked the journalists and designers to choose one of the available options. To show them options which should be more robust than paper prototypes, we prepared videos and explained what task they should do with Jiggle. Without any additional instruction, we just observed them, watched their thinking process, and received feedback on the prototypes, and lastly, we learned that there were a lot of differences from our expectations. These facts would never have been known just from our discussions.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_10__img_1_3_v1_jpeg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Tool Proficiency Analysis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'What feature would be helpful or not? Different from our expectation and effort, most of our considerations and stuff would not that helpful. No matter how good a feature is, it is not a good feature if it does not fit the user level. The easiest way to know the user level is listing up the tools they use. Knowing how they use them would be better. To design our feature more practical for them and enter into detailed step, we observe what they use, and how they use to make their chart.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-sm-14 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_6__img_tool_proficiency_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:'#ffffff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,'Decision 01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Chart Templates'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'There have been already many types of chart. Each chart has own purpose and requirements to show a result. But these typical charts would not help current journalist making their own message at all. We thought the chart should be animated as well as redefined own types with respect to their intention. We collected currently used chart images and classify them with their shapes, intentions, and frequency. This classification came out a new type of chart and we call it \'Template\'. Template represent animation, shapes, and intention itself. By defining like this, the journalist can choose most proper one of them easily.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:__WEBPACK_IMPORTED_MODULE_21__var__["a" /* colors */].black},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-sm-20 col-md-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_7__img_templates_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,'Decision 02'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Inputs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'What if we tried to force a user to input their data into our service in a different way from what they\'ve done before? The familiar way cannot be changed easily and possibly costly. \'Input data\' is just such a case. Most of us already use many input shortcut and conventions even though the program continuously switched. We always move data from one to another using \'ctrl+c(copy)\' and \'ctrl+v(paste)\'. Also if there is the case should be undone, we press \'ctrl+z(undo)\'. This is why knowing user\'s workflow and the familiar task is important to transfer user\'s environment from one to other places.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-sm-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_11__img_input_diagram_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:'#37ce75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_13__img_input_cells_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'\'Cell-like\' representation is really powerful user to utilize as many features as possible without any instruction. However, sometimes the degree of freedom while inputting data really make service handle data hard. In our case, it would be resolved with studying input data structure from practical and real example data. It is because we already make our chart template including intention.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-sm-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_12__img_input_diagram2_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Especially, in the process of input, we handle the narrative part of chart template. The important point is this special and novel feature is not sudden. It is even familiar with a journalist because they\'ve already highlighted some part/cell to emphasize before delivering to a designer. This valuable observation can save many design cost to inject new feature into typical representation.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:__WEBPACK_IMPORTED_MODULE_21__var__["a" /* colors */].black},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_14__img_input2_emp_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,'Decision 03'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Styling'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'Although chart template is able to deliver a message, in many cases, there are needs for other resources(color, image, and font) to be fertile what the chart means. In reality, a chart has some additional images on the background for the purpose of explaining visually(we knew that it\'s one of DONT in visualization). However, most of the journalist suffer from lack of sense of design. So basic styling features (1)foreground/background color, (2)color(Similar/Contrast) and (3)image composer were designed to help journalist. In this process, the load of using feature minimized based on our design principle(Be familiar).'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-24 col-md-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_15__img_styling_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,'Decision 04'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,'Navigation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'With the same feature and contents, the navigation can make a significant difference in the whole service. Structuring navigation can be a most important part so that listing up use cases as flow chart should be done before. This task can help us by answering these questions.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'What type of task is required to do the next step?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'What triggers the user to go back they\'ve already done?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'The relevance and frequency of each task really matter?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Based on this, we figure out the normal and reverse flow of our service and labeling each step with the trigger.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:'#ffffff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-20 col-md-14'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_16__img_navigation_flow_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-22 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row start-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,'With our 3 main decision (1)Chart Template, (2)Input and (3)Styling and navigation flow chart it results as designing scroll paging rather than pagination or page stacking. A user can know which direction they head to by transition and it makes he/she whole process more understandable. These were the main benefit of scroll paging so that we made a real app prototype for testing.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-16 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row center-xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'ratio__img',src:__WEBPACK_IMPORTED_MODULE_17__img_nav_paper_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-11 col-xs-offset-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,muted:true,playsInline:true,loop:true,className:'ratio__img shadow-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_18__img_SectionScroll_mp4___default.a,type:'video/mp4'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null));};/* harmony default export */ __webpack_exports__["a"] = (Design);__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{width:'560',height:'315',src:'https://www.youtube.com/embed/t5W0OjdfIqI?start=4102',frameborder:'0',allow:'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',allowfullscreen:true});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/crop_persona.cb61bce4.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/persona_diagram.5ef06a9f.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/persona_interview.1d1051cf.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/proto.df8bad93.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tool_proficiency.0b1a5f37.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/templates.932dea25.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1_1.317e5fae.jpeg";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1_2.6fbf45fd.jpeg";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1_3.v1.bc0d3a85.jpeg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input_diagram.5c4475a9.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input_diagram2.9219ddf1.png";

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input2_emp.9795499b.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/styling.dd372648.png";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/navigation_flow.d2fce899.png";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nav_paper.b0db4637.png";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SectionScroll.8095eb42.mp4";

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_impl_diagram_png__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_impl_diagram_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_impl_diagram_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_uml_png__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_uml_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_uml_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_uml_board_png__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_uml_board_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_uml_board_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_cell_algo_png__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_cell_algo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_cell_algo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_handle_image_png__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_handle_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_handle_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_crossplat_png__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_crossplat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_crossplat_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Concepts__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__var__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  &:after {\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    content: \"\";\n    background: #002f52;\n    opacity: 0.3;\n  }\n"],["\n  position: relative;\n  display: block;\n  &:after {\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    content: \"\";\n    background: #002f52;\n    opacity: 0.3;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n"],["\n  position: relative;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  background: ",";\n"],["\n  background: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PicGrid=__WEBPACK_IMPORTED_MODULE_8_styled_components__["b" /* default */].div(_templateObject);var ProtoImgWrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["b" /* default */].div(_templateObject2);var ProtoImg=__WEBPACK_IMPORTED_MODULE_8_styled_components__["b" /* default */].img(_templateObject3);var ColorParagraph=__WEBPACK_IMPORTED_MODULE_8_styled_components__["b" /* default */].div(_templateObject4,function(props){return props.color;});var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--2-1"})));};var SmallGap=function SmallGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-sm-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})));};var Implementation=function Implementation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,"Implementation"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-16 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,"With the mission of \"Benefit media with technology\", we agreed with open our service and core project public. So we wanted our Jiggle service also be a client of open source library that we'll make. By doing this, many developers and other media companies would try to build better chart/service later. Our philosophy could be found from overall structure."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_impl_diagram_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,"Jiggle Core"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Chart Abstraction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"To solve a complex and sophisticated problem, it is necessary to make the problem as simple as possible and usually call this process as \"Abstraction\". Because our chart creating core library also transform into various kinds of the chart with additional features, we should abstract our core chart functionalities."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_4__img_uml_board_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11 col-xs-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#37ce75",style:{display:"flex",height:"100%",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_3__img_uml_png___default.a})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"Finally, we wrapped d3.js chart library in our way. It was mandatory because we redefine chart type to including shape, animation, and intention. To represent them, CommonFactory must have ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Drawing()"),": Shaping",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"TrainstionRendering()"),": Define transition animation according to the template type",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"TransitionRecording()"),": Record to export results for publishing",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"With CommonFactory, any client can define any shape, transition and even recording(intention) with some development."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,"Jiggle Web"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Handle Input"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"As long as we chose to use 'Cell-like' UI, there must be some tricky input cases. Because 'Handsontable' provides powerful features to use 'Cell-like' function, put UI on our service was really cheap. However, handling data should be processed by our algorithm so that devised some steps to resolve it."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_5__img_cell_algo_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,"Jiggle Web"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Handle Image"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"One of the main reason to design and implement the styling part was ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"image attachment.")," Even though we've already known attatching images harm visualization itself, due to its prevalence, we have no choice but implementing this feature. The real problem of attaching images is it would hide data object when we merely give maker the controller. We solve this case elgantly: only if transforming mode, that image cover chart data object."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-24 col-md-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_6__img_handle_image_png___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["b" /* ArticleSubTitle */],null,"Jiggle Core + Web"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Export as GIF"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"Nothing is complete unless you put in final shape. Even though we help journalist creating their own chart, if we fail to publish it to CMS and portal sites, this format cannot be accepted.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"It is not easy to think that ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"GIF")," will be an answer in case all dynamic scripting is rejected. GIF can express transition itself and be accepted many platforms. It even doesn't require a user to play cause it loops automatically. Of course, it has many flaws as well. Due to its old format, usually, it has a large volume, low framerate and unable to seek some point(pause or stop). However, we thought it's enough to deliver our mission to Korea readers.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_7__img_crossplat_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"The new type of chart image would make a typical reader confused with which part they should see. It is because GIF format loops and doesn't provide seek function. The ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"'progress bar'")," can be a rescue! We posed the progress bar on our chart and though it can be a great role to express our BI(Brand Identity)."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Concepts__["a" /* Concept */],{color:"#ffffff"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-10 col-md-6 col-xs-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Concepts__["a" /* Concept */],{color:__WEBPACK_IMPORTED_MODULE_11__var__["a" /* colors */].semiblack}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null));};/* harmony default export */ __webpack_exports__["a"] = (Implementation);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/impl_diagram.d7ec6368.png";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uml.0609f79d.png";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uml_board.505da854.png";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cell_algo.e753e96e.png";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/handle_image.723942c4.png";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/crossplat.d9a30c94.png";

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_fw_jpeg__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_fw_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_fw_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_ps_jpeg__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_ps_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_ps_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_mt_jpeg__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_mt_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_mt_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_example1_mp4__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_example1_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_example1_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_example2_mp4__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_example2_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_example2_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Concepts__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Helper_pxToVw__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__var__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(["\n  background: ",";\n"],["\n  background: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 45vw;\n  & > img {\n    height: 90%;\n    width: auto;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  height: 45vw;\n  & > img {\n    height: 90%;\n    width: auto;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ColorParagraph=__WEBPACK_IMPORTED_MODULE_7_styled_components__["b" /* default */].div(_templateObject,function(props){return props.color;});var PresentContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["b" /* default */].div(_templateObject2);var ResponsiveGap=function ResponsiveGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--2-1"})));};var SmallGap=function SmallGap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-sm-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ratio--4-1"})));};var Impact=function Impact(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["h" /* SectionTitle */],null,"Impact"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-16 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["g" /* SectionDescription */],null,"For 2 months, we felt some pressure whether we can solve this big problem. There were many iterations to redesign and implement but eventually, we could take a chance to show our service to the world."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Spread The Message"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"Luckily, we had many opportunities to present our idea and progress. Even when we were not prepared, there were many feedbacks to enhance our service quality. We were surprised that many journalists have wanted our service and technical advisory for adopting our core service to their CMS. This was the first time we can change the world."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#0c0300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PresentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_3__img_ps_jpeg___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_4__img_mt_jpeg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-11 col-xs-offset-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"ratio__img",src:__WEBPACK_IMPORTED_MODULE_2__img_fw_jpeg___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-22 col-sm-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row start-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["c" /* ArticleTitle */],null,"Change Media"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* ArticleParagraph */],null,"The final destination might be seeing whether our challenge really impacts on the world. At the first time the chart made from our service publish to the portal site, we didn't yet really feel this happened. Without any plugin or additional lesson to the journalist, we succeed to see our chart has the power to change our media environment and problem."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:"#513bd6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-16 col-md-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{autoPlay:true,muted:true,playsInline:true,loop:true,className:"ratio__img shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{src:__WEBPACK_IMPORTED_MODULE_5__img_example1_mp4___default.a,type:"video/mp4"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorParagraph,{color:__WEBPACK_IMPORTED_MODULE_10__var__["a" /* colors */].semiblack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row center-xs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-6 col-md-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video",{autoPlay:true,muted:true,playsInline:true,loop:true,className:"ratio__img shadow-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("source",{src:__WEBPACK_IMPORTED_MODULE_6__img_example2_mp4___default.a,type:"video/mp4"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallGap,null)));};/* harmony default export */ __webpack_exports__["a"] = (Impact);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fw.72c15def.jpeg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ps.b48bacad.jpeg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mt.9da5393f.jpeg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/example1.2d62678a.mp4";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/example2.916e2dcc.mp4";

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/chaht01.github.io",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/chaht01.github.io"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7fdce5f4.js